// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const EK: IClientSubSystemModel = {
  Code: 'EK',
  DisplayLabel: 'Ekonomi',
  BusinessModels: {
    EKAnalyslogg: {
      CollectionName: 'EKAnalyslogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Analyslogg',
        Abstract: false,
        SOLabel: 'Analyslogg',
        SOGLabel: 'Analyslogg',
        SBLabel: 'Analyslogg',
        SBGLabel: 'Analyslogg',
        POLabel: 'Analyslogg',
        POGLabel: 'Analyslogg',
        PBLabel: 'Analyslogg',
        PBGLabel: 'Analyslogg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Analyslogg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Analyslogg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Analyslogg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RAPPORT_IDKOD: {
          AttributeName: 'RAPPORT_IDKOD',
          DisplayLabel: 'Rapport, idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RAPPORT_ID: {
          AttributeName: 'RAPPORT_ID',
          DisplayLabel: 'Rapport, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Analysdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIOD: {
          AttributeName: 'PERIOD',
          DisplayLabel: 'Period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANALYSTYP: {
          AttributeName: 'ANALYSTYP',
          DisplayLabel: 'Analystyp',
          Hint: 'Ekonomisk analys/Ekonomirapporter/Kontoanalys/Rapportpaket',
          DataType: 'Enum',
          EnumValues: new Map([['EKONOMISK_ANALYS', 'Ekonomisk analys'], ['EKONOMIRAPPORTER', 'Ekonomirapporter'], ['KONTOANALYS', 'Kontoanalys'], ['RAPPORTPAKET', 'Rapportpaket']]),
          EnumSortValues: new Map([['EKONOMISK_ANALYS', 'A'], ['EKONOMIRAPPORTER', 'E'], ['KONTOANALYS', 'K'], ['RAPPORTPAKET', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EKONOMISK_ANALYS=Ekonomisk analys;EKONOMIRAPPORTER=Ekonomirapporter;KONTOANALYS=Kontoanalys;RAPPORTPAKET=Rapportpaket"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetAnstalld: {
      CollectionName: 'EKArbetsbudgetAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetAnstalld',
        Abstract: false,
        SOLabel: 'Anställda i personalgrupp per arbetsbudget',
        SOGLabel: 'Anställda i personalgrupp per arbetsbudget',
        SBLabel: 'Anställda i personalgrupp per arbetsbudget',
        SBGLabel: 'Anställda i personalgrupp per arbetsbudget',
        POLabel: 'Anställda i personalgrupp per arbetsbudget',
        POGLabel: 'Anställda i personalgrupp per arbetsbudget',
        PBLabel: 'Anställda i personalgrupp per arbetsbudget',
        PBGLabel: 'Anställda i personalgrupp per arbetsbudget',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anställda i personalgrupp per arbetsbudget primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anställda i personalgrupp per arbetsbudget versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anställda i personalgrupp per arbetsbudget fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERS_GRUPP_ID: {
          AttributeName: 'PERS_GRUPP_ID',
          DisplayLabel: 'Id, personalgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FROM_AR: {
          AttributeName: 'FROM_AR',
          DisplayLabel: 'Fr.o.m år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_AR: {
          AttributeName: 'TOM_AR',
          DisplayLabel: 'T.o.m år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Externt anställningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_LONESYSTEM: {
          AttributeName: 'FRAN_LONESYSTEM',
          DisplayLabel: 'Från lönesystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Personalgrupp: {
          AssociationName: 'Personalgrupp',
          DisplayLabel: 'Personalgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonal',
          AssociatedComponentName: 'ArbetsbudgetPersonalPersgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAnvRapport: {
      CollectionName: 'EKAnvRapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AnvRapport',
        Abstract: false,
        SOLabel: 'Användarens ekonomirapport',
        SOGLabel: 'Användarens ekonomirapport',
        SBLabel: 'Användarens ekonomirapportAnvändarens ekonomirapport',
        SBGLabel: 'Användarens ekonomirapport',
        POLabel: 'Användarens ekonomirapporter',
        POGLabel: 'Användarens ekonomirapporter',
        PBLabel: 'Användarens ekonomirapporter',
        PBGLabel: 'Användarens ekonomirapporter',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Användarens ekonomirapport primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Användarens ekonomirapport versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Användarens ekonomirapport fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORT_ID: {
          AttributeName: 'RAPPORT_ID',
          DisplayLabel: 'Rapport, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTD_LOPNR: {
          AttributeName: 'UTD_LOPNR',
          DisplayLabel: 'Utdelad, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Kodbehörighet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        UtdeladEkonomirapport: {
          AssociationName: 'UtdeladEkonomirapport',
          DisplayLabel: 'Utdela ekonomirapport',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKArbetsbudgetUrval: {
      CollectionName: 'EKArbetsbudgetUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetUrval',
        Abstract: false,
        SOLabel: 'Arbetsbudget budgetgrupp, urval',
        SOGLabel: 'Arbetsbudget budgetgrupp, urval',
        SBLabel: 'Arbetsbudget budgetgrupp, urval',
        SBGLabel: 'Arbetsbudget budgetgrupp, urval',
        POLabel: 'Arbetsbudget budgetgrupp, urval',
        POGLabel: 'Arbetsbudget budgetgrupp, urval',
        PBLabel: 'Arbetsbudget budgetgrupp, urval',
        PBGLabel: 'Arbetsbudget budgetgrupp, urval',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget budgetgrupp, urval primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget budgetgrupp, urval versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget budgetgrupp, urval fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetPersonal: {
      CollectionName: 'EKArbetsbudgetPersonal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetPersonal',
        Abstract: true,
        SOLabel: 'Arbetsbudget personal',
        SOGLabel: 'Arbetsbudget personal',
        SBLabel: 'Arbetsbudget personal',
        SBGLabel: 'Arbetsbudget personal',
        POLabel: 'Arbetsbudget Personalposter',
        POGLabel: 'Arbetsbudget personal',
        PBLabel: 'Arbetsbudget personal',
        PBGLabel: 'Arbetsbudget personal',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'ArbetsbudgetPersonalPost',
            Abstract: true,
            SOLabel: 'Arbetsbudget, personalpost',
            SOGLabel: 'Arbetsbudget, personalpost',
            SBLabel: 'Arbetsbudget, personalpost',
            SBGLabel: 'Arbetsbudget, personalpost',
            POLabel: 'Arbetsbudget, personalpost',
            POGLabel: 'Arbetsbudget, personalpost',
            PBLabel: 'Arbetsbudget, personalpost',
            PBGLabel: 'Arbetsbudget, personalpost',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'ArbetsbudgetPersonalAnstalld',
                Abstract: false,
                SOLabel: 'Anställd per arbetsbudget',
                SOGLabel: 'Anställd per arbetsbudget',
                SBLabel: 'Anställd per arbetsbudget',
                SBGLabel: 'Anställd per arbetsbudget',
                POLabel: 'Anställd per arbetsbudget',
                POGLabel: 'Anställd per arbetsbudget',
                PBLabel: 'Anställd per arbetsbudget',
                PBGLabel: 'Anställd per arbetsbudget',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'ArbetsbudgetPersonalAvveckling',
                Abstract: false,
                SOLabel: 'Planerad personalminskning',
                SOGLabel: 'Planerad personalminskning',
                SBLabel: 'Planerad personalminskning',
                SBGLabel: 'Planerad personalminskning',
                POLabel: 'Planerad personalminskning',
                POGLabel: 'Planerad personalminskning',
                PBLabel: 'Planerad personalminskning',
                PBGLabel: 'Planerad personalminskning',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'ArbetsbudgetPersonalPersgrupp',
            Abstract: false,
            SOLabel: 'Personalgrupp per arbetsbudget',
            SOGLabel: 'Personalgrupp per arbetsbudget',
            SBLabel: 'Personalgrupp per arbetsbudget',
            SBGLabel: 'Personalgrupp per arbetsbudget',
            POLabel: 'Personalgrupp per arbetsbudget',
            POGLabel: 'Personalgrupp per arbetsbudget',
            PBLabel: 'Personalgrupp per arbetsbudget',
            PBGLabel: 'Personalgrupp per arbetsbudget',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget personal primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget personal versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['ARBETSBUDGETPERSONALANSTALLD', 'Anställd per arbetsbudget'], ['ARBETSBUDGETPERSONALAVVECKLING', 'Planerad personalminskning'], ['ARBETSBUDGETPERSONALPERSGRUPP', 'Personalgrupp per arbetsbudget']]),
          EnumSortValues: new Map([['ARBETSBUDGETPERSONALANSTALLD', 'A'], ['ARBETSBUDGETPERSONALAVVECKLING', 'V'], ['ARBETSBUDGETPERSONALPERSGRUPP', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetsbudget personal id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget personal fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERSONAL_ID: {
          AttributeName: 'PERSONAL_ID',
          DisplayLabel: 'Id, personal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Anställningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Id, Anställd',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BEFATTNINGSKOD: {
          AttributeName: 'BEFATTNINGSKOD',
          DisplayLabel: 'Befattningskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FODELSE_AR: {
          AttributeName: 'FODELSE_AR',
          DisplayLabel: 'Födelseår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANST_MANAD: {
          AttributeName: 'ANST_MANAD',
          DisplayLabel: 'Anställningsmånad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SLUT_MANAD: {
          AttributeName: 'SLUT_MANAD',
          DisplayLabel: 'Slutmånad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SEM_DGR: {
          AttributeName: 'SEM_DGR',
          DisplayLabel: 'Semesterdagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVTALS_OMR_ID: {
          AttributeName: 'AVTALS_OMR_ID',
          DisplayLabel: 'Id, avtalsområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HELTIDSLON: {
          AttributeName: 'HELTIDSLON',
          DisplayLabel: 'Heltidslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LON_TYP: {
          AttributeName: 'LON_TYP',
          DisplayLabel: 'Lönetyp',
          Hint: 'Månadslön/Timlön/Tillfälligt anställda',
          DataType: 'Enum',
          EnumValues: new Map([['MANADSLON', 'Månadslön'], ['TIMLON', 'Timlön'], ['TILLFALLIGT_ANSTALLDA', 'Tillfälligt anställda']]),
          EnumSortValues: new Map([['MANADSLON', 'M'], ['TIMLON', 'T'], ['TILLFALLIGT_ANSTALLDA', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANADSLON=Månadslön;TIMLON=Timlön;TILLFALLIGT_ANSTALLDA=Tillfälligt anställda"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SYSSELSATTNINGSGRAD: {
          AttributeName: 'SYSSELSATTNINGSGRAD',
          DisplayLabel: 'Sysselsättningsgrad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="3"',
          FormatterDisplayParams: 'Decimals="3";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Borttagen',
        },
        FRAN_LONESYSTEM: {
          AttributeName: 'FRAN_LONESYSTEM',
          DisplayLabel: 'Från lönesystem',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        UPPEHALL_FAKTOR: {
          AttributeName: 'UPPEHALL_FAKTOR',
          DisplayLabel: 'Uppehåll faktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LON_AVSER_AR: {
          AttributeName: 'LON_AVSER_AR',
          DisplayLabel: 'Lön avser år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL_TIMMAR: {
          AttributeName: 'ANTAL_TIMMAR',
          DisplayLabel: 'Antal timmar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UPPRAKNING_FGA_PROCENT: {
          AttributeName: 'UPPRAKNING_FGA_PROCENT',
          DisplayLabel: 'Uppräkning, fg år %',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        UPPRAKNING_BA_PROCENT: {
          AttributeName: 'UPPRAKNING_BA_PROCENT',
          DisplayLabel: 'Uppräkning budgetår %',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        LondatumFGA: {
          AttributeName: 'LondatumFGA',
          DisplayLabel: 'Löndatum föreg år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        LondatumBA: {
          AttributeName: 'LondatumBA',
          DisplayLabel: 'Löndatum budgetår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        HeltidslonFGA: {
          AttributeName: 'HeltidslonFGA',
          DisplayLabel: 'Heltidslön fg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Övrigt',
        },
        HeltidslonBA: {
          AttributeName: 'HeltidslonBA',
          DisplayLabel: 'Heltidslön budgetår',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        UPPRAKNING_FGA_KR: {
          AttributeName: 'UPPRAKNING_FGA_KR',
          DisplayLabel: 'Uppräkning, fg år kr',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        UPPRAKNING_BA_KR: {
          AttributeName: 'UPPRAKNING_BA_KR',
          DisplayLabel: 'Uppräkning, budgetår kr',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Arslon: {
          AttributeName: 'Arslon',
          DisplayLabel: 'Årslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        SemesterErs: {
          AttributeName: 'SemesterErs',
          DisplayLabel: 'Semesterersättningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        SarskErs: {
          AttributeName: 'SarskErs',
          DisplayLabel: 'Särskilda ersättningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        SocAvg: {
          AttributeName: 'SocAvg',
          DisplayLabel: 'Sociala avgifter',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        LonTotalt: {
          AttributeName: 'LonTotalt',
          DisplayLabel: 'Budgeterad lönekostnad',
          Hint: 'Summerar årslön, semesterers, särskilda ersättningar och sociala avgifter',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        ArslonBerakning: {
          AttributeName: 'ArslonBerakning',
          DisplayLabel: 'Beräkning av årslön',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        BefkodBen: {
          AttributeName: 'BefkodBen',
          DisplayLabel: 'Befattning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        SemesterErsBerakning: {
          AttributeName: 'SemesterErsBerakning',
          DisplayLabel: 'Beräkning av semesterersättning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        SarskErsBerakning: {
          AttributeName: 'SarskErsBerakning',
          DisplayLabel: 'Beräkning av särskild ersättning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        SocAvgBerakning: {
          AttributeName: 'SocAvgBerakning',
          DisplayLabel: 'Beräkning av avtalsenl soc avg',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        LonTotaltBerakning: {
          AttributeName: 'LonTotaltBerakning',
          DisplayLabel: 'Beräkning av total lönekostnad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        UPPRAKNINGSTYP: {
          AttributeName: 'UPPRAKNINGSTYP',
          DisplayLabel: 'Uppräkningstyp',
          Hint: 'Generell uppräkning/Individuell uppräkning',
          DataType: 'Enum',
          EnumValues: new Map([['GENERELL_UPPRAKNING', 'Generell uppräkning'], ['INDIVIDUELL_UPPRAKNING', 'Individuell uppräkning']]),
          EnumSortValues: new Map([['GENERELL_UPPRAKNING', 'G'], ['INDIVIDUELL_UPPRAKNING', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GENERELL_UPPRAKNING=Generell uppräkning;INDIVIDUELL_UPPRAKNING=Individuell uppräkning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        FASTSTALLD_ARSLON: {
          AttributeName: 'FASTSTALLD_ARSLON',
          DisplayLabel: 'Fastställd årslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_SEMERS: {
          AttributeName: 'FASTSTALLD_SEMERS',
          DisplayLabel: 'Fastställd semesterersättning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_SARSKERS: {
          AttributeName: 'FASTSTALLD_SARSKERS',
          DisplayLabel: 'Fastställd särskild ersättning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_AVTSOCAVG: {
          AttributeName: 'FASTSTALLD_AVTSOCAVG',
          DisplayLabel: 'Fastställd avt. soc. avgifter',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_TOT_LONEKOSTNAD: {
          AttributeName: 'FASTSTALLD_TOT_LONEKOSTNAD',
          DisplayLabel: 'Fastställd total lönekostnad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_ARSLON_TEXT: {
          AttributeName: 'FASTSTALLD_ARSLON_TEXT',
          DisplayLabel: 'Fastställd årslön, beräkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_SEMERS_TEXT: {
          AttributeName: 'FASTSTALLD_SEMERS_TEXT',
          DisplayLabel: 'Fastställd sem.ers, beräkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_SARSKERS_TEXT: {
          AttributeName: 'FASTSTALLD_SARSKERS_TEXT',
          DisplayLabel: 'Fastställd särsk ers, beräkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_AVTSOCAVG_TEXT: {
          AttributeName: 'FASTSTALLD_AVTSOCAVG_TEXT',
          DisplayLabel: 'Fastställd avt soc avg, beräkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FASTSTALLD_TOT_LONEKOSTNAD_TEXT: {
          AttributeName: 'FASTSTALLD_TOT_LONEKOSTNAD_TEXT',
          DisplayLabel: 'Fastställd tot lönekostn, beräkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Föreg arbetsbudget',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Budgetgrupp: {
          AttributeName: 'Budgetgrupp',
          DisplayLabel: 'Budgetgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SYSSELSATTNINGSGRAD_TYP: {
          AttributeName: 'SYSSELSATTNINGSGRAD_TYP',
          DisplayLabel: 'Sysselsättningsgrad, typ',
          Hint: 'Per år/Per månad',
          DataType: 'Enum',
          EnumValues: new Map([['PER_AR', 'Per år'], ['PER_MANAD', 'Per månad']]),
          EnumSortValues: new Map([['PER_AR', 'A'], ['PER_MANAD', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PER_AR=Per år;PER_MANAD=Per månad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_1: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_1',
          DisplayLabel: 'Sysselsättningsgrad, januari',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_2: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_2',
          DisplayLabel: 'Sysselsättningsgrad, februari',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_3: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_3',
          DisplayLabel: 'Sysselsättningsgrad, mars',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_4: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_4',
          DisplayLabel: 'Sysselsättningsgrad, april',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_5: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_5',
          DisplayLabel: 'Sysselsättningsgrad, maj',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_6: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_6',
          DisplayLabel: 'Sysselsättningsgrad, juni',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_7: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_7',
          DisplayLabel: 'Sysselsättningsgrad, juli',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_8: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_8',
          DisplayLabel: 'Sysselsättningsgrad, augusti',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_9: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_9',
          DisplayLabel: 'Sysselsättningsgrad, september',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_10: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_10',
          DisplayLabel: 'Sysselsättningsgrad, oktober',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_11: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_11',
          DisplayLabel: 'Sysselsättningsgrad, november',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        SYSSELSATTNINGSGRAD_PER_12: {
          AttributeName: 'SYSSELSATTNINGSGRAD_PER_12',
          DisplayLabel: 'Sysselsättningsgrad, december',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Sysselsättningsgrad',
        },
        GenomsnittligSysselsattningsgrad: {
          AttributeName: 'GenomsnittligSysselsattningsgrad',
          DisplayLabel: 'Genomsnittlig sysselsättningsgrad',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          AttributeGroup: 'Sysselsättningsgrad',
        },
        BUDGETGRUPP_ID: {
          AttributeName: 'BUDGETGRUPP_ID',
          DisplayLabel: 'Budgetgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATGARDAS: {
          AttributeName: 'ATGARDAS',
          DisplayLabel: 'Åtgärdas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LON_TYP_ANDRAD: {
          AttributeName: 'LON_TYP_ANDRAD',
          DisplayLabel: 'Lönetyp ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        HELTIDSLON_ANDRAD: {
          AttributeName: 'HELTIDSLON_ANDRAD',
          DisplayLabel: 'Heltidlön ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        SYSSELSATTNINGSGRAD_ANDRAD: {
          AttributeName: 'SYSSELSATTNINGSGRAD_ANDRAD',
          DisplayLabel: 'Sysselsättningsgrad ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        UPPEHALL_FAKTOR_ANDRAD: {
          AttributeName: 'UPPEHALL_FAKTOR_ANDRAD',
          DisplayLabel: 'Uppehållsfaktor ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          AttributeGroup: 'Övrigt',
        },
        ANST_MANAD_ANDRAD: {
          AttributeName: 'ANST_MANAD_ANDRAD',
          DisplayLabel: 'Anställningsmånad ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        SLUT_MANAD_ANDRAD: {
          AttributeName: 'SLUT_MANAD_ANDRAD',
          DisplayLabel: 'Slutmånad ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          AttributeGroup: 'Övrigt',
        },
        ANDRINGSLOGG: {
          AttributeName: 'ANDRINGSLOGG',
          DisplayLabel: 'Ändringslogg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        FgArslon: {
          AttributeName: 'FgArslon',
          DisplayLabel: 'Årslön, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg års budget',
        },
        FgSemesterErs: {
          AttributeName: 'FgSemesterErs',
          DisplayLabel: 'Semesterersättningar, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg års budget',
        },
        FgSarskErs: {
          AttributeName: 'FgSarskErs',
          DisplayLabel: 'Särskilda ersättningar, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg års budget',
        },
        FgSocAvg: {
          AttributeName: 'FgSocAvg',
          DisplayLabel: 'Sociala avg, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg års budget',
        },
        FgLonTotalt: {
          AttributeName: 'FgLonTotalt',
          DisplayLabel: 'Total lönekostnad, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg års budget',
        },
        FgArslonBerakning: {
          AttributeName: 'FgArslonBerakning',
          DisplayLabel: 'Beräkning av årslön, föreg år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Föreg års budget',
        },
        FgSemesterErsBerakning: {
          AttributeName: 'FgSemesterErsBerakning',
          DisplayLabel: 'Beräkning semesterers, föreg år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Föreg års budget',
        },
        FgSarskErsBerakning: {
          AttributeName: 'FgSarskErsBerakning',
          DisplayLabel: 'Beräkning särsk ers, föreg år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Föreg års budget',
        },
        FgSocAvgBerakning: {
          AttributeName: 'FgSocAvgBerakning',
          DisplayLabel: 'Beräkning soc avg, föreg år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Föreg års budget',
        },
        FgLonTotaltBerakning: {
          AttributeName: 'FgLonTotaltBerakning',
          DisplayLabel: 'Beräkning total lönekostn, föreg år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Föreg års budget',
        },
        JmfrPlanArslon: {
          AttributeName: 'JmfrPlanArslon',
          DisplayLabel: 'Årslön, jfmr planbudget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSemesterErs: {
          AttributeName: 'JmfrPlanSemesterErs',
          DisplayLabel: 'Semesterersättningar, jfmr planbudget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSarskErs: {
          AttributeName: 'JmfrPlanSarskErs',
          DisplayLabel: 'Särskilda ersättningar, jfmr planbudget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSocAvg: {
          AttributeName: 'JmfrPlanSocAvg',
          DisplayLabel: 'Sociala avg, jfmr planbudget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanLonTotalt: {
          AttributeName: 'JmfrPlanLonTotalt',
          DisplayLabel: 'Total lönekostnad, jfmr planbudget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanArslonBerakning: {
          AttributeName: 'JmfrPlanArslonBerakning',
          DisplayLabel: 'Beräkning av årslön, jfmr planbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSemesterErsBerakning: {
          AttributeName: 'JmfrPlanSemesterErsBerakning',
          DisplayLabel: 'Beräkning semesterers, jfmr planbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSarskErsBerakning: {
          AttributeName: 'JmfrPlanSarskErsBerakning',
          DisplayLabel: 'Beräkning särsk ers, jfmr planbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanSocAvgBerakning: {
          AttributeName: 'JmfrPlanSocAvgBerakning',
          DisplayLabel: 'Beräkning soc avg, jfmr planbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Jämför planbudget',
        },
        JmfrPlanLonTotaltBerakning: {
          AttributeName: 'JmfrPlanLonTotaltBerakning',
          DisplayLabel: 'Beräkning total lönekostn, jfmr planbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Jämför planbudget',
        },
        LonUtfallArslon: {
          AttributeName: 'LonUtfallArslon',
          DisplayLabel: 'Utfall lönesystem, årslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Utfall lönesystem',
        },
        LonUtfallSemesterErs: {
          AttributeName: 'LonUtfallSemesterErs',
          DisplayLabel: 'Utfall lönesystem, semesterers',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Utfall lönesystem',
        },
        LonUtfallSarskErs: {
          AttributeName: 'LonUtfallSarskErs',
          DisplayLabel: 'Utfall lönesystem, särskild ersättning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Utfall lönesystem',
        },
        LonUtfallSocAvg: {
          AttributeName: 'LonUtfallSocAvg',
          DisplayLabel: 'Utfall lönesystem, sociala avg',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Utfall lönesystem',
        },
        LonUtfallLonTotalt: {
          AttributeName: 'LonUtfallLonTotalt',
          DisplayLabel: 'Utfall lönesystem, total lönekostn',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Utfall lönesystem',
        },
        LonHittillsArslon: {
          AttributeName: 'LonHittillsArslon',
          DisplayLabel: 'Hittills lönesystem, årslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Hittills lönesystem',
        },
        LonHittillsSemesterErs: {
          AttributeName: 'LonHittillsSemesterErs',
          DisplayLabel: 'Hittills lönesystem, semesterers',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Hittills lönesystem',
        },
        LonHittillsSarskErs: {
          AttributeName: 'LonHittillsSarskErs',
          DisplayLabel: 'Hittills lönesystem, särsk ers',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Hittills lönesystem',
        },
        LonHittillsSocAvg: {
          AttributeName: 'LonHittillsSocAvg',
          DisplayLabel: 'Hittills lönesystem, soc avg',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Hittills lönesystem',
        },
        LonHittillsLonTotalt: {
          AttributeName: 'LonHittillsLonTotalt',
          DisplayLabel: 'Hittills lönesystem, total lönekostnad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Hittills lönesystem',
        },
        DELSTATUS: {
          AttributeName: 'DELSTATUS',
          DisplayLabel: 'Summerad årsbudget klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BudgLonekostnOkning: {
          AttributeName: 'BudgLonekostnOkning',
          DisplayLabel: 'Budgeterad lönekostnadsökning',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        FgBudgLonekostnOkning: {
          AttributeName: 'FgBudgLonekostnOkning',
          DisplayLabel: 'Budgeterad lönekostnadsökning, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
        },
        KostnadPersbudgetrad: {
          AttributeName: 'KostnadPersbudgetrad',
          DisplayLabel: 'Total lönekostnad',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          InterfaceType: 'ifNone',
        },
        LONEBIDRAG: {
          AttributeName: 'LONEBIDRAG',
          DisplayLabel: 'Lönebidrag',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FgLonebidrag: {
          AttributeName: 'FgLonebidrag',
          DisplayLabel: 'Lönebidrag, föreg år',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Föreg år',
        },
        JmfrplanLonebidrag: {
          AttributeName: 'JmfrplanLonebidrag',
          DisplayLabel: 'Lönebidrag, jmfr plan',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'Decimals="0";DisplayZeroAsBlank="Y"',
          AttributeGroup: 'Jämför planbudget',
        },
        MANUELL_FAP: {
          AttributeName: 'MANUELL_FAP',
          DisplayLabel: 'FÅP',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENLIGT_80_90_100: {
          AttributeName: 'ENLIGT_80_90_100',
          DisplayLabel: 'Budgeteras enl 80/90/100',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Komplett: {
          AttributeName: 'Komplett',
          DisplayLabel: 'Komplett',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SaknasForKomplett: {
          AttributeName: 'SaknasForKomplett',
          DisplayLabel: 'Saknade uppgifter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SarskErsInfo: {
          AttributeName: 'SarskErsInfo',
          DisplayLabel: 'Särskilda ersättningar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BefBenEllerTyp: {
          AttributeName: 'BefBenEllerTyp',
          DisplayLabel: 'Befattning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        PeriodbaseradSysselsattningsgrad: {
          AttributeName: 'PeriodbaseradSysselsattningsgrad',
          DisplayLabel: 'Periodbaserad sysselsättningsgrad',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        ErsatterExterntAnstnr: {
          AttributeName: 'ErsatterExterntAnstnr',
          DisplayLabel: 'Ersätter anställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ErsattsAvExterntAnstnr: {
          AttributeName: 'ErsattsAvExterntAnstnr',
          DisplayLabel: 'Ersatts av anställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ErsatterAnstalld: {
          AttributeName: 'ErsatterAnstalld',
          DisplayLabel: 'Ersätter personalpost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ErsattsAvAnstalld: {
          AttributeName: 'ErsattsAvAnstalld',
          DisplayLabel: 'Ersätts av personalpost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTERNT_ANSTNR_ANDRAD: {
          AttributeName: 'EXTERNT_ANSTNR_ANDRAD',
          DisplayLabel: 'Anställningsnr, ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avtalsomrade: {
          AssociationName: 'Avtalsomrade',
          DisplayLabel: 'Avtalsområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAvtalsOmrade',
          AssociatedComponentName: 'Avtalsomrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetgrupp: {
          AssociationName: 'Budgetgrupp',
          DisplayLabel: 'Budgetgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetBudgetgrupp',
          AssociatedComponentName: 'ArbetsbudgetBudgetgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Befattningskod: {
          AssociationName: 'Befattningskod',
          DisplayLabel: 'Befattningskod',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBefattningskod',
          AssociatedComponentName: 'Befattningskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonal',
          AssociatedComponentName: 'Personal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anstallda: {
          AssociationName: 'Anstallda',
          DisplayLabel: 'Anställda',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKArbetsbudgetAnstalld',
          AssociatedComponentName: 'ArbetsbudgetAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Lonkonto: {
          AssociationName: 'Lonkonto',
          DisplayLabel: 'Lönekonto',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetLonekonto',
          AssociatedComponentName: 'ArbetsbudgetLonekonto',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SarskErsattning: {
          AssociationName: 'SarskErsattning',
          DisplayLabel: 'SarskErsattning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgPersSarskErs',
          AssociatedComponentName: 'ArbetsbudgPersSarskErs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        FordelnPeriod: {
          AssociationName: 'FordelnPeriod',
          DisplayLabel: 'Fördelningsperioder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonalFordelnPeriod',
          AssociatedComponentName: 'ArbetsbudgetPersonalFordelnPeriod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetrader: {
          AssociationName: 'Budgetrader',
          DisplayLabel: 'Budgetrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonalbudgetrad',
          AssociatedComponentName: 'ArbetsbudgetPersonalbudgetrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgetPerBudggrupp: {
      CollectionName: 'EKArbetsbudgetPerBudggrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetPerBudggrupp',
        Abstract: false,
        SOLabel: 'Arbetsbudget personal, budgetgrupper',
        SOGLabel: 'Arbetsbudget personal, budgetgrupper',
        SBLabel: 'Arbetsbudget personal, budgetgrupper',
        SBGLabel: 'Arbetsbudget personal, budgetgrupper',
        POLabel: 'Arbetsbudget personal, budgetgrupper',
        POGLabel: 'Arbetsbudget personal, budgetgrupper',
        PBLabel: 'Arbetsbudget personal, budgetgrupper',
        PBGLabel: 'Arbetsbudget personal, budgetgrupper',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget personal, budgetgrupper primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget personal, budgetgrupper versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget personal, budgetgrupper fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetPersonalFordelnPeriod: {
      CollectionName: 'EKArbetsbudgetPersonalFordelnPeriod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetPersonalFordelnPeriod',
        Abstract: false,
        SOLabel: 'Arbetsbudget personal, fördelning period',
        SOGLabel: 'Arbetsbudget personal, fördelning period',
        SBLabel: 'Arbetsbudget personal, fördelning period',
        SBGLabel: 'Arbetsbudget personal, fördelning period',
        POLabel: 'Arbetsbudget personal, fördelning period',
        POGLabel: 'Arbetsbudget personal, fördelning period',
        PBLabel: 'Arbetsbudget personal, fördelning period',
        PBGLabel: 'Arbetsbudget personal, fördelning period',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget personal, fördelning period primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget personal, fördelning period versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget personal, fördelning period fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_PERIOD: {
          AttributeName: 'FROM_PERIOD',
          DisplayLabel: 'Period fr.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_PERIOD: {
          AttributeName: 'TOM_PERIOD',
          DisplayLabel: 'Period t.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PeriodIntervall: {
          AttributeName: 'PeriodIntervall',
          DisplayLabel: 'Periodintervall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TotalProcent: {
          AttributeName: 'TotalProcent',
          DisplayLabel: 'Totalt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        AVVIKANDE_SYSSELSATTNINGSGRAD: {
          AttributeName: 'AVVIKANDE_SYSSELSATTNINGSGRAD',
          DisplayLabel: 'Avvikande sysselsättningsgrad',
          Hint: 'Ska tas bort',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonal',
          AssociatedComponentName: 'ArbetsbudgetPersonal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Procent: {
          AssociationName: 'Procent',
          DisplayLabel: 'Procent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonalFordelnProcent',
          AssociatedComponentName: 'ArbetsbudgetPersonalFordelnProcent',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgetPersonalFordelnProcent: {
      CollectionName: 'EKArbetsbudgetPersonalFordelnProcent',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetPersonalFordelnProcent',
        Abstract: false,
        SOLabel: 'Arbetsbudget personal, fördelning procent',
        SOGLabel: 'Arbetsbudget personal, fördelning procent',
        SBLabel: 'Arbetsbudget personal, fördelning procent',
        SBGLabel: 'Arbetsbudget personal, fördelning procent',
        POLabel: 'Arbetsbudget personal, fördelning procent',
        POGLabel: 'Arbetsbudget personal, fördelning procent',
        PBLabel: 'Arbetsbudget personal, fördelning procent',
        PBGLabel: 'Arbetsbudget personal, fördelning procent',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget personal, fördelning procent primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget personal, fördelning procent versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget personal, fördelning procent fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSBUDGET_ID: {
          AttributeName: 'ARBETSBUDGET_ID',
          DisplayLabel: 'Id, arbetsbudget',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnummer 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Id, konto_1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnummer 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Id, konto_2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnummer 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Id, konto_3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnummer 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Id, konto_4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnummer 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Id, konto_5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnummer 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Id, konto_6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnummer 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Id, konto_7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnummer 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Id, konto_8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnummer 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Id, konto_9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnummer 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Id, konto_10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROCENTSATS: {
          AttributeName: 'PROCENTSATS',
          DisplayLabel: 'Procentsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y']]),
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Period: {
          AssociationName: 'Period',
          DisplayLabel: 'Period',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonalFordelnPeriod',
          AssociatedComponentName: 'ArbetsbudgetPersonalFordelnPeriod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKArbetsbudgetPersonalbudgetrad: {
      CollectionName: 'EKArbetsbudgetPersonalbudgetrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetPersonalbudgetrad',
        Abstract: false,
        SOLabel: 'Arbetsbudget personalbudgetrader',
        SOGLabel: 'Arbetsbudget personalbudgetrader',
        SBLabel: 'Arbetsbudget personalbudgetrader',
        SBGLabel: 'Arbetsbudget personalbudgetrader',
        POLabel: 'Arbetsbudget personalbudgetrader',
        POGLabel: 'Arbetsbudget personalbudgetrader',
        PBLabel: 'Arbetsbudget personalbudgetrader',
        PBGLabel: 'Arbetsbudget personalbudgetrader',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget personalbudgetrader primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget personalbudgetrader versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget personalbudgetrader fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_BOKF_PER: {
          AttributeName: 'FROM_BOKF_PER',
          DisplayLabel: 'Bokföring period fr.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_BOKF_PER: {
          AttributeName: 'TOM_BOKF_PER',
          DisplayLabel: 'Bokföring period t.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTERAD: {
          AttributeName: 'ATTESTERAD',
          DisplayLabel: 'Attesterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        ATTESTERAD_SIGNATUR: {
          AttributeName: 'ATTESTERAD_SIGNATUR',
          DisplayLabel: 'Attesterad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        ATTESTERAD_DATUM: {
          AttributeName: 'ATTESTERAD_DATUM',
          DisplayLabel: 'Attesterad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        KOSTNADSSLAG: {
          AttributeName: 'KOSTNADSSLAG',
          DisplayLabel: 'Kostnadsslag',
          Hint: 'Årslön/Semesterersättningar/Särskilda ersättningar/Arb.avg o avtalsenl soc avgifter/Lönebidrag',
          DataType: 'Enum',
          EnumValues: new Map([['ARSLON', 'Årslön'], ['SEMESTERERSATTNINGAR', 'Semesterersättningar'], ['SARSKILDA_ERSATTNINGAR', 'Särskilda ersättningar'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'Arb.avg o avtalsenl soc avgifter'], ['LONEBIDRAG', 'Lönebidrag']]),
          EnumSortValues: new Map([['ARSLON', 'ÅRSLÖN'], ['SEMESTERERSATTNINGAR', 'SEMERS'], ['SARSKILDA_ERSATTNINGAR', 'SÄRSKERS'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'SOCAVG'], ['LONEBIDRAG', 'LÖNEBIDRAG']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSLON=Årslön;SEMESTERERSATTNINGAR=Semesterersättningar;SARSKILDA_ERSATTNINGAR=Särskilda ersättningar;ARB_AVG_O_AVTALSENL_SOC_AVGIFTER=Arb.avg o avtalsenl soc avgifter;LONEBIDRAG=Lönebidrag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PersonalInfo: {
          AttributeName: 'PersonalInfo',
          DisplayLabel: 'Personalinfo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SYSSELSATTNINGSGRAD: {
          AttributeName: 'SYSSELSATTNINGSGRAD',
          DisplayLabel: 'Fördelad syssesättningsgrad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="3"',
          FormatterDisplayParams: 'Decimals="3";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERSGRUPP_KALKYLERAD: {
          AttributeName: 'PERSGRUPP_KALKYLERAD',
          DisplayLabel: 'Kalkylerad rad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        SOC_AVG_PROC: {
          AttributeName: 'SOC_AVG_PROC',
          DisplayLabel: 'Soc avg (%)',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERSGRUPP_KALK_FROM_KONTODEL: {
          AttributeName: 'PERSGRUPP_KALK_FROM_KONTODEL',
          DisplayLabel: 'Kalkylerad från kontodel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SRSK_ERS_FORDELNINGSTYP: {
          AttributeName: 'SRSK_ERS_FORDELNINGSTYP',
          DisplayLabel: 'Fördelningstyp',
          Hint: 'Fördelning/Kontosträng',
          DataType: 'Enum',
          EnumValues: new Map([['FORDELNING', 'Fördelning'], ['KONTOSTRANG', 'Kontosträng']]),
          EnumSortValues: new Map([['FORDELNING', 'F'], ['KONTOSTRANG', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORDELNING=Fördelning;KONTOSTRANG=Kontosträng"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonal',
          AssociatedComponentName: 'ArbetsbudgetPersonal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgetrad: {
      CollectionName: 'EKArbetsbudgetrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Arbetsbudgetrad',
        Abstract: false,
        SOLabel: 'Arbetsbudgetrad',
        SOGLabel: 'Arbetsbudgetrad',
        SBLabel: 'Arbetsbudgetrad',
        SBGLabel: 'Arbetsbudgetrad',
        POLabel: 'Arbetsbudgetrad',
        POGLabel: 'Arbetsbudgetrad',
        PBLabel: 'Arbetsbudgetrad',
        PBGLabel: 'Arbetsbudgetrad',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudgetrad primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudgetrad versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudgetrad fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ARS_LOPNR: {
          AttributeName: 'ARS_LOPNR',
          DisplayLabel: 'Löpnummer för årspost',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGETKURVA_ID: {
          AttributeName: 'BUDGETKURVA_ID',
          DisplayLabel: 'Budgetkurva',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVRUNDNINGSKOD: {
          AttributeName: 'AVRUNDNINGSKOD',
          DisplayLabel: 'Avrundningskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Ref löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FORDELNINGSTYP: {
          AttributeName: 'FORDELNINGSTYP',
          DisplayLabel: 'Fördelningstyp',
          Hint: 'Internfördelning/Fördelning/Ingående balanserat resultat',
          DataType: 'Enum',
          EnumValues: new Map([['INTERNFORDELNING', 'Internfördelning'], ['FORDELNING', 'Fördelning'], ['INGAENDE_BALANSERAT_RESULTAT', 'Ingående balanserat resultat']]),
          EnumSortValues: new Map([['INTERNFORDELNING', 'I'], ['FORDELNING', 'F'], ['INGAENDE_BALANSERAT_RESULTAT', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTERNFORDELNING=Internfördelning;FORDELNING=Fördelning;INGAENDE_BALANSERAT_RESULTAT=Ingående balanserat resultat"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Budgetkommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTERAD: {
          AttributeName: 'ATTESTERAD',
          DisplayLabel: 'Attesterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTERAD_SIGNATUR: {
          AttributeName: 'ATTESTERAD_SIGNATUR',
          DisplayLabel: 'Attesterad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTERAD_DATUM: {
          AttributeName: 'ATTESTERAD_DATUM',
          DisplayLabel: 'Attesterad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Underlagstyp: {
          AttributeName: 'Underlagstyp',
          DisplayLabel: 'Underlagstyp',
          Hint: 'Arbetsbudgetrad/Personalbudgetrad/Beraknad rad',
          DataType: 'Enum',
          EnumValues: new Map([['ARBETSBUDGETRAD', 'Arbetsbudgetrad'], ['PERSONALBUDGETRAD', 'Personalbudgetrad'], ['BERAKNAD_RAD', 'Beraknad rad']]),
          EnumSortValues: new Map([['ARBETSBUDGETRAD', 'A'], ['PERSONALBUDGETRAD', 'P'], ['BERAKNAD_RAD', 'B']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARBETSBUDGETRAD=Arbetsbudgetrad;PERSONALBUDGETRAD=Personalbudgetrad;BERAKNAD_RAD=Beraknad rad"',
        },
        Analyskolumn_1: {
          AttributeName: 'Analyskolumn_1',
          DisplayLabel: 'Analyskolumn_1',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Analyskolumn_2: {
          AttributeName: 'Analyskolumn_2',
          DisplayLabel: 'Analyskolumn_2',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Analyskolumn_3: {
          AttributeName: 'Analyskolumn_3',
          DisplayLabel: 'Analyskolumn_3',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FordeladFran: {
          AssociationName: 'FordeladFran',
          DisplayLabel: 'Fördelad från',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetrad',
          AssociatedComponentName: 'Arbetsbudgetrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgPersSarskErs: {
      CollectionName: 'EKArbetsbudgPersSarskErs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgPersSarskErs',
        Abstract: false,
        SOLabel: 'Arbetsbudget, särskild ersättning',
        SOGLabel: 'Arbetsbudget, särskild ersättning',
        SBLabel: 'Arbetsbudget, särskild ersättning',
        SBGLabel: 'Arbetsbudget, särskild ersättning',
        POLabel: 'Arbetsbudget, särskild ersättning',
        POGLabel: 'Arbetsbudget, särskild ersättning',
        PBLabel: 'Arbetsbudget, särskild ersättning',
        PBGLabel: 'Arbetsbudget, särskild ersättning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget, särskild ersättning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget, särskild ersättning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget, särskild ersättning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSBUDGET_ID: {
          AttributeName: 'ARBETSBUDGET_ID',
          DisplayLabel: 'Arbetsbudget, ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILLAGG_ID: {
          AttributeName: 'TILLAGG_ID',
          DisplayLabel: 'Särskild ersättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Lonekonto: {
          AttributeName: 'Lonekonto',
          DisplayLabel: 'Lönekonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELNINGSTYP: {
          AttributeName: 'FORDELNINGSTYP',
          DisplayLabel: 'Budgeteras enligt',
          Hint: 'Fördelning/F/Kontosträng/K',
          DataType: 'Enum',
          EnumValues: new Map([['FORDELNING', 'Fördelning'], ['F', 'F'], ['KONTOSTRANG', 'Kontosträng'], ['K', 'K']]),
          EnumSortValues: new Map([['FORDELNING', 'F'], ['F', 'F'], ['KONTOSTRANG', 'K'], ['K', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORDELNING=Fördelning;F=F;KONTOSTRANG=Kontosträng;K=K"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lonetillagg: {
          AssociationName: 'Lonetillagg',
          DisplayLabel: 'Särskild ersättning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKLonetillagg',
          AssociatedComponentName: 'Lonetillagg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKArbetsbudget: {
      CollectionName: 'EKArbetsbudget',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,15006']]),
      RootType: {
        TypeValue: 'Arbetsbudget',
        Abstract: false,
        SOLabel: 'Arbetsbudget',
        SOGLabel: 'Arbetsbudgets',
        SBLabel: 'Arbetsbudgeten',
        SBGLabel: 'Arbetsbudgetens',
        POLabel: 'Arbetsbudgetar',
        POGLabel: 'Arbetsbudgetars',
        PBLabel: 'Arbetsbudgetarna',
        PBGLabel: 'Arbetsbudgetarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudgetens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudgetens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetsbudgetens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudgetens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Id, kategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BokfarBudget2: {
          AttributeName: 'BokfarBudget2',
          DisplayLabel: 'Arbetsbudget - år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Bokförd/Påbörjad',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORD', 'Bokförd'], ['PABORJAD', 'Påbörjad']]),
          EnumSortValues: new Map([['BOKFORD', 'B'], ['PABORJAD', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORD=Bokförd;PABORJAD=Påbörjad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DebetSumma: {
          AttributeName: 'DebetSumma',
          DisplayLabel: 'DebetSumma',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KreditSumma: {
          AttributeName: 'KreditSumma',
          DisplayLabel: 'KreditSumma',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        FRAN_ARBETSBUDGET_ID: {
          AttributeName: 'FRAN_ARBETSBUDGET_ID',
          DisplayLabel: 'Jämför med arbetsbudget, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfarBudget: {
          AttributeName: 'BokfarBudget',
          DisplayLabel: 'Arbetsbudget - år',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JMFR_PLAN_ARBETSBUDGET_ID: {
          AttributeName: 'JMFR_PLAN_ARBETSBUDGET_ID',
          DisplayLabel: 'Jmfr med planbudget',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kategori: {
          AssociationName: 'Kategori',
          DisplayLabel: 'Kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetkategori',
          AssociatedComponentName: 'Budgetkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FranArbetsbudget: {
          AssociationName: 'FranArbetsbudget',
          DisplayLabel: 'Jämför med arbetsbudget',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        JmfrPlanbudget: {
          AssociationName: 'JmfrPlanbudget',
          DisplayLabel: 'Jämför med plandbudget',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetgrupper: {
          AssociationName: 'Budgetgrupper',
          DisplayLabel: 'Budgetgrupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetBudgetgrupp',
          AssociatedComponentName: 'ArbetsbudgetBudgetgrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonal',
          AssociatedComponentName: 'ArbetsbudgetPersonal',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetrader: {
          AssociationName: 'Budgetrader',
          DisplayLabel: 'Budgetrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetrad',
          AssociatedComponentName: 'Arbetsbudgetrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Personalbudgetrader: {
          AssociationName: 'Personalbudgetrader',
          DisplayLabel: 'Personalbudgetrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonalbudgetrad',
          AssociatedComponentName: 'ArbetsbudgetPersonalbudgetrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Palagg: {
          AssociationName: 'Palagg',
          DisplayLabel: 'Avtalsenl soc avg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPalagg',
          AssociatedComponentName: 'Palagg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAutomatkontGiltighet: {
      CollectionName: 'EKAutomatkontGiltighet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AutomatkontGiltighet',
        Abstract: false,
        SOLabel: 'Automatkontering, giltighet',
        SOGLabel: 'Automatkontering, giltighet',
        SBLabel: 'Automatkontering, giltigheten',
        SBGLabel: 'Automatkontering, giltigheten',
        POLabel: 'Automatkontering, giltigheter',
        POGLabel: 'Automatkontering, giltigheter',
        PBLabel: 'Automatkontering, giltigheterna',
        PBGLabel: 'Automatkontering, giltigheterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Automatkontering, giltigheten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Automatkontering, giltigheten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Automatkontering, giltigheten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Automatkontering, giltigheten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_BOKFDATUM: {
          AttributeName: 'FROM_BOKFDATUM',
          DisplayLabel: 'Fr o m bokf.datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TOM_BOKFDATUM: {
          AttributeName: 'TOM_BOKFDATUM',
          DisplayLabel: 'T o m bokf.datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'Registrerad av användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Giltighetstid: {
          AttributeName: 'Giltighetstid',
          DisplayLabel: 'Giltighetstid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SummaProcent: {
          AttributeName: 'SummaProcent',
          DisplayLabel: 'Summa fördelad procent',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        FORDELN_RAPPORT_ID: {
          AttributeName: 'FORDELN_RAPPORT_ID',
          DisplayLabel: 'Fördelningsrapport_id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_RAPPORT_IDKOD: {
          AttributeName: 'FORDELN_RAPPORT_IDKOD',
          DisplayLabel: 'Fördelningsrapport, idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FordelningsRapportBenamning: {
          AttributeName: 'FordelningsRapportBenamning',
          DisplayLabel: 'Fördelningsrapport, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        EXKLUDERA_BASKONTON: {
          AttributeName: 'EXKLUDERA_BASKONTON',
          DisplayLabel: 'Exkludera baskonton från utlösande rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Automatkontering: {
          AssociationName: 'Automatkontering',
          DisplayLabel: 'Automatkontering',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'Automatkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fordelnrapport: {
          AssociationName: 'Fordelnrapport',
          DisplayLabel: 'Fördelningsrapport',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkontUrval',
          AssociatedComponentName: 'AutomatkontUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Mall: {
          AssociationName: 'Mall',
          DisplayLabel: 'Mall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkontMall',
          AssociatedComponentName: 'AutomatkontMall',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        OmfordelningLogg: {
          AssociationName: 'OmfordelningLogg',
          DisplayLabel: 'Logg, omfördelning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKOmfordelningLogg',
          AssociatedComponentName: 'OmfordelningLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAutomatkontMall: {
      CollectionName: 'EKAutomatkontMall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AutomatkontMall',
        Abstract: false,
        SOLabel: 'Automatkontering, mall',
        SOGLabel: 'Automatkontering, mall',
        SBLabel: 'Automatkontering, mallen',
        SBGLabel: 'Automatkontering, mallen',
        POLabel: 'Automatkontering, mallar',
        POGLabel: 'Automatkontering, mallar',
        PBLabel: 'Automatkontering, mallarna',
        PBGLabel: 'Automatkontering, mallarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Automatkontering, mallen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Automatkontering, mallen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Automatkontering, mallen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Automatkontering, mallen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: 'Kontodel 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: 'Kontodel 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: 'Kontodel 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: 'Kontodel 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: 'Kontodel 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: 'Kontodel 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: 'Kontodel 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: 'Kontodel 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: 'Kontodel 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: 'Kontodel 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PROCENTSATS: {
          AttributeName: 'PROCENTSATS',
          DisplayLabel: 'Procentsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MOTKONTODEL_1: {
          AttributeName: 'MOTKONTODEL_1',
          DisplayLabel: 'Motkontodel 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_2: {
          AttributeName: 'MOTKONTODEL_2',
          DisplayLabel: 'Motkontodel 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_3: {
          AttributeName: 'MOTKONTODEL_3',
          DisplayLabel: 'Motkontodel 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_4: {
          AttributeName: 'MOTKONTODEL_4',
          DisplayLabel: 'Motkontodel 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_5: {
          AttributeName: 'MOTKONTODEL_5',
          DisplayLabel: 'Motkontodel 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_6: {
          AttributeName: 'MOTKONTODEL_6',
          DisplayLabel: 'Motkontodel 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_7: {
          AttributeName: 'MOTKONTODEL_7',
          DisplayLabel: 'Motkontodel 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_8: {
          AttributeName: 'MOTKONTODEL_8',
          DisplayLabel: 'Motkontodel 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_9: {
          AttributeName: 'MOTKONTODEL_9',
          DisplayLabel: 'Motkontodel 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOTKONTODEL_10: {
          AttributeName: 'MOTKONTODEL_10',
          DisplayLabel: 'Motkontodel 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AUTOMATKONTERA_VIDARE: {
          AttributeName: 'AUTOMATKONTERA_VIDARE',
          DisplayLabel: 'Automatkontera vidare',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
        },
        FORDELN_RAPPORT_ID: {
          AttributeName: 'FORDELN_RAPPORT_ID',
          DisplayLabel: 'Fördelnrapport, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_DIMENSION: {
          AttributeName: 'FORDELN_DIMENSION',
          DisplayLabel: 'Fördelnrapport, dimension',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_LOPNR: {
          AttributeName: 'FORDELN_LOPNR',
          DisplayLabel: 'Fördelnrapport, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rapportrad: {
          AttributeName: 'Rapportrad',
          DisplayLabel: 'Rapportrad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RapportradRadnr: {
          AttributeName: 'RapportradRadnr',
          DisplayLabel: 'Radnr i rapport',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RADTYP: {
          AttributeName: 'RADTYP',
          DisplayLabel: 'Radtyp',
          Hint: 'Utgående moms/Omsättningskonto, med momskod/Korrektivkonto, utan momskod/Ingående moms',
          DataType: 'Enum',
          EnumValues: new Map([['UTGAENDE_MOMS', 'Utgående moms'], ['OMSATTNINGSKONTO__MED_MOMSKOD', 'Omsättningskonto, med momskod'], ['KORREKTIVKONTO__UTAN_MOMSKOD', 'Korrektivkonto, utan momskod'], ['INGAENDE_MOMS', 'Ingående moms']]),
          EnumSortValues: new Map([['UTGAENDE_MOMS', '1'], ['OMSATTNINGSKONTO__MED_MOMSKOD', '2'], ['KORREKTIVKONTO__UTAN_MOMSKOD', '3'], ['INGAENDE_MOMS', '4']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTGAENDE_MOMS=Utgående moms;OMSATTNINGSKONTO__MED_MOMSKOD=Omsättningskonto, med momskod;KORREKTIVKONTO__UTAN_MOMSKOD=Korrektivkonto, utan momskod;INGAENDE_MOMS=Ingående moms"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_RAPPORT_IDKOD_LOPNR: {
          AttributeName: 'FORDELN_RAPPORT_IDKOD_LOPNR',
          DisplayLabel: 'Fördelningsrapport, radnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Giltighet: {
          AssociationName: 'Giltighet',
          DisplayLabel: 'Giltighet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAutomatkontGiltighet',
          AssociatedComponentName: 'AutomatkontGiltighet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapportrad: {
          AssociationName: 'Rapportrad',
          DisplayLabel: 'Fördelas enligt rad',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKDimensionsrad',
          AssociatedComponentName: 'Dimensionsrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAutomatkontUrval: {
      CollectionName: 'EKAutomatkontUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AutomatkontUrval',
        Abstract: false,
        SOLabel: 'Automatkontering, urval',
        SOGLabel: 'Automatkontering, urval',
        SBLabel: 'Automatkontering, urvalet',
        SBGLabel: 'Automatkontering, urvalet',
        POLabel: 'Automatkontering, urval',
        POGLabel: 'Automatkontering, urval',
        PBLabel: 'Automatkontering, urvalen',
        PBGLabel: 'Automatkontering, urvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Automatkontering, urvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Automatkontering, urvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Automatkontering, urvalet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Automatkontering, urvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_KONTODEL_1: {
          AttributeName: 'FROM_KONTODEL_1',
          DisplayLabel: 'Fr o m kontodel 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_1: {
          AttributeName: 'TOM_KONTODEL_1',
          DisplayLabel: 'T o m kontodel 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_2: {
          AttributeName: 'FROM_KONTODEL_2',
          DisplayLabel: 'Fr o m kontodel 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_2: {
          AttributeName: 'TOM_KONTODEL_2',
          DisplayLabel: 'T o m kontodel 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_3: {
          AttributeName: 'FROM_KONTODEL_3',
          DisplayLabel: 'Fr o m kontodel 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_3: {
          AttributeName: 'TOM_KONTODEL_3',
          DisplayLabel: 'T o m kontodel 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_4: {
          AttributeName: 'FROM_KONTODEL_4',
          DisplayLabel: 'Fr o m kontodel 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_4: {
          AttributeName: 'TOM_KONTODEL_4',
          DisplayLabel: 'T o m kontodel 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_5: {
          AttributeName: 'FROM_KONTODEL_5',
          DisplayLabel: 'Fr o m kontodel 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_5: {
          AttributeName: 'TOM_KONTODEL_5',
          DisplayLabel: 'T o m kontodel 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_6: {
          AttributeName: 'FROM_KONTODEL_6',
          DisplayLabel: 'Fr o m kontodel 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_6: {
          AttributeName: 'TOM_KONTODEL_6',
          DisplayLabel: 'T o m kontodel 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_7: {
          AttributeName: 'FROM_KONTODEL_7',
          DisplayLabel: 'Fr o m kontodel 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_7: {
          AttributeName: 'TOM_KONTODEL_7',
          DisplayLabel: 'T o m kontodel 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_KONTODEL_8: {
          AttributeName: 'FROM_KONTODEL_8',
          DisplayLabel: 'Fr o m kontodel 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_8: {
          AttributeName: 'TOM_KONTODEL_8',
          DisplayLabel: 'T o m kontodel 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_9: {
          AttributeName: 'FROM_KONTODEL_9',
          DisplayLabel: 'Fr o m kontodel 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_9: {
          AttributeName: 'TOM_KONTODEL_9',
          DisplayLabel: 'T o m kontodel 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FROM_KONTODEL_10: {
          AttributeName: 'FROM_KONTODEL_10',
          DisplayLabel: 'Fr o m kontodel 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL_10: {
          AttributeName: 'TOM_KONTODEL_10',
          DisplayLabel: 'T o m kontodel 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Giltighet: {
          AssociationName: 'Giltighet',
          DisplayLabel: 'Giltighet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAutomatkontGiltighet',
          AssociatedComponentName: 'AutomatkontGiltighet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAutomatkonteringar: {
      CollectionName: 'EKAutomatkonteringar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2009'], ['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'Automatkontering',
        Abstract: true,
        SOLabel: 'Automatkontering',
        SOGLabel: 'Automatkontering',
        SBLabel: 'Automatkonteringen',
        SBGLabel: 'Automatkonteringen',
        POLabel: 'Automatkonteringar',
        POGLabel: 'Automatkonteringar',
        PBLabel: 'Automatkonteringarna',
        PBGLabel: 'Automatkonteringarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'SaldoAutomatkontering',
            Abstract: false,
            SOLabel: 'Omfördelning',
            SOGLabel: 'Omfördelnings',
            SBLabel: 'Omfördelningen',
            SBGLabel: 'Omfördelningens',
            POLabel: 'Omfördelningar',
            POGLabel: 'Omfördelningars',
            PBLabel: 'Omfördelningarna',
            PBGLabel: 'Omfördelningarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'TransaktionAutomatkontering',
            Abstract: false,
            SOLabel: 'Automatkontering',
            SOGLabel: 'Automatkonterings',
            SBLabel: 'Automatkonteringen',
            SBGLabel: 'Automatkonteringens',
            POLabel: 'Automatkonteringar',
            POGLabel: 'Automatkonteringars',
            PBLabel: 'Automatkonteringarna',
            PBGLabel: 'Automatkonteringarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'FordelningsmallAutomatkontering',
            Abstract: false,
            SOLabel: 'Fördelningsmall',
            SOGLabel: 'Fördelningsmalls',
            SBLabel: 'Fördelningsmallen',
            SBGLabel: 'Fördelningsmallens',
            POLabel: 'Fördelningsmallar',
            POGLabel: 'Fördelningsmallars',
            PBLabel: 'Fördelningsmallarna',
            PBGLabel: 'Fördelningsmallarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'UtlandskMomsAutomatkontering',
            Abstract: false,
            SOLabel: 'Mallar för Utlänsk moms',
            SOGLabel: 'Mallar för Utlänsk moms',
            SBLabel: 'Mallar för Utlänsk moms',
            SBGLabel: 'Mallar för Utlänsk moms',
            POLabel: 'Mallar för Utlänsk moms',
            POGLabel: 'Mallar för Utlänsk moms',
            PBLabel: 'Mallar för Utlänsk moms',
            PBGLabel: 'Mallar för Utlänsk moms',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'InternfordelningAutomatkontering',
            Abstract: false,
            SOLabel: 'Internfördelning, särredovisning',
            SOGLabel: 'Internfördelning, särredovisning',
            SBLabel: 'Internfördelning, särredovisning',
            SBGLabel: 'Internfördelning, särredovisning',
            POLabel: 'Internfördelning, särredovisning',
            POGLabel: 'Internfördelning, särredovisning',
            PBLabel: 'Internfördelning, särredovisning',
            PBGLabel: 'Internfördelning, särredovisning',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Automatkonteringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Automatkonteringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['SALDOAUTOMATKONTERING', 'Omfördelning'], ['TRANSAKTIONAUTOMATKONTERING', 'Automatkontering'], ['FORDELNINGSMALLAUTOMATKONTERING', 'Fördelningsmall'], ['UTLANDSKMOMSAUTOMATKONTERING', 'Mallar för Utlänsk moms'], ['INTERNFORDELNINGAUTOMATKONTERING', 'Internfördelning, särredovisning']]),
          EnumSortValues: new Map([['SALDOAUTOMATKONTERING', 'S'], ['TRANSAKTIONAUTOMATKONTERING', 'T'], ['FORDELNINGSMALLAUTOMATKONTERING', 'F'], ['UTLANDSKMOMSAUTOMATKONTERING', 'U'], ['INTERNFORDELNINGAUTOMATKONTERING', 'I']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Automatkonteringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Automatkonteringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 70,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Bokfört värde/Budget',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORT_VARDE', 'Bokfört värde'], ['BUDGET', 'Budget']]),
          EnumSortValues: new Map([['BOKFORT_VARDE', 'S'], ['BUDGET', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORT_VARDE=Bokfört värde;BUDGET=Budget"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        PRIORITERING: {
          AttributeName: 'PRIORITERING',
          DisplayLabel: 'Prioritering',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Automatkonteringstyp: {
          AttributeName: 'Automatkonteringstyp',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KortTyp: {
          AttributeName: 'KortTyp',
          DisplayLabel: 'Kort typbenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        GiltigPerDatum: {
          AttributeName: 'GiltigPerDatum',
          DisplayLabel: 'Giltighetstid inom',
          DataType: 'DateTime',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.interval,
        },
        SALDO_FORDELA: {
          AttributeName: 'SALDO_FORDELA',
          DisplayLabel: 'Fördela',
          Hint: 'Hittills i år/Aktuel bokf.period',
          DataType: 'Enum',
          EnumValues: new Map([['HITTILLS_I_AR', 'Hittills i år'], ['AKTUEL_BOKF_PERIOD', 'Aktuel bokf.period']]),
          EnumSortValues: new Map([['HITTILLS_I_AR', 'Å'], ['AKTUEL_BOKF_PERIOD', 'P']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HITTILLS_I_AR=Hittills i år;AKTUEL_BOKF_PERIOD=Aktuel bokf.period"',
          GUIEditable: true,
        },
        HUNDRA_PROCENT: {
          AttributeName: 'HUNDRA_PROCENT',
          DisplayLabel: 'Fördela alltid 100 %',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          ValidInComps: ['SaldoAutomatkontering'],
        },
        FORDELNINGSTYP: {
          AttributeName: 'FORDELNINGSTYP',
          DisplayLabel: 'Fördelningstyp',
          Hint: 'Fördelning/Pålägg',
          DataType: 'Enum',
          EnumValues: new Map([['FORDELNING', 'Fördelning'], ['PALAGG', 'Pålägg']]),
          EnumSortValues: new Map([['FORDELNING', 'F'], ['PALAGG', 'P']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORDELNING=Fördelning;PALAGG=Pålägg"',
          GUIEditable: true,
          ValidInComps: ['TransaktionAutomatkontering'],
        },
        KPLAN_KONV_ID: {
          AttributeName: 'KPLAN_KONV_ID',
          DisplayLabel: 'Konv id vid kplanbyte',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gas',
        },
        FORDELN_MALL_AVSKR: {
          AttributeName: 'FORDELN_MALL_AVSKR',
          DisplayLabel: 'Gäller för avskrivningar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORDELN_MALL_INTRANTA: {
          AttributeName: 'FORDELN_MALL_INTRANTA',
          DisplayLabel: 'Gäller för internränta',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Standard: {
          AttributeName: 'Standard',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        UTL_MOMS_SATS: {
          AttributeName: 'UTL_MOMS_SATS',
          DisplayLabel: 'Utländsk momssats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['UtlandskMomsAutomatkontering'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Giltighet: {
          AssociationName: 'Giltighet',
          DisplayLabel: 'Giltighet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkontGiltighet',
          AssociatedComponentName: 'AutomatkontGiltighet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg över omfördelningar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKOmfordelningLogg',
          AssociatedComponentName: 'OmfordelningLogg',
          JoinAssociation: false,
          ValidInComps: ['SaldoAutomatkontering'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAvdragsratt: {
      CollectionName: 'EKAvdragsratt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Avdragsratt',
        Abstract: false,
        SOLabel: 'Avdragsrätt',
        SOGLabel: 'Avdragsrätts',
        SBLabel: 'Avdragsrätten',
        SBGLabel: 'Avdragsrättens',
        POLabel: 'Avdragsrätter',
        POGLabel: 'Avdragsrätters',
        PBLabel: 'Avdragsrätterna',
        PBGLabel: 'Avdragsrätternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avdragsrättens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avdragsrättens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avdragsrättens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN: {
          AttributeName: 'FRAN',
          DisplayLabel: 'Avdragsrätt, från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILL: {
          AttributeName: 'TILL',
          DisplayLabel: 'Avdragsrätt, till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PROCENT: {
          AttributeName: 'PROCENT',
          DisplayLabel: 'Procent',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterValidateParams: 'MinValue="0";MaxValue="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Koddel: {
          AssociationName: 'Koddel',
          DisplayLabel: 'Koddel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPalagg: {
      CollectionName: 'EKPalagg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Palagg',
        Abstract: false,
        SOLabel: 'Avtalsenliga sociala avgifter',
        SOGLabel: 'Avtalsenliga sociala avgifter',
        SBLabel: 'Avtalsenliga sociala avgifter',
        SBGLabel: 'Avtalsenliga sociala avgifter',
        POLabel: 'Avtalsenliga sociala avgifter',
        POGLabel: 'Avtalsenliga sociala avgifter',
        PBLabel: 'Avtalsenliga sociala avgifter',
        PBGLabel: 'Avtalsenliga sociala avgifter',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avtalsenliga sociala avgifter primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avtalsenliga sociala avgifter versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Avtalsenliga sociala avgifter id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avtalsenliga sociala avgifter fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        PROCENTSATS: {
          AttributeName: 'PROCENTSATS',
          DisplayLabel: 'Procentsats',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        FODELSE_FROM_AR: {
          AttributeName: 'FODELSE_FROM_AR',
          DisplayLabel: 'Födelseår fr.o.m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FODELSE_TOM_AR: {
          AttributeName: 'FODELSE_TOM_AR',
          DisplayLabel: 'Födelseår t.o.m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVTALSOMRADE: {
          AttributeName: 'AVTALSOMRADE',
          DisplayLabel: 'Avtalsområde',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SARSKILD_LONESKATT: {
          AttributeName: 'SARSKILD_LONESKATT',
          DisplayLabel: 'Särskild löneskatt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOSTNADSKONTO: {
          AttributeName: 'KOSTNADSKONTO',
          DisplayLabel: 'Kostnadskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKULDKONTO: {
          AttributeName: 'SKULDKONTO',
          DisplayLabel: 'Skuldkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEARTER: {
          AttributeName: 'LONEARTER',
          DisplayLabel: 'Lönearter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_LONESYSTEM: {
          AttributeName: 'FRAN_LONESYSTEM',
          DisplayLabel: 'Från Lönesystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LONEKONTO_ORDNINGS_NR: {
          AttributeName: 'LONEKONTO_ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr, lönekonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LONEKONTO_KONTO_ID: {
          AttributeName: 'LONEKONTO_KONTO_ID',
          DisplayLabel: 'Id, lönekonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SARSK_ORDNINGS_NR: {
          AttributeName: 'SARSK_ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr, sarsk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SARSK_KONTO_ID: {
          AttributeName: 'SARSK_KONTO_ID',
          DisplayLabel: 'Id, sarsk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVAND_TAKBELOPP: {
          AttributeName: 'ANVAND_TAKBELOPP',
          DisplayLabel: 'Använd takbelopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Lonekonto: {
          AssociationName: 'Lonekonto',
          DisplayLabel: 'Lönekonto',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SarskKonto: {
          AssociationName: 'SarskKonto',
          DisplayLabel: 'Lönekonto, särsk ers',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAvtalsOmrade: {
      CollectionName: 'EKAvtalsOmrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2042']]),
      RootType: {
        TypeValue: 'AvtalsOmrade',
        Abstract: false,
        SOLabel: 'Avtalsområde',
        SOGLabel: 'Avtalsområdes',
        SBLabel: 'Avtalsområden',
        SBGLabel: 'Avtalsområdens',
        POLabel: 'Avtalsområden',
        POGLabel: 'Avtalsområdens',
        PBLabel: 'Avtalsområderna',
        PBGLabel: 'Avtalsområdernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avtalsområdens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avtalsområdens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Avtalsområdens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avtalsområdens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBefattningskod: {
      CollectionName: 'EKBefattningskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2041']]),
      RootType: {
        TypeValue: 'Befattningskod',
        Abstract: false,
        SOLabel: 'Befattningskod',
        SOGLabel: 'Befattningskods',
        SBLabel: 'Befattningskoden',
        SBGLabel: 'Befattningskodens',
        POLabel: 'Befattningskoder',
        POGLabel: 'Befattningskoders',
        PBLabel: 'Befattningskoderna',
        PBGLabel: 'Befattningskodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Befattningskodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Befattningskodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Befattningskodens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Befattningskodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'BSF-kod/BKSK-kod',
          DataType: 'Enum',
          EnumValues: new Map([['BSF_KOD', 'BSF-kod'], ['BKSK_KOD', 'BKSK-kod']]),
          EnumSortValues: new Map([['BSF_KOD', '1'], ['BKSK_KOD', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BSF_KOD=BSF-kod;BKSK_KOD=BKSK-kod"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_FROM: {
          AttributeName: 'GILTIG_FROM',
          DisplayLabel: 'Giltig, fr o m',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        GILTIG_TOM: {
          AttributeName: 'GILTIG_TOM',
          DisplayLabel: 'Giltig, t o m',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        GiltigIIntervall: {
          AttributeName: 'GiltigIIntervall',
          DisplayLabel: 'Giltig i intervall',
          DataType: 'DateTime',
          Attribute: 'None',
          Condition: 'Internal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKOBBokfFil: {
      CollectionName: 'EKKOBBokfFil',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBBokfFil',
        Abstract: false,
        SOLabel: 'Bokföringsfil',
        SOGLabel: 'Bokföringsfil',
        SBLabel: 'Bokföringsfilen',
        SBGLabel: 'Bokföringsfilens',
        POLabel: 'Bokföringsfiler',
        POGLabel: 'Bokföringsfilers',
        PBLabel: 'Bokföringsfilerna',
        PBGLabel: 'Bokföringsfilernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsfilens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsfilens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsfilens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOBID: {
          AttributeName: 'KOBID',
          DisplayLabel: 'KOB id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BETALNINGSDATUM: {
          AttributeName: 'BETALNINGSDATUM',
          DisplayLabel: 'Betalningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        ORGNR: {
          AttributeName: 'ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'Enhets-id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENHETSNAMN: {
          AttributeName: 'ENHETSNAMN',
          DisplayLabel: 'Enhetsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INLAST_DATUM: {
          AttributeName: 'INLAST_DATUM',
          DisplayLabel: 'Inläst datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INLAST_SIGNATUR: {
          AttributeName: 'INLAST_SIGNATUR',
          DisplayLabel: 'Inläst sign',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMMUNIKATIONSFIL_ID: {
          AttributeName: 'KOMMUNIKATIONSFIL_ID',
          DisplayLabel: 'Kommunikationsfil, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Inläst/Hanterad/Komplettera transaktionstyper/Komplettera KOB-konto/Komplettera bokföringsgrupp/Felaktig/Backad/Bokföringsperiod låst/Bokföringsperiod saknas/Bokföringsår saknas/Journalnummerserie saknas/Verifikationsnummerserie saknas/Bokföringsordernummerserie saknas',
          DataType: 'Enum',
          EnumValues: new Map([['INLAST', 'Inläst'], ['HANTERAD', 'Hanterad'], ['KOMPLETTERA_TRANSAKTIONSTYPER', 'Komplettera transaktionstyper'], ['KOMPLETTERA_KOB_KONTO', 'Komplettera KOB-konto'], ['KOMPLETTERA_BOKFORINGSGRUPP', 'Komplettera bokföringsgrupp'], ['FELAKTIG', 'Felaktig'], ['BACKAD', 'Backad'], ['BOKFORINGSPERIOD_LAST', 'Bokföringsperiod låst'], ['BOKFORINGSPERIOD_SAKNAS', 'Bokföringsperiod saknas'], ['BOKFORINGSAR_SAKNAS', 'Bokföringsår saknas'], ['JOURNALNUMMERSERIE_SAKNAS', 'Journalnummerserie saknas'], ['VERIFIKATIONSNUMMERSERIE_SAKNAS', 'Verifikationsnummerserie saknas'], ['BOKFORINGSORDERNUMMERSERIE_SAKNAS', 'Bokföringsordernummerserie saknas']]),
          EnumSortValues: new Map([['INLAST', 'I'], ['HANTERAD', 'H'], ['KOMPLETTERA_TRANSAKTIONSTYPER', 'T'], ['KOMPLETTERA_KOB_KONTO', 'K'], ['KOMPLETTERA_BOKFORINGSGRUPP', 'G'], ['FELAKTIG', 'F'], ['BACKAD', 'B'], ['BOKFORINGSPERIOD_LAST', 'P'], ['BOKFORINGSPERIOD_SAKNAS', 'A'], ['BOKFORINGSAR_SAKNAS', 'C'], ['JOURNALNUMMERSERIE_SAKNAS', 'J'], ['VERIFIKATIONSNUMMERSERIE_SAKNAS', 'V'], ['BOKFORINGSORDERNUMMERSERIE_SAKNAS', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INLAST=Inläst;HANTERAD=Hanterad;KOMPLETTERA_TRANSAKTIONSTYPER=Komplettera transaktionstyper;KOMPLETTERA_KOB_KONTO=Komplettera KOB-konto;KOMPLETTERA_BOKFORINGSGRUPP=Komplettera bokföringsgrupp;FELAKTIG=Felaktig;BACKAD=Backad;BOKFORINGSPERIOD_LAST=Bokföringsperiod låst;BOKFORINGSPERIOD_SAKNAS=Bokföringsperiod saknas;BOKFORINGSAR_SAKNAS=Bokföringsår saknas;JOURNALNUMMERSERIE_SAKNAS=Journalnummerserie saknas;VERIFIKATIONSNUMMERSERIE_SAKNAS=Verifikationsnummerserie saknas;BOKFORINGSORDERNUMMERSERIE_SAKNAS=Bokföringsordernummerserie saknas"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BokfStatus: {
          AttributeName: 'BokfStatus',
          DisplayLabel: 'Bokföringsstatus',
          Hint: 'Inläst/Verifikation skapad/Bokföringsorder skapad/Felaktig',
          DataType: 'Enum',
          EnumValues: new Map([['INLAST', 'Inläst'], ['VERIFIKATION_SKAPAD', 'Verifikation skapad'], ['BOKFORINGSORDER_SKAPAD', 'Bokföringsorder skapad'], ['FELAKTIG', 'Felaktig']]),
          EnumSortValues: new Map([['INLAST', 'I'], ['VERIFIKATION_SKAPAD', 'V'], ['BOKFORINGSORDER_SKAPAD', 'B'], ['FELAKTIG', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INLAST=Inläst;VERIFIKATION_SKAPAD=Verifikation skapad;BOKFORINGSORDER_SKAPAD=Bokföringsorder skapad;FELAKTIG=Felaktig"',
          InterfaceType: 'ifNone',
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rad: {
          AssociationName: 'Rad',
          DisplayLabel: 'Rad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBBokfFilRad',
          AssociatedComponentName: 'KOBBokfFilRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKKOBBokfFilRad: {
      CollectionName: 'EKKOBBokfFilRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBBokfFilRad',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKKOBBokfFilRads primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKKOBBokfFilRads versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKKOBBokfFilRads fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYPKOD: {
          AttributeName: 'TYPKOD',
          DisplayLabel: 'Typkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORGNR: {
          AttributeName: 'ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        KOBFil: {
          AssociationName: 'KOBFil',
          DisplayLabel: 'KOBFil',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBBokfFil',
          AssociatedComponentName: 'KOBBokfFil',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Transaktionstyp: {
          AssociationName: 'Transaktionstyp',
          DisplayLabel: 'Transaktionstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBTransTyp',
          AssociatedComponentName: 'KOBTransTyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokforingsmallParam: {
      CollectionName: 'EKBokforingsmallParam',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokforingsmallParam',
        Abstract: false,
        SOLabel: 'Bokföringsmall, parameter',
        SOGLabel: 'Bokföringsmall, parameters',
        SBLabel: 'Bokföringsmall, parametern',
        SBGLabel: 'Bokföringsmall, parameterns',
        POLabel: 'Bokföringsmall, parametrar',
        POGLabel: 'Bokföringsmall, parametrars',
        PBLabel: 'Bokföringsmall, parametrarna',
        PBGLabel: 'Bokföringsmall, parametrarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsmall, parameterns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsmall, parameterns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsmall, parameterns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARAM_NAME: {
          AttributeName: 'PARAM_NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PARAM_BENAMNING: {
          AttributeName: 'PARAM_BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PARAM_DATATYP: {
          AttributeName: 'PARAM_DATATYP',
          DisplayLabel: 'Datatyp',
          Hint: 'Text/Heltal/Decimaltal/Belopp/Datum (ÅÅÅÅ-MM-DD)',
          DataType: 'Enum',
          EnumValues: new Map([['TEXT', 'Text'], ['HELTAL', 'Heltal'], ['DECIMALTAL', 'Decimaltal'], ['BELOPP', 'Belopp'], ['DATUM__AAAA_MM_DD_', 'Datum (ÅÅÅÅ-MM-DD)']]),
          EnumSortValues: new Map([['TEXT', 'A'], ['HELTAL', 'I'], ['DECIMALTAL', 'F'], ['BELOPP', 'C'], ['DATUM__AAAA_MM_DD_', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TEXT=Text;HELTAL=Heltal;DECIMALTAL=Decimaltal;BELOPP=Belopp;DATUM__AAAA_MM_DD_=Datum (ÅÅÅÅ-MM-DD)"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORESLA_BOKFDATUM: {
          AttributeName: 'FORESLA_BOKFDATUM',
          DisplayLabel: 'Föreslå bokföringsdatum',
          Hint: 'Föreslå inte/Samma dag/Nästkommande vardag/Nästa dag',
          DataType: 'Enum',
          EnumValues: new Map([['FORESLA_INTE', 'Föreslå inte'], ['SAMMA_DAG', 'Samma dag'], ['NASTKOMMANDE_VARDAG', 'Nästkommande vardag'], ['NASTA_DAG', 'Nästa dag']]),
          EnumSortValues: new Map([['FORESLA_INTE', '0'], ['SAMMA_DAG', '-2'], ['NASTKOMMANDE_VARDAG', '-1'], ['NASTA_DAG', '1']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORESLA_INTE=Föreslå inte;SAMMA_DAG=Samma dag;NASTKOMMANDE_VARDAG=Nästkommande vardag;NASTA_DAG=Nästa dag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBokforingsmallRad: {
      CollectionName: 'EKBokforingsmallRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokforingsmallRad',
        Abstract: false,
        SOLabel: 'Bokföringsmall, rad',
        SOGLabel: 'Bokföringsmall, rads',
        SBLabel: 'Bokföringsmall, raden',
        SBGLabel: 'Bokföringsmall, radens',
        POLabel: 'Bokföringsmall, rader',
        POGLabel: 'Bokföringsmall, raders',
        PBLabel: 'Bokföringsmall, raderna',
        PBGLabel: 'Bokföringsmall, radernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsmall, radens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsmall, radens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsmall, radens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_1: {
          AttributeName: 'KAN_ANDRAS_1',
          DisplayLabel: '@KONTO1@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_1: {
          AttributeName: 'VILLKOR_1',
          DisplayLabel: '@KONTO1@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_1: {
          AttributeName: 'GILTIG_INTERVALL_1',
          DisplayLabel: '@KONTO1@,  giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL_TYP_1: {
          AttributeName: 'MALL_TYP_1',
          DisplayLabel: '@KONTO1@, användning',
          Hint: 'Kassa kontant/Bank kontant/Skåp kontant/Kort/Swish',
          DataType: 'Enum',
          EnumValues: new Map([['KASSA_KONTANT', 'Kassa kontant'], ['BANK_KONTANT', 'Bank kontant'], ['SKAP_KONTANT', 'Skåp kontant'], ['KORT', 'Kort'], ['SWISH', 'Swish']]),
          EnumSortValues: new Map([['KASSA_KONTANT', 'K_KONT'], ['BANK_KONTANT', 'K_BANK'], ['SKAP_KONTANT', 'K_SKAP'], ['KORT', 'K_KORT'], ['SWISH', 'K_SWISH']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KASSA_KONTANT=Kassa kontant;BANK_KONTANT=Bank kontant;SKAP_KONTANT=Skåp kontant;KORT=Kort;SWISH=Swish"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_2: {
          AttributeName: 'KAN_ANDRAS_2',
          DisplayLabel: '@KONTO2@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_2: {
          AttributeName: 'VILLKOR_2',
          DisplayLabel: '@KONTO2@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_2: {
          AttributeName: 'GILTIG_INTERVALL_2',
          DisplayLabel: '@KONTO2@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KAN_ANDRAS_3: {
          AttributeName: 'KAN_ANDRAS_3',
          DisplayLabel: '@KONTO3@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_3: {
          AttributeName: 'VILLKOR_3',
          DisplayLabel: '@KONTO3@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_3: {
          AttributeName: 'GILTIG_INTERVALL_3',
          DisplayLabel: '@KONTO3@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_4: {
          AttributeName: 'KAN_ANDRAS_4',
          DisplayLabel: '@KONTO4@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_4: {
          AttributeName: 'VILLKOR_4',
          DisplayLabel: '@KONTO4@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_4: {
          AttributeName: 'GILTIG_INTERVALL_4',
          DisplayLabel: '@KONTO4@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_5: {
          AttributeName: 'KAN_ANDRAS_5',
          DisplayLabel: '@KONTO5@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_5: {
          AttributeName: 'VILLKOR_5',
          DisplayLabel: '@KONTO5@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_5: {
          AttributeName: 'GILTIG_INTERVALL_5',
          DisplayLabel: '@KONTO5@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_6: {
          AttributeName: 'KAN_ANDRAS_6',
          DisplayLabel: '@KONTO6@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_6: {
          AttributeName: 'VILLKOR_6',
          DisplayLabel: '@KONTO6@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_6: {
          AttributeName: 'GILTIG_INTERVALL_6',
          DisplayLabel: '@KONTO6@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_7: {
          AttributeName: 'KAN_ANDRAS_7',
          DisplayLabel: '@KONTO7@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_7: {
          AttributeName: 'VILLKOR_7',
          DisplayLabel: '@KONTO7@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_7: {
          AttributeName: 'GILTIG_INTERVALL_7',
          DisplayLabel: '@KONTO7@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_8: {
          AttributeName: 'KAN_ANDRAS_8',
          DisplayLabel: '@KONTO8@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_8: {
          AttributeName: 'VILLKOR_8',
          DisplayLabel: '@KONTO8@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_8: {
          AttributeName: 'GILTIG_INTERVALL_8',
          DisplayLabel: '@KONTO8@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_9: {
          AttributeName: 'KAN_ANDRAS_9',
          DisplayLabel: '@KONTO9@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_9: {
          AttributeName: 'VILLKOR_9',
          DisplayLabel: '@KONTO9@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_9: {
          AttributeName: 'GILTIG_INTERVALL_9',
          DisplayLabel: '@KONTO9@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRAS_10: {
          AttributeName: 'KAN_ANDRAS_10',
          DisplayLabel: '@KONTO10@, kan ändras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VILLKOR_10: {
          AttributeName: 'VILLKOR_10',
          DisplayLabel: '@KONTO10@, villkor',
          Hint: 'Får anges/Måste anges/Får ej anges',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_ANGES', 'Får anges'], ['MASTE_ANGES', 'Måste anges'], ['FAR_EJ_ANGES', 'Får ej anges']]),
          EnumSortValues: new Map([['FAR_ANGES', '0'], ['MASTE_ANGES', '1'], ['FAR_EJ_ANGES', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_ANGES=Får anges;MASTE_ANGES=Måste anges;FAR_EJ_ANGES=Får ej anges"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_INTERVALL_10: {
          AttributeName: 'GILTIG_INTERVALL_10',
          DisplayLabel: '@KONTO10@, giltigt intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DEB_KRED: {
          AttributeName: 'DEB_KRED',
          DisplayLabel: 'Debet/Kredit',
          Hint: 'Debet/Kredit',
          DataType: 'Enum',
          EnumValues: new Map([['DEBET', 'Debet'], ['KREDIT', 'Kredit']]),
          EnumSortValues: new Map([['DEBET', 'D'], ['KREDIT', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBET=Debet;KREDIT=Kredit"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANDEL_PROCENT: {
          AttributeName: 'ANDEL_PROCENT',
          DisplayLabel: 'Andel i procent',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODISERAS: {
          AttributeName: 'PERIODISERAS',
          DisplayLabel: 'Periodiseras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANGE_PROCENTSATS: {
          AttributeName: 'ANGE_PROCENTSATS',
          DisplayLabel: 'Ange procentsats',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTERINGSKOD_ID_1: {
          AttributeName: 'KONTERINGSKOD_ID_1',
          DisplayLabel: 'Konteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokforingsmall: {
      CollectionName: 'EKBokforingsmall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bokforingsmall',
        Abstract: false,
        SOLabel: 'Bokföringsmall',
        SOGLabel: 'Bokföringsmalls',
        SBLabel: 'Bokföringsmallen',
        SBGLabel: 'Bokföringsmallens',
        POLabel: 'Bokföringsmaller',
        POGLabel: 'Bokföringsmallers',
        PBLabel: 'Bokföringsmallerna',
        PBGLabel: 'Bokföringsmallernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsmallens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsmallens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsmallens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsmallens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarParametrar: {
          AttributeName: 'HarParametrar',
          DisplayLabel: 'HarParametrar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Standardmall: {
          AttributeName: 'Standardmall',
          DisplayLabel: 'Standardmall',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        EXKLUDERA_BELOPP: {
          AttributeName: 'EXKLUDERA_BELOPP',
          DisplayLabel: 'Exkludera belopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kodplan: {
          AssociationName: 'Kodplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Parametrar: {
          AssociationName: 'Parametrar',
          DisplayLabel: 'Parametrar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforingsmallParam',
          AssociatedComponentName: 'BokforingsmallParam',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Rader: {
          AssociationName: 'Rader',
          DisplayLabel: 'Rader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforingsmallRad',
          AssociatedComponentName: 'BokforingsmallRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokforder: {
      CollectionName: 'EKBokforder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Bokfgrupp'], ['AllowSelection', '2060,15006'], ['AllowEdit', '15006']]),
      RootType: {
        TypeValue: 'Bokforder',
        Abstract: false,
        SOLabel: 'Bokföringsorder',
        SOGLabel: 'Bokföringsorders',
        SBLabel: 'Bokföringsordern',
        SBGLabel: 'Bokföringsorderns',
        POLabel: 'Bokföringsorder',
        POGLabel: 'Bokföringsorders',
        PBLabel: 'Bokföringsorderna',
        PBGLabel: 'Bokföringsorderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsorderns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsorderns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsorderns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsorderns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLNINGSNR: {
          AttributeName: 'BESTALLNINGSNR',
          DisplayLabel: 'Bokföringsordernr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Utkast/Attest används ej/Ej godkänd/Skapad/Väntar på attest/På väg till betalning/Attesterad/Verifikation skapad/Borttagen',
          DataType: 'Enum',
          EnumValues: new Map([['UTKAST', 'Utkast'], ['ATTEST_ANVANDS_EJ', 'Attest används ej'], ['EJ_GODKAND', 'Ej godkänd'], ['SKAPAD', 'Skapad'], ['VANTAR_PA_ATTEST', 'Väntar på attest'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['ATTESTERAD', 'Attesterad'], ['VERIFIKATION_SKAPAD', 'Verifikation skapad'], ['BORTTAGEN', 'Borttagen']]),
          EnumSortValues: new Map([['UTKAST', '1'], ['ATTEST_ANVANDS_EJ', '2'], ['EJ_GODKAND', '3'], ['SKAPAD', '4'], ['VANTAR_PA_ATTEST', '5'], ['PA_VAG_TILL_BETALNING', '6'], ['ATTESTERAD', '7'], ['VERIFIKATION_SKAPAD', '8'], ['BORTTAGEN', '0']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTKAST=Utkast;ATTEST_ANVANDS_EJ=Attest används ej;EJ_GODKAND=Ej godkänd;SKAPAD=Skapad;VANTAR_PA_ATTEST=Väntar på attest;PA_VAG_TILL_BETALNING=På väg till betalning;ATTESTERAD=Attesterad;VERIFIKATION_SKAPAD=Verifikation skapad;BORTTAGEN=Borttagen"',
          GUIEditable: true,
          Required: true,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESTALLD_AV_ID: {
          AttributeName: 'BESTALLD_AV_ID',
          DisplayLabel: 'Beställd av, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLD_DATUM: {
          AttributeName: 'BESTALLD_DATUM',
          DisplayLabel: 'Beställd, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKF_DATUM: {
          AttributeName: 'BOKF_DATUM',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTERAS_AV_ID: {
          AttributeName: 'ATTESTERAS_AV_ID',
          DisplayLabel: 'ANVÄNDS EJ - Attesteras, av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTERAD_DATUM: {
          AttributeName: 'ATTESTERAD_DATUM',
          DisplayLabel: 'ANVÄNDS EJ - Attesterad, datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VER_SKAPAD_AV_ID: {
          AttributeName: 'VER_SKAPAD_AV_ID',
          DisplayLabel: 'Verifikation skapav av, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VER_SKAPAD_DATUM: {
          AttributeName: 'VER_SKAPAD_DATUM',
          DisplayLabel: 'Verifikation skapad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAMINNELSE_SKICKAD_DATUM: {
          AttributeName: 'PAMINNELSE_SKICKAD_DATUM',
          DisplayLabel: 'Påminnelse skickad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KalkStatus: {
          AttributeName: 'KalkStatus',
          DisplayLabel: 'Status',
          Hint: 'Utkast/Attest används ej/Ej godkänd/Skapad/Väntar på attest/På väg till betalning/Attesterad/Verifikation skapad/Journal bokförd',
          DataType: 'Enum',
          EnumValues: new Map([['UTKAST', 'Utkast'], ['ATTEST_ANVANDS_EJ', 'Attest används ej'], ['EJ_GODKAND', 'Ej godkänd'], ['SKAPAD', 'Skapad'], ['VANTAR_PA_ATTEST', 'Väntar på attest'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['ATTESTERAD', 'Attesterad'], ['VERIFIKATION_SKAPAD', 'Verifikation skapad'], ['JOURNAL_BOKFORD', 'Journal bokförd']]),
          EnumSortValues: new Map([['UTKAST', '1'], ['ATTEST_ANVANDS_EJ', '2'], ['EJ_GODKAND', '3'], ['SKAPAD', '4'], ['VANTAR_PA_ATTEST', '5'], ['PA_VAG_TILL_BETALNING', '6'], ['ATTESTERAD', '7'], ['VERIFIKATION_SKAPAD', '8'], ['JOURNAL_BOKFORD', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTKAST=Utkast;ATTEST_ANVANDS_EJ=Attest används ej;EJ_GODKAND=Ej godkänd;SKAPAD=Skapad;VANTAR_PA_ATTEST=Väntar på attest;PA_VAG_TILL_BETALNING=På väg till betalning;ATTESTERAD=Attesterad;VERIFIKATION_SKAPAD=Verifikation skapad;JOURNAL_BOKFORD=Journal bokförd"',
          InterfaceType: 'ifChecklist',
        },
        REF_BOKF_AR: {
          AttributeName: 'REF_BOKF_AR',
          DisplayLabel: 'Referensverifikation, bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REF_VER_NR: {
          AttributeName: 'REF_VER_NR',
          DisplayLabel: 'Referensverifikation, vernr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Summa_Debet: {
          AttributeName: 'Summa_Debet',
          DisplayLabel: 'Summa debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
        },
        Summa_Kredit: {
          AttributeName: 'Summa_Kredit',
          DisplayLabel: 'Summa kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
        },
        KalkBestnr: {
          AttributeName: 'KalkBestnr',
          DisplayLabel: 'Beställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Meddelande: {
          AttributeName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AttestantSignaturer: {
          AttributeName: 'AttestantSignaturer',
          DisplayLabel: 'Attesteras av, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        SaknarAttestanter: {
          AttributeName: 'SaknarAttestanter',
          DisplayLabel: 'Saknar attestanter',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        AttestantFullnames: {
          AttributeName: 'AttestantFullnames',
          DisplayLabel: 'Attestanter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FardigAttesteradDatum: {
          AttributeName: 'FardigAttesteradDatum',
          DisplayLabel: 'Attesterad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        ShortTextWeb: {
          AttributeName: 'ShortTextWeb',
          DisplayLabel: 'Kort text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ShortTextMobil: {
          AttributeName: 'ShortTextMobil',
          DisplayLabel: 'Kort text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'Bokföringsmall, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARAMVALUES: {
          AttributeName: 'PARAMVALUES',
          DisplayLabel: 'Parametervärden',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_DATUM: {
          AttributeName: 'MALL_DATUM',
          DisplayLabel: 'Avser datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MALL_PLATS: {
          AttributeName: 'MALL_PLATS',
          DisplayLabel: 'Avser plats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL_ANDAMAL: {
          AttributeName: 'MALL_ANDAMAL',
          DisplayLabel: 'Avser ändamål',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL_IDENTIFIKATION: {
          AttributeName: 'MALL_IDENTIFIKATION',
          DisplayLabel: 'Avser idnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL_LIKVIDSATT: {
          AttributeName: 'MALL_LIKVIDSATT',
          DisplayLabel: 'Avser likvidsätt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEST_BOKF_DATUM: {
          AttributeName: 'BEST_BOKF_DATUM',
          DisplayLabel: 'Beställt bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BetBokfdatum: {
          AttributeName: 'BetBokfdatum',
          DisplayLabel: 'Beställt bokföringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VERKAT_KOD: {
          AttributeName: 'VERKAT_KOD',
          DisplayLabel: 'Verifikationskategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOBFIL_ID: {
          AttributeName: 'KOBFIL_ID',
          DisplayLabel: 'KOB-fil, Id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HarMeddelande: {
          AttributeName: 'HarMeddelande',
          DisplayLabel: 'Har meddelande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        HarDokument: {
          AttributeName: 'HarDokument',
          DisplayLabel: 'Har dokument',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        MinBokforderStatus: {
          AttributeName: 'MinBokforderStatus',
          DisplayLabel: 'Min bokf.order status',
          Hint: 'Utkast/Ej godkänd av attestant/Attesteras, hos attestant/Att attestera/Att kontrollattestera/Attesterad, hos annan attestant/Attesterad (beställare)/Attesterad (attestant)/Kontrollattesterad (attestant)/Verifikation skapad (beställare)/Verifikation skapad (attestant)/Definitivbokförd (beställare)/Definitivbokförd (attestant)/Verifikation korrigerad (beställare)/Verifikation korrigerad (attestant)/På väg till betalning/Borttagen (beställare)',
          DataType: 'Enum',
          EnumValues: new Map([['UTKAST', 'Utkast'], ['EJ_GODKAND_AV_ATTESTANT', 'Ej godkänd av attestant'], ['ATTESTERAS__HOS_ATTESTANT', 'Attesteras, hos attestant'], ['ATT_ATTESTERA', 'Att attestera'], ['ATT_KONTROLLATTESTERA', 'Att kontrollattestera'], ['ATTESTERAD__HOS_ANNAN_ATTESTANT', 'Attesterad, hos annan attestant'], ['ATTESTERAD__BESTALLARE_', 'Attesterad (beställare)'], ['ATTESTERAD__ATTESTANT_', 'Attesterad (attestant)'], ['KONTROLLATTESTERAD__ATTESTANT_', 'Kontrollattesterad (attestant)'], ['VERIFIKATION_SKAPAD__BESTALLARE_', 'Verifikation skapad (beställare)'], ['VERIFIKATION_SKAPAD__ATTESTANT_', 'Verifikation skapad (attestant)'], ['DEFINITIVBOKFORD__BESTALLARE_', 'Definitivbokförd (beställare)'], ['DEFINITIVBOKFORD__ATTESTANT_', 'Definitivbokförd (attestant)'], ['VERIFIKATION_KORRIGERAD__BESTALLARE_', 'Verifikation korrigerad (beställare)'], ['VERIFIKATION_KORRIGERAD__ATTESTANT_', 'Verifikation korrigerad (attestant)'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['BORTTAGEN__BESTALLARE_', 'Borttagen (beställare)']]),
          EnumSortValues: new Map([['UTKAST', '10'], ['EJ_GODKAND_AV_ATTESTANT', '12'], ['ATTESTERAS__HOS_ATTESTANT', '20'], ['ATT_ATTESTERA', '22'], ['ATT_KONTROLLATTESTERA', '23'], ['ATTESTERAD__HOS_ANNAN_ATTESTANT', '24'], ['ATTESTERAD__BESTALLARE_', '30'], ['ATTESTERAD__ATTESTANT_', '32'], ['KONTROLLATTESTERAD__ATTESTANT_', '34'], ['VERIFIKATION_SKAPAD__BESTALLARE_', '40'], ['VERIFIKATION_SKAPAD__ATTESTANT_', '42'], ['DEFINITIVBOKFORD__BESTALLARE_', '50'], ['DEFINITIVBOKFORD__ATTESTANT_', '52'], ['VERIFIKATION_KORRIGERAD__BESTALLARE_', '60'], ['VERIFIKATION_KORRIGERAD__ATTESTANT_', '62'], ['PA_VAG_TILL_BETALNING', '38'], ['BORTTAGEN__BESTALLARE_', '70']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTKAST=Utkast;EJ_GODKAND_AV_ATTESTANT=Ej godkänd av attestant;ATTESTERAS__HOS_ATTESTANT=Attesteras, hos attestant;ATT_ATTESTERA=Att attestera;ATT_KONTROLLATTESTERA=Att kontrollattestera;ATTESTERAD__HOS_ANNAN_ATTESTANT=Attesterad, hos annan attestant;ATTESTERAD__BESTALLARE_=Attesterad (beställare);ATTESTERAD__ATTESTANT_=Attesterad (attestant);KONTROLLATTESTERAD__ATTESTANT_=Kontrollattesterad (attestant);VERIFIKATION_SKAPAD__BESTALLARE_=Verifikation skapad (beställare);VERIFIKATION_SKAPAD__ATTESTANT_=Verifikation skapad (attestant);DEFINITIVBOKFORD__BESTALLARE_=Definitivbokförd (beställare);DEFINITIVBOKFORD__ATTESTANT_=Definitivbokförd (attestant);VERIFIKATION_KORRIGERAD__BESTALLARE_=Verifikation korrigerad (beställare);VERIFIKATION_KORRIGERAD__ATTESTANT_=Verifikation korrigerad (attestant);PA_VAG_TILL_BETALNING=På väg till betalning;BORTTAGEN__BESTALLARE_=Borttagen (beställare)"',
          InterfaceType: 'ifChecklist',
        },
        BokfordNamnDatum: {
          AttributeName: 'BokfordNamnDatum',
          DisplayLabel: 'Bokförd av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BestalldNamnDatum: {
          AttributeName: 'BestalldNamnDatum',
          DisplayLabel: 'Beställd av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OMFORINGSTYP: {
          AttributeName: 'OMFORINGSTYP',
          DisplayLabel: 'Omföringstyp',
          Hint: 'Kopiera/Vänd/Ombokför/Periodisera/Undefined',
          DataType: 'Enum',
          EnumValues: new Map([['KOPIERA', 'Kopiera'], ['VAND', 'Vänd'], ['OMBOKFOR', 'Ombokför'], ['PERIODISERA', 'Periodisera'], ['UNDEFINED', 'Undefined']]),
          EnumSortValues: new Map([['KOPIERA', 'K'], ['VAND', 'V'], ['OMBOKFOR', 'O'], ['PERIODISERA', 'P'], ['UNDEFINED', 'U']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KOPIERA=Kopiera;VAND=Vänd;OMBOKFOR=Ombokför;PERIODISERA=Periodisera;UNDEFINED=Undefined"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Bokföringsorder/Utanordning',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORINGSORDER', 'Bokföringsorder'], ['UTANORDNING', 'Utanordning']]),
          EnumSortValues: new Map([['BOKFORINGSORDER', 'B'], ['UTANORDNING', 'U']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORINGSORDER=Bokföringsorder;UTANORDNING=Utanordning"',
          GUIEditable: true,
        },
        U_BETALNINGSMOTTAGARE: {
          AttributeName: 'U_BETALNINGSMOTTAGARE',
          DisplayLabel: 'Betalningsmottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utanordning',
        },
        U_FRITEXT: {
          AttributeName: 'U_FRITEXT',
          DisplayLabel: 'Fritext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utanordning',
        },
        U_CLEARING_BANKKONTONUMMER: {
          AttributeName: 'U_CLEARING_BANKKONTONUMMER',
          DisplayLabel: 'Clearing- och bankkontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifNone',
          AttributeGroup: 'Utanordning',
        },
        U_BELOPP: {
          AttributeName: 'U_BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          AttributeGroup: 'Utanordning',
        },
        U_BANK: {
          AttributeName: 'U_BANK',
          DisplayLabel: 'Bank',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utanordning',
        },
        U_BETSATT_ID: {
          AttributeName: 'U_BETSATT_ID',
          DisplayLabel: 'Utbetalningssätt ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        U_UTBETALNINGSKATEGORI: {
          AttributeName: 'U_UTBETALNINGSKATEGORI',
          DisplayLabel: 'Utbetalningskategori',
          Hint: 'Bankkonto/Pgbg/Kontant/Swish/Tillogodo',
          DataType: 'Enum',
          EnumValues: new Map([['BANKKONTO', 'Bankkonto'], ['PGBG', 'Pgbg'], ['KONTANT', 'Kontant'], ['SWISH', 'Swish'], ['TILLOGODO', 'Tillogodo']]),
          EnumSortValues: new Map([['BANKKONTO', 'B'], ['PGBG', 'P'], ['KONTANT', 'K'], ['SWISH', 'S'], ['TILLOGODO', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKKONTO=Bankkonto;PGBG=Pgbg;KONTANT=Kontant;SWISH=Swish;TILLOGODO=Tillogodo"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utanordning',
        },
        Variant: {
          AttributeName: 'Variant',
          DisplayLabel: 'Variant',
          Hint: 'Mall/Kopiera/Vänd/Ombokför/Periodisera/Tom/UtanordingBankonto/UtanordingKontant/UtanordingPgBg/UtanordningTillgodo',
          DataType: 'Enum',
          EnumValues: new Map([['MALL', 'Mall'], ['KOPIERA', 'Kopiera'], ['VAND', 'Vänd'], ['OMBOKFOR', 'Ombokför'], ['PERIODISERA', 'Periodisera'], ['TOM', 'Tom'], ['UTANORDINGBANKONTO', 'UtanordingBankonto'], ['UTANORDINGKONTANT', 'UtanordingKontant'], ['UTANORDINGPGBG', 'UtanordingPgBg'], ['UTANORDNINGTILLGODO', 'UtanordningTillgodo']]),
          EnumSortValues: new Map([['MALL', 'M'], ['KOPIERA', 'K'], ['VAND', 'V'], ['OMBOKFOR', 'O'], ['PERIODISERA', 'P'], ['TOM', 'T'], ['UTANORDINGBANKONTO', 'UB'], ['UTANORDINGKONTANT', 'UK'], ['UTANORDINGPGBG', 'UP'], ['UTANORDNINGTILLGODO', 'UT']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MALL=Mall;KOPIERA=Kopiera;VAND=Vänd;OMBOKFOR=Ombokför;PERIODISERA=Periodisera;TOM=Tom;UTANORDINGBANKONTO=UtanordingBankonto;UTANORDINGKONTANT=UtanordingKontant;UTANORDINGPGBG=UtanordingPgBg;UTANORDNINGTILLGODO=UtanordningTillgodo"',
          InterfaceType: 'ifChecklist',
        },
        U_BANK_PLUSGIRONUMMER: {
          AttributeName: 'U_BANK_PLUSGIRONUMMER',
          DisplayLabel: 'Bank/Plusgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Utanordning',
        },
        KalkTYP: {
          AttributeName: 'KalkTYP',
          DisplayLabel: 'Typ',
          Hint: 'Bokföringsorder/Utanordning',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORINGSORDER', 'Bokföringsorder'], ['UTANORDNING', 'Utanordning']]),
          EnumSortValues: new Map([['BOKFORINGSORDER', 'B'], ['UTANORDNING', 'U']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORINGSORDER=Bokföringsorder;UTANORDNING=Utanordning"',
          InterfaceType: 'ifChecklist',
        },
        U_KUND_ID: {
          AttributeName: 'U_KUND_ID',
          DisplayLabel: 'Kund id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Utanordning',
        },
        U_BETALNINGSUPPDRAG_ID: {
          AttributeName: 'U_BETALNINGSUPPDRAG_ID',
          DisplayLabel: 'Betalningsuppdrags id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Utanordning',
        },
        UkalkKontonr: {
          AttributeName: 'UkalkKontonr',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Utanordning',
        },
        INNAN_BOKF_STATUS: {
          AttributeName: 'INNAN_BOKF_STATUS',
          DisplayLabel: 'Föregående status innan bokföring',
          Hint: 'Attest används ej/På väg till betalning/Attesterad',
          DataType: 'Enum',
          EnumValues: new Map([['ATTEST_ANVANDS_EJ', 'Attest används ej'], ['PA_VAG_TILL_BETALNING', 'På väg till betalning'], ['ATTESTERAD', 'Attesterad']]),
          EnumSortValues: new Map([['ATTEST_ANVANDS_EJ', '2'], ['PA_VAG_TILL_BETALNING', '6'], ['ATTESTERAD', '7']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATTEST_ANVANDS_EJ=Attest används ej;PA_VAG_TILL_BETALNING=På väg till betalning;ATTESTERAD=Attesterad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        KOLLEKTFIL_ID: {
          AttributeName: 'KOLLEKTFIL_ID',
          DisplayLabel: 'Kollektfil, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kalla: {
          AttributeName: 'Kalla',
          DisplayLabel: 'Källa',
          Hint: 'Bokföringsfil från KOB/Kollekt från KOB/Insamling från KOB/Registrerad',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORINGSFIL_FRAN_KOB', 'Bokföringsfil från KOB'], ['KOLLEKT_FRAN_KOB', 'Kollekt från KOB'], ['INSAMLING_FRAN_KOB', 'Insamling från KOB'], ['REGISTRERAD', 'Registrerad']]),
          EnumSortValues: new Map([['BOKFORINGSFIL_FRAN_KOB', 'B'], ['KOLLEKT_FRAN_KOB', 'K'], ['INSAMLING_FRAN_KOB', 'I'], ['REGISTRERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORINGSFIL_FRAN_KOB=Bokföringsfil från KOB;KOLLEKT_FRAN_KOB=Kollekt från KOB;INSAMLING_FRAN_KOB=Insamling från KOB;REGISTRERAD=Registrerad"',
          InterfaceType: 'ifChecklist',
        },
        KONTROLLATTESTERAS_AV_ID: {
          AttributeName: 'KONTROLLATTESTERAS_AV_ID',
          DisplayLabel: 'Kontrollattesteras av, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTROLLATTESTERAD_DATUM: {
          AttributeName: 'KONTROLLATTESTERAD_DATUM',
          DisplayLabel: 'Kontrollattesterad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AllaRaderAttesterade: {
          AttributeName: 'AllaRaderAttesterade',
          DisplayLabel: 'Alla rader attesterade',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PAMINNELSE_KONTROLL_SKICKAD_DATUM: {
          AttributeName: 'PAMINNELSE_KONTROLL_SKICKAD_DATUM',
          DisplayLabel: 'Påminnelse, kontrollattest skickad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        U_MEDDELANDE: {
          AttributeName: 'U_MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 140,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTROLLATTESTERAD_AV_RESERV_ID: {
          AttributeName: 'KONTROLLATTESTERAD_AV_RESERV_ID',
          DisplayLabel: 'Kontrollattesterad av reserv, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontrollattestantFullname: {
          AttributeName: 'KontrollattestantFullname',
          DisplayLabel: 'Kontrollattestant (inkl reserver)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        VerSkapadAv: {
          AssociationName: 'VerSkapadAv',
          DisplayLabel: 'Verifikation skapad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokfver: {
          AssociationName: 'Bokfver',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'Bokfver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RefBokfver: {
          AssociationName: 'RefBokfver',
          DisplayLabel: 'Referensverifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'Bokfver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokforingsmall: {
          AssociationName: 'Bokforingsmall',
          DisplayLabel: 'Bokföringsmall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforingsmall',
          AssociatedComponentName: 'Bokforingsmall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Utbetalningssatt: {
          AssociationName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Tillgodohavande kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'FakturaKund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsuppdrag: {
          AssociationName: 'Betalningsuppdrag',
          DisplayLabel: 'Utbetalningsorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRBetalningsuppdrag',
          AssociatedComponentName: 'Betalningsuppdrag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kollekttillfalle: {
          AssociationName: 'Kollekttillfalle',
          DisplayLabel: 'Kollekt/insamling',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBKollektFilTillfalle',
          AssociatedComponentName: 'KOBKollektFilTillfalle',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontrollattestant: {
          AssociationName: 'Kontrollattestant',
          DisplayLabel: 'Kontrollattestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ReservKontrollattestant: {
          AssociationName: 'ReservKontrollattestant',
          DisplayLabel: 'Kontrollattestant, reserv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rader: {
          AssociationName: 'Rader',
          DisplayLabel: 'Rader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforderRad',
          AssociatedComponentName: 'BokforderRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforderDokument',
          AssociatedComponentName: 'BokforderDokument',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Meddelande: {
          AssociationName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforderMeddelande',
          AssociatedComponentName: 'BokforderMeddelande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokforderMeddelande: {
      CollectionName: 'EKBokforderMeddelande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,15006']]),
      RootType: {
        TypeValue: 'BokforderMeddelande',
        Abstract: false,
        SOLabel: 'Bokföringsorder, meddelande',
        SOGLabel: 'Bokföringsorder, meddelande',
        SBLabel: 'Bokföringsorder, meddelandet',
        SBGLabel: 'Bokföringsorder, meddelandets',
        POLabel: 'Bokföringsorder, meddelande',
        POGLabel: 'Bokföringsorder, meddelande',
        PBLabel: 'Bokföringsorder, meddelandena',
        PBGLabel: 'Bokföringsorder, meddelandenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsorder, meddelandets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsorder, meddelandets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsorder, meddelandets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVSANDAR_TYP: {
          AttributeName: 'AVSANDAR_TYP',
          DisplayLabel: 'Avsändartyp',
          Hint: 'Från beställare/Från attestant/Från ekonom',
          DataType: 'Enum',
          EnumValues: new Map([['FRAN_BESTALLARE', 'Från beställare'], ['FRAN_ATTESTANT', 'Från attestant'], ['FRAN_EKONOM', 'Från ekonom']]),
          EnumSortValues: new Map([['FRAN_BESTALLARE', 'B'], ['FRAN_ATTESTANT', 'A'], ['FRAN_EKONOM', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FRAN_BESTALLARE=Från beställare;FRAN_ATTESTANT=Från attestant;FRAN_EKONOM=Från ekonom"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EKONOM_ID: {
          AttributeName: 'EKONOM_ID',
          DisplayLabel: 'Ekonom, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTERAS_AV_ID: {
          AttributeName: 'ATTESTERAS_AV_ID',
          DisplayLabel: 'Attesteras av,id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLD_AV_ID: {
          AttributeName: 'BESTALLD_AV_ID',
          DisplayLabel: 'Beställare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        AvsandareDatumTid: {
          AttributeName: 'AvsandareDatumTid',
          DisplayLabel: 'Avsändare och tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MittMeddelande: {
          AttributeName: 'MittMeddelande',
          DisplayLabel: 'Mitt meddelande',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Meddelanderad: {
          AttributeName: 'Meddelanderad',
          DisplayLabel: 'Meddelanderad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvsandarId: {
          AttributeName: 'AvsandarId',
          DisplayLabel: 'Avsändare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ekonom: {
          AssociationName: 'Ekonom',
          DisplayLabel: 'Ekonom',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avsandare: {
          AssociationName: 'Avsandare',
          DisplayLabel: 'Avsändare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokforderRad: {
      CollectionName: 'EKBokforderRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokforderRad',
        Abstract: false,
        SOLabel: 'Bokföringsorder, rad',
        SOGLabel: 'Bokföringsorder, rads',
        SBLabel: 'Bokföringsorder, raden',
        SBGLabel: 'Bokföringsorder, radens',
        POLabel: 'Bokföringsorder, rader',
        POGLabel: 'Bokföringsorder, raders',
        PBLabel: 'Bokföringsorder, raderna',
        PBGLabel: 'Bokföringsorder, radernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsorder, radens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsorder, radens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsorder, radens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Radtext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiseras',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERIODISERAD_FROM_DATUM: {
          AttributeName: 'PERIODISERAD_FROM_DATUM',
          DisplayLabel: 'Periodiserad, from datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIODISERAD_TOM_DATUM: {
          AttributeName: 'PERIODISERAD_TOM_DATUM',
          DisplayLabel: 'Periodiserad, t o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kodsträng, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kodsträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATTESTERAS_AV_ID: {
          AttributeName: 'ATTESTERAS_AV_ID',
          DisplayLabel: 'Attesteras av, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ATTESTERAD_DATUM: {
          AttributeName: 'ATTESTERAD_DATUM',
          DisplayLabel: 'Attesterad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PAMINNELSE_SKICKAD_DATUM: {
          AttributeName: 'PAMINNELSE_SKICKAD_DATUM',
          DisplayLabel: 'Påminnelse skickad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Periodiseringskonto: {
          AttributeName: 'Periodiseringskonto',
          DisplayLabel: 'Periodiseringskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'Från mall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALLRAD_LOPNR: {
          AttributeName: 'MALLRAD_LOPNR',
          DisplayLabel: 'Från mallrad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LIKVIDSATT: {
          AttributeName: 'LIKVIDSATT',
          DisplayLabel: 'Likvidsätt',
          Hint: 'Kassa kontant/Bank kontant/Skåp kontant/Kort/Swish',
          DataType: 'Enum',
          EnumValues: new Map([['KASSA_KONTANT', 'Kassa kontant'], ['BANK_KONTANT', 'Bank kontant'], ['SKAP_KONTANT', 'Skåp kontant'], ['KORT', 'Kort'], ['SWISH', 'Swish']]),
          EnumSortValues: new Map([['KASSA_KONTANT', 'K_KONT'], ['BANK_KONTANT', 'K_BANK'], ['SKAP_KONTANT', 'K_SKAP'], ['KORT', 'K_KORT'], ['SWISH', 'K_SWISH']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KASSA_KONTANT=Kassa kontant;BANK_KONTANT=Bank kontant;SKAP_KONTANT=Skåp kontant;KORT=Kort;SWISH=Swish"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOBFIL_ID: {
          AttributeName: 'KOBFIL_ID',
          DisplayLabel: 'KOB-fil, Id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KOBFIL_RADNR: {
          AttributeName: 'KOBFIL_RADNR',
          DisplayLabel: 'KOB-fil, radnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Referens radlöpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_BOKF_AR: {
          AttributeName: 'KONT_BOKF_AR',
          DisplayLabel: 'Kontering, bokf.år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        KONT_VER_NR: {
          AttributeName: 'KONT_VER_NR',
          DisplayLabel: 'Kontering, verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_LOPNR: {
          AttributeName: 'KONT_LOPNR',
          DisplayLabel: 'Kontering, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfortAvvikande: {
          AttributeName: 'BokfortAvvikande',
          DisplayLabel: 'Bokfört på avvikande konto',
          Hint: 'Ja/Nej/Saknar referens',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['SAKNAR_REFERENS', 'Saknar referens']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['SAKNAR_REFERENS', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;SAKNAR_REFERENS=Saknar referens"',
        },
        BokfortAvvikandeSQL: {
          AttributeName: 'BokfortAvvikandeSQL',
          DisplayLabel: 'BokfortAvvikandeSQL',
          Hint: 'Ja/Nej/Saknar referens',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['SAKNAR_REFERENS', 'Saknar referens']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['SAKNAR_REFERENS', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;SAKNAR_REFERENS=Saknar referens"',
          InterfaceType: 'ifChecklist',
        },
        KONT_USE_ROW: {
          AttributeName: 'KONT_USE_ROW',
          DisplayLabel: 'Kontering, använd rad',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
        },
        DebetCurr: {
          AttributeName: 'DebetCurr',
          DisplayLabel: 'DebetCurr',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KreditCurr: {
          AttributeName: 'KreditCurr',
          DisplayLabel: 'KreditCurr',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KOLLEKTFIL_LOPNR: {
          AttributeName: 'KOLLEKTFIL_LOPNR',
          DisplayLabel: 'Kollektfil, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URSPR_KODSTRANG: {
          AttributeName: 'URSPR_KODSTRANG',
          DisplayLabel: 'Urspunglig kodsträng',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTERAD_AV_RESERV_ID: {
          AttributeName: 'ATTESTERAD_AV_RESERV_ID',
          DisplayLabel: 'Attesterad av reserv, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokforder: {
          AssociationName: 'Bokforder',
          DisplayLabel: 'Bokföringsorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforder',
          AssociatedComponentName: 'Bokforder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kodplan: {
          AssociationName: 'Kodplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokfkontering: {
          AssociationName: 'Bokfkontering',
          DisplayLabel: 'Verifikationsrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'Bokfkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Reserv: {
          AssociationName: 'Reserv',
          DisplayLabel: 'Reserv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBudget: {
      CollectionName: 'EKBudget',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Budget',
        Abstract: false,
        SOLabel: 'Budget',
        SOGLabel: 'Budget',
        SBLabel: 'Budgeten',
        SBGLabel: 'Budgeten',
        POLabel: 'Budgetar',
        POGLabel: 'Budgetar',
        PBLabel: 'Budgetarna',
        PBGLabel: 'Budgetarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgeten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgeten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgeten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgeten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BUDGET_NR: {
          AttributeName: 'BUDGET_NR',
          DisplayLabel: 'Budgetnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        I_HUVUDBOK: {
          AttributeName: 'I_HUVUDBOK',
          DisplayLabel: 'I huvudbok',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ANTAGENDATUM: {
          AttributeName: 'ANTAGENDATUM',
          DisplayLabel: 'Antagen (datum)',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTAGENTEXT: {
          AttributeName: 'ANTAGENTEXT',
          DisplayLabel: 'Antagen (text)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BUDGETKATEGORI: {
          AttributeName: 'BUDGETKATEGORI',
          DisplayLabel: 'Budgetkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DebetSumma: {
          AttributeName: 'DebetSumma',
          DisplayLabel: 'Summa debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KreditSumma: {
          AttributeName: 'KreditSumma',
          DisplayLabel: 'Summa kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Saldo: {
          AttributeName: 'Saldo',
          DisplayLabel: 'Saldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        NamnAr: {
          AttributeName: 'NamnAr',
          DisplayLabel: 'Budget',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSBUDGET_ID: {
          AttributeName: 'ARBETSBUDGET_ID',
          DisplayLabel: 'Arbetsbudget, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetverifikationer: {
          AssociationName: 'Budgetverifikationer',
          DisplayLabel: 'Budgetverifikationer',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBudgetVer',
          AssociatedComponentName: 'Budgetver',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgetUnderlagAnv: {
      CollectionName: 'EKArbetsbudgetUnderlagAnv',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetUnderlagAnvSaml',
        Abstract: false,
        SOLabel: 'Budgeteringsunderlag, anv',
        SOGLabel: 'Budgeteringsunderlag, anv',
        SBLabel: 'Budgeteringsunderlag, anv',
        SBGLabel: 'Budgeteringsunderlag, anv',
        POLabel: 'Budgeteringsunderlag, anv',
        POGLabel: 'Budgeteringsunderlag, anv',
        PBLabel: 'Budgeteringsunderlag, anv',
        PBGLabel: 'Budgeteringsunderlag, anv',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgeteringsunderlag, anv primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgeteringsunderlag, anv versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgeteringsunderlag, anv fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSBUDGET_ID: {
          AttributeName: 'ARBETSBUDGET_ID',
          DisplayLabel: 'Arbetsbudget, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGETGRUPP_ID: {
          AttributeName: 'BUDGETGRUPP_ID',
          DisplayLabel: 'Budgetgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXPORT_DATUM: {
          AttributeName: 'EXPORT_DATUM',
          DisplayLabel: 'Exporterad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        EXPORT_USER_ID: {
          AttributeName: 'EXPORT_USER_ID',
          DisplayLabel: 'Exportad, användare, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IMPORTERAD_DATUM: {
          AttributeName: 'IMPORTERAD_DATUM',
          DisplayLabel: 'Importerad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IMPORTERAD_USER_ID: {
          AttributeName: 'IMPORTERAD_USER_ID',
          DisplayLabel: 'Importerad, användare, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESLUTAD_DATUM: {
          AttributeName: 'BESLUTAD_DATUM',
          DisplayLabel: 'Beslutad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BESLUTAD_AV: {
          AttributeName: 'BESLUTAD_AV',
          DisplayLabel: 'Beslutad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ExportUser: {
          AssociationName: 'ExportUser',
          DisplayLabel: 'ExporteradAv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ImportUser: {
          AssociationName: 'ImportUser',
          DisplayLabel: 'Importerad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBudgetgruppBudgkonton: {
      CollectionName: 'EKBudgetgruppBudgkonton',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BudgetgruppBudgkonton',
        Abstract: false,
        SOLabel: 'Budgetgrupp, budgetkonto',
        SOGLabel: 'Budgetgrupp, budgetkonto',
        SBLabel: 'Budgetgrupp, budgetkonto',
        SBGLabel: 'Budgetgrupp, budgetkonto',
        POLabel: 'Budgetgrupp, budgetkonto',
        POGLabel: 'Budgetgrupp, budgetkonto',
        PBLabel: 'Budgetgrupp, budgetkonto',
        PBGLabel: 'Budgetgrupp, budgetkonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgrupp, budgetkonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgrupp, budgetkonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgrupp, budgetkonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Personalmodul/Kapitalmodul',
          DataType: 'Enum',
          EnumValues: new Map([['PERSONALMODUL', 'Personalmodul'], ['KAPITALMODUL', 'Kapitalmodul']]),
          EnumSortValues: new Map([['PERSONALMODUL', 'P'], ['KAPITALMODUL', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PERSONALMODUL=Personalmodul;KAPITALMODUL=Kapitalmodul"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBudgetgruppFordkonton: {
      CollectionName: 'EKBudgetgruppFordkonton',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BudgetgruppFordkonton',
        Abstract: false,
        SOLabel: 'Budgetgrupp, fördelningskonto',
        SOGLabel: 'Budgetgrupp, fördelningskonto',
        SBLabel: 'Budgetgrupp, fördelningskonto',
        SBGLabel: 'Budgetgrupp, fördelningskonto',
        POLabel: 'Budgetgrupp, fördelningskonto',
        POGLabel: 'Budgetgrupp, fördelningskonto',
        PBLabel: 'Budgetgrupp, fördelningskonto',
        PBGLabel: 'Budgetgrupp, fördelningskonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgrupp, fördelningskonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgrupp, fördelningskonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgrupp, fördelningskonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBudgetgruppUrval: {
      CollectionName: 'EKBudgetgruppUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BudgetgruppUrval',
        Abstract: false,
        SOLabel: 'Budgetgrupp, urval',
        SOGLabel: 'Budgetgrupp, urval',
        SBLabel: 'Budgetgrupp, urval',
        SBGLabel: 'Budgetgrupp, urval',
        POLabel: 'Budgetgrupp, urval',
        POGLabel: 'Budgetgrupp, urval',
        PBLabel: 'Budgetgrupp, urval',
        PBGLabel: 'Budgetgrupp, urval',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgrupp, urval primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgrupp, urval versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgrupp, urval fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetBudgkonton: {
      CollectionName: 'EKArbetsbudgetBudgkonton',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetBudgkonton',
        Abstract: false,
        SOLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        SOGLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        SBLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        SBGLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        POLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        POGLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        PBLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        PBGLabel: 'Budgetgruppen per arbetsbudget, budgetkonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, budgetkonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, budgetkonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, budgetkonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetFordkonton: {
      CollectionName: 'EKArbetsbudgetFordkonton',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetFordkonton',
        Abstract: false,
        SOLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        SOGLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        SBLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        SBGLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        POLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        POGLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        PBLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        PBGLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, fördelningskonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Id, view',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKArbetsbudgetLonekonto: {
      CollectionName: 'EKArbetsbudgetLonekonto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetLonekonto',
        Abstract: false,
        SOLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        SOGLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        SBLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        SBGLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        POLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        POGLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        PBLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        PBGLabel: 'Budgetgruppen per arbetsbudget, lönekonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, lönekonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, lönekonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgruppen per arbetsbudget, lönekonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSBUDGET_ID: {
          AttributeName: 'ARBETSBUDGET_ID',
          DisplayLabel: 'Id, arbetsbudget',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Id, konto',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Kontodel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBudgetgrupp: {
      CollectionName: 'EKBudgetgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2038']]),
      RootType: {
        TypeValue: 'Budgetgrupp',
        Abstract: false,
        SOLabel: 'Budgetgrupp',
        SOGLabel: 'Budgetgrupp',
        SBLabel: 'Budgetgruppen',
        SBGLabel: 'Budgetgruppens',
        POLabel: 'Budgetgrupper',
        POGLabel: 'Budgetgruppers',
        PBLabel: 'Budgetgrupperna',
        PBGLabel: 'Budgetgruppernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetgruppens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetgruppens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgetgruppens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetgruppens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        LONESYSTEM_BUDGETGRUPP: {
          AttributeName: 'LONESYSTEM_BUDGETGRUPP',
          DisplayLabel: 'Budgetgrupp, lönesystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FORDELA_ENLIGT_PERSREG: {
          AttributeName: 'FORDELA_ENLIGT_PERSREG',
          DisplayLabel: 'Fördela enligt personalregistret',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UrvalID: {
          AttributeName: 'UrvalID',
          DisplayLabel: 'Urval, ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'ID', defaultValue: ''}},
        },
        UrvalBeskrivning: {
          AttributeName: 'UrvalBeskrivning',
          DisplayLabel: 'Urval, beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'ID', defaultValue: ''}},
        },
        SPECIELLA_BASKONTON: {
          AttributeName: 'SPECIELLA_BASKONTON',
          DisplayLabel: 'Unika baskonton',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetgruppUrval',
          AssociatedComponentName: 'BudgetgruppUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetkonton: {
          AssociationName: 'Budgetkonton',
          DisplayLabel: 'Budgetkonton',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetgruppBudgkonton',
          AssociatedComponentName: 'BudgetgruppBudgkonton',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fordkonton: {
          AssociationName: 'Fordkonton',
          DisplayLabel: 'Fordkonton',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetgruppFordkonton',
          AssociatedComponentName: 'BudgetgruppFordkonton',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        PersonalBudggrupp: {
          AssociationName: 'PersonalBudggrupp',
          DisplayLabel: 'Personal Budgetgrupper',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalBudggrupp',
          AssociatedComponentName: 'PersonalBudggrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonal',
          AssociatedComponentName: 'Personal',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKArbetsbudgetBudgetgrupp: {
      CollectionName: 'EKArbetsbudgetBudgetgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbetsbudgetBudgetgrupp',
        Abstract: false,
        SOLabel: 'Arbetsbudget budgetgrupper',
        SOGLabel: 'Arbetsbudget budgetgrupper',
        SBLabel: 'Arbetsbudget budgetgrupper',
        SBGLabel: 'Arbetsbudget budgetgrupper',
        POLabel: 'Arbetsbudget budgetgrupper',
        POGLabel: 'Arbetsbudget budgetgrupper',
        PBLabel: 'Arbetsbudget budgetgrupper',
        PBGLabel: 'Arbetsbudget budgetgrupper',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsbudget budgetgrupper primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsbudget budgetgrupper versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetsbudget budgetgrupper id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsbudget budgetgrupper fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        LONESYSTEM_BUDGETGRUPP: {
          AttributeName: 'LONESYSTEM_BUDGETGRUPP',
          DisplayLabel: 'Lönesystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BUDGETRAM: {
          AttributeName: 'BUDGETRAM',
          DisplayLabel: 'Budgetram/ANVÄNDS EJ',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        StatusText: {
          AttributeName: 'StatusText',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DELSTATUS: {
          AttributeName: 'DELSTATUS',
          DisplayLabel: 'Summerad årsbudget klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DetaljeradStatusText: {
          AttributeName: 'DetaljeradStatusText',
          DisplayLabel: 'Statustext, detaljerad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SPECIELLA_BASKONTON: {
          AttributeName: 'SPECIELLA_BASKONTON',
          DisplayLabel: 'Unika baskonton',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsbudget: {
          AssociationName: 'Arbetsbudget',
          DisplayLabel: 'Arbetsbudget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudget',
          AssociatedComponentName: 'Arbetsbudget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetUrval',
          AssociatedComponentName: 'ArbetsbudgetUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetkonton: {
          AssociationName: 'Budgetkonton',
          DisplayLabel: 'Budgetkonton',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetBudgkonton',
          AssociatedComponentName: 'ArbetsbudgetBudgkonton',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fordkonton: {
          AssociationName: 'Fordkonton',
          DisplayLabel: 'Fordkonton',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetFordkonton',
          AssociatedComponentName: 'ArbetsbudgetFordkonton',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKArbetsbudgetPersonal',
          AssociatedComponentName: 'ArbetsbudgetPersonal',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBudgetkategori: {
      CollectionName: 'EKBudgetkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Budgetkategori',
        Abstract: false,
        SOLabel: 'Budgetkategori',
        SOGLabel: 'Budgetkategoris',
        SBLabel: 'Budgetkategorin',
        SBGLabel: 'Budgetkategorins',
        POLabel: 'Budgetkategorier',
        POGLabel: 'Budgetkategorier',
        PBLabel: 'Budgetkategorierna',
        PBGLabel: 'Budgetkategoriernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetkategorins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetkategorins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgetkategorins id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetkategorins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PLANBUDGET: {
          AttributeName: 'PLANBUDGET',
          DisplayLabel: 'Planbudget',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENDAST_ADM: {
          AttributeName: 'ENDAST_ADM',
          DisplayLabel: 'Endast för delprogramansvariga',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBudgetkurva: {
      CollectionName: 'EKBudgetkurva',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Budgetkurva',
        Abstract: false,
        SOLabel: 'Budgetkurva',
        SOGLabel: 'Budgetkurva',
        SBLabel: 'Budgetkurvan',
        SBGLabel: 'Budgetkurvan',
        POLabel: 'Budgetkurvor',
        POGLabel: 'Budgetkurvor',
        PBLabel: 'Budgetkurvorna',
        PBGLabel: 'Budgetkurvorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetkurvan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetkurvan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgetkurvan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetkurvan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FORDELNING: {
          AttributeName: 'FORDELNING',
          DisplayLabel: 'Fördelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OVERSKOTT: {
          AttributeName: 'OVERSKOTT',
          DisplayLabel: 'Fördelning av överskott',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBudgetkontering: {
      CollectionName: 'EKBudgetkontering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Budgetkontering',
        Abstract: false,
        SOLabel: 'Budgetrad',
        SOGLabel: 'Budgetrad',
        SBLabel: 'Budgetraden',
        SBGLabel: 'Budgetraden',
        POLabel: 'Budgetrader',
        POGLabel: 'Budgetrader',
        PBLabel: 'Budgetraderna',
        PBGLabel: 'Budgetraderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgetraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOMAT_ID: {
          AttributeName: 'AUTOMAT_ID',
          DisplayLabel: 'Automatkontering id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOMAT_LOPNR: {
          AttributeName: 'AUTOMAT_LOPNR',
          DisplayLabel: 'Automatkontering löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARS_LOPNR: {
          AttributeName: 'ARS_LOPNR',
          DisplayLabel: 'Löpnummer för årspost',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGETKURVA_ID: {
          AttributeName: 'BUDGETKURVA_ID',
          DisplayLabel: 'Budgetkurva',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kodsträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben1: {
          AttributeName: 'Kontoben1',
          DisplayLabel: 'Benämning 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben2: {
          AttributeName: 'Kontoben2',
          DisplayLabel: 'Benämning 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben3: {
          AttributeName: 'Kontoben3',
          DisplayLabel: 'Benämning3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben4: {
          AttributeName: 'Kontoben4',
          DisplayLabel: 'Benämning 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben5: {
          AttributeName: 'Kontoben5',
          DisplayLabel: 'Benämning 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben6: {
          AttributeName: 'Kontoben6',
          DisplayLabel: 'Benämning 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben7: {
          AttributeName: 'Kontoben7',
          DisplayLabel: 'Benämning 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben8: {
          AttributeName: 'Kontoben8',
          DisplayLabel: 'Benämning 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben9: {
          AttributeName: 'Kontoben9',
          DisplayLabel: 'Benämning 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben10: {
          AttributeName: 'Kontoben10',
          DisplayLabel: 'Benämning 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Verifikationstext: {
          AttributeName: 'Verifikationstext',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVRUNDNINGSKOD: {
          AttributeName: 'AVRUNDNINGSKOD',
          DisplayLabel: 'Avrundningskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sumDebet: {
          AttributeName: 'sumDebet',
          DisplayLabel: 'sumDebet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sumKredit: {
          AttributeName: 'sumKredit',
          DisplayLabel: 'sumKredit',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        periodiserad: {
          AttributeName: 'periodiserad',
          DisplayLabel: 'periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        arsPost: {
          AttributeName: 'arsPost',
          DisplayLabel: 'arsPost',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        budgetKurvaBen: {
          AttributeName: 'budgetKurvaBen',
          DisplayLabel: 'budgetKurvaBen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSLUTAT_MOT_PROJEKT: {
          AttributeName: 'AVSLUTAT_MOT_PROJEKT',
          DisplayLabel: 'Avslutat mot projekt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        Konto_del1: {
          AttributeName: 'Konto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '1']]),
        },
        Konto_del2: {
          AttributeName: 'Konto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '2']]),
        },
        Konto_del3: {
          AttributeName: 'Konto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '3']]),
        },
        Konto_del4: {
          AttributeName: 'Konto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '4']]),
        },
        Konto_del5: {
          AttributeName: 'Konto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '5']]),
        },
        Konto_del6: {
          AttributeName: 'Konto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '6']]),
        },
        Konto_del7: {
          AttributeName: 'Konto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '7']]),
        },
        Konto_del8: {
          AttributeName: 'Konto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '8']]),
        },
        Konto_del9: {
          AttributeName: 'Konto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '9']]),
        },
        Konto_del10: {
          AttributeName: 'Konto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['Kontodel', '10']]),
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Anställningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMMENTAR: {
          AttributeName: 'KOMMENTAR',
          DisplayLabel: 'Kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BEFATTNINGSKOD: {
          AttributeName: 'BEFATTNINGSKOD',
          DisplayLabel: 'Befattningskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Fastighetsnr: {
          AttributeName: 'Fastighetsnr',
          DisplayLabel: 'Fastighetsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Fastighetsuppföljning',
        },
        Fastighetstyp: {
          AttributeName: 'Fastighetstyp',
          DisplayLabel: 'Fastighetstyp',
          Hint: 'Församlingshem/Kyrka',
          DataType: 'Enum',
          EnumValues: new Map([['FORSAMLINGSHEM', 'Församlingshem'], ['KYRKA', 'Kyrka']]),
          EnumSortValues: new Map([['FORSAMLINGSHEM', 'F'], ['KYRKA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORSAMLINGSHEM=Församlingshem;KYRKA=Kyrka"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Fastighetsuppföljning',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Budgetverifikation: {
          AssociationName: 'Budgetverifikation',
          DisplayLabel: 'Budgetverifikation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBudgetVer',
          AssociatedComponentName: 'Budgetver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        budgetkurva: {
          AssociationName: 'budgetkurva',
          DisplayLabel: 'budgetkurva',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBudgetkurva',
          AssociatedComponentName: 'Budgetkurva',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfar: {
          AssociationName: 'Bokfar',
          DisplayLabel: 'Bokföringsår',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfar',
          AssociatedComponentName: 'Bokfar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBudgetVer: {
      CollectionName: 'EKBudgetVer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Budgetver',
        Abstract: false,
        SOLabel: 'Budgetverifikation',
        SOGLabel: 'Budgetverifikation',
        SBLabel: 'Budgetverifikationen',
        SBGLabel: 'Budgetverifikationen',
        POLabel: 'Budgetverifikationer',
        POGLabel: 'Budgetverifikationer',
        PBLabel: 'Budgetverifikationerna',
        PBGLabel: 'Budgetverifikationerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Budgetverifikationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Budgetverifikationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Budgetverifikationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Budgetverifikationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGET_NR: {
          AttributeName: 'BUDGET_NR',
          DisplayLabel: 'BUDGET_NR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DebetSumma: {
          AttributeName: 'DebetSumma',
          DisplayLabel: 'Summa debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KreditSumma: {
          AttributeName: 'KreditSumma',
          DisplayLabel: 'Summa kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Budget: {
          AssociationName: 'Budget',
          DisplayLabel: 'Budget',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudget',
          AssociatedComponentName: 'Budget',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetkonteringar: {
          AssociationName: 'Budgetkonteringar',
          DisplayLabel: 'Budgetrader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetkontering',
          AssociatedComponentName: 'Budgetkontering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBunt: {
      CollectionName: 'EKBunt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Bunt',
        Abstract: false,
        SOLabel: 'Bunt',
        SOGLabel: 'Bunt',
        SBLabel: 'Bunten',
        SBGLabel: 'Bunten',
        POLabel: 'Buntar',
        POGLabel: 'Buntar',
        PBLabel: 'Buntarna',
        PBGLabel: 'Buntarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bunten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bunten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bunten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bunten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUNT_SUMMA: {
          AttributeName: 'BUNT_SUMMA',
          DisplayLabel: 'Buntsumma',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Journal: {
          AssociationName: 'Journal',
          DisplayLabel: 'Journal',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfjournal',
          AssociatedComponentName: 'Journal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Verifikationer: {
          AssociationName: 'Verifikationer',
          DisplayLabel: 'Verifikationer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKDelrapport: {
      CollectionName: 'EKDelrapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Delrapport',
        Abstract: false,
        SOLabel: 'Delrapport',
        SOGLabel: 'Delrapport',
        SBLabel: 'Delrapporten',
        SBGLabel: 'Delrapporten',
        POLabel: 'Delrapporter',
        POGLabel: 'Delrapporter',
        PBLabel: 'Delrapporterna',
        PBGLabel: 'Delrapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Delrapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Delrapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Delrapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Delrapport: {
          AssociationName: 'Delrapport',
          DisplayLabel: 'Delrapport',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKDetaljeringsnivaGrupp: {
      CollectionName: 'EKDetaljeringsnivaGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'DetaljeringsnivaGrupp',
        Abstract: false,
        SOLabel: 'Detaljeringsnivå per bokf.grupp',
        SOGLabel: 'Detaljeringsnivå per bokf.grupp',
        SBLabel: 'Detaljeringsnivån per bokf.grupp',
        SBGLabel: 'Detaljeringsnivån per bokf.grupp',
        POLabel: 'Detaljeringsnivåer per bokf.grupp',
        POGLabel: 'Detaljeringsnivåer per bokf.grupp',
        PBLabel: 'Detaljeringsnivåerna per bokf.grupp',
        PBGLabel: 'Detaljeringsnivåerna per bokf.grupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Detaljeringsnivån per bokf.grupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Detaljeringsnivån per bokf.grupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Detaljeringsnivån per bokf.grupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJNIVA: {
          AttributeName: 'DETALJNIVA',
          DisplayLabel: 'Summeringsnivå',
          Hint: 'Kontering/Verifikation/Journal/Datum',
          DataType: 'Enum',
          EnumValues: new Map([['KONTERING', 'Kontering'], ['VERIFIKATION', 'Verifikation'], ['JOURNAL_DATUM', 'Journal/Datum']]),
          EnumSortValues: new Map([['KONTERING', '0'], ['VERIFIKATION', '1'], ['JOURNAL_DATUM', '2']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTERING=Kontering;VERIFIKATION=Verifikation;JOURNAL_DATUM=Journal/Datum"',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBokforderDokument: {
      CollectionName: 'EKBokforderDokument',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,15006']]),
      RootType: {
        TypeValue: 'BokforderDokument',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokuments',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentets',
        POLabel: 'Dokument',
        POGLabel: 'Dokuments',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumentens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBokfVerRemovedDok: {
      CollectionName: 'EKBokfVerRemovedDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfVerRemovedDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokuments',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentets',
        POLabel: 'Dokument',
        POGLabel: 'Dokuments',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumentens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORRTAGEN_DATUM: {
          AttributeName: 'BORRTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGN: {
          AttributeName: 'BORTTAGEN_SIGN',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKGavaDokument: {
      CollectionName: 'EKGavaDokument',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GavaDokument',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Gava: {
          AssociationName: 'Gava',
          DisplayLabel: 'Gåva',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGava',
          AssociatedComponentName: 'Gava',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokfVerDok: {
      CollectionName: 'EKBokfVerDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfVerDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokuments',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentets',
        POLabel: 'Dokument',
        POGLabel: 'Dokuments',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumentens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VER_BILAGA_ID: {
          AttributeName: 'VER_BILAGA_ID',
          DisplayLabel: 'Verifikationsbilaga',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKMomsunderlagDokument: {
      CollectionName: 'EKMomsunderlagDokument',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'MomsunderlagDokument',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokuments',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentets',
        POLabel: 'Dokument',
        POGLabel: 'Dokuments',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumentens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKVerksamhetsniva: {
      CollectionName: 'EKVerksamhetsniva',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Verksamhetsniva',
        Abstract: false,
        SOLabel: 'Verksamhetsnivå',
        SOGLabel: 'Verksamhetsnivå',
        SBLabel: 'Verksamhetsnivå',
        SBGLabel: 'Verksamhetsnivå',
        POLabel: 'Verksamhetsnivå',
        POGLabel: 'Verksamhetsnivå',
        PBLabel: 'Verksamhetsnivå',
        PBGLabel: 'Verksamhetsnivå',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verksamhetsnivå primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verksamhetsnivå versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verksamhetsnivå id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verksamhetsnivå fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifNone',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRappAnvFor: {
      CollectionName: 'EKRappAnvFor',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RappAnvFor',
        Abstract: false,
        SOLabel: 'Ekonomirapport används för',
        SOGLabel: 'Ekonomirapport används för',
        SBLabel: 'Ekonomirapport används för',
        SBGLabel: 'Ekonomirapport används för',
        POLabel: 'Ekonomirapport används för',
        POGLabel: 'Ekonomirapport används för',
        PBLabel: 'Ekonomirapport används för',
        PBGLabel: 'Ekonomirapport används för',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapport används för primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapport används för versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapport används för fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORT_ID: {
          AttributeName: 'RAPPORT_ID',
          DisplayLabel: 'Rapport id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Balans/Resultat/Blandat/Hela huvudboken',
          DataType: 'Enum',
          EnumValues: new Map([['BALANS', 'Balans'], ['RESULTAT', 'Resultat'], ['BLANDAT', 'Blandat'], ['HELA_HUVUDBOKEN', 'Hela huvudboken']]),
          EnumSortValues: new Map([['BALANS', '1'], ['RESULTAT', '2'], ['BLANDAT', '3'], ['HELA_HUVUDBOKEN', '4']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BALANS=Balans;RESULTAT=Resultat;BLANDAT=Blandat;HELA_HUVUDBOKEN=Hela huvudboken"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportDimension: {
      CollectionName: 'EKRapportDimension',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportDimension',
        Abstract: true,
        SOLabel: 'Ekonomirapport, Dimension',
        SOGLabel: 'Ekonomirapport, Dimension',
        SBLabel: 'Ekonomirapport, Dimensionen',
        SBGLabel: 'Ekonomirapport, Dimensionen',
        POLabel: 'Ekonomirapport, Dimensioner',
        POGLabel: 'Ekonomirapport, Dimensioner',
        PBLabel: 'Ekonomirapport, Dimensionerna',
        PBGLabel: 'Ekonomirapport, Dimensionerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapportDimensionLopande',
            Abstract: false,
            SOLabel: 'Löpande',
            SOGLabel: 'Löpande',
            SBLabel: 'Löpande rapporten',
            SBGLabel: 'Löpande rapporten',
            POLabel: 'Löpande rapporter',
            POGLabel: 'Löpande rapporter',
            PBLabel: 'Löpande rapporterna',
            PBGLabel: 'Löpande rapporterna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportDimensionRaddriven',
            Abstract: false,
            SOLabel: 'Radbaserad',
            SOGLabel: 'Radbaserad',
            SBLabel: 'Radbaserade rapporten',
            SBGLabel: 'Radbaserade rapporten',
            POLabel: 'Radbaserade rapporter',
            POGLabel: 'Radbaserade rapporter',
            PBLabel: 'Radbaserade rapporterna',
            PBGLabel: 'Radbaserade rapporterna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportDimensionSammansatt',
            Abstract: false,
            SOLabel: 'Sammansatt rapport',
            SOGLabel: 'Sammansatt rapport',
            SBLabel: 'Sammansatta rapporten',
            SBGLabel: 'Sammansatta rapporten',
            POLabel: 'Sammansatta rapporter',
            POGLabel: 'Sammansatta rapporter',
            PBLabel: 'Sammansatta rapporterna',
            PBGLabel: 'Sammansatta rapporterna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportDimensionBudgeteringsmodell',
            Abstract: false,
            SOLabel: 'Radbaserad summeringsmodell',
            SOGLabel: 'Radbaserad summeringsmodells',
            SBLabel: 'Radbaserad summeringsmodellen',
            SBGLabel: 'Radbaserad summeringsmodellens',
            POLabel: 'Radbaserad summeringsmodeller',
            POGLabel: 'Radbaserad summeringsmodellers',
            PBLabel: 'Radbaserad summeringsmodellerna',
            PBGLabel: 'Radbaserad summeringsmodellernas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportDimensionBudgeteringLopande',
            Abstract: false,
            SOLabel: 'Löpande summeringsmodell',
            SOGLabel: 'Löpande summeringsmodells',
            SBLabel: 'Löpande summeringsmodellen',
            SBGLabel: 'Löpande summeringsmodellens',
            POLabel: 'Löpande summeringsmodeller',
            POGLabel: 'Löpande summeringsmodellers',
            PBLabel: 'Löpande summeringsmodellerna',
            PBGLabel: 'Löpande summeringsmodellernas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportDimensionBudgeteringsunderlag',
            Abstract: false,
            SOLabel: 'Budgeteringsunderlagsmodell',
            SOGLabel: 'Budgeteringsunderlagsmodells',
            SBLabel: 'Budgeteringsunderlagsmodellen',
            SBGLabel: 'Budgeteringsunderlagsmodellens',
            POLabel: 'Budgeteringsunderlagsmodeller',
            POGLabel: 'Budgeteringsunderlagsmodellers',
            PBLabel: 'Budgeteringsunderlagsmodellerna',
            PBGLabel: 'Budgeteringsunderlagsmodellernas',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapport, Dimensionen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapport, Dimensionen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTDIMENSIONLOPANDE', 'Löpande'], ['RAPPORTDIMENSIONRADDRIVEN', 'Radbaserad'], ['RAPPORTDIMENSIONSAMMANSATT', 'Sammansatt rapport'], ['RAPPORTDIMENSIONBUDGETERINGSMODELL', 'Radbaserad summeringsmodell'], ['RAPPORTDIMENSIONBUDGETERINGLOPANDE', 'Löpande summeringsmodell'], ['RAPPORTDIMENSIONBUDGETERINGSUNDERLAG', 'Budgeteringsunderlagsmodell']]),
          EnumSortValues: new Map([['RAPPORTDIMENSIONLOPANDE', 'L'], ['RAPPORTDIMENSIONRADDRIVEN', 'R'], ['RAPPORTDIMENSIONSAMMANSATT', 'S'], ['RAPPORTDIMENSIONBUDGETERINGSMODELL', 'B'], ['RAPPORTDIMENSIONBUDGETERINGLOPANDE', '1'], ['RAPPORTDIMENSIONBUDGETERINGSUNDERLAG', '2']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RAPPORTDIMENSIONLOPANDE=Löpande;RAPPORTDIMENSIONRADDRIVEN=Radbaserad;RAPPORTDIMENSIONSAMMANSATT=Sammansatt rapport;RAPPORTDIMENSIONBUDGETERINGSMODELL=Radbaserad summeringsmodell;RAPPORTDIMENSIONBUDGETERINGLOPANDE=Löpande summeringsmodell;RAPPORTDIMENSIONBUDGETERINGSUNDERLAG=Budgeteringsunderlagsmodell"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ekonomirapport, Dimensionen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapport, Dimensionen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INDENTERA_NIVAER: {
          AttributeName: 'INDENTERA_NIVAER',
          DisplayLabel: 'Indentera nivåer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVAND_FARG: {
          AttributeName: 'ANVAND_FARG',
          DisplayLabel: 'Färga nivåer',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_FONT_NAMN: {
          AttributeName: 'SUMMA_FONT_NAMN',
          DisplayLabel: 'Summa, teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMA_STORLEK: {
          AttributeName: 'SUMMA_STORLEK',
          DisplayLabel: 'Summa, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMA_BOLD: {
          AttributeName: 'SUMMA_BOLD',
          DisplayLabel: 'Summa, fet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_ITALIC: {
          AttributeName: 'SUMMA_ITALIC',
          DisplayLabel: 'Summa, kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_UNDERLINE: {
          AttributeName: 'SUMMA_UNDERLINE',
          DisplayLabel: 'Summa, understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_STRIKE_OUT: {
          AttributeName: 'SUMMA_STRIKE_OUT',
          DisplayLabel: 'Summe, genomstruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        DETALJ_FONT_NAMN: {
          AttributeName: 'DETALJ_FONT_NAMN',
          DisplayLabel: 'Detaljnivå, teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJ_STORLEK: {
          AttributeName: 'DETALJ_STORLEK',
          DisplayLabel: 'Detalj, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJ_BOLD: {
          AttributeName: 'DETALJ_BOLD',
          DisplayLabel: 'Detaljnivå, fet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJ_ITALIC: {
          AttributeName: 'DETALJ_ITALIC',
          DisplayLabel: 'Detaljnivå, kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        DETALJ_UNDERLINE: {
          AttributeName: 'DETALJ_UNDERLINE',
          DisplayLabel: 'Detaljnivå, understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        DETALJ_STRIKE_OUT: {
          AttributeName: 'DETALJ_STRIKE_OUT',
          DisplayLabel: 'Detaljnivå, genomstruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BEN_FLERA_RADER: {
          AttributeName: 'BEN_FLERA_RADER',
          DisplayLabel: 'Tillåt flera rader i benämning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BEN_BREDD: {
          AttributeName: 'BEN_BREDD',
          DisplayLabel: 'Benämningens bredd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Ekonomirapport: {
          AssociationName: 'Ekonomirapport',
          DisplayLabel: 'Ekonomirapport',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grupperingsbegrepp: {
          AssociationName: 'Grupperingsbegrepp',
          DisplayLabel: 'Grupperingsbegrepp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGruppering',
          AssociatedComponentName: 'Gruppering',
          JoinAssociation: false,
          ValidInComps: ['RapportDimensionLopande'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dimensionsrader: {
          AssociationName: 'Dimensionsrader',
          DisplayLabel: 'Rader',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKDimensionsrad',
          AssociatedComponentName: 'Dimensionsrad',
          JoinAssociation: false,
          ValidInComps: ['RapportDimensionRaddriven'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKRapportFalt: {
      CollectionName: 'EKRapportFalt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportFalt',
        Abstract: false,
        SOLabel: 'Ekonomirapport, Kolumn',
        SOGLabel: 'Ekonomirapport, Kolumn',
        SBLabel: 'Ekonomirapport, Kolumnen',
        SBGLabel: 'Ekonomirapport, Kolumnen',
        POLabel: 'Ekonomirapport, Kolumner',
        POGLabel: 'Ekonomirapport, Kolumner',
        PBLabel: 'Ekonomirapport, Kolumnerna',
        PBGLabel: 'Ekonomirapport, Kolumnerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapport, Kolumnen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapport, Kolumnen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ekonomirapport, Kolumnen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapport, Kolumnen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPECIFIKATION: {
          AttributeName: 'SPECIFIKATION',
          DisplayLabel: 'Fältspecifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FALTKOD: {
          AttributeName: 'FALTKOD',
          DisplayLabel: 'Hämtas från',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_AR: {
          AttributeName: 'FROM_AR',
          DisplayLabel: 'Fr o m år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_AR_RELATIV: {
          AttributeName: 'FROM_AR_RELATIV',
          DisplayLabel: 'Fr o m relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_AR: {
          AttributeName: 'TOM_AR',
          DisplayLabel: 'T o m år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_AR_RELATIV: {
          AttributeName: 'TOM_AR_RELATIV',
          DisplayLabel: 'T o m år relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_PER: {
          AttributeName: 'FROM_PER',
          DisplayLabel: 'Fr o m period',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_PER_RELATIV: {
          AttributeName: 'FROM_PER_RELATIV',
          DisplayLabel: 'Fr o m period relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_PER: {
          AttributeName: 'TOM_PER',
          DisplayLabel: 'T o m period',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOM_PER_RELATIV: {
          AttributeName: 'TOM_PER_RELATIV',
          DisplayLabel: 'T o m period relativ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGET_TYP: {
          AttributeName: 'BUDGET_TYP',
          DisplayLabel: 'Urval budgettyp',
          Hint: 'Alla/Specifik budgettyp/Specifik budget',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA', 'Alla'], ['SPECIFIK_BUDGETTYP', 'Specifik budgettyp'], ['SPECIFIK_BUDGET', 'Specifik budget']]),
          EnumSortValues: new Map([['ALLA', 'A'], ['SPECIFIK_BUDGETTYP', 'T'], ['SPECIFIK_BUDGET', 'B']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA=Alla;SPECIFIK_BUDGETTYP=Specifik budgettyp;SPECIFIK_BUDGET=Specifik budget"',
        },
        BUDGET_BENAMNING: {
          AttributeName: 'BUDGET_BENAMNING',
          DisplayLabel: 'Urval budgetbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FALT_TYP: {
          AttributeName: 'FALT_TYP',
          DisplayLabel: 'Fälttyp',
          Hint: 'Saldo/Debet/Kredit/Antal',
          DataType: 'Enum',
          EnumValues: new Map([['SALDO', 'Saldo'], ['DEBET', 'Debet'], ['KREDIT', 'Kredit'], ['ANTAL', 'Antal']]),
          EnumSortValues: new Map([['SALDO', 'S'], ['DEBET', 'D'], ['KREDIT', 'K'], ['ANTAL', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SALDO=Saldo;DEBET=Debet;KREDIT=Kredit;ANTAL=Antal"',
        },
        VISA_FROM_TOM: {
          AttributeName: 'VISA_FROM_TOM',
          DisplayLabel: 'Visa from/tom',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BAS: {
          AttributeName: 'BAS',
          DisplayLabel: 'Bas',
          Hint: 'Kronor/Tusentals kronor/Miljontals kronor',
          DataType: 'Enum',
          EnumValues: new Map([['KRONOR', 'Kronor'], ['TUSENTALS_KRONOR', 'Tusentals kronor'], ['MILJONTALS_KRONOR', 'Miljontals kronor']]),
          EnumSortValues: new Map([['KRONOR', '1'], ['TUSENTALS_KRONOR', '1000'], ['MILJONTALS_KRONOR', '1000000']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KRONOR=Kronor;TUSENTALS_KRONOR=Tusentals kronor;MILJONTALS_KRONOR=Miljontals kronor"',
        },
        ANTAL_DECIMALER: {
          AttributeName: 'ANTAL_DECIMALER',
          DisplayLabel: 'Antal decimaler',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="2"',
        },
        VAND_TECKEN: {
          AttributeName: 'VAND_TECKEN',
          DisplayLabel: 'Vänd tecken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BREDD_PROCENT: {
          AttributeName: 'BREDD_PROCENT',
          DisplayLabel: 'Procentuell bredd vid utskrift',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        BENAMNING2: {
          AttributeName: 'BENAMNING2',
          DisplayLabel: 'Benämning 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOLLUNDERTRYCK: {
          AttributeName: 'NOLLUNDERTRYCK',
          DisplayLabel: 'Nollundertryckning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FIELDID: {
          AttributeName: 'FIELDID',
          DisplayLabel: 'Fält id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_FONT_NAMN: {
          AttributeName: 'RUB_FONT_NAMN',
          DisplayLabel: 'Teckensnitt, rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_STORLEK: {
          AttributeName: 'RUB_STORLEK',
          DisplayLabel: 'Rubrik, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_BOLD: {
          AttributeName: 'RUB_BOLD',
          DisplayLabel: 'Rubrik, fet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RUB_ITALIC: {
          AttributeName: 'RUB_ITALIC',
          DisplayLabel: 'Rubrik, kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RUB_UNDERLINE: {
          AttributeName: 'RUB_UNDERLINE',
          DisplayLabel: 'Rubrik, understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SKRIV_UT: {
          AttributeName: 'SKRIV_UT',
          DisplayLabel: 'Skriv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_FARG_NEGATIV: {
          AttributeName: 'BELOPP_FARG_NEGATIV',
          DisplayLabel: 'Färg för negativt belopp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERVALL_TYP: {
          AttributeName: 'INTERVALL_TYP',
          DisplayLabel: 'Intervalltyp',
          Hint: 'Period/Datum',
          DataType: 'Enum',
          EnumValues: new Map([['PERIOD', 'Period'], ['DATUM', 'Datum']]),
          EnumSortValues: new Map([['PERIOD', '0'], ['DATUM', '1']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PERIOD=Period;DATUM=Datum"',
        },
        BREDD_MM: {
          AttributeName: 'BREDD_MM',
          DisplayLabel: 'Kolumnbredd i mm',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Kolumntyp',
          Hint: 'Enkel/Beräknad/Procentuell fördelning',
          DataType: 'Enum',
          EnumValues: new Map([['ENKEL', 'Enkel'], ['BERAKNAD', 'Beräknad'], ['PROCENTUELL_FORDELNING', 'Procentuell fördelning']]),
          EnumSortValues: new Map([['ENKEL', 'F'], ['BERAKNAD', 'B'], ['PROCENTUELL_FORDELNING', 'P']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENKEL=Enkel;BERAKNAD=Beräknad;PROCENTUELL_FORDELNING=Procentuell fördelning"',
          GUIEditable: true,
        },
        RESULTAT_TYP: {
          AttributeName: 'RESULTAT_TYP',
          DisplayLabel: 'Resultattyp',
          Hint: 'Belopp/Procent',
          DataType: 'Enum',
          EnumValues: new Map([['BELOPP', 'Belopp'], ['PROCENT', 'Procent']]),
          EnumSortValues: new Map([['BELOPP', 'B'], ['PROCENT', 'P']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BELOPP=Belopp;PROCENT=Procent"',
          GUIEditable: true,
          Required: true,
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_RADNIVA: {
          AttributeName: 'FORDELN_RADNIVA',
          DisplayLabel: 'Fördelning i förhållande till radnivå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORDELN_VISA_RADNIVA: {
          AttributeName: 'FORDELN_VISA_RADNIVA',
          DisplayLabel: 'Visa kolumn för radnivå',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_DETALJ: {
          AttributeName: 'SKRIV_DETALJ',
          DisplayLabel: 'Skriv detaljbelopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RULLANDE: {
          AttributeName: 'RULLANDE',
          DisplayLabel: 'Rullande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kolumnspecifikationer: {
          AssociationName: 'Kolumnspecifikationer',
          DisplayLabel: 'Kolumnspecifikationer',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportfaltSpec',
          AssociatedComponentName: 'RapportfaltSpec',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKRapportfaltSpec: {
      CollectionName: 'EKRapportfaltSpec',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapportfaltSpec',
        Abstract: true,
        SOLabel: 'Kolumnspecifikation',
        SOGLabel: 'Kolumnspecifikation',
        SBLabel: 'Kolumnspecifikationen',
        SBGLabel: 'Kolumnspecifikationen',
        POLabel: 'Kolumnspecifikationer',
        POGLabel: 'Kolumnspecifikationer',
        PBLabel: 'Kolumnspecifikationerna',
        PBGLabel: 'Kolumnspecifikationerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapportfaltspecFalt',
            Abstract: false,
            SOLabel: 'Kolumn',
            SOGLabel: 'Kolumn',
            SBLabel: 'Kolumnen',
            SBGLabel: 'Kolumnen',
            POLabel: 'Kolumner',
            POGLabel: 'Kolumner',
            PBLabel: 'Kolumnerna',
            PBGLabel: 'Kolumnerna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportfaltspecOperator',
            Abstract: false,
            SOLabel: 'Operator',
            SOGLabel: 'Operator',
            SBLabel: 'Operatorn',
            SBGLabel: 'Operatorn',
            POLabel: 'Operatorer',
            POGLabel: 'Operatorer',
            PBLabel: 'Operatorerna',
            PBGLabel: 'Operatorerna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportfaltspecKonstant',
            Abstract: false,
            SOLabel: 'Konstant',
            SOGLabel: 'Konstant',
            SBLabel: 'Konstanten',
            SBGLabel: 'Konstanten',
            POLabel: 'Konstanter',
            POGLabel: 'Konstanter',
            PBLabel: 'Konstanterna',
            PBGLabel: 'Konstanterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kolumnspecifikationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kolumnspecifikationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTFALTSPECFALT', 'Kolumn'], ['RAPPORTFALTSPECOPERATOR', 'Operator'], ['RAPPORTFALTSPECKONSTANT', 'Konstant']]),
          EnumSortValues: new Map([['RAPPORTFALTSPECFALT', 'F'], ['RAPPORTFALTSPECOPERATOR', 'O'], ['RAPPORTFALTSPECKONSTANT', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kolumnspecifikationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kolumnspecifikationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORT_ID: {
          AttributeName: 'RAPPORT_ID',
          DisplayLabel: 'Rapport id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        REF_RAPPORT_ID: {
          AttributeName: 'REF_RAPPORT_ID',
          DisplayLabel: 'Ref rapport id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecFalt'],
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Ref lopnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecFalt'],
        },
        OPERATOR: {
          AttributeName: 'OPERATOR',
          DisplayLabel: 'Operator',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
          ValidInComps: ['RapportfaltspecOperator'],
        },
        CONSTANT: {
          AttributeName: 'CONSTANT',
          DisplayLabel: 'Konstant',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['RapportfaltspecKonstant'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKDimensionsrad: {
      CollectionName: 'EKDimensionsrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Dimensionsrad',
        Abstract: true,
        SOLabel: 'Rapportrad',
        SOGLabel: 'Rapportrad',
        SBLabel: 'Rapportraden',
        SBGLabel: 'Rapportraden',
        POLabel: 'Rapportrader',
        POGLabel: 'Rapportrader',
        PBLabel: 'Rapportraderna',
        PBGLabel: 'Rapportraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapportDimensionsRad',
            Abstract: false,
            SOLabel: 'Beloppsrad',
            SOGLabel: 'Beloppsrad',
            SBLabel: 'Beloppsraden',
            SBGLabel: 'Beloppsraden',
            POLabel: 'Beloppsrader',
            POGLabel: 'Beloppsrader',
            PBLabel: 'Beloppsraderna',
            PBGLabel: 'Beloppsraderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SummaDimensionsrad',
            Abstract: false,
            SOLabel: 'Summarad',
            SOGLabel: 'Summarad',
            SBLabel: 'Summaraden',
            SBGLabel: 'Summaraden',
            POLabel: 'Summarader',
            POGLabel: 'Summarader',
            PBLabel: 'Summaraderna',
            PBGLabel: 'Summaraderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'TextDimensionsRad',
            Abstract: false,
            SOLabel: 'Textrad',
            SOGLabel: 'Textrad',
            SBLabel: 'Textraden',
            SBGLabel: 'Textraden',
            POLabel: 'Textrader',
            POGLabel: 'Textrader',
            PBLabel: 'Textraderna',
            PBGLabel: 'Textraderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'SidbrytningDimensionsrad',
            Abstract: false,
            SOLabel: 'Sidbrytning',
            SOGLabel: 'Sidbrytning',
            SBLabel: 'Sidbrytningen',
            SBGLabel: 'Sidbrytningen',
            POLabel: 'Sidbrytningar',
            POGLabel: 'Sidbrytningar',
            PBLabel: 'Sidbrytningarna',
            PBGLabel: 'Sidbrytningarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BudgetramDimensionsrad',
            Abstract: false,
            SOLabel: 'Budgetram',
            SOGLabel: 'Budgetrams',
            SBLabel: 'Budgetramen',
            SBGLabel: 'Budgetramens',
            POLabel: 'Budgetramar',
            POGLabel: 'Budgetramars',
            PBLabel: 'Budgetramarna',
            PBGLabel: 'Budgetramarnas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BalansresDimensionsrad',
            Abstract: false,
            SOLabel: 'Balanserat resultat',
            SOGLabel: 'Balanserat resultat',
            SBLabel: 'Balanserat resultat',
            SBGLabel: 'Balanserat resultat',
            POLabel: 'Balanserat resultat',
            POGLabel: 'Balanserat resultat',
            PBLabel: 'Balanserat resultat',
            PBGLabel: 'Balanserat resultat',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'LinjeDimensionsrad',
            Abstract: false,
            SOLabel: 'Linje, normal',
            SOGLabel: 'Linje, normal',
            SBLabel: 'Linje, normal',
            SBGLabel: 'Linje, normal',
            POLabel: 'Linje, normal',
            POGLabel: 'Linje, normal',
            PBLabel: 'Linje, normal',
            PBGLabel: 'Linje, normal',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'FetLinjeDimensionsrad',
            Abstract: false,
            SOLabel: 'Linje, fetstil',
            SOGLabel: 'Linje, fetstil',
            SBLabel: 'Linje, fetstil',
            SBGLabel: 'Linje, fetstil',
            POLabel: 'Linje, fetstil',
            POGLabel: 'Linje, fetstil',
            PBLabel: 'Linje, fetstil',
            PBGLabel: 'Linje, fetstil',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTDIMENSIONSRAD', 'Beloppsrad'], ['SUMMADIMENSIONSRAD', 'Summarad'], ['TEXTDIMENSIONSRAD', 'Textrad'], ['SIDBRYTNINGDIMENSIONSRAD', 'Sidbrytning'], ['BUDGETRAMDIMENSIONSRAD', 'Budgetram'], ['BALANSRESDIMENSIONSRAD', 'Balanserat resultat'], ['LINJEDIMENSIONSRAD', 'Linje, normal'], ['FETLINJEDIMENSIONSRAD', 'Linje, fetstil']]),
          EnumSortValues: new Map([['RAPPORTDIMENSIONSRAD', 'R'], ['SUMMADIMENSIONSRAD', 'S'], ['TEXTDIMENSIONSRAD', 'T'], ['SIDBRYTNINGDIMENSIONSRAD', 'N'], ['BUDGETRAMDIMENSIONSRAD', 'B'], ['BALANSRESDIMENSIONSRAD', 'C'], ['LINJEDIMENSIONSRAD', 'L'], ['FETLINJEDIMENSIONSRAD', 'F']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RAPPORTDIMENSIONSRAD=Beloppsrad;SUMMADIMENSIONSRAD=Summarad;TEXTDIMENSIONSRAD=Textrad;SIDBRYTNINGDIMENSIONSRAD=Sidbrytning;BUDGETRAMDIMENSIONSRAD=Budgetram;BALANSRESDIMENSIONSRAD=Balanserat resultat;LINJEDIMENSIONSRAD=Linje, normal;FETLINJEDIMENSIONSRAD=Linje, fetstil"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NIVA: {
          AttributeName: 'NIVA',
          DisplayLabel: 'Nivå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FONT_NAMN: {
          AttributeName: 'FONT_NAMN',
          DisplayLabel: 'Font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOLD: {
          AttributeName: 'BOLD',
          DisplayLabel: 'Fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        ITALIC: {
          AttributeName: 'ITALIC',
          DisplayLabel: 'Kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UNDERLINE: {
          AttributeName: 'UNDERLINE',
          DisplayLabel: 'Understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        STRIKE_OUT: {
          AttributeName: 'STRIKE_OUT',
          DisplayLabel: 'STRIKE_OUT',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RAD_ID: {
          AttributeName: 'RAD_ID',
          DisplayLabel: 'Rad id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_FONT_NAMN: {
          AttributeName: 'BELOPP_FONT_NAMN',
          DisplayLabel: 'Belopp - font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_STORLEK: {
          AttributeName: 'BELOPP_STORLEK',
          DisplayLabel: 'Belopp - storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_BOLD: {
          AttributeName: 'BELOPP_BOLD',
          DisplayLabel: 'Belopp -fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_ITALIC: {
          AttributeName: 'BELOPP_ITALIC',
          DisplayLabel: 'Belopp - kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_UNDERLINE: {
          AttributeName: 'BELOPP_UNDERLINE',
          DisplayLabel: 'Belopp - understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_STRIKE_OUT: {
          AttributeName: 'BELOPP_STRIKE_OUT',
          DisplayLabel: 'BELOPP_STRIKE_OUT',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SKRIV_UT_NOLLBELOPP: {
          AttributeName: 'SKRIV_UT_NOLLBELOPP',
          DisplayLabel: 'Skriv ut nollbelopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SKRIV_EJ_FALT: {
          AttributeName: 'SKRIV_EJ_FALT',
          DisplayLabel: 'Skriv ej ut följande fält',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_EJ_RAD: {
          AttributeName: 'SKRIV_EJ_RAD',
          DisplayLabel: 'Skriv inte ut raden',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RAD_NOT: {
          AttributeName: 'RAD_NOT',
          DisplayLabel: 'Not',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMERING: {
          AttributeName: 'SUMMERING',
          DisplayLabel: 'Summering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA: {
          AttributeName: 'DELSUMMA',
          DisplayLabel: 'Delsumma',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Radnr: {
          AttributeName: 'Radnr',
          DisplayLabel: 'Radnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
        },
        SM_KONTROLLERA_KONTODELAR: {
          AttributeName: 'SM_KONTROLLERA_KONTODELAR',
          DisplayLabel: 'Kontrollera kontodelar',
          Hint: 'Summeringsmodell, kontrollera kontokombination vid registreringa av arbetsbudget',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Radspec: {
          AssociationName: 'Radspec',
          DisplayLabel: 'Radspec',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportradsspec',
          AssociatedComponentName: 'Rapportradsspec',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGruppering: {
      CollectionName: 'EKGruppering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Gruppering',
        Abstract: false,
        SOLabel: 'Ekonomirapport, Radnivå',
        SOGLabel: 'Ekonomirapport, Radnivå',
        SBLabel: 'Ekonomirapport, Radnivån',
        SBGLabel: 'Ekonomirapport, Radnivån',
        POLabel: 'Ekonomirapport, Radnivåer',
        POGLabel: 'Ekonomirapport, Radnivåer',
        PBLabel: 'Ekonomirapport, Radnivåerna',
        PBGLabel: 'Ekonomirapport, Radnivåerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapport, Radnivån primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapport, Radnivån versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ekonomirapport, Radnivån id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapport, Radnivån fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_KONTODEL: {
          AttributeName: 'ORDNINGS_NR_KONTODEL',
          DisplayLabel: 'Ordningsnr för kontodel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTPOS: {
          AttributeName: 'STARTPOS',
          DisplayLabel: 'Startposition',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTPOS: {
          AttributeName: 'SLUTPOS',
          DisplayLabel: 'Slutposition',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_NIVA: {
          AttributeName: 'DOLJ_NIVA',
          DisplayLabel: 'Dölj nivå',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SIDBRYTNING: {
          AttributeName: 'SIDBRYTNING',
          DisplayLabel: 'Sidbrytning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BENAMNING_BLANK: {
          AttributeName: 'BENAMNING_BLANK',
          DisplayLabel: 'Benämning för blank kontodel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING_ANTAL_POS: {
          AttributeName: 'BENAMNING_ANTAL_POS',
          DisplayLabel: 'Antal tecken i benämningen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING_FLERA_RADER: {
          AttributeName: 'BENAMNING_FLERA_RADER',
          DisplayLabel: 'Tillåt benämning på flera rader',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        GRUPPERINGSTYP: {
          AttributeName: 'GRUPPERINGSTYP',
          DisplayLabel: 'Grupperingstyp',
          Hint: 'Redovisningsklass/Redovisningsgrupp/Momskod/Verksamhetsområde/Verksamhetsnivå/Fastighetsnr/Fastighetstyp/Huvudprojekt/Leverantör',
          DataType: 'Enum',
          EnumValues: new Map([['REDOVISNINGSKLASS', 'Redovisningsklass'], ['REDOVISNINGSGRUPP', 'Redovisningsgrupp'], ['MOMSKOD', 'Momskod'], ['VERKSAMHETSOMRADE', 'Verksamhetsområde'], ['VERKSAMHETSNIVA', 'Verksamhetsnivå'], ['FASTIGHETSNR', 'Fastighetsnr'], ['FASTIGHETSTYP', 'Fastighetstyp'], ['HUVUDPROJEKT', 'Huvudprojekt'], ['LEVERANTOR', 'Leverantör']]),
          EnumSortValues: new Map([['REDOVISNINGSKLASS', 'REDOVISN_TYP'], ['REDOVISNINGSGRUPP', 'KI_TYP'], ['MOMSKOD', 'MOMS_KOD'], ['VERKSAMHETSOMRADE', 'KB_VERKSOMR'], ['VERKSAMHETSNIVA', 'KB_VERKSAMHET'], ['FASTIGHETSNR', 'FASTIGHETSNUMMER'], ['FASTIGHETSTYP', 'FASTIGHETSTYP'], ['HUVUDPROJEKT', 'HUVUDPROJEKT'], ['LEVERANTOR', 'LEVERANTORSNR']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="REDOVISNINGSKLASS=Redovisningsklass;REDOVISNINGSGRUPP=Redovisningsgrupp;MOMSKOD=Momskod;VERKSAMHETSOMRADE=Verksamhetsområde;VERKSAMHETSNIVA=Verksamhetsnivå;FASTIGHETSNR=Fastighetsnr;FASTIGHETSTYP=Fastighetstyp;HUVUDPROJEKT=Huvudprojekt;LEVERANTOR=Leverantör"',
          Properties: new Map([['MOMS_KOD_JOIN', 'left outer join EK_MOMSKOD M on M.ID = K1.MOMS_ID;MOMS_KOD_ALIAS=M;MOMS_KOD_WIDTH=4;MOMS_KOD_BENAMNING=select BENAMNING from EK_MOMSKOD where MOMS_KOD = :GRUPPERINGSTYP;KB_VERKSOMR_VERKSAMHET=Y;KB_VERKSAMHET_VERKSAMHET=Y;FASTIGHETSNUMMER_JOIN=left outer join AR_PLATS FN on FN.ID = @KX.FASTIGHETS_ID;FASTIGHETSNUMMER_ALIAS=FN;FASTIGHETSNUMMER_WIDTH=12;FASTIGHETSTYP_JOIN=left outer join AR_PLATS FT on FT.ID = @KX.FASTIGHETS_ID;FASTIGHETSTYP_ALIAS=FT;FASTIGHETSTYP_KOD_WIDTH=12;HUVUDPROJEKT_JOIN=left outer join EK_HUVUDPROJEKT HP on HP.KPLAN_ID  = @KX.KPLAN_ID and HP.ORDNINGS_NR  = @KX.ORDNINGS_NR and HP.ID = @KX.HUVUDPROJEKT_ID ;HUVUDPROJEKT_ALIAS=HP;HUVUDPROJEKT_WIDTH=12;']]),
        },
        FONT_NAMN: {
          AttributeName: 'FONT_NAMN',
          DisplayLabel: 'Teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Stroek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOLD: {
          AttributeName: 'BOLD',
          DisplayLabel: 'Fet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ITALIC: {
          AttributeName: 'ITALIC',
          DisplayLabel: 'Kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UNDERLINE: {
          AttributeName: 'UNDERLINE',
          DisplayLabel: 'Understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STRIKE_OUT: {
          AttributeName: 'STRIKE_OUT',
          DisplayLabel: 'Genomstruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIVERSE: {
          AttributeName: 'DIVERSE',
          DisplayLabel: 'Diverse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA: {
          AttributeName: 'DELSUMMA',
          DisplayLabel: 'Delsumma',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SKRIV_DELSUMMA: {
          AttributeName: 'SKRIV_DELSUMMA',
          DisplayLabel: 'Skriv delsumma',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        DELSUMMA_FORMAT: {
          AttributeName: 'DELSUMMA_FORMAT',
          DisplayLabel: 'Delsumma format',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_FONT_NAMN: {
          AttributeName: 'DELSUMMA_FONT_NAMN',
          DisplayLabel: 'Delsumma, teckensnitt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_STORLEK: {
          AttributeName: 'DELSUMMA_STORLEK',
          DisplayLabel: 'Delsumma, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_BOLD: {
          AttributeName: 'DELSUMMA_BOLD',
          DisplayLabel: 'Delsumma, fetstil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_ITALIC: {
          AttributeName: 'DELSUMMA_ITALIC',
          DisplayLabel: 'Delsumma, kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_UNDERLINE: {
          AttributeName: 'DELSUMMA_UNDERLINE',
          DisplayLabel: 'Delsumma, understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSUMMA_STRIKE_OUT: {
          AttributeName: 'DELSUMMA_STRIKE_OUT',
          DisplayLabel: 'Delsumma, genomstruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_EJ_FALT: {
          AttributeName: 'SKRIV_EJ_FALT',
          DisplayLabel: 'Skriv ej ut följande belopp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportradsspec: {
      CollectionName: 'EKRapportradsspec',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Rapportradsspec',
        Abstract: true,
        SOLabel: 'Rapportradsspecifikation',
        SOGLabel: 'Rapportradsspecifikation',
        SBLabel: 'Rapportradsspecifikationen',
        SBGLabel: 'Rapportradsspecifikationen',
        POLabel: 'Rapportradsspecifikationer',
        POGLabel: 'Rapportradsspecifikationer',
        PBLabel: 'Rapportradsspecifikationerna',
        PBGLabel: 'Rapportradsspecifikationerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapportradspecUrval',
            Abstract: false,
            SOLabel: 'Urval',
            SOGLabel: 'Urval',
            SBLabel: 'Urvalet',
            SBGLabel: 'Urvalet',
            POLabel: 'Urval',
            POGLabel: 'Urval',
            PBLabel: 'Urvalet',
            PBGLabel: 'Urvalet',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportradspecOperator',
            Abstract: false,
            SOLabel: 'Operator',
            SOGLabel: 'Operator',
            SBLabel: 'Operatorn',
            SBGLabel: 'Operatorn',
            POLabel: 'Operatorer',
            POGLabel: 'Operatorer',
            PBLabel: 'Operatorerna',
            PBGLabel: 'Operatorerna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapportradspecReferens',
            Abstract: false,
            SOLabel: 'Rapportrad',
            SOGLabel: 'Rapportrad',
            SBLabel: 'Rapportraden',
            SBGLabel: 'Rapportraden',
            POLabel: 'Rapportrader',
            POGLabel: 'Rapportrader',
            PBLabel: 'Rapportraderna',
            PBGLabel: 'Rapportraderna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'RapportradspecCellRef',
                Abstract: false,
                SOLabel: 'Rapportvärde',
                SOGLabel: 'Rapportvärde',
                SBLabel: 'Rapportvärdet',
                SBGLabel: 'Rapportvärdet',
                POLabel: 'Rapportvärde',
                POGLabel: 'Rapportvärde',
                PBLabel: 'Rapportvärdena',
                PBGLabel: 'Rapportvärdena',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'RapportradspecKonstant',
            Abstract: false,
            SOLabel: 'Konstant',
            SOGLabel: 'Konstant',
            SBLabel: 'Konstanten',
            SBGLabel: 'Konstanten',
            POLabel: 'Konstanter',
            POGLabel: 'Konstanter',
            PBLabel: 'Konstanterna',
            PBGLabel: 'Konstanterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportradsspecifikationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportradsspecifikationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTRADSPECURVAL', 'Urval'], ['RAPPORTRADSPECOPERATOR', 'Operator'], ['RAPPORTRADSPECREFERENS', 'Rapportrad'], ['RAPPORTRADSPECCELLREF', 'Rapportvärde'], ['RAPPORTRADSPECKONSTANT', 'Konstant']]),
          EnumSortValues: new Map([['RAPPORTRADSPECURVAL', 'U'], ['RAPPORTRADSPECOPERATOR', 'O'], ['RAPPORTRADSPECREFERENS', 'R'], ['RAPPORTRADSPECCELLREF', 'F'], ['RAPPORTRADSPECKONSTANT', 'C']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportradsspecifikationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportradsspecifikationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urvals id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecUrval'],
        },
        OPERATOR: {
          AttributeName: 'OPERATOR',
          DisplayLabel: 'Operator',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecOperator'],
        },
        REF_RAPPORT_ID: {
          AttributeName: 'REF_RAPPORT_ID',
          DisplayLabel: 'Ref rapport id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecReferens'],
        },
        REF_DIMENSION: {
          AttributeName: 'REF_DIMENSION',
          DisplayLabel: 'Ref dimension',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecReferens'],
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Ref lopnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecReferens'],
        },
        CONSTANT: {
          AttributeName: 'CONSTANT',
          DisplayLabel: 'Konstant',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapportradspecKonstant'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Dimensionsrad: {
          AssociationName: 'Dimensionsrad',
          DisplayLabel: 'Rapportrad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKDimensionsrad',
          AssociatedComponentName: 'RapportDimensionsRad',
          JoinAssociation: true,
          ValidInComps: ['RapportradspecReferens'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapport: {
          AssociationName: 'Rapport',
          DisplayLabel: 'Rapport',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Celler: {
          AssociationName: 'Celler',
          DisplayLabel: 'Celler',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKTEDEKRapportradspecCell',
          AssociatedComponentName: 'RapportradspecCell',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTEDEKRapportradspecCell: {
      CollectionName: 'EKTEDEKRapportradspecCell',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportradspecCell',
        Abstract: false,
        SOLabel: 'Rapportvärde från cell',
        SOGLabel: 'Rapportvärde från cell',
        SBLabel: 'Rapportvärdet från cell',
        SBGLabel: 'Rapportvärdet från cell',
        POLabel: 'Rapportvärde från cell',
        POGLabel: 'Rapportvärde från cell',
        PBLabel: 'Rapportvärdena från cell',
        PBGLabel: 'Rapportvärdena från cell',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportvärdet från cell primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportvärdet från cell versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportvärdet från cell id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportvärdet från cell fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_RAPPORT_ID: {
          AttributeName: 'REF_RAPPORT_ID',
          DisplayLabel: 'Ref rapportid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_DIMENSION: {
          AttributeName: 'REF_DIMENSION',
          DisplayLabel: 'Ref, dimension',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_LOPNR: {
          AttributeName: 'REF_LOPNR',
          DisplayLabel: 'Ref lopnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_FALT_LOPNR: {
          AttributeName: 'REF_FALT_LOPNR',
          DisplayLabel: 'Ref fältopnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportHuvud: {
      CollectionName: 'EKRapportHuvud',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapporthuvud',
        Abstract: false,
        SOLabel: 'Ekonomirapport, Sidhuvud',
        SOGLabel: 'Ekonomirapport, Sidhuvud',
        SBLabel: 'Ekonomirapport, Sidhuvudet',
        SBGLabel: 'Ekonomirapport, Sidhuvudet',
        POLabel: 'Ekonomirapport, Sidhuvud',
        POGLabel: 'Ekonomirapport, Sidhuvud',
        PBLabel: 'Ekonomirapport, Sidhuvuden',
        PBGLabel: 'Ekonomirapport, Sidhuvuden',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapport, Sidhuvudet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapport, Sidhuvudet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ekonomirapport, Sidhuvudet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapport, Sidhuvudet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Format',
          Hint: 'Stående/Liggande',
          DataType: 'Enum',
          EnumValues: new Map([['STAENDE', 'Stående'], ['LIGGANDE', 'Liggande']]),
          EnumSortValues: new Map([['STAENDE', 'S'], ['LIGGANDE', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STAENDE=Stående;LIGGANDE=Liggande"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        HEIGHT: {
          AttributeName: 'HEIGHT',
          DisplayLabel: 'Höjd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          GUIEditable: true,
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Ekonomi/Budget/Tidredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['EKONOMI', 'Ekonomi'], ['BUDGET', 'Budget'], ['TIDREDOVISNING', 'Tidredovisning']]),
          EnumSortValues: new Map([['EKONOMI', 'E'], ['BUDGET', 'B'], ['TIDREDOVISNING', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EKONOMI=Ekonomi;BUDGET=Budget;TIDREDOVISNING=Tidredovisning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Falt: {
          AssociationName: 'Falt',
          DisplayLabel: 'Fält',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportHuvudFalt',
          AssociatedComponentName: 'RapporthuvudFalt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKEkonomirapport: {
      CollectionName: 'EKEkonomirapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Ekonomirapport',
        Abstract: false,
        SOLabel: 'Ekonomirapport',
        SOGLabel: 'Ekonomirapport',
        SBLabel: 'Ekonomirapporten',
        SBGLabel: 'Ekonomirapporten',
        POLabel: 'Ekonomirapporter',
        POGLabel: 'Ekonomirapporter',
        PBLabel: 'Ekonomirapporterna',
        PBGLabel: 'Ekonomirapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ekonomirapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ekonomirapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ekonomirapporten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ekonomirapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTBEGREPP: {
          AttributeName: 'SORTBEGREPP',
          DisplayLabel: 'Sorteringsbegrepp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'Rapportmall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_UTSKRIFT: {
          AttributeName: 'BELOPP_UTSKRIFT',
          DisplayLabel: 'Utskrift av belopp',
          Hint: 'Standard/Enligt rad/Annan',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARD', 'Standard'], ['ENLIGT_RAD', 'Enligt rad'], ['ANNAN', 'Annan']]),
          EnumSortValues: new Map([['STANDARD', 'S'], ['ENLIGT_RAD', 'R'], ['ANNAN', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARD=Standard;ENLIGT_RAD=Enligt rad;ANNAN=Annan"',
        },
        BELOPP_BOLD_ENL_RAD: {
          AttributeName: 'BELOPP_BOLD_ENL_RAD',
          DisplayLabel: 'Fetstil enligt rad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_FONT_NAMN: {
          AttributeName: 'BELOPP_FONT_NAMN',
          DisplayLabel: 'Belopp - font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_STORLEK: {
          AttributeName: 'BELOPP_STORLEK',
          DisplayLabel: 'Belopp - storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_BOLD: {
          AttributeName: 'BELOPP_BOLD',
          DisplayLabel: 'Belopp -fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_ITALIC: {
          AttributeName: 'BELOPP_ITALIC',
          DisplayLabel: 'Belopp - kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_UNDERLINE: {
          AttributeName: 'BELOPP_UNDERLINE',
          DisplayLabel: 'Belopp - understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BELOPP_STRIKE_OUT: {
          AttributeName: 'BELOPP_STRIKE_OUT',
          DisplayLabel: 'BELOPP_STRIKE_OUT',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Stående/Liggande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP_SEPARATOR: {
          AttributeName: 'BELOPP_SEPARATOR',
          DisplayLabel: 'Avskiljare för kolumner',
          Hint: 'Ingen/Skuggning/Linjer',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN', 'Ingen'], ['SKUGGNING', 'Skuggning'], ['LINJER', 'Linjer']]),
          EnumSortValues: new Map([['INGEN', 'I'], ['SKUGGNING', 'S'], ['LINJER', 'L']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN=Ingen;SKUGGNING=Skuggning;LINJER=Linjer"',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        HUVUD_ID: {
          AttributeName: 'HUVUD_ID',
          DisplayLabel: 'Sidhuvud',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rapportmall: {
          AttributeName: 'Rapportmall',
          DisplayLabel: 'Rapportmall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Sidhuvud: {
          AttributeName: 'Sidhuvud',
          DisplayLabel: 'Sidhuvud',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KONTOSTRANG_DETALJRAD: {
          AttributeName: 'KONTOSTRANG_DETALJRAD',
          DisplayLabel: 'Kontosträng på detaljrader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Senast ändrad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTDELAD_TILL_ALLA: {
          AttributeName: 'UTDELAD_TILL_ALLA',
          DisplayLabel: 'Utdelad till alla användare',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Rapportkategori, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_NOLLRADER: {
          AttributeName: 'DOLJ_NOLLRADER',
          DisplayLabel: 'Skriv inte ut nollrader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kategori: {
          AttributeName: 'Kategori',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKRIV_NOT: {
          AttributeName: 'SKRIV_NOT',
          DisplayLabel: 'Använd not',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        STD_RAPPORT: {
          AttributeName: 'STD_RAPPORT',
          DisplayLabel: 'Standardrapport',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        LOPSALDO_DETALJRAD: {
          AttributeName: 'LOPSALDO_DETALJRAD',
          DisplayLabel: 'Löpande saldo på detaljrad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOANALYS: {
          AttributeName: 'KONTOANALYS',
          DisplayLabel: 'Används av kontoanalys',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        DOLJ_TOTALSUMMA: {
          AttributeName: 'DOLJ_TOTALSUMMA',
          DisplayLabel: 'Dölj totalsumma',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        KPLAN_KONV_ID: {
          AttributeName: 'KPLAN_KONV_ID',
          DisplayLabel: 'Konverterad från ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Atgardas: {
          AttributeName: 'Atgardas',
          DisplayLabel: 'Åtgärdas kontoplanbyte',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        JMFR_OVER_KONTOPLAN: {
          AttributeName: 'JMFR_OVER_KONTOPLAN',
          DisplayLabel: 'Jämför mellan olika kontoplaner',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDKOD',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          AttributeGroup: 'GAS',
        },
        ANVANDS_I: {
          AttributeName: 'ANVANDS_I',
          DisplayLabel: 'Används i enhetstyp',
          Hint: 'Alla/Pastorat/Pastorat, Gas/Pastorat, Övriga/Stift/Stiftelse',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA', 'Alla'], ['PASTORAT', 'Pastorat'], ['PASTORAT__GAS', 'Pastorat, Gas'], ['PASTORAT__OVRIGA', 'Pastorat, Övriga'], ['STIFT', 'Stift'], ['STIFTELSE', 'Stiftelse']]),
          EnumSortValues: new Map([['ALLA', 'A'], ['PASTORAT', 'P'], ['PASTORAT__GAS', 'G'], ['PASTORAT__OVRIGA', 'Ö'], ['STIFT', 'S'], ['STIFTELSE', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA=Alla;PASTORAT=Pastorat;PASTORAT__GAS=Pastorat, Gas;PASTORAT__OVRIGA=Pastorat, Övriga;STIFT=Stift;STIFTELSE=Stiftelse"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Har utgått - Används för (balans/resultat)',
          Hint: 'Balans/Resultat/Blandat/Hela huvudboken/Ej definierat',
          DataType: 'Enum',
          EnumValues: new Map([['BALANS', 'Balans'], ['RESULTAT', 'Resultat'], ['BLANDAT', 'Blandat'], ['HELA_HUVUDBOKEN', 'Hela huvudboken'], ['EJ_DEFINIERAT', 'Ej definierat']]),
          EnumSortValues: new Map([['BALANS', '1'], ['RESULTAT', '2'], ['BLANDAT', '3'], ['HELA_HUVUDBOKEN', '4'], ['EJ_DEFINIERAT', '9']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BALANS=Balans;RESULTAT=Resultat;BLANDAT=Blandat;HELA_HUVUDBOKEN=Hela huvudboken;EJ_DEFINIERAT=Ej definierat"',
        },
        KombMedKodbeh: {
          AttributeName: 'KombMedKodbeh',
          DisplayLabel: 'Kombineras med kodbehörigheter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        EGEN_ANALYS: {
          AttributeName: 'EGEN_ANALYS',
          DisplayLabel: 'Användarens egen analys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        EGEN_ANALYS_USER_ID: {
          AttributeName: 'EGEN_ANALYS_USER_ID',
          DisplayLabel: 'Ägare av egen analys',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANGLIG_EK_ANALYS: {
          AttributeName: 'TILLGANGLIG_EK_ANALYS',
          DisplayLabel: 'Tillgänglig i Ekonomisk analys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Ekonomisk analys',
        },
        USER_DEFAULT_EK_ANALYS: {
          AttributeName: 'USER_DEFAULT_EK_ANALYS',
          DisplayLabel: 'Visa i analysmenyn för nya användare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Ekonomisk analys',
        },
        USER_START_EK_ANALYS: {
          AttributeName: 'USER_START_EK_ANALYS',
          DisplayLabel: 'Visa som startanalys för nya användare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Ekonomisk analys',
        },
        Standardrapport: {
          AttributeName: 'Standardrapport',
          DisplayLabel: 'Standardrapport',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        EJ_RELEVANT_EK_ANALYS: {
          AttributeName: 'EJ_RELEVANT_EK_ANALYS',
          DisplayLabel: 'Ej relevant för Ekonomisk analys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Ekonomisk analys',
        },
        RelevantEkonomiskAnalys: {
          AttributeName: 'RelevantEkonomiskAnalys',
          DisplayLabel: 'Kan användas i Ekonomisk Analys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Ekonomisk analys',
        },
        Grundurval: {
          AttributeName: 'Grundurval',
          DisplayLabel: 'Grundurval på utdelning till Ekonomisk analys',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Ekonomisk analys',
        },
        OBLIGATORISK_GAS: {
          AttributeName: 'OBLIGATORISK_GAS',
          DisplayLabel: 'Obligatorisk för rollerna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Ekonomisk analys',
        },
        Obligatorisk: {
          AttributeName: 'Obligatorisk',
          DisplayLabel: 'Obligatorisk för rollerna',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OBLIGATORISK_EJ_GAS: {
          AttributeName: 'OBLIGATORISK_EJ_GAS',
          DisplayLabel: 'Obligatorisk',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Ekonomisk analys',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AI_PROMPT: {
          AttributeName: 'AI_PROMPT',
          DisplayLabel: 'AI prompt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DETALJANALYS: {
          AttributeName: 'DETALJANALYS',
          DisplayLabel: 'Detaljanalys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Rapportmall: {
          AssociationName: 'Rapportmall',
          DisplayLabel: 'Rapportmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportMall',
          AssociatedComponentName: 'RapportMall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sidhuvud: {
          AssociationName: 'Sidhuvud',
          DisplayLabel: 'Sidhuvud',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportHuvud',
          AssociatedComponentName: 'Rapporthuvud',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kategori: {
          AssociationName: 'Kategori',
          DisplayLabel: 'Kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRapportkategori',
          AssociatedComponentName: 'Rapportkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dimensioner: {
          AssociationName: 'Dimensioner',
          DisplayLabel: 'Dimensioner',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportDimension',
          AssociatedComponentName: 'RapportDimension',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapportfalt: {
          AssociationName: 'Rapportfalt',
          DisplayLabel: 'Rapportfält',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportFalt',
          AssociatedComponentName: 'RapportFalt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportUrval',
          AssociatedComponentName: 'RapportUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Utdelade: {
          AssociationName: 'Utdelade',
          DisplayLabel: 'Utdelade rapporter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnvandsFor: {
          AssociationName: 'AnvandsFor',
          DisplayLabel: 'Kombineras med kodbehörighet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKRappAnvFor',
          AssociatedComponentName: 'RappAnvFor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKUtdeladRapport: {
      CollectionName: 'EKUtdeladRapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UtdeladRapport',
        Abstract: false,
        SOLabel: 'Utdelad rapport',
        SOGLabel: 'Utdelad rapport',
        SBLabel: 'Utdelade rapporten',
        SBGLabel: 'Utdelade rapporten',
        POLabel: 'Utdelade rapporter',
        POGLabel: 'Utdelade rapporter',
        PBLabel: 'Utdelade rapporterna',
        PBGLabel: 'Utdelade rapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utdelade rapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utdelade rapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utdelade rapporten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utdelade rapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        VIEW_ID_1: {
          AttributeName: 'VIEW_ID_1',
          DisplayLabel: 'Urval 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID_2: {
          AttributeName: 'VIEW_ID_2',
          DisplayLabel: 'Urval 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJRADER: {
          AttributeName: 'DETALJRADER',
          DisplayLabel: 'Tillåt detaljrader',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        Urval1: {
          AttributeName: 'Urval1',
          DisplayLabel: 'Urval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Urval2: {
          AttributeName: 'Urval2',
          DisplayLabel: 'Tilläggsurval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJFALT_BOKF: {
          AttributeName: 'DETALJFALT_BOKF',
          DisplayLabel: 'Visa detaljrader för fält',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJFALT_BUDG: {
          AttributeName: 'DETALJFALT_BUDG',
          DisplayLabel: 'Visa budgetdetaljer för fält',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DETALJNIVA_BOKF: {
          AttributeName: 'DETALJNIVA_BOKF',
          DisplayLabel: 'Detaljnivå',
          Hint: 'Kontering/Verifikation/Journal',
          DataType: 'Enum',
          EnumValues: new Map([['KONTERING', 'Kontering'], ['VERIFIKATION', 'Verifikation'], ['JOURNAL', 'Journal']]),
          EnumSortValues: new Map([['KONTERING', '0'], ['VERIFIKATION', '1'], ['JOURNAL', '2']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTERING=Kontering;VERIFIKATION=Verifikation;JOURNAL=Journal"',
        },
        DETALJNIVA_BUDG: {
          AttributeName: 'DETALJNIVA_BUDG',
          DisplayLabel: 'Budgetdetaljnivå',
          Hint: 'Kontering/Verifikation/Budget',
          DataType: 'Enum',
          EnumValues: new Map([['KONTERING', 'Kontering'], ['VERIFIKATION', 'Verifikation'], ['BUDGET', 'Budget']]),
          EnumSortValues: new Map([['KONTERING', '0'], ['VERIFIKATION', '1'], ['BUDGET', '2']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTERING=Kontering;VERIFIKATION=Verifikation;BUDGET=Budget"',
        },
        BEHBEGR_TYP: {
          AttributeName: 'BEHBEGR_TYP',
          DisplayLabel: 'Behörighetsbegränsning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMP_URVAL: {
          AttributeName: 'KOMP_URVAL',
          DisplayLabel: 'Kompletterande urval',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RAPPORTPAKET_ID: {
          AttributeName: 'RAPPORTPAKET_ID',
          DisplayLabel: 'Rapportpaket, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIDBRYTNING: {
          AttributeName: 'SIDBRYTNING',
          DisplayLabel: 'Sidbrytning kan anges',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        DISTRDETALJERAD: {
          AttributeName: 'DISTRDETALJERAD',
          DisplayLabel: 'Distribuera rapport detaljerad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        Rapport: {
          AttributeName: 'Rapport',
          DisplayLabel: 'Rapport',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kategori: {
          AttributeName: 'Kategori',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rapportpaket: {
          AttributeName: 'Rapportpaket',
          DisplayLabel: 'Rapportpaket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKRIV_URVAL: {
          AttributeName: 'SKRIV_URVAL',
          DisplayLabel: 'Skriv urvalssida',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          AttributeGroup: 'GAS',
        },
        UTDELNINGSTYP: {
          AttributeName: 'UTDELNINGSTYP',
          DisplayLabel: 'Utdelningstyp',
          Hint: 'Rapport/Ekonomisk analys',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORT', 'Rapport'], ['EKONOMISK_ANALYS', 'Ekonomisk analys']]),
          EnumSortValues: new Map([['RAPPORT', 'R'], ['EKONOMISK_ANALYS', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RAPPORT=Rapport;EKONOMISK_ANALYS=Ekonomisk analys"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapport: {
          AssociationName: 'Rapport',
          DisplayLabel: 'Rapport',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Prenumeranter: {
          AssociationName: 'Prenumeranter',
          DisplayLabel: 'Prenumeranter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKUtdeladRapportPren',
          AssociatedComponentName: 'UtdeladRapportPren',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapportpaket: {
          AssociationName: 'Rapportpaket',
          DisplayLabel: 'Rapportpaket',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportpaket',
          AssociatedComponentName: 'Rapportpaket',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grundurval: {
          AssociationName: 'Grundurval',
          DisplayLabel: 'Grundurval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtdeladTill: {
          AssociationName: 'UtdeladTill',
          DisplayLabel: 'Utdelad till',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKTEDEKUtdeladRapportAnv',
          AssociatedComponentName: 'UtdeladRapportAnv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnvRapport: {
          AssociationName: 'AnvRapport',
          DisplayLabel: 'Användarens rapport',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAnvRapport',
          AssociatedComponentName: 'AnvRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKFakturahandelse: {
      CollectionName: 'EKFakturahandelse',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Bokfgrupp'], ['USER_DEF_REPORT_ROUTINE', '2037'], ['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'Fakturahandelse',
        Abstract: true,
        SOLabel: 'Fakturahändelse (Kund o Leverantör)',
        SOGLabel: 'Fakturahändelse (Kund o Leverantör)',
        SBLabel: 'Fakturahändelsen (Kund o Leverantör)',
        SBGLabel: 'Fakturahändelsen (Kund o Leverantör)',
        POLabel: 'Fakturahändelser (Kund o Leverantör)',
        POGLabel: 'Fakturahändelser (Kund o Leverantör)',
        PBLabel: 'Fakturahändelserna (Kund o Leverantör)',
        PBGLabel: 'Fakturahändelserna (Kund o Leverantör)',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Krav',
            Abstract: false,
            SOLabel: 'Krav',
            SOGLabel: 'Krav',
            SBLabel: 'Kravet',
            SBGLabel: 'Kravet',
            POLabel: 'Krav',
            POGLabel: 'Krav',
            PBLabel: 'Kraven',
            PBGLabel: 'Kraven',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Inkasso',
                Abstract: false,
                SOLabel: 'Inkasso',
                SOGLabel: 'Inkasso',
                SBLabel: 'Inkassot',
                SBGLabel: 'Inkassot',
                POLabel: 'Inkasso',
                POGLabel: 'Inkasso',
                PBLabel: 'Inkasson',
                PBGLabel: 'Inkasson',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'FakturaJustering',
            Abstract: false,
            SOLabel: 'Justering av förfallodatum',
            SOGLabel: 'Justering av förfallodatum',
            SBLabel: 'Justeringen av förfallodatum',
            SBGLabel: 'Justeringen av förfallodatum',
            POLabel: 'Justeringar av förfallodatum',
            POGLabel: 'Justeringar av förfallodatum',
            PBLabel: 'Justeringarna av förfallodatum',
            PBGLabel: 'Justeringarna av förfallodatum',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BeloppHandelse',
            Abstract: true,
            SOLabel: 'Beloppshändelse',
            SOGLabel: 'Beloppshändelse',
            SBLabel: 'Beloppshändelsen',
            SBGLabel: 'Beloppshändelsen',
            POLabel: 'Beloppshändelser',
            POGLabel: 'Beloppshändelser',
            PBLabel: 'Beloppshändelserna',
            PBGLabel: 'Beloppshändelserna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Initiering',
                Abstract: false,
                SOLabel: 'Startbelopp kundkonto',
                SOGLabel: 'Startbelopp kundkonto',
                SBLabel: 'Startbelopp kundkonto',
                SBGLabel: 'Startbelopp kundkonto',
                POLabel: 'Startbelopp kundkonto',
                POGLabel: 'Startbelopp kundkonto',
                PBLabel: 'Startbelopp kundkonto',
                PBGLabel: 'Startbelopp kundkonto',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BokfHandelse',
                Abstract: true,
                SOLabel: 'Bokföringshändelse',
                SOGLabel: 'Bokföringshändelse',
                SBLabel: 'Bokföringshändelsen',
                SBGLabel: 'Bokföringshändelsen',
                POLabel: 'Bokföringshändelser',
                POGLabel: 'Bokföringshändelser',
                PBLabel: 'Bokföringshändelserna',
                PBGLabel: 'Bokföringshändelserna',
                Visible: true,
                ChildTypes: [
                  {
                    TypeValue: 'BokfHandelseKonto',
                    Abstract: true,
                    SOLabel: 'Bokföringshändelse kundkonto',
                    SOGLabel: 'Bokföringshändelse kundkonto',
                    SBLabel: 'Bokföringshändelsen kundkonto',
                    SBGLabel: 'Bokföringshändelsen kundkonto',
                    POLabel: 'Bokföringshändelser kundkonto',
                    POGLabel: 'Bokföringshändelser kundkonto',
                    PBLabel: 'Bokföringshändelserna kundkonto',
                    PBGLabel: 'Bokföringshändelserna kundkonto',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'Insattning',
                        Abstract: true,
                        SOLabel: 'Skulduppräkning',
                        SOGLabel: 'Skulduppräkning',
                        SBLabel: 'Skulduppräkningen',
                        SBGLabel: 'Skulduppräkningen',
                        POLabel: 'Skulduppräkningar',
                        POGLabel: 'Skulduppräkningar',
                        PBLabel: 'Skulduppräkningarna',
                        PBGLabel: 'Skulduppräkningarna',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'Inbetalning',
                            Abstract: false,
                            SOLabel: 'Manuell insättning',
                            SOGLabel: 'Manuell insättning',
                            SBLabel: 'Manuella insättningen',
                            SBGLabel: 'Manuella insättningen',
                            POLabel: 'Manuella insättningar',
                            POGLabel: 'Manuella insättningar',
                            PBLabel: 'Manuella insättningarna',
                            PBGLabel: 'Manuella insättningarna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'InsattningRanta',
                            Abstract: false,
                            SOLabel: 'Tillgodoränta',
                            SOGLabel: 'Tillgodoränta',
                            SBLabel: 'Tillgodoräntan',
                            SBGLabel: 'Tillgodoräntan',
                            POLabel: 'Tillgodoräntor',
                            POGLabel: 'Tillgodoräntor',
                            PBLabel: 'Tillgodoräntorna',
                            PBGLabel: 'Tillgodoräntorna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'InsattningKreditfaktura',
                            Abstract: false,
                            SOLabel: 'Insättning från kreditfaktura',
                            SOGLabel: 'Insättning från kreditfaktura',
                            SBLabel: 'Insättningen från kreditfaktura',
                            SBGLabel: 'Insättningen från kreditfaktura',
                            POLabel: 'Insättningar från kreditfaktura',
                            POGLabel: 'Insättningar från kreditfaktura',
                            PBLabel: 'Insättningarna från kreditfaktura',
                            PBGLabel: 'Insättningarna från kreditfaktura',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'Skuldupprakning',
                            Abstract: false,
                            SOLabel: 'Skulduppräkning, fasttidsavtal',
                            SOGLabel: 'Skulduppräkning, fasttidsavtal',
                            SBLabel: 'Skulduppräkningen, fasttidsavtal',
                            SBGLabel: 'Skulduppräkningen, fasttidsavtal',
                            POLabel: 'Skulduppräkningar, fasttidsavtal',
                            POGLabel: 'Skulduppräkningar, fasttidsavtal',
                            PBLabel: 'Skulduppräkningarna, fasttidsavtal',
                            PBGLabel: 'Skulduppräkningarna, fasttidsavtal',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'SkuldupprJust',
                            Abstract: false,
                            SOLabel: 'Skulduppräkningsjustering, fasttidsavtal',
                            SOGLabel: 'Skulduppräkningsjustering, fasttidsavtal',
                            SBLabel: 'Skulduppräkningsjusteringen, fasttidsavtal',
                            SBGLabel: 'Skulduppräkningsjusteringen, fasttidsavtal',
                            POLabel: 'Skulduppräkningsjusteringar, fasttidsavtal',
                            POGLabel: 'Skulduppräkningsjusteringar, fasttidsavtal',
                            PBLabel: 'Skulduppräkningsjusteringarna, fasttidsavtal',
                            PBGLabel: 'Skulduppräkningsjusteringarna, fasttidsavtal',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'AutomatiskInsattning',
                            Abstract: false,
                            SOLabel: 'Automatisk insättning på avtal',
                            SOGLabel: 'Automatisk insättning på avtal',
                            SBLabel: 'Automatiska insättningen på avtal',
                            SBGLabel: 'Automatiska insättningen på avtal',
                            POLabel: 'Automatiska insättningar på avtal',
                            POGLabel: 'Automatiska insättningar på avtal',
                            PBLabel: 'Automatiska insättningarna på avtal',
                            PBGLabel: 'Automatiska insättningarna på avtal',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                      {
                        TypeValue: 'Uttag',
                        Abstract: true,
                        SOLabel: 'Skuldnedräkning',
                        SOGLabel: 'Skuldnedräkning',
                        SBLabel: 'Skuldnedräkningen',
                        SBGLabel: 'Skuldnedräkningen',
                        POLabel: 'Skuldnedräkningar',
                        POGLabel: 'Skuldnedräkningar',
                        PBLabel: 'Skuldnedräkningarna',
                        PBGLabel: 'Skuldnedräkningarna',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'UttagMotBetalning',
                            Abstract: false,
                            SOLabel: 'Uttag för betalning av faktura',
                            SOGLabel: 'Uttag för betalning av faktura',
                            SBLabel: 'Uttag för betalningen av faktura',
                            SBGLabel: 'Uttag för betalningen av faktura',
                            POLabel: 'Uttag för betalningar av faktura',
                            POGLabel: 'Uttag för betalningar av faktura',
                            PBLabel: 'Uttag för betalningarna av faktura',
                            PBGLabel: 'Uttag för betalningarna av faktura',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'Utbetalning',
                            Abstract: false,
                            SOLabel: 'Utbetalning',
                            SOGLabel: 'Utbetalning',
                            SBLabel: 'Utbetalningen',
                            SBGLabel: 'Utbetalningen',
                            POLabel: 'Utbetalningar',
                            POGLabel: 'Utbetalningar',
                            PBLabel: 'Utbetalningarna',
                            PBGLabel: 'Utbetalningarna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'Avrakning',
                            Abstract: false,
                            SOLabel: 'Avräkning, fasttidsavtal',
                            SOGLabel: 'Avräkning, fasttidsavtal',
                            SBLabel: 'Avräkningen, fasttidsavtal',
                            SBGLabel: 'Avräkningen, fasttidsavtal',
                            POLabel: 'Avräkningar, fasttidsavtal',
                            POGLabel: 'Avräkningar, fasttidsavtal',
                            PBLabel: 'Avräkningarna, fasttidsavtal',
                            PBGLabel: 'Avräkningarna, fasttidsavtal',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'UttagRanta',
                            Abstract: false,
                            SOLabel: 'Skuldränta',
                            SOGLabel: 'Skuldränta',
                            SBLabel: 'Skuldräntan',
                            SBGLabel: 'Skuldräntan',
                            POLabel: 'Skuldräntor',
                            POGLabel: 'Skuldräntor',
                            PBLabel: 'Skuldräntorna',
                            PBGLabel: 'Skuldräntorna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'AvrakningJust',
                            Abstract: false,
                            SOLabel: 'Avräkningsjustering, fasttidsavtal',
                            SOGLabel: 'Avräkningsjustering, fasttidsavtal',
                            SBLabel: 'Avräkningsjusteringen, fasttidsavtal',
                            SBGLabel: 'Avräkningsjusteringen, fasttidsavtal',
                            POLabel: 'Avräkningsjusteringar, fasttidsavtal',
                            POGLabel: 'Avräkningsjusteringar, fasttidsavtal',
                            PBLabel: 'Avräkningsjusteringarna, fasttidsavtal',
                            PBGLabel: 'Avräkningsjusteringarna, fasttidsavtal',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    TypeValue: 'BokfHandelseFaktura',
                    Abstract: true,
                    SOLabel: 'Bokföringshändelse kundfaktura',
                    SOGLabel: 'Bokföringshändelse kundfaktura',
                    SBLabel: 'Bokföringshändelsen kundfaktura',
                    SBGLabel: 'Bokföringshändelsen kundfaktura',
                    POLabel: 'Bokföringshändelser kundfaktura',
                    POGLabel: 'Bokföringshändelser kundfaktura',
                    PBLabel: 'Bokföringshändelserna kundfaktura',
                    PBGLabel: 'Bokföringshändelserna kundfaktura',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'Kreditering',
                        Abstract: false,
                        SOLabel: 'Kreditering',
                        SOGLabel: 'Kreditering',
                        SBLabel: 'Krediteringen',
                        SBGLabel: 'Krediteringen',
                        POLabel: 'Krediteringar',
                        POGLabel: 'Krediteringar',
                        PBLabel: 'Krediteringarna',
                        PBGLabel: 'Krediteringarna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'Kundforlust',
                        Abstract: false,
                        SOLabel: 'Kundförlust',
                        SOGLabel: 'Kundförlust',
                        SBLabel: 'Kundförlusten',
                        SBGLabel: 'Kundförlusten',
                        POLabel: 'Kundförluster',
                        POGLabel: 'Kundförluster',
                        PBLabel: 'Kundförlusterna',
                        PBGLabel: 'Kundförlusterna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'FakturaRegistrering',
                        Abstract: false,
                        SOLabel: 'Fakturaregistrering',
                        SOGLabel: 'Fakturaregistrering',
                        SBLabel: 'Fakturaregistreringen',
                        SBGLabel: 'Fakturaregistreringen',
                        POLabel: 'Fakturaregistreringar',
                        POGLabel: 'Fakturaregistreringar',
                        PBLabel: 'Fakturaregistreringarna',
                        PBGLabel: 'Fakturaregistreringarna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'Betalning',
                        Abstract: true,
                        SOLabel: 'Betalning',
                        SOGLabel: 'Betalning',
                        SBLabel: 'Betalningen',
                        SBGLabel: 'Betalningen',
                        POLabel: 'Betalningar',
                        POGLabel: 'Betalningar',
                        PBLabel: 'Betalningarna',
                        PBGLabel: 'Betalningarna',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'Direktbetalning',
                            Abstract: true,
                            SOLabel: 'Direktbetalning',
                            SOGLabel: 'Direktbetalning',
                            SBLabel: 'Direktbetalningen',
                            SBGLabel: 'Direktbetalningen',
                            POLabel: 'Direktbetalningar',
                            POGLabel: 'Direktbetalningar',
                            PBLabel: 'Direktbetalningarna',
                            PBGLabel: 'Direktbetalningarna',
                            Visible: true,
                            ChildTypes: [
                              {
                                TypeValue: 'BetalningInternfaktura',
                                Abstract: false,
                                SOLabel: 'Betalning internfaktura',
                                SOGLabel: 'Betalning internfaktura',
                                SBLabel: 'Betalningen internfaktura',
                                SBGLabel: 'Betalningen internfaktura',
                                POLabel: 'Betalningar internfaktura',
                                POGLabel: 'Betalningar internfaktura',
                                PBLabel: 'Betalningarna internfaktura',
                                PBGLabel: 'Betalningarna internfaktura',
                                Visible: true,
                                ChildTypes: [
                                ],
                              },
                              {
                                TypeValue: 'BetalningKreditfaktura',
                                Abstract: false,
                                SOLabel: 'Betalning mot insättning på konto',
                                SOGLabel: 'Betalning mot insättning på konto',
                                SBLabel: 'Betalningen mot insättning på konto',
                                SBGLabel: 'Betalningen mot insättning på konto',
                                POLabel: 'Betalningar mot insättning på konto',
                                POGLabel: 'Betalningar mot insättning på konto',
                                PBLabel: 'Betalningarna mot insättning på konto',
                                PBGLabel: 'Betalningarna mot insättning på konto',
                                Visible: true,
                                ChildTypes: [
                                ],
                              },
                              {
                                TypeValue: 'BetalningFranKonto',
                                Abstract: false,
                                SOLabel: 'Betalning från konto',
                                SOGLabel: 'Betalning från konto',
                                SBLabel: 'Betalningen från konto',
                                SBGLabel: 'Betalningen från konto',
                                POLabel: 'Betalningar från konto',
                                POGLabel: 'Betalningar från konto',
                                PBLabel: 'Betalningarna från konto',
                                PBGLabel: 'Betalningarna från konto',
                                Visible: true,
                                ChildTypes: [
                                ],
                              },
                              {
                                TypeValue: 'BetalningKundAvtal',
                                Abstract: false,
                                SOLabel: 'Betalning från kundavtal',
                                SOGLabel: 'Betalning från kundavtal',
                                SBLabel: 'Betalningen från kundavtal',
                                SBGLabel: 'Betalningen från kundavtal',
                                POLabel: 'Betalningar från kundavtal',
                                POGLabel: 'Betalningar från kundavtal',
                                PBLabel: 'Betalningarna från kundavtal',
                                PBGLabel: 'Betalningarna från kundavtal',
                                Visible: true,
                                ChildTypes: [
                                ],
                              },
                            ],
                          },
                          {
                            TypeValue: 'ManuellBetalning',
                            Abstract: false,
                            SOLabel: 'Manuell betalning',
                            SOGLabel: 'Manuell betalning',
                            SBLabel: 'Manuella betalningen',
                            SBGLabel: 'Manuella betalningen',
                            POLabel: 'Manuella betalningar',
                            POGLabel: 'Manuella betalningar',
                            PBLabel: 'Manuella betalningarna',
                            PBGLabel: 'Manuella betalningarna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'AutomatiskBetalning',
                            Abstract: false,
                            SOLabel: 'Automatisk betalning',
                            SOGLabel: 'Automatisk betalning',
                            SBLabel: 'Automatiska betalningen',
                            SBGLabel: 'Automatiska betalningen',
                            POLabel: 'Automatiska betalningar',
                            POGLabel: 'Automatiska betalningar',
                            PBLabel: 'Automatiska betalningarna',
                            PBGLabel: 'Automatiska betalningarna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'GodkandDifferens',
                            Abstract: false,
                            SOLabel: 'Godkänd differens',
                            SOGLabel: 'Godkänd differens',
                            SBLabel: 'Godkända differensen',
                            SBGLabel: 'Godkända differensen',
                            POLabel: 'Godkända differenser',
                            POGLabel: 'Godkända differenser',
                            PBLabel: 'Godkända differenserna',
                            PBGLabel: 'Godkända differenserna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'BetalningBankkonto',
                            Abstract: false,
                            SOLabel: 'Betalning från bankkonto',
                            SOGLabel: 'Betalning från bankkonto',
                            SBLabel: 'Betalningen från bankkonto',
                            SBGLabel: 'Betalningen från bankkonto',
                            POLabel: 'Betalningar från bankkonto',
                            POGLabel: 'Betalningar från bankkonto',
                            PBLabel: 'Betalningarna från bankkonto',
                            PBGLabel: 'Betalningarna från bankkonto',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                      {
                        TypeValue: 'Beloppskorrigering',
                        Abstract: false,
                        SOLabel: 'Beloppskorrigering',
                        SOGLabel: 'Beloppskorrigerings',
                        SBLabel: 'Beloppskorrigeringen',
                        SBGLabel: 'Beloppskorrigeringens',
                        POLabel: 'Beloppskorrigeringar',
                        POGLabel: 'Beloppskorrigeringars',
                        PBLabel: 'Beloppskorrigeringarna',
                        PBGLabel: 'Beloppskorrigeringarnas',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                    ],
                  },
                  {
                    TypeValue: 'LRBokfhandelseFaktura',
                    Abstract: true,
                    SOLabel: 'Bokföringshändelse leverantörsfaktura',
                    SOGLabel: 'Bokföringshändelse leverantörsfaktura',
                    SBLabel: 'Bokföringshändelsen leverantörsfaktura',
                    SBGLabel: 'Bokföringshändelsen leverantörsfaktura',
                    POLabel: 'Bokföringshändelser leverantörsfaktura',
                    POGLabel: 'Bokföringshändelser leverantörsfaktura',
                    PBLabel: 'Bokföringshändelserna leverantörsfaktura',
                    PBGLabel: 'Bokföringshändelserna leverantörsfaktura',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'LRFakturaRegistrering',
                        Abstract: false,
                        SOLabel: 'Definitivbokning, ny faktura',
                        SOGLabel: 'Definitivbokningens, ny faktura',
                        SBLabel: 'Definitivbokningen, ny faktura',
                        SBGLabel: 'Definitivbokningens, ny faktura',
                        POLabel: 'Definitivbokningar, ny faktura',
                        POGLabel: 'Definitivbokningars, ny faktura',
                        PBLabel: 'Definitivbokningarna, ny faktura',
                        PBGLabel: 'Definitivbokningarnas, ny faktura',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRAnkomstregistrering',
                        Abstract: false,
                        SOLabel: 'Ankomstregistrering',
                        SOGLabel: 'Ankomstregistrering',
                        SBLabel: 'Ankomstregistreringen',
                        SBGLabel: 'Ankomstregistreringen',
                        POLabel: 'Ankomstregistreringar',
                        POGLabel: 'Ankomstregistreringar',
                        PBLabel: 'Ankomstregistreringarna',
                        PBGLabel: 'Ankomstregistreringarna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRDefinitivbokning',
                        Abstract: false,
                        SOLabel: 'Definitivbokning, ankomstregistrerad faktura',
                        SOGLabel: 'Definitivbokning, ankomstregistrerad faktura',
                        SBLabel: 'Definitivbokningen, ankomstregistrerad faktura',
                        SBGLabel: 'Definitivbokningens, ankomstregistrerad faktura',
                        POLabel: 'Definitivbokningar, ankomstregistrerad faktura',
                        POGLabel: 'Definitivbokningars, ankomstregistrerad faktura',
                        PBLabel: 'Definitivbokningarna, ankomstregistrerad faktura',
                        PBGLabel: 'Definitivbokningarnas, ankomstregistrerad faktura',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRBetalning',
                        Abstract: true,
                        SOLabel: 'Betalning',
                        SOGLabel: 'Betalning',
                        SBLabel: 'Betalningen',
                        SBGLabel: 'Betalningen',
                        POLabel: 'Betalningar',
                        POGLabel: 'Betalningar',
                        PBLabel: 'Betalningarna',
                        PBGLabel: 'Betalningarna',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'LRBetalningMotUppdrag',
                            Abstract: false,
                            SOLabel: 'Betalning mot uppdrag',
                            SOGLabel: 'Betalning mot uppdrag',
                            SBLabel: 'Betalningen mot uppdrag',
                            SBGLabel: 'Betalningen mot uppdrag',
                            POLabel: 'Betalningar mot uppdrag',
                            POGLabel: 'Betalningar mot uppdrag',
                            PBLabel: 'Betalningarna mot uppdrag',
                            PBGLabel: 'Betalningarna mot uppdrag',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'LRDirektBetalning',
                            Abstract: false,
                            SOLabel: 'Direktbetalning',
                            SOGLabel: 'Direktbetalning',
                            SBLabel: 'Direktbetalningen',
                            SBGLabel: 'Direktbetalningen',
                            POLabel: 'Direktbetalningar',
                            POGLabel: 'Direktbetalningar',
                            PBLabel: 'Direktbetalningarna',
                            PBGLabel: 'Direktbetalningarna',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                          {
                            TypeValue: 'LRBetalningFranKonto',
                            Abstract: false,
                            SOLabel: 'Betalning från konto',
                            SOGLabel: 'Betalning från konto',
                            SBLabel: 'Betalningen från konto',
                            SBGLabel: 'Betalningen från konto',
                            POLabel: 'Betalningar från konto',
                            POGLabel: 'Betalningar från konto',
                            PBLabel: 'Betalningarna från konto',
                            PBGLabel: 'Betalningarna från konto',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                      {
                        TypeValue: 'LRBeloppsJustering',
                        Abstract: false,
                        SOLabel: 'Justering av belopp',
                        SOGLabel: 'Justering av belopp',
                        SBLabel: 'Justeringen av belopp',
                        SBGLabel: 'Justeringen av belopp',
                        POLabel: 'Justeringar av belopp',
                        POGLabel: 'Justeringar av belopp',
                        PBLabel: 'Justeringarna av belopp',
                        PBGLabel: 'Justeringarna av belopp',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRMakulering',
                        Abstract: false,
                        SOLabel: 'Makulering',
                        SOGLabel: 'Makulering',
                        SBLabel: 'Makuleringen',
                        SBGLabel: 'Makuleringen',
                        POLabel: 'Makuleringar',
                        POGLabel: 'Makuleringar',
                        PBLabel: 'Makuleringarna',
                        PBGLabel: 'Makuleringarna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRValutaDifferens',
                        Abstract: false,
                        SOLabel: 'Valutadifferens',
                        SOGLabel: 'Valutadifferens',
                        SBLabel: 'Valutadifferensen',
                        SBGLabel: 'Valutadifferensen',
                        POLabel: 'Valutadifferenser',
                        POGLabel: 'Valutadifferenser',
                        PBLabel: 'Valutadifferenserna',
                        PBGLabel: 'Valutadifferenserna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'LRGodkandDifferens',
                        Abstract: false,
                        SOLabel: 'Godkänd differens',
                        SOGLabel: 'Godkänd differens',
                        SBLabel: 'Godkända differensen',
                        SBGLabel: 'Godkända differensen',
                        POLabel: 'Godkända differenser',
                        POGLabel: 'Godkända differenser',
                        PBLabel: 'Godkända differenserna',
                        PBGLabel: 'Godkända differenserna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                    ],
                  },
                  {
                    TypeValue: 'LRBokfHandelseKonto',
                    Abstract: true,
                    SOLabel: 'Bokföringshändelse leverantörskonto',
                    SOGLabel: 'Bokföringshändelse leverantörskonto',
                    SBLabel: 'Bokföringshändelsen leverantörskonto',
                    SBGLabel: 'Bokföringshändelsen leverantörskonto',
                    POLabel: 'Bokföringshändelser leverantörskonto',
                    POGLabel: 'Bokföringshändelser leverantörskonto',
                    PBLabel: 'Bokföringshändelserna leverantörskonto',
                    PBGLabel: 'Bokföringshändelserna leverantörskonto',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'LRInsattning',
                        Abstract: true,
                        SOLabel: 'Insättning',
                        SOGLabel: 'Insättning',
                        SBLabel: 'Insättningen',
                        SBGLabel: 'Insättningen',
                        POLabel: 'Insättningar',
                        POGLabel: 'Insättningar',
                        PBLabel: 'Insättningarna',
                        PBGLabel: 'Insättningarna',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'LRInsattningKreditfaktura',
                            Abstract: false,
                            SOLabel: 'Insättning från kreditfaktura',
                            SOGLabel: 'Insättning från kreditfaktura',
                            SBLabel: 'Insättningen från kreditfaktura',
                            SBGLabel: 'Insättningen från kreditfaktura',
                            POLabel: 'Insättningar från kreditfaktura',
                            POGLabel: 'Insättningar från kreditfaktura',
                            PBLabel: 'Insättningarna från kreditfaktura',
                            PBGLabel: 'Insättningarna från kreditfaktura',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                      {
                        TypeValue: 'LRUttag',
                        Abstract: true,
                        SOLabel: 'Uttag',
                        SOGLabel: 'Uttag',
                        SBLabel: 'Uttaget',
                        SBGLabel: 'Uttaget',
                        POLabel: 'Uttag',
                        POGLabel: 'Uttag',
                        PBLabel: 'Uttagen',
                        PBGLabel: 'Uttagen',
                        Visible: true,
                        ChildTypes: [
                          {
                            TypeValue: 'LRUttagMotBetalning',
                            Abstract: false,
                            SOLabel: 'Uttag mot betalning',
                            SOGLabel: 'Uttag mot betalning',
                            SBLabel: 'Uttaget mot betalning',
                            SBGLabel: 'Uttaget mot betalning',
                            POLabel: 'Uttag mot betalning',
                            POGLabel: 'Uttag mot betalning',
                            PBLabel: 'Uttagen mot betalning',
                            PBGLabel: 'Uttagen mot betalning',
                            Visible: true,
                            ChildTypes: [
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            TypeValue: 'FaktMakGrav',
            Abstract: false,
            SOLabel: 'Makulering från Grav',
            SOGLabel: 'Makulerings från Grav',
            SBLabel: 'Makuleringen från Grav',
            SBGLabel: 'Makuleringens från Grav',
            POLabel: 'Makuleringar från Grav',
            POGLabel: 'Makuleringars från Grav',
            PBLabel: 'Makuleringarna från Grav',
            PBGLabel: 'Makuleringarnas från Grav',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturahändelsen (Kund o Leverantör) primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturahändelsen (Kund o Leverantör) versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Händelsetyp',
          DataType: 'Enum',
          EnumValues: new Map([['KRAV', 'Krav'], ['INKASSO', 'Inkasso'], ['FAKTURAJUSTERING', 'Justering av förfallodatum'], ['INITIERING', 'Startbelopp kundkonto'], ['INBETALNING', 'Manuell insättning'], ['INSATTNINGRANTA', 'Tillgodoränta'], ['INSATTNINGKREDITFAKTURA', 'Insättning från kreditfaktura'], ['SKULDUPPRAKNING', 'Skulduppräkning, fasttidsavtal'], ['SKULDUPPRJUST', 'Skulduppräkningsjustering, fasttidsavtal'], ['AUTOMATISKINSATTNING', 'Automatisk insättning på avtal'], ['UTTAGMOTBETALNING', 'Uttag för betalning av faktura'], ['UTBETALNING', 'Utbetalning'], ['AVRAKNING', 'Avräkning, fasttidsavtal'], ['UTTAGRANTA', 'Skuldränta'], ['AVRAKNINGJUST', 'Avräkningsjustering, fasttidsavtal'], ['KREDITERING', 'Kreditering'], ['KUNDFORLUST', 'Kundförlust'], ['FAKTURAREGISTRERING', 'Fakturaregistrering'], ['BETALNINGINTERNFAKTURA', 'Betalning internfaktura'], ['BETALNINGKREDITFAKTURA', 'Betalning mot insättning på konto'], ['BETALNINGFRANKONTO', 'Betalning från konto'], ['BETALNINGKUNDAVTAL', 'Betalning från kundavtal'], ['MANUELLBETALNING', 'Manuell betalning'], ['AUTOMATISKBETALNING', 'Automatisk betalning'], ['GODKANDDIFFERENS', 'Godkänd differens'], ['BETALNINGBANKKONTO', 'Betalning från bankkonto'], ['BELOPPSKORRIGERING', 'Beloppskorrigering'], ['LRFAKTURAREGISTRERING', 'Definitivbokning, ny faktura'], ['LRANKOMSTREGISTRERING', 'Ankomstregistrering'], ['LRDEFINITIVBOKNING', 'Definitivbokning, ankomstregistrerad faktura'], ['LRBETALNINGMOTUPPDRAG', 'Betalning mot uppdrag'], ['LRDIREKTBETALNING', 'Direktbetalning'], ['LRBETALNINGFRANKONTO', 'Betalning från konto'], ['LRBELOPPSJUSTERING', 'Justering av belopp'], ['LRMAKULERING', 'Makulering'], ['LRVALUTADIFFERENS', 'Valutadifferens'], ['LRGODKANDDIFFERENS', 'Godkänd differens'], ['LRINSATTNINGKREDITFAKTURA', 'Insättning från kreditfaktura'], ['LRUTTAGMOTBETALNING', 'Uttag mot betalning'], ['FAKTMAKGRAV', 'Makulering från Grav']]),
          EnumSortValues: new Map([['KRAV', 'P'], ['INKASSO', 'O'], ['FAKTURAJUSTERING', 'J'], ['INITIERING', 'N'], ['INBETALNING', 'I'], ['INSATTNINGRANTA', 'R'], ['INSATTNINGKREDITFAKTURA', 'E'], ['SKULDUPPRAKNING', 'L'], ['SKULDUPPRJUST', 'T'], ['AUTOMATISKINSATTNING', 'Ä'], ['UTTAGMOTBETALNING', 'B'], ['UTBETALNING', 'U'], ['AVRAKNING', 'W'], ['UTTAGRANTA', 'S'], ['AVRAKNINGJUST', '0'], ['KREDITERING', 'K'], ['KUNDFORLUST', '+'], ['FAKTURAREGISTRERING', 'F'], ['BETALNINGINTERNFAKTURA', 'X'], ['BETALNINGKREDITFAKTURA', 'Y'], ['BETALNINGFRANKONTO', 'Z'], ['BETALNINGKUNDAVTAL', 'Q'], ['MANUELLBETALNING', 'M'], ['AUTOMATISKBETALNING', 'A'], ['GODKANDDIFFERENS', 'D'], ['BETALNINGBANKKONTO', 'H'], ['BELOPPSKORRIGERING', 'Å'], ['LRFAKTURAREGISTRERING', '1'], ['LRANKOMSTREGISTRERING', '2'], ['LRDEFINITIVBOKNING', '3'], ['LRBETALNINGMOTUPPDRAG', '4'], ['LRDIREKTBETALNING', '5'], ['LRBETALNINGFRANKONTO', '6'], ['LRBELOPPSJUSTERING', '9'], ['LRMAKULERING', 'C'], ['LRVALUTADIFFERENS', 'V'], ['LRGODKANDDIFFERENS', 'G'], ['LRINSATTNINGKREDITFAKTURA', '7'], ['LRUTTAGMOTBETALNING', '8'], ['FAKTMAKGRAV', 'Ö']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturahändelsen (Kund o Leverantör) id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturahändelsen (Kund o Leverantör) fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'KundID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_BOKF_GRUPP_ID: {
          AttributeName: 'FAKTURA_BOKF_GRUPP_ID',
          DisplayLabel: 'Fakturans bokföringsgruppID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURA_ID: {
          AttributeName: 'FAKTURA_ID',
          DisplayLabel: 'FakturaID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'AnvändarID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESKONTRA_KONTO: {
          AttributeName: 'RESKONTRA_KONTO',
          DisplayLabel: 'Reskontra eller konto',
          Hint: 'Kundreskontra/Tillgodohavande kund/Leverantörsreskontra/Tillgodohavande leverantörer',
          DataType: 'Enum',
          EnumValues: new Map([['KUNDRESKONTRA', 'Kundreskontra'], ['TILLGODOHAVANDE_KUND', 'Tillgodohavande kund'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['TILLGODOHAVANDE_LEVERANTORER', 'Tillgodohavande leverantörer']]),
          EnumSortValues: new Map([['KUNDRESKONTRA', 'R'], ['TILLGODOHAVANDE_KUND', 'K'], ['LEVERANTORSRESKONTRA', 'L'], ['TILLGODOHAVANDE_LEVERANTORER', 'T']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KUNDRESKONTRA=Kundreskontra;TILLGODOHAVANDE_KUND=Tillgodohavande kund;LEVERANTORSRESKONTRA=Leverantörsreskontra;TILLGODOHAVANDE_LEVERANTORER=Tillgodohavande leverantörer"',
        },
        LEVFAKTURA_BOKF_GRUPP_ID: {
          AttributeName: 'LEVFAKTURA_BOKF_GRUPP_ID',
          DisplayLabel: 'LEVFAKTURA_BOKF_GRUPP_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVFAKTURA_ID: {
          AttributeName: 'LEVFAKTURA_ID',
          DisplayLabel: 'LEVFAKTURA_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEV_ID: {
          AttributeName: 'LEV_ID',
          DisplayLabel: 'LeverantörsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'DisplayZeroAsBlank="True"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Belopp',
        },
        MOMS_BELOPP: {
          AttributeName: 'MOMS_BELOPP',
          DisplayLabel: 'Momsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'DisplayZeroAsBlank="True"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Belopp',
        },
        Handelse: {
          AttributeName: 'Handelse',
          DisplayLabel: 'Typ av händelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Fakturanummer: {
          AttributeName: 'Fakturanummer',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundNr: {
          AttributeName: 'KundNr',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kundnamn: {
          AttributeName: 'Kundnamn',
          DisplayLabel: 'Kundnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KRAV_NR: {
          AttributeName: 'KRAV_NR',
          DisplayLabel: 'Kravnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Krav'],
        },
        KRAVRUTIN_ID: {
          AttributeName: 'KRAVRUTIN_ID',
          DisplayLabel: 'Kravrutin',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Krav'],
        },
        SPRAK_ID: {
          AttributeName: 'SPRAK_ID',
          DisplayLabel: 'Språk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Krav'],
        },
        KRAVOMGANG_ID: {
          AttributeName: 'KRAVOMGANG_ID',
          DisplayLabel: 'KravomgångID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Krav'],
        },
        FORFALLO_DATUM: {
          AttributeName: 'FORFALLO_DATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['FakturaJustering'],
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'ValutaID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BeloppHandelse'],
        },
        BELOPP_I_VALUTA: {
          AttributeName: 'BELOPP_I_VALUTA',
          DisplayLabel: 'Belopp i valuta',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'DisplayZeroAsBlank="True"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BeloppHandelse'],
          AttributeGroup: 'Belopp',
        },
        MOMS_I_VALUTA: {
          AttributeName: 'MOMS_I_VALUTA',
          DisplayLabel: 'Momsbelopp i valuta',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterDisplayParams: 'DisplayZeroAsBlank="True"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BeloppHandelse'],
          AttributeGroup: 'Belopp',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BeloppHandelse'],
        },
        BETALNINGSSATT_ID: {
          AttributeName: 'BETALNINGSSATT_ID',
          DisplayLabel: 'BetalningssättID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfHandelse'],
        },
        JUST_BOKF_GRUPP_ID: {
          AttributeName: 'JUST_BOKF_GRUPP_ID',
          DisplayLabel: 'Justerar händelse (grupp)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfHandelse'],
        },
        JUST_HANDELSE_ID: {
          AttributeName: 'JUST_HANDELSE_ID',
          DisplayLabel: 'Justerar händelse (id)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfHandelse'],
        },
        Inbetalningssatt: {
          AttributeName: 'Inbetalningssatt',
          DisplayLabel: 'Inbetalningssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfHandelse'],
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Bokfdatum: {
          AttributeName: 'Bokfdatum',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BokfHandelse'],
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        I_huvudbok: {
          AttributeName: 'I_huvudbok',
          DisplayLabel: 'I_Huvudbok',
          Hint: 'Bokförd/Ej bokförd',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Ej bokförd";TrueText="Bokförd"',
          FormatterDisplayParams: 'FalseText="Ej bokförd";TrueText="Bokförd"',
          ValidInComps: ['BokfHandelse'],
        },
        RANTA_FROM_DATUM: {
          AttributeName: 'RANTA_FROM_DATUM',
          DisplayLabel: 'Ränteberäknad fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BokfHandelseKonto'],
        },
        RANTA_TOM_DATUM: {
          AttributeName: 'RANTA_TOM_DATUM',
          DisplayLabel: 'Ränteberäknad t o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_FR: {
          AttributeName: 'AVTAL_FR',
          DisplayLabel: 'Avtal, startmånad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateMonth',
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_TI: {
          AttributeName: 'AVTAL_TI',
          DisplayLabel: 'Avtal, slutmånad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateMonth',
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_BELOPP: {
          AttributeName: 'AVTAL_BELOPP',
          DisplayLabel: 'Avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_UPPLAGGNINGS_DATUM: {
          AttributeName: 'AVTAL_UPPLAGGNINGS_DATUM',
          DisplayLabel: 'Avtal, uppläggningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_AVRAKNAT_TOM: {
          AttributeName: 'AVTAL_AVRAKNAT_TOM',
          DisplayLabel: 'Avräknat t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          ValidInComps: ['BokfHandelseKonto'],
        },
        AVTAL_UPPR_RANTESATS: {
          AttributeName: 'AVTAL_UPPR_RANTESATS',
          DisplayLabel: 'Avtal, räntesats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          ValidInComps: ['Skuldupprakning'],
        },
        AVTAL_UPPR_AR: {
          AttributeName: 'AVTAL_UPPR_AR',
          DisplayLabel: 'Avtal, uppräkning för år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          ValidInComps: ['Skuldupprakning'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KRAV_EXTERNPRINT: {
          AttributeName: 'KRAV_EXTERNPRINT',
          DisplayLabel: 'Krav via fakturaväxeln',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KRAV_STATUS: {
          AttributeName: 'KRAV_STATUS',
          DisplayLabel: 'Kravstatus, fakturaväxeln',
          Hint: 'Skapad/Skickad till fakuraväxeln/Fel',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['SKICKAD_TILL_FAKURAVAXELN', 'Skickad till fakuraväxeln'], ['FEL', 'Fel']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['SKICKAD_TILL_FAKURAVAXELN', 'M'], ['FEL', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;SKICKAD_TILL_FAKURAVAXELN=Skickad till fakuraväxeln;FEL=Fel"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KRAV_FELTEXT: {
          AttributeName: 'KRAV_FELTEXT',
          DisplayLabel: 'Krav, feltext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KRAV_SKICKAD_MED_POSTTYP: {
          AttributeName: 'KRAV_SKICKAD_MED_POSTTYP',
          DisplayLabel: 'Krav, skickad med posttyp',
          Hint: 'A-post/B-post',
          DataType: 'Enum',
          EnumValues: new Map([['A_POST', 'A-post'], ['B_POST', 'B-post']]),
          EnumSortValues: new Map([['A_POST', 'A'], ['B_POST', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="A_POST=A-post;B_POST=B-post"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Kundfaktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Bokfgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['LEV_NOCOMBINE', 'True']]),
        },
        Levfaktura: {
          AssociationName: 'Levfaktura',
          DisplayLabel: 'Leverantörsfaktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantorfaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kravtext: {
          AssociationName: 'Kravtext',
          DisplayLabel: 'Kravtext',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSKravText',
          AssociatedComponentName: 'Kravtext',
          JoinAssociation: true,
          ValidInComps: ['Krav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kravomgang: {
          AssociationName: 'Kravomgang',
          DisplayLabel: 'Kravomgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKravOmgang',
          AssociatedComponentName: 'Kravomgang',
          JoinAssociation: true,
          ValidInComps: ['Krav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: ['BeloppHandelse'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfverifikationer: {
          AssociationName: 'Bokfverifikationer',
          DisplayLabel: 'Bokfverifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: ['BokfHandelse'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Inbetalningssatt: {
          AssociationName: 'Inbetalningssatt',
          DisplayLabel: 'Inbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningssatt',
          AssociatedComponentName: 'Betalningssatt',
          JoinAssociation: true,
          ValidInComps: ['BokfHandelse'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FindVer: {
          AssociationName: 'FindVer',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: false,
          ValidInComps: ['BokfHandelse'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGavoGrupp: {
      CollectionName: 'EKGavoGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2030']]),
      RootType: {
        TypeValue: 'Gavogrupp',
        Abstract: false,
        SOLabel: 'Gåvogrupp',
        SOGLabel: 'Gåvogrupp',
        SBLabel: 'Gåvogruppen',
        SBGLabel: 'Gåvogruppen',
        POLabel: 'Gåvogrupper',
        POGLabel: 'Gåvogrupper',
        PBLabel: 'Gåvogrupperna',
        PBGLabel: 'Gåvogrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gåvogruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gåvogruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gåvogruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gåvogruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        VALFRI_VERIFIKATION: {
          AttributeName: 'VALFRI_VERIFIKATION',
          DisplayLabel: 'Hämta gåvorad från valfri verifikation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        GAVO_SERIE_ID: {
          AttributeName: 'GAVO_SERIE_ID',
          DisplayLabel: 'Serie id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Gavonrserie: {
          AssociationName: 'Gavonrserie',
          DisplayLabel: 'Gåvonrserie',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GavoradUrval: {
          AssociationName: 'GavoradUrval',
          DisplayLabel: 'Gåvorader, urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGavogruppUrval',
          AssociatedComponentName: 'GavogruppUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGava: {
      CollectionName: 'EKGava',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Grupp'], ['USER_DEF_REPORT_ROUTINE', '2031']]),
      RootType: {
        TypeValue: 'Gava',
        Abstract: true,
        SOLabel: 'Gåva',
        SOGLabel: 'Gåva',
        SBLabel: 'Gåvan',
        SBGLabel: 'Gåvan',
        POLabel: 'Gåvor',
        POGLabel: 'Gåvor',
        PBLabel: 'Gåvorna',
        PBGLabel: 'Gåvorna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'GavaAndamalsbestamd',
            Abstract: true,
            SOLabel: 'Ändamålsbestämd gåva',
            SOGLabel: 'Ändamålsbestämd gåva',
            SBLabel: '',
            SBGLabel: '',
            POLabel: '',
            POGLabel: '',
            PBLabel: '',
            PBGLabel: '',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'GavaKapital',
                Abstract: false,
                SOLabel: 'Gåva, finansiell',
                SOGLabel: 'Gåva, finansiell',
                SBLabel: 'Gåvan, finansiell',
                SBGLabel: 'Gåvan, finansiell',
                POLabel: 'Gåvor, finansiell',
                POGLabel: 'Gåvor, finansiell',
                PBLabel: 'Gåvorna, finansiell',
                PBGLabel: 'Gåvorna, finansiell',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'GavaAnlaggntillgang',
                Abstract: false,
                SOLabel: 'Gåva, materiell',
                SOGLabel: 'Gåva, materiell',
                SBLabel: 'Gåvan, materiell',
                SBGLabel: 'Gåvan, materiell',
                POLabel: 'Gåvor, materiell',
                POGLabel: 'Gåvor, materiell',
                PBLabel: 'Gåvorna, materiell',
                PBGLabel: 'Gåvorna, materiell',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'GavaFri',
            Abstract: false,
            SOLabel: 'Gåva, fri',
            SOGLabel: 'Gåva, fri',
            SBLabel: 'Gåvan, fri',
            SBGLabel: 'Gåvan, fri',
            POLabel: 'Gåvor, fria',
            POGLabel: 'Gåvor, fria',
            PBLabel: 'Gåvorna, fria',
            PBGLabel: 'Gåvorna, fria',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gåvan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gåvan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['GAVAKAPITAL', 'Gåva, finansiell'], ['GAVAANLAGGNTILLGANG', 'Gåva, materiell'], ['GAVAFRI', 'Gåva, fri']]),
          EnumSortValues: new Map([['GAVAKAPITAL', 'K'], ['GAVAANLAGGNTILLGANG', 'A'], ['GAVAFRI', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GAVAKAPITAL=Gåva, finansiell;GAVAANLAGGNTILLGANG=Gåva, materiell;GAVAFRI=Gåva, fri"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gåvan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gåvan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GAVONR: {
          AttributeName: 'GAVONR',
          DisplayLabel: 'Gåvonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        OMRADE_ID: {
          AttributeName: 'OMRADE_ID',
          DisplayLabel: 'Område, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GAVOGRUPP_ID: {
          AttributeName: 'GAVOGRUPP_ID',
          DisplayLabel: 'Gåvogrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK_ID: {
          AttributeName: 'RUBRIK_ID',
          DisplayLabel: 'Rubrik, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Omrade: {
          AttributeName: 'Omrade',
          DisplayLabel: 'Område',
          Hint: 'Område, kod + benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        OmradeKod: {
          AttributeName: 'OmradeKod',
          DisplayLabel: 'Område, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        Gavogrupp: {
          AttributeName: 'Gavogrupp',
          DisplayLabel: 'Grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AckGavovarde: {
          AttributeName: 'AckGavovarde',
          DisplayLabel: 'Totalt gåvovärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        IngAterstarPerDatum: {
          AttributeName: 'IngAterstarPerDatum',
          DisplayLabel: 'Återstår vid årets början',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Per månad',
          AttributeParams: {'iadatum': {type: 'Date', defaultValue: ''}},
        },
        UtgAterstarPerdatum: {
          AttributeName: 'UtgAterstarPerdatum',
          DisplayLabel: 'Återstår per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Per månad',
          AttributeParams: {'uadatum': {type: 'Date', defaultValue: ''}},
        },
        GavovardeUnderAret: {
          AttributeName: 'GavovardeUnderAret',
          DisplayLabel: 'Tillkommande under året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Per månad',
          AttributeParams: {'gvdatum': {type: 'Date', defaultValue: ''}},
        },
        IansprUnderAret: {
          AttributeName: 'IansprUnderAret',
          DisplayLabel: 'Ianspråktaget under året',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Per månad',
          AttributeParams: {'itdatum': {type: 'Date', defaultValue: ''}},
        },
        RubrikKodBen: {
          AttributeName: 'RubrikKodBen',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RubrikKod: {
          AttributeName: 'RubrikKod',
          DisplayLabel: 'Rubrik, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RubrikBen: {
          AttributeName: 'RubrikBen',
          DisplayLabel: 'Rubrik, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UtgGavovardePerDatum: {
          AttributeName: 'UtgGavovardePerDatum',
          DisplayLabel: 'Ack tillkommande per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'ugdatum': {type: 'Date', defaultValue: ''}},
        },
        UtgIansprPerDatum: {
          AttributeName: 'UtgIansprPerDatum',
          DisplayLabel: 'Ack ianspråktaget per datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Per månad',
          AttributeParams: {'uidatum': {type: 'Date', defaultValue: ''}, 'ugdatum': {type: 'String', defaultValue: ''}},
        },
        AckIanspraktaget: {
          AttributeName: 'AckIanspraktaget',
          DisplayLabel: 'Totalt ianspråktaget',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['GavaAndamalsbestamd'],
        },
        AckAterstar: {
          AttributeName: 'AckAterstar',
          DisplayLabel: 'Återstår',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['GavaAndamalsbestamd'],
        },
        TILLGANG_ID: {
          AttributeName: 'TILLGANG_ID',
          DisplayLabel: 'Anläggningstillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GavaAnlaggntillgang'],
        },
        AnlaggnNr: {
          AttributeName: 'AnlaggnNr',
          DisplayLabel: 'Anläggningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GavaAnlaggntillgang'],
        },
        AnlaggnBen: {
          AttributeName: 'AnlaggnBen',
          DisplayLabel: 'Anläggningstillgång, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GavaAnlaggntillgang'],
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        URSPR_ID: {
          AttributeName: 'URSPR_ID',
          DisplayLabel: 'Tidigare ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Import',
        },
        K3_OVERFOR_TILL_BIDRAG: {
          AttributeName: 'K3_OVERFOR_TILL_BIDRAG',
          DisplayLabel: 'K3, överförs till villkorat bidrag',
          Hint: 'Ja/Nej/Delvis',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej'], ['DELVIS', 'Delvis']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N'], ['DELVIS', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej;DELVIS=Delvis"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'K3',
        },
        K3_OVERFOR_PROCENTSATS: {
          AttributeName: 'K3_OVERFOR_PROCENTSATS',
          DisplayLabel: 'K3, överförs till vilkorat bidrag (%)',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'K3',
        },
        K3_OVERFOR_TILL_GAVONR: {
          AttributeName: 'K3_OVERFOR_TILL_GAVONR',
          DisplayLabel: 'K3, överförs till bidragsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'K3',
        },
        K3_OVERFORD_DATUM: {
          AttributeName: 'K3_OVERFORD_DATUM',
          DisplayLabel: 'K3, överförd datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'K3',
        },
        K3_OVERFORD_SIGNATUR: {
          AttributeName: 'K3_OVERFORD_SIGNATUR',
          DisplayLabel: 'K3, överförd signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'K3',
        },
        K3_OVERFORD_KONTODEL_2: {
          AttributeName: 'K3_OVERFORD_KONTODEL_2',
          DisplayLabel: 'Överförd, del 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_3: {
          AttributeName: 'K3_OVERFORD_KONTODEL_3',
          DisplayLabel: 'Överförd, del 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_4: {
          AttributeName: 'K3_OVERFORD_KONTODEL_4',
          DisplayLabel: 'Överförd, del 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_5: {
          AttributeName: 'K3_OVERFORD_KONTODEL_5',
          DisplayLabel: 'Överförd, del 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_6: {
          AttributeName: 'K3_OVERFORD_KONTODEL_6',
          DisplayLabel: 'Överförd, del 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_7: {
          AttributeName: 'K3_OVERFORD_KONTODEL_7',
          DisplayLabel: 'Överförd, del 7',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_8: {
          AttributeName: 'K3_OVERFORD_KONTODEL_8',
          DisplayLabel: 'Överförd, del 8',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_9: {
          AttributeName: 'K3_OVERFORD_KONTODEL_9',
          DisplayLabel: 'Överförd, del 9',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        K3_OVERFORD_KONTODEL_10: {
          AttributeName: 'K3_OVERFORD_KONTODEL_10',
          DisplayLabel: 'Överförd, del 10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UrsprGavovarde: {
          AttributeName: 'UrsprGavovarde',
          DisplayLabel: 'UrsprGavovarde',
          Hint: 'Används för export till arkiv',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGavaBlob',
          AssociatedComponentName: 'GavaBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Gåvogrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGavoGrupp',
          AssociatedComponentName: 'Gavogrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Omrade: {
          AssociationName: 'Omrade',
          DisplayLabel: 'Område',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Plats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Gavorubrik: {
          AssociationName: 'Gavorubrik',
          DisplayLabel: 'Gåvorubrik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKGavorubrik',
          AssociatedComponentName: 'Gavorubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anlaggntillgang: {
          AssociationName: 'Anlaggntillgang',
          DisplayLabel: 'Anläggningstillgång',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARTillgang',
          AssociatedComponentName: 'Tillgang',
          JoinAssociation: true,
          ValidInComps: ['GavaAnlaggntillgang'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gavorader: {
          AssociationName: 'Gavorader',
          DisplayLabel: 'Gåvorader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKGavorad',
          AssociatedComponentName: 'Gavorad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKGavaDokument',
          AssociatedComponentName: 'GavaDokument',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGavorad: {
      CollectionName: 'EKGavorad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Gavorad',
        Abstract: true,
        SOLabel: 'Gåvorad',
        SOGLabel: 'Gåvorad',
        SBLabel: 'Gåvoraden',
        SBGLabel: 'Gåvoraden',
        POLabel: 'Gåvorader',
        POGLabel: 'Gåvorader',
        PBLabel: 'Gåvoraderna',
        PBGLabel: 'Gåvoraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'GavoradUpprakning',
            Abstract: true,
            SOLabel: 'Uppräkningshändelser',
            SOGLabel: 'Uppräkningshändelser',
            SBLabel: 'Uppräkningshändelser',
            SBGLabel: 'Uppräkningshändelser',
            POLabel: 'Uppräkningshändelser',
            POGLabel: 'Uppräkningshändelser',
            PBLabel: 'Uppräkningshändelser',
            PBGLabel: 'Uppräkningshändelser',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'GavoradTillkomna',
                Abstract: false,
                SOLabel: 'Tillkomna medel',
                SOGLabel: 'Tillkomna medel',
                SBLabel: 'Tillkomna medel',
                SBGLabel: 'Tillkomna medel',
                POLabel: 'Tillkomna medel',
                POGLabel: 'Tillkomna medel',
                PBLabel: 'Tillkomna medel',
                PBGLabel: 'Tillkomna medel',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'GavoradOverfFranAM',
                Abstract: false,
                SOLabel: 'Överföring från ändamålsbestämda medel',
                SOGLabel: 'Överföring från ändamålsbestämda medel',
                SBLabel: 'Överföring från ändamålsbestämda medel',
                SBGLabel: 'Överföring från ändamålsbestämda medel',
                POLabel: 'Överföring från ändamålsbestämda medel',
                POGLabel: 'Överföring från ändamålsbestämda medel',
                PBLabel: 'Överföring från ändamålsbestämda medel',
                PBGLabel: 'Överföring från ändamålsbestämda medel',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'ARGavoradRegistrerat',
                Abstract: false,
                SOLabel: 'Registrerat bidrag',
                SOGLabel: 'Registrerat bidrag',
                SBLabel: 'Registrerat bidrag',
                SBGLabel: 'Registrerat bidrag',
                POLabel: 'Registrerat bidrag',
                POGLabel: 'Registrerat bidrag',
                PBLabel: 'Registrerat bidrag',
                PBGLabel: 'Registrerat bidrag',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'GavoradAvrakning',
            Abstract: true,
            SOLabel: 'Avräkningshändelse',
            SOGLabel: 'Avräkningshändelse',
            SBLabel: 'Avräkningshändelse',
            SBGLabel: 'Avräkningshändelse',
            POLabel: 'Avräkningshändelse',
            POGLabel: 'Avräkningshändelse',
            PBLabel: '',
            PBGLabel: '',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'GavoradIanspraktagna',
                Abstract: false,
                SOLabel: 'Ianspråkstagna medel',
                SOGLabel: 'Ianspråkstagna medel',
                SBLabel: 'Ianspråkstagna medel',
                SBGLabel: 'Ianspråkstagna medel',
                POLabel: 'Ianspråkstagna medel',
                POGLabel: 'Ianspråkstagna medel',
                PBLabel: 'Ianspråkstagna medel',
                PBGLabel: 'Ianspråkstagna medel',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'GavoradOverforTillVB',
                Abstract: false,
                SOLabel: 'Överföring till bidrag',
                SOGLabel: 'Överföring till bidrag',
                SBLabel: 'Överföring till bidrag',
                SBGLabel: 'Överföring till bidrag',
                POLabel: 'Överföring till bidrag',
                POGLabel: 'Överföring till bidrag',
                PBLabel: 'Överföring till bidrag',
                PBGLabel: 'Överföring till bidrag',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'GavoradOverforTillBR',
                Abstract: false,
                SOLabel: 'Överföring till balanserat resultat',
                SOGLabel: 'Överföring till balanserat resultat',
                SBLabel: 'Överföring till balanserat resultat',
                SBGLabel: 'Överföring till balanserat resultat',
                POLabel: 'Överföring till balanserat resultat',
                POGLabel: 'Överföring till balanserat resultat',
                PBLabel: 'Överföring till balanserat resultat',
                PBGLabel: 'Överföring till balanserat resultat',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gåvoraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gåvoraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['GAVORADTILLKOMNA', 'Tillkomna medel'], ['GAVORADOVERFFRANAM', 'Överföring från ändamålsbestämda medel'], ['ARGAVORADREGISTRERAT', 'Registrerat bidrag'], ['GAVORADIANSPRAKTAGNA', 'Ianspråkstagna medel'], ['GAVORADOVERFORTILLVB', 'Överföring till bidrag'], ['GAVORADOVERFORTILLBR', 'Överföring till balanserat resultat']]),
          EnumSortValues: new Map([['GAVORADTILLKOMNA', 'T'], ['GAVORADOVERFFRANAM', 'Ä'], ['ARGAVORADREGISTRERAT', 'R'], ['GAVORADIANSPRAKTAGNA', 'I'], ['GAVORADOVERFORTILLVB', 'V'], ['GAVORADOVERFORTILLBR', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GAVORADTILLKOMNA=Tillkomna medel;GAVORADOVERFFRANAM=Överföring från ändamålsbestämda medel;ARGAVORADREGISTRERAT=Registrerat bidrag;GAVORADIANSPRAKTAGNA=Ianspråkstagna medel;GAVORADOVERFORTILLVB=Överföring till bidrag;GAVORADOVERFORTILLBR=Överföring till balanserat resultat"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gåvoraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GAVO_ID: {
          AttributeName: 'GAVO_ID',
          DisplayLabel: 'Gåva, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONT_BOKF_AR: {
          AttributeName: 'KONT_BOKF_AR',
          DisplayLabel: 'Kontering, bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KONT_VER_NR: {
          AttributeName: 'KONT_VER_NR',
          DisplayLabel: 'Kontering, vernr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KONT_LOPNR: {
          AttributeName: 'KONT_LOPNR',
          DisplayLabel: 'Kontering, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GAVO_TYP: {
          AttributeName: 'GAVO_TYP',
          DisplayLabel: 'Gåvotyp',
          Hint: 'Finansiell/Materiell/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['FINANSIELL', 'Finansiell'], ['MATERIELL', 'Materiell'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['FINANSIELL', 'K'], ['MATERIELL', 'A'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FINANSIELL=Finansiell;MATERIELL=Materiell;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Makulerad/Skapad',
          DataType: 'Enum',
          EnumValues: new Map([['MAKULERAD', 'Makulerad'], ['SKAPAD', 'Skapad']]),
          EnumSortValues: new Map([['MAKULERAD', 'M'], ['SKAPAD', 'S']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MAKULERAD=Makulerad;SKAPAD=Skapad"',
          GUIEditable: true,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        Bokf_Ar_Bokf: {
          AttributeName: 'Bokf_Ar_Bokf',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_1_Bokf: {
          AttributeName: 'KontoId_1_Bokf',
          DisplayLabel: 'KontoId_1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_2_Bokf: {
          AttributeName: 'KontoId_2_Bokf',
          DisplayLabel: 'KontoId_2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_3_Bokf: {
          AttributeName: 'KontoId_3_Bokf',
          DisplayLabel: 'KontoId_3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_4_Bokf: {
          AttributeName: 'KontoId_4_Bokf',
          DisplayLabel: 'KontoId_4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_5_Bokf: {
          AttributeName: 'KontoId_5_Bokf',
          DisplayLabel: 'KontoId_5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_6_Bokf: {
          AttributeName: 'KontoId_6_Bokf',
          DisplayLabel: 'KontoId_6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_7_Bokf: {
          AttributeName: 'KontoId_7_Bokf',
          DisplayLabel: 'KontoId_7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_8_Bokf: {
          AttributeName: 'KontoId_8_Bokf',
          DisplayLabel: 'KontoId_8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_9_Bokf: {
          AttributeName: 'KontoId_9_Bokf',
          DisplayLabel: 'KontoId_9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoId_10_Bokf: {
          AttributeName: 'KontoId_10_Bokf',
          DisplayLabel: 'KontoId_10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoStr: {
          AttributeName: 'KontoStr',
          DisplayLabel: 'Kodsträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontoBen: {
          AttributeName: 'KontoBen',
          DisplayLabel: 'Kontobenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VerText: {
          AttributeName: 'VerText',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DefBokf: {
          AttributeName: 'DefBokf',
          DisplayLabel: 'Definitivbokförd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        SortKontostr: {
          AttributeName: 'SortKontostr',
          DisplayLabel: 'SortKontostr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Konto_del1: {
          AttributeName: 'Konto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del2: {
          AttributeName: 'Konto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del3: {
          AttributeName: 'Konto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del4: {
          AttributeName: 'Konto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del5: {
          AttributeName: 'Konto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del6: {
          AttributeName: 'Konto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del7: {
          AttributeName: 'Konto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del8: {
          AttributeName: 'Konto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del9: {
          AttributeName: 'Konto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto_del10: {
          AttributeName: 'Konto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokfdatum: {
          AttributeName: 'Bokfdatum',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BokfBelopp: {
          AttributeName: 'BokfBelopp',
          DisplayLabel: 'Bokfört belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Knuten: {
          AttributeName: 'Knuten',
          DisplayLabel: 'Knuten',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          InterfaceType: 'ifBoolean',
        },
        Gavogrupp: {
          AttributeName: 'Gavogrupp',
          DisplayLabel: 'Gåvogrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GavoGruppID: {
          AttributeName: 'GavoGruppID',
          DisplayLabel: 'GavoGruppId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Gavonr: {
          AttributeName: 'Gavonr',
          DisplayLabel: 'Gåvonr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GavoBen: {
          AttributeName: 'GavoBen',
          DisplayLabel: 'Gåva, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Typnamn: {
          AttributeName: 'Typnamn',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ING_DATUM: {
          AttributeName: 'ING_DATUM',
          DisplayLabel: 'Ingående datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ING_VARDE: {
          AttributeName: 'ING_VARDE',
          DisplayLabel: 'Startvärde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GavoradDatum: {
          AttributeName: 'GavoradDatum',
          DisplayLabel: 'Datum för gåvorad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GavoradBelopp: {
          AttributeName: 'GavoradBelopp',
          DisplayLabel: 'Gåvorad, belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        URSPR_DATUM: {
          AttributeName: 'URSPR_DATUM',
          DisplayLabel: 'Urspr datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        URSPR_VARDE: {
          AttributeName: 'URSPR_VARDE',
          DisplayLabel: 'Urspr värde',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GavoradText: {
          AttributeName: 'GavoradText',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Gava: {
          AssociationName: 'Gava',
          DisplayLabel: 'Gåva',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKGava',
          AssociatedComponentName: 'Gava',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontering: {
          AssociationName: 'Kontering',
          DisplayLabel: 'Verifikationsrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'Bokfkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Bokfver: {
          AssociationName: 'Bokfver',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGavaBlob: {
      CollectionName: 'EKGavaBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GavaBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKGavaBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKGavaBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'EKGavaBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKGavaBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKGavorubrik: {
      CollectionName: 'EKGavorubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Gavorubrik',
        Abstract: false,
        SOLabel: 'Gåvorubrik',
        SOGLabel: 'Gåvorubrik',
        SBLabel: 'Gåvorubriken',
        SBGLabel: 'Gåvorubriken',
        POLabel: 'Gåvorubriker',
        POGLabel: 'Gåvorubriker',
        PBLabel: 'Gåvorubrikerna',
        PBGLabel: 'Gåvorubrikerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gåvorubriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gåvorubriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gåvorubriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gåvorubriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KodBen: {
          AttributeName: 'KodBen',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKHuvudprojekt: {
      CollectionName: 'EKHuvudprojekt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Huvudprojekt',
        Abstract: false,
        SOLabel: 'Huvudprojekt',
        SOGLabel: 'Huvudprojekts',
        SBLabel: 'Huvudprojektet',
        SBGLabel: 'Huvudprojektets',
        POLabel: 'Huvudprojekt',
        POGLabel: 'Huvudprojekts',
        PBLabel: 'Huvudprojekten',
        PBGLabel: 'Huvudprojektens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Huvudprojektets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Huvudprojektets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Huvudprojektets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Huvudprojektets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="1";DefDay="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILL_DATUM: {
          AttributeName: 'TILL_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="1";DefDay="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Delprojekt: {
          AssociationName: 'Delprojekt',
          DisplayLabel: 'Delprojekt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTEDEKIngBalans: {
      CollectionName: 'EKTEDEKIngBalans',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'IngBalans',
        Abstract: false,
        SOLabel: 'Ingående balans',
        SOGLabel: 'Ingående balans',
        SBLabel: 'Ingående balansen',
        SBGLabel: 'Ingående balansen',
        POLabel: 'Ingående balanser',
        POGLabel: 'Ingående balanser',
        PBLabel: 'Ingående balanserna',
        PBGLabel: 'Ingående balanserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ingående balansen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ingående balansen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ingående balansen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ingående balansen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kodsträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSLUTAT_MOT_PROJEKT: {
          AttributeName: 'AVSLUTAT_MOT_PROJEKT',
          DisplayLabel: 'Avslutat mot projekt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Konto_del1: {
          AttributeName: 'Konto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '1']]),
        },
        Konto_del2: {
          AttributeName: 'Konto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '2']]),
        },
        Konto_del3: {
          AttributeName: 'Konto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '3']]),
        },
        Konto_del4: {
          AttributeName: 'Konto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '4']]),
        },
        Konto_del5: {
          AttributeName: 'Konto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '5']]),
        },
        Konto_del6: {
          AttributeName: 'Konto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '6']]),
        },
        Konto_del7: {
          AttributeName: 'Konto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '7']]),
        },
        Konto_del8: {
          AttributeName: 'Konto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '8']]),
        },
        Konto_del9: {
          AttributeName: 'Konto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '9']]),
        },
        Konto_del10: {
          AttributeName: 'Konto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '10']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokfjournal: {
      CollectionName: 'EKBokfjournal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Bokfgrupp'], ['USER_DEF_REPORT_ROUTINE', '6005']]),
      RootType: {
        TypeValue: 'Journal',
        Abstract: true,
        SOLabel: 'Journal',
        SOGLabel: 'Journal',
        SBLabel: 'Journalen',
        SBGLabel: 'Journalen',
        POLabel: 'Journaler',
        POGLabel: 'Journaler',
        PBLabel: 'Journalerna',
        PBGLabel: 'Journalerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'HuvudBokfjournal',
            Abstract: true,
            SOLabel: 'Bokföringsjournal',
            SOGLabel: 'Bokföringsjournal',
            SBLabel: 'Bokföringsjournalen',
            SBGLabel: 'Bokföringsjournalen',
            POLabel: 'Bokföringsjournaler',
            POGLabel: 'Bokföringsjournaler',
            PBLabel: 'Bokföringsjournalerna',
            PBGLabel: 'Bokföringsjournalerna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Bokfjournal',
                Abstract: false,
                SOLabel: 'Bokföringsjournal för verifikationer',
                SOGLabel: 'Bokföringsjournal för verifikationer',
                SBLabel: 'Bokföringsjournalen för verifikationer',
                SBGLabel: 'Bokföringsjournalen för verifikationer',
                POLabel: 'Bokföringsjournaler för verifikationer',
                POGLabel: 'Bokföringsjournaler för verifikationer',
                PBLabel: 'Bokföringsjournalerna för verifikationer',
                PBGLabel: 'Bokföringsjournalerna för verifikationer',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'PeriodJournal',
                Abstract: false,
                SOLabel: 'Bokföringsjournal för periodiserade verifikationer',
                SOGLabel: 'Bokföringsjournal för periodiserade verifikationer',
                SBLabel: 'Bokföringsjournalen för periodiserade verifikationer',
                SBGLabel: 'Bokföringsjournalen för periodiserade verifikationer',
                POLabel: 'Bokföringsjournaler för periodiserade verifikationer',
                POGLabel: 'Bokföringsjournaler för periodiserade verifikationer',
                PBLabel: 'Bokföringsjournalerna för periodiserade verifikationer',
                PBGLabel: 'Bokföringsjournalerna för periodiserade verifikationer',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'ErbjudandeJournal',
            Abstract: false,
            SOLabel: 'Journal för erbjudande',
            SOGLabel: 'Journal för erbjudande',
            SBLabel: 'Journalen för erbjudande',
            SBGLabel: 'Journalen för erbjudande',
            POLabel: 'Journaler för erbjudande',
            POGLabel: 'Journaler för erbjudande',
            PBLabel: 'Journalerna för erbjudande',
            PBGLabel: 'Journalerna för erbjudande',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'KonvJournal',
            Abstract: false,
            SOLabel: 'Bokföringsjournal för konverterade fakturor',
            SOGLabel: 'Bokföringsjournal för konverterade fakturor',
            SBLabel: 'Bokföringsjournalen för konverterade fakturor',
            SBGLabel: 'Bokföringsjournalen för konverterade fakturor',
            POLabel: 'Bokföringsjournaler för konverterade fakturor',
            POGLabel: 'Bokföringsjournaler för konverterade fakturor',
            PBLabel: 'Bokföringsjournalerna för konverterade fakturor',
            PBGLabel: 'Bokföringsjournalerna för konverterade fakturor',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Journalen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Journalen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFJOURNAL', 'Bokföringsjournal för verifikationer'], ['PERIODJOURNAL', 'Bokföringsjournal för periodiserade verifikationer'], ['ERBJUDANDEJOURNAL', 'Journal för erbjudande'], ['KONVJOURNAL', 'Bokföringsjournal för konverterade fakturor']]),
          EnumSortValues: new Map([['BOKFJOURNAL', 'B'], ['PERIODJOURNAL', 'P'], ['ERBJUDANDEJOURNAL', 'E'], ['KONVJOURNAL', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Journalen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Journalen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JOURNAL_NR: {
          AttributeName: 'JOURNAL_NR',
          DisplayLabel: 'Journalnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'BokföringsgruppID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMERAD: {
          AttributeName: 'SUMMERAD',
          DisplayLabel: 'Summerad (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        OVERFORD_DATUM: {
          AttributeName: 'OVERFORD_DATUM',
          DisplayLabel: 'Definitivbokförd datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANVANDAR_ID: {
          AttributeName: 'ANVANDAR_ID',
          DisplayLabel: 'AnvändarID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BUNTAD: {
          AttributeName: 'BUNTAD',
          DisplayLabel: 'Använd buntsumma (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          Hint: 'Ex "Backad av ..."',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Bokföringsperiod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Definitivbokförd/Backad/Bokföringsunderlag skapat/Konverterad/Felaktig journal. Skall backas/Låst',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['DEFINITIVBOKFORD', 'Definitivbokförd'], ['BACKAD', 'Backad'], ['BOKFORINGSUNDERLAG_SKAPAT', 'Bokföringsunderlag skapat'], ['KONVERTERAD', 'Konverterad'], ['FELAKTIG_JOURNAL__SKALL_BACKAS', 'Felaktig journal. Skall backas'], ['LAST', 'Låst']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['DEFINITIVBOKFORD', 'H'], ['BACKAD', 'B'], ['BOKFORINGSUNDERLAG_SKAPAT', 'U'], ['KONVERTERAD', 'K'], ['FELAKTIG_JOURNAL__SKALL_BACKAS', 'F'], ['LAST', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;DEFINITIVBOKFORD=Definitivbokförd;BACKAD=Backad;BOKFORINGSUNDERLAG_SKAPAT=Bokföringsunderlag skapat;KONVERTERAD=Konverterad;FELAKTIG_JOURNAL__SKALL_BACKAS=Felaktig journal. Skall backas;LAST=Låst"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTEGRATIONSTYP: {
          AttributeName: 'INTEGRATIONSTYP',
          DisplayLabel: 'Kopieras från gruppen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Bokfgrupp: {
          AttributeName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AnvandarNamn: {
          AttributeName: 'AnvandarNamn',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Period: {
          AttributeName: 'Period',
          DisplayLabel: 'Period',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SummaDebet: {
          AttributeName: 'SummaDebet',
          DisplayLabel: 'Summa debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        SummaKredit: {
          AttributeName: 'SummaKredit',
          DisplayLabel: 'Summa kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        SummaSaldo: {
          AttributeName: 'SummaSaldo',
          DisplayLabel: 'Saldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        BokfarPeriod: {
          AttributeName: 'BokfarPeriod',
          DisplayLabel: 'År och period',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        verifikationer: {
          AttributeName: 'verifikationer',
          DisplayLabel: 'verifikationer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        K3Journal: {
          AttributeName: 'K3Journal',
          DisplayLabel: 'K3-journal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        OVERFORD_KLOCKSLAG: {
          AttributeName: 'OVERFORD_KLOCKSLAG',
          DisplayLabel: 'Definitivbokförd klockslag',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HarFelaktigPeriodisering: {
          AttributeName: 'HarFelaktigPeriodisering',
          DisplayLabel: 'Innehåller felaktig periodisering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        VerkatKoder: {
          AttributeName: 'VerkatKoder',
          DisplayLabel: 'VerkatKoder',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JOURNALHANTERING: {
          AttributeName: 'JOURNALHANTERING',
          DisplayLabel: 'Journalhantering',
          Hint: 'Manuellt/Fråga vid avslut/Bokför direkt',
          DataType: 'Enum',
          EnumValues: new Map([['MANUELLT', 'Manuellt'], ['FRAGA_VID_AVSLUT', 'Fråga vid avslut'], ['BOKFOR_DIREKT', 'Bokför direkt']]),
          EnumSortValues: new Map([['MANUELLT', 'MAN'], ['FRAGA_VID_AVSLUT', 'FAV'], ['BOKFOR_DIREKT', 'BDI']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANUELLT=Manuellt;FRAGA_VID_AVSLUT=Fråga vid avslut;BOKFOR_DIREKT=Bokför direkt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKAPAD_USER_ID: {
          AttributeName: 'SKAPAD_USER_ID',
          DisplayLabel: 'Skapad av användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DefbokfAvNameSign: {
          AttributeName: 'DefbokfAvNameSign',
          DisplayLabel: 'Definitivbokförd av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfjournalBlob',
          AssociatedComponentName: 'JournalBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokforingsperiod: {
          AssociationName: 'Bokforingsperiod',
          DisplayLabel: 'Bokföringsperiod',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfPeriod',
          AssociatedComponentName: 'BokfPeriod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Definitivbokförd av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SkapadAvAnvandare: {
          AssociationName: 'SkapadAvAnvandare',
          DisplayLabel: 'Skapad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfverifikationer: {
          AssociationName: 'Bokfverifikationer',
          DisplayLabel: 'Bokfverifikationer',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Buntar: {
          AssociationName: 'Buntar',
          DisplayLabel: 'Buntar',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBunt',
          AssociatedComponentName: 'Bunt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokfjournalBlob: {
      CollectionName: 'EKBokfjournalBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'JournalBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKBokfjournalBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKBokfjournalBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'EKBokfjournalBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKBokfjournalBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKontobegrepp: {
      CollectionName: 'EKKontobegrepp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Kontobegrepp',
        Abstract: false,
        SOLabel: 'Kodbegrepp',
        SOGLabel: 'Kodbegrepp',
        SBLabel: 'Kodbegreppet',
        SBGLabel: 'Kodbegreppet',
        POLabel: 'Kodbegrepp',
        POGLabel: 'Kodbegrepp',
        PBLabel: 'Kodbegreppen',
        PBGLabel: 'Kodbegreppen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kodbegreppet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kodbegreppet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kodbegreppet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kodbegreppet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TILL_POSITION: {
          AttributeName: 'TILL_POSITION',
          DisplayLabel: 'Position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        FRAN_POSITION: {
          AttributeName: 'FRAN_POSITION',
          DisplayLabel: 'Från position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KONTOBEGREPP: {
          AttributeName: 'KONTOBEGREPP',
          DisplayLabel: 'Kontobegrepp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        DEF_REDOVISNTYP: {
          AttributeName: 'DEF_REDOVISNTYP',
          DisplayLabel: 'Redovisningsklass',
          Hint: 'Ställningskonto/Resultatkonto/Internkonto/Odefinierat',
          DataType: 'Enum',
          EnumValues: new Map([['STALLNINGSKONTO', 'Ställningskonto'], ['RESULTATKONTO', 'Resultatkonto'], ['INTERNKONTO', 'Internkonto'], ['ODEFINIERAT', 'Odefinierat']]),
          EnumSortValues: new Map([['STALLNINGSKONTO', 'S'], ['RESULTATKONTO', 'R'], ['INTERNKONTO', 'I'], ['ODEFINIERAT', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STALLNINGSKONTO=Ställningskonto;RESULTATKONTO=Resultatkonto;INTERNKONTO=Internkonto;ODEFINIERAT=Odefinierat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        DEF_KONTOTYP: {
          AttributeName: 'DEF_KONTOTYP',
          DisplayLabel: 'Kontotyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DEF_KI_TYP: {
          AttributeName: 'DEF_KI_TYP',
          DisplayLabel: 'Redovisningsgrupp',
          Hint: 'Intäkter/Kostnader/Personalkostnader/Avskrivningar/Finans/Skatter/Tillgångar/Skulder/Interna Intäkter/Interna Kostnader/Interna Tillgångar/Interna Skulder/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['INTAKTER', 'Intäkter'], ['KOSTNADER', 'Kostnader'], ['PERSONALKOSTNADER', 'Personalkostnader'], ['AVSKRIVNINGAR', 'Avskrivningar'], ['FINANS', 'Finans'], ['SKATTER', 'Skatter'], ['TILLGANGAR', 'Tillgångar'], ['SKULDER', 'Skulder'], ['INTERNA_INTAKTER', 'Interna Intäkter'], ['INTERNA_KOSTNADER', 'Interna Kostnader'], ['INTERNA_TILLGANGAR', 'Interna Tillgångar'], ['INTERNA_SKULDER', 'Interna Skulder'], ['ODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['INTAKTER', 'I'], ['KOSTNADER', 'K'], ['PERSONALKOSTNADER', 'P'], ['AVSKRIVNINGAR', 'R'], ['FINANS', 'F'], ['SKATTER', '1'], ['TILLGANGAR', 'T'], ['SKULDER', 'U'], ['INTERNA_INTAKTER', 'V'], ['INTERNA_KOSTNADER', 'Y'], ['INTERNA_TILLGANGAR', 'Y'], ['INTERNA_SKULDER', 'Z'], ['ODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTAKTER=Intäkter;KOSTNADER=Kostnader;PERSONALKOSTNADER=Personalkostnader;AVSKRIVNINGAR=Avskrivningar;FINANS=Finans;SKATTER=Skatter;TILLGANGAR=Tillgångar;SKULDER=Skulder;INTERNA_INTAKTER=Interna Intäkter;INTERNA_KOSTNADER=Interna Kostnader;INTERNA_TILLGANGAR=Interna Tillgångar;INTERNA_SKULDER=Interna Skulder;ODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        DEF_MOMS_ID: {
          AttributeName: 'DEF_MOMS_ID',
          DisplayLabel: 'MomsID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontobegreppdef: {
          AssociationName: 'Kontobegreppdef',
          DisplayLabel: 'Kodbegreppsdefinition',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontobegreppdef',
          AssociatedComponentName: 'Kontobegreppdef',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kombinationer: {
          AssociationName: 'Kombinationer',
          DisplayLabel: 'Kombinationer',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontobegreppkombination',
          AssociatedComponentName: 'Kontobegreppkombination',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontobegreppkombination: {
      CollectionName: 'EKKontobegreppkombination',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Kontobegreppkombination',
        Abstract: false,
        SOLabel: 'Kodbegreppkombination',
        SOGLabel: 'Kodbegreppkombination',
        SBLabel: 'Kodbegreppkombinationen',
        SBGLabel: 'Kodbegreppkombinationen',
        POLabel: 'Kodbegreppkombinationer',
        POGLabel: 'Kodbegreppkombinationer',
        PBLabel: 'Kodbegreppkombinationerna',
        PBGLabel: 'Kodbegreppkombinationerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kodbegreppkombinationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kodbegreppkombinationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kodbegreppkombinationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMBINATION: {
          AttributeName: 'KOMBINATION',
          DisplayLabel: 'Kombination',
          Hint: 'Får kombineras/Måste kombineras/Får ej kombineras',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_KOMBINERAS', 'Får kombineras'], ['MASTE_KOMBINERAS', 'Måste kombineras'], ['FAR_EJ_KOMBINERAS', 'Får ej kombineras']]),
          EnumSortValues: new Map([['FAR_KOMBINERAS', '0'], ['MASTE_KOMBINERAS', '1'], ['FAR_EJ_KOMBINERAS', '2']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_KOMBINERAS=Får kombineras;MASTE_KOMBINERAS=Måste kombineras;FAR_EJ_KOMBINERAS=Får ej kombineras"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontobegrepp: {
          AssociationName: 'Kontobegrepp',
          DisplayLabel: 'Kodbegrepp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontobegrepp',
          AssociatedComponentName: 'Kontobegrepp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKAnvKontourval: {
      CollectionName: 'EKAnvKontourval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'AnvKontourval',
        Abstract: false,
        SOLabel: 'Kodbegränsning',
        SOGLabel: 'Kodbegränsning',
        SBLabel: 'Kodbegränsningen',
        SBGLabel: 'Kodbegränsningen',
        POLabel: 'Kodbegränsningar',
        POGLabel: 'Kodbegränsningar',
        PBLabel: 'Kodbegränsningarna',
        PBGLabel: 'Kodbegränsningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kodbegränsningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kodbegränsningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kodbegränsningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URVAL_ID: {
          AttributeName: 'URVAL_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONV_TO_VIEW_ID: {
          AttributeName: 'KONV_TO_VIEW_ID',
          DisplayLabel: 'Konverterad till kodbeh viewid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Kodbegränsning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Kontoplan: {
          AssociationName: 'Kontoplan',
          DisplayLabel: 'Kontoplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKAnvKontobegr: {
      CollectionName: 'EKAnvKontobegr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2054']]),
      RootType: {
        TypeValue: 'AnvKontobegr',
        Abstract: false,
        SOLabel: 'Kodbehörighet',
        SOGLabel: 'Kodbehörighets',
        SBLabel: 'Kodbehörigheten',
        SBGLabel: 'Kodbehörighetens',
        POLabel: 'Kodbehörigheter',
        POGLabel: 'Kodbehörigheters',
        PBLabel: 'Kodbehörigheterna',
        PBGLabel: 'Kodbehörigheternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kodbehörighetens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kodbehörighetens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kodbehörighetens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kodbehörighetens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FOR_ANALYS: {
          AttributeName: 'FOR_ANALYS',
          DisplayLabel: 'För kontoanalys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOR_RAPPORT: {
          AttributeName: 'FOR_RAPPORT',
          DisplayLabel: 'För ekonomirapport',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATTESTOMRADE_ID: {
          AttributeName: 'ATTESTOMRADE_ID',
          DisplayLabel: 'Attestområde, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTESTRATT_LOPNR: {
          AttributeName: 'ATTESTRATT_LOPNR',
          DisplayLabel: 'Attesträtt, lopnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTEST_TYP: {
          AttributeName: 'ATTEST_TYP',
          DisplayLabel: 'Attest faktura',
          Hint: 'Beslutsattest/Mottagningsattest/Används ej för attest',
          DataType: 'Enum',
          EnumValues: new Map([['BESLUTSATTEST', 'Beslutsattest'], ['MOTTAGNINGSATTEST', 'Mottagningsattest'], ['ANVANDS_EJ_FOR_ATTEST', 'Används ej för attest']]),
          EnumSortValues: new Map([['BESLUTSATTEST', 'B'], ['MOTTAGNINGSATTEST', 'M'], ['ANVANDS_EJ_FOR_ATTEST', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESLUTSATTEST=Beslutsattest;MOTTAGNINGSATTEST=Mottagningsattest;ANVANDS_EJ_FOR_ATTEST=Används ej för attest"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESLUT_MAXBELOPP: {
          AttributeName: 'BESLUT_MAXBELOPP',
          DisplayLabel: 'Maxbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTROLL_BELOPP: {
          AttributeName: 'KONTROLL_BELOPP',
          DisplayLabel: 'Kontrollbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTROLL_ATTESTOMRADE_ID: {
          AttributeName: 'KONTROLL_ATTESTOMRADE_ID',
          DisplayLabel: 'Kontrollattestant, attestområde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTROLL_LOPNR: {
          AttributeName: 'KONTROLL_LOPNR',
          DisplayLabel: 'Kontrollattestant, attesträtt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FOR_BUDGET: {
          AttributeName: 'FOR_BUDGET',
          DisplayLabel: 'För budget',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UrvalBeskrivning: {
          AttributeName: 'UrvalBeskrivning',
          DisplayLabel: 'Urval, beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        FOR_BOKFORDER: {
          AttributeName: 'FOR_BOKFORDER',
          DisplayLabel: 'Attest bokföringsorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IsGAS: {
          AttributeName: 'IsGAS',
          DisplayLabel: 'Är standard',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UrvalBeskrivningKoddel1: {
          AttributeName: 'UrvalBeskrivningKoddel1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel2: {
          AttributeName: 'UrvalBeskrivningKoddel2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel3: {
          AttributeName: 'UrvalBeskrivningKoddel3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel4: {
          AttributeName: 'UrvalBeskrivningKoddel4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel5: {
          AttributeName: 'UrvalBeskrivningKoddel5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel6: {
          AttributeName: 'UrvalBeskrivningKoddel6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel7: {
          AttributeName: 'UrvalBeskrivningKoddel7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel8: {
          AttributeName: 'UrvalBeskrivningKoddel8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel9: {
          AttributeName: 'UrvalBeskrivningKoddel9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        UrvalBeskrivningKoddel10: {
          AttributeName: 'UrvalBeskrivningKoddel10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kodbehörighetsbegrepp',
        },
        KOMBINERAD: {
          AttributeName: 'KOMBINERAD',
          DisplayLabel: 'Kombinerad kodbehörighet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMBINERAD_ANVANDS_FOR: {
          AttributeName: 'KOMBINERAD_ANVANDS_FOR',
          DisplayLabel: 'Kombinerad, används för',
          Hint: 'Balans/Resultat/Blandat/Hela huvudboken/Ej definierat',
          DataType: 'Enum',
          EnumValues: new Map([['BALANS', 'Balans'], ['RESULTAT', 'Resultat'], ['BLANDAT', 'Blandat'], ['HELA_HUVUDBOKEN', 'Hela huvudboken'], ['EJ_DEFINIERAT', 'Ej definierat']]),
          EnumSortValues: new Map([['BALANS', '1'], ['RESULTAT', '2'], ['BLANDAT', '3'], ['HELA_HUVUDBOKEN', '4'], ['EJ_DEFINIERAT', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BALANS=Balans;RESULTAT=Resultat;BLANDAT=Blandat;HELA_HUVUDBOKEN=Hela huvudboken;EJ_DEFINIERAT=Ej definierat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOMBINERAD_VISA: {
          AttributeName: 'KOMBINERAD_VISA',
          DisplayLabel: 'Visa kombinerad behörighet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOR_UTANORDNING: {
          AttributeName: 'FOR_UTANORDNING',
          DisplayLabel: 'Attest utanordning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        UTANORDNING_KONTROLL: {
          AttributeName: 'UTANORDNING_KONTROLL',
          DisplayLabel: 'Kontrollattest utanordningar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTANORDNING_KA_MAXBELOPP: {
          AttributeName: 'UTANORDNING_KA_MAXBELOPP',
          DisplayLabel: 'Utanordning maxbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTANORDNING_KONTROLLBELOPP: {
          AttributeName: 'UTANORDNING_KONTROLLBELOPP',
          DisplayLabel: 'Utanordning kontrollbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontoplan: {
          AssociationName: 'Kontoplan',
          DisplayLabel: 'Kontoplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontrollattestratt: {
          AssociationName: 'Kontrollattestratt',
          DisplayLabel: 'Kontrollattestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestratt',
          AssociatedComponentName: 'Attestratt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        MinaUtdelningar: {
          AssociationName: 'MinaUtdelningar',
          DisplayLabel: 'Mina utdelningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', 'dbo.fn_UtdelningValidForUser({FromAlias.IsGAS},  \'N\', {FromAlias.KPLAN_ID}, {FromAlias.ANV_ID}, {FromAlias.LOPNR}, {Alias.RAPPORT_ID}, {Alias.LOPNR}) = \'Y\'']]),
        },
        MinaFavoritUtdelningar: {
          AssociationName: 'MinaFavoritUtdelningar',
          DisplayLabel: 'Mina favoritutdelningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', 'dbo.fn_UtdelningValidForUser({FromAlias.IsGAS},  \'Y\', {FromAlias.KPLAN_ID}, {FromAlias.ANV_ID}, {FromAlias.LOPNR}, {Alias.RAPPORT_ID}, {Alias.LOPNR}) = \'Y\'']]),
        },
        AnvForAnalyser: {
          AssociationName: 'AnvForAnalyser',
          DisplayLabel: 'Används för analyser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAnvRapport',
          AssociatedComponentName: 'AnvRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontodel: {
      CollectionName: 'EKKontodel',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2003'], ['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'Kontodel',
        Abstract: false,
        SOLabel: 'Koddel',
        SOGLabel: 'Koddels',
        SBLabel: 'Koddelen',
        SBGLabel: 'Koddelens',
        POLabel: 'Koddelar',
        POGLabel: 'Koddelars',
        PBLabel: 'Koddelarna',
        PBGLabel: 'Koddelarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Koddelens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Koddelens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Koddelens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Koddelens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTODEL: {
          AttributeName: 'KONTODEL',
          DisplayLabel: 'Kontodel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REDOVISN_TYP: {
          AttributeName: 'REDOVISN_TYP',
          DisplayLabel: 'Redovisningsklass',
          Hint: 'Ställningskonto/Resultatkonto/Internkonto/Odefinierat',
          DataType: 'Enum',
          EnumValues: new Map([['STALLNINGSKONTO', 'Ställningskonto'], ['RESULTATKONTO', 'Resultatkonto'], ['INTERNKONTO', 'Internkonto'], ['ODEFINIERAT', 'Odefinierat']]),
          EnumSortValues: new Map([['STALLNINGSKONTO', 'S'], ['RESULTATKONTO', 'R'], ['INTERNKONTO', 'I'], ['ODEFINIERAT', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STALLNINGSKONTO=Ställningskonto;RESULTATKONTO=Resultatkonto;INTERNKONTO=Internkonto;ODEFINIERAT=Odefinierat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        KONTOTYP: {
          AttributeName: 'KONTOTYP',
          DisplayLabel: 'Kontotyp',
          Hint: 'Tillgångar/Skulder/Eget kapital/Inkomster/Intäkter/Utgifter/Kostnader/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['TILLGANGAR', 'Tillgångar'], ['SKULDER_EGET_KAPITAL', 'Skulder/Eget kapital'], ['INKOMSTER_INTAKTER', 'Inkomster/Intäkter'], ['UTGIFTER_KOSTNADER', 'Utgifter/Kostnader'], ['ODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['TILLGANGAR', 'T'], ['SKULDER_EGET_KAPITAL', 'S'], ['INKOMSTER_INTAKTER', 'I'], ['UTGIFTER_KOSTNADER', 'U'], ['ODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLGANGAR=Tillgångar;SKULDER_EGET_KAPITAL=Skulder/Eget kapital;INKOMSTER_INTAKTER=Inkomster/Intäkter;UTGIFTER_KOSTNADER=Utgifter/Kostnader;ODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        KI_TYP: {
          AttributeName: 'KI_TYP',
          DisplayLabel: 'Redovisningsgrupp',
          Hint: 'Intäkter/Kostnader/Personalkostnader/Avskrivningar/Finans/Skatter/Odefinierad/Tillgångar/Skulder/Interna Intäkter/Interna Kostnader/Interna Tillgångar/Interna Skulder',
          DataType: 'Enum',
          EnumValues: new Map([['INTAKTER', 'Intäkter'], ['KOSTNADER', 'Kostnader'], ['PERSONALKOSTNADER', 'Personalkostnader'], ['AVSKRIVNINGAR', 'Avskrivningar'], ['FINANS', 'Finans'], ['SKATTER', 'Skatter'], ['ODEFINIERAD', 'Odefinierad'], ['TILLGANGAR', 'Tillgångar'], ['SKULDER', 'Skulder'], ['INTERNA_INTAKTER', 'Interna Intäkter'], ['INTERNA_KOSTNADER', 'Interna Kostnader'], ['INTERNA_TILLGANGAR', 'Interna Tillgångar'], ['INTERNA_SKULDER', 'Interna Skulder']]),
          EnumSortValues: new Map([['INTAKTER', 'I'], ['KOSTNADER', 'K'], ['PERSONALKOSTNADER', 'P'], ['AVSKRIVNINGAR', 'R'], ['FINANS', 'F'], ['SKATTER', '1'], ['ODEFINIERAD', 'O'], ['TILLGANGAR', 'T'], ['SKULDER', 'U'], ['INTERNA_INTAKTER', 'V'], ['INTERNA_KOSTNADER', 'X'], ['INTERNA_TILLGANGAR', 'Y'], ['INTERNA_SKULDER', 'Z']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTAKTER=Intäkter;KOSTNADER=Kostnader;PERSONALKOSTNADER=Personalkostnader;AVSKRIVNINGAR=Avskrivningar;FINANS=Finans;SKATTER=Skatter;ODEFINIERAD=Odefinierad;TILLGANGAR=Tillgångar;SKULDER=Skulder;INTERNA_INTAKTER=Interna Intäkter;INTERNA_KOSTNADER=Interna Kostnader;INTERNA_TILLGANGAR=Interna Tillgångar;INTERNA_SKULDER=Interna Skulder"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SRU_KOD: {
          AttributeName: 'SRU_KOD',
          DisplayLabel: 'SRU-kod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'MomsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDGETKONTO: {
          AttributeName: 'BUDGETKONTO',
          DisplayLabel: 'Budgetkonto',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KontodelBenamning: {
          AttributeName: 'KontodelBenamning',
          DisplayLabel: 'KontodelBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="1";DefDay="1"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILL_DATUM: {
          AttributeName: 'TILL_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'AllowIncomplete="Y";DefMonth="12";DefDay="31"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        INTERN_KONTO: {
          AttributeName: 'INTERN_KONTO',
          DisplayLabel: 'Internkonto',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SPARRA_MANUELL: {
          AttributeName: 'SPARRA_MANUELL',
          DisplayLabel: 'Spärr för manuell bokföring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        PROJEKTBENAMNING: {
          AttributeName: 'PROJEKTBENAMNING',
          DisplayLabel: 'Projektbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        PROJEKTANSVARIG: {
          AttributeName: 'PROJEKTANSVARIG',
          DisplayLabel: 'Projektansvarig',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        PROJEKT_SUMMERA_AVSLUT: {
          AttributeName: 'PROJEKT_SUMMERA_AVSLUT',
          DisplayLabel: 'Summera projektverifikationer vid avslut',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTALSREDOVISNING: {
          AttributeName: 'ANTALSREDOVISNING',
          DisplayLabel: 'Antalsredovisning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        STANDARDKONTO: {
          AttributeName: 'STANDARDKONTO',
          DisplayLabel: 'Standardkonto',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KBProjDebKontodel: {
          AttributeName: 'KBProjDebKontodel',
          DisplayLabel: 'KBProjDebKontodel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-69;']]),
        },
        KBProjDebProjekt: {
          AttributeName: 'KBProjDebProjekt',
          DisplayLabel: 'KBProjDebProjekt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-70;']]),
        },
        KBProjKredKontodel: {
          AttributeName: 'KBProjKredKontodel',
          DisplayLabel: 'KBProjKredKontodel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-71;']]),
        },
        KBProjKredProjekt: {
          AttributeName: 'KBProjKredProjekt',
          DisplayLabel: 'KBProjKredProjekt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConstantValue', '-72;']]),
        },
        ProjDebKontodel: {
          AttributeName: 'ProjDebKontodel',
          DisplayLabel: 'Debetkonto vid projektavslut',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ProjDebProjekt: {
          AttributeName: 'ProjDebProjekt',
          DisplayLabel: 'ProjDebProjekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ProjKredKontodel: {
          AttributeName: 'ProjKredKontodel',
          DisplayLabel: 'Kreditkonto vid projektavslut',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ProjKredProjekt: {
          AttributeName: 'ProjKredProjekt',
          DisplayLabel: 'ProjKredProjekt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        kontodelsdefNamn: {
          AttributeName: 'kontodelsdefNamn',
          DisplayLabel: 'kontodelsdefNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GiltigIIntervall: {
          AttributeName: 'GiltigIIntervall',
          DisplayLabel: 'Giltig inom datum',
          DataType: 'DateTime',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.interval,
        },
        RuleORDNINGS_NR: {
          AttributeName: 'RuleORDNINGS_NR',
          DisplayLabel: 'RuleORDNINGS_NR',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKPLAN_ID: {
          AttributeName: 'RuleKPLAN_ID',
          DisplayLabel: 'RuleKPLAN_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KB_VERKSOMR: {
          AttributeName: 'KB_VERKSOMR',
          DisplayLabel: 'Verksamhetsområde',
          Hint: '0 Övrigt/1 Grundläggande uppgift/3 Övrig kyrklig verksamhet/5 Styrning och ledning/6 Stödjande verksamhet/7 Övrigt/8 Begravningsverksamhet/9 Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['K0_OVRIGT', '0 Övrigt'], ['K1_GRUNDLAGGANDE_UPPGIFT', '1 Grundläggande uppgift'], ['K3_OVRIG_KYRKLIG_VERKSAMHET', '3 Övrig kyrklig verksamhet'], ['K5_STYRNING_OCH_LEDNING', '5 Styrning och ledning'], ['K6_STODJANDE_VERKSAMHET', '6 Stödjande verksamhet'], ['K7_OVRIGT', '7 Övrigt'], ['K8_BEGRAVNINGSVERKSAMHET', '8 Begravningsverksamhet'], ['K9_OVRIGT', '9 Övrigt']]),
          EnumSortValues: new Map([['K0_OVRIGT', '0'], ['K1_GRUNDLAGGANDE_UPPGIFT', '1'], ['K3_OVRIG_KYRKLIG_VERKSAMHET', '3'], ['K5_STYRNING_OCH_LEDNING', '5'], ['K6_STODJANDE_VERKSAMHET', '6'], ['K7_OVRIGT', '7'], ['K8_BEGRAVNINGSVERKSAMHET', '8'], ['K9_OVRIGT', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K0_OVRIGT=0 Övrigt;K1_GRUNDLAGGANDE_UPPGIFT=1 Grundläggande uppgift;K3_OVRIG_KYRKLIG_VERKSAMHET=3 Övrig kyrklig verksamhet;K5_STYRNING_OCH_LEDNING=5 Styrning och ledning;K6_STODJANDE_VERKSAMHET=6 Stödjande verksamhet;K7_OVRIGT=7 Övrigt;K8_BEGRAVNINGSVERKSAMHET=8 Begravningsverksamhet;K9_OVRIGT=9 Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KB_VERKSAMHET: {
          AttributeName: 'KB_VERKSAMHET',
          DisplayLabel: 'Verksamhetsnivå',
          Hint: '101 Verksamhetsgemensamt/110 Gudstjänster och kyrkliga handlingar/140 Undervisning/210 Diakonal verksamhet/260 Mission/310 Övrig församlingsverksamhet/360 Serviceverksamhet/380 Inomkyrkligt tillhandahållande/410 Skattepliktig rörelse/510 Strategisk styrning/580 Verksamhetsledning/610 Församlingsadministration och verksamhetsstöd/630 Gemensamma kostnader och administration/650 Fastigheter och lokaler/690 Finansiella poster/801 Verksamhetsgemensamt/810 Administration och ledning/820 Gravsättning och kyrkogårdsskötsel/840 Krematorium/860 Fastigheter och mark/890 Inomkyrkligt tillhandahållande inom BV',
          DataType: 'Enum',
          EnumValues: new Map([['K101_VERKSAMHETSGEMENSAMT', '101 Verksamhetsgemensamt'], ['K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR', '110 Gudstjänster och kyrkliga handlingar'], ['K140_UNDERVISNING', '140 Undervisning'], ['K210_DIAKONAL_VERKSAMHET', '210 Diakonal verksamhet'], ['K260_MISSION', '260 Mission'], ['K310_OVRIG_FORSAMLINGSVERKSAMHET', '310 Övrig församlingsverksamhet'], ['K360_SERVICEVERKSAMHET', '360 Serviceverksamhet'], ['K380_INOMKYRKLIGT_TILLHANDAHALLANDE', '380 Inomkyrkligt tillhandahållande'], ['K410_SKATTEPLIKTIG_RORELSE', '410 Skattepliktig rörelse'], ['K510_STRATEGISK_STYRNING', '510 Strategisk styrning'], ['K580_VERKSAMHETSLEDNING', '580 Verksamhetsledning'], ['K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD', '610 Församlingsadministration och verksamhetsstöd'], ['K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION', '630 Gemensamma kostnader och administration'], ['K650_FASTIGHETER_OCH_LOKALER', '650 Fastigheter och lokaler'], ['K690_FINANSIELLA_POSTER', '690 Finansiella poster'], ['K801_VERKSAMHETSGEMENSAMT', '801 Verksamhetsgemensamt'], ['K810_ADMINISTRATION_OCH_LEDNING', '810 Administration och ledning'], ['K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL', '820 Gravsättning och kyrkogårdsskötsel'], ['K840_KREMATORIUM', '840 Krematorium'], ['K860_FASTIGHETER_OCH_MARK', '860 Fastigheter och mark'], ['K890_INOMKYRKLIGT_TILLHANDAHALLANDE_INOM_BV', '890 Inomkyrkligt tillhandahållande inom BV']]),
          EnumSortValues: new Map([['K101_VERKSAMHETSGEMENSAMT', '101'], ['K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR', '110'], ['K140_UNDERVISNING', '140'], ['K210_DIAKONAL_VERKSAMHET', '210'], ['K260_MISSION', '260'], ['K310_OVRIG_FORSAMLINGSVERKSAMHET', '310'], ['K360_SERVICEVERKSAMHET', '360'], ['K380_INOMKYRKLIGT_TILLHANDAHALLANDE', '380'], ['K410_SKATTEPLIKTIG_RORELSE', '410'], ['K510_STRATEGISK_STYRNING', '510'], ['K580_VERKSAMHETSLEDNING', '580'], ['K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD', '610'], ['K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION', '630'], ['K650_FASTIGHETER_OCH_LOKALER', '650'], ['K690_FINANSIELLA_POSTER', '690'], ['K801_VERKSAMHETSGEMENSAMT', '801'], ['K810_ADMINISTRATION_OCH_LEDNING', '810'], ['K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL', '820'], ['K840_KREMATORIUM', '840'], ['K860_FASTIGHETER_OCH_MARK', '860'], ['K890_INOMKYRKLIGT_TILLHANDAHALLANDE_INOM_BV', '890']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K101_VERKSAMHETSGEMENSAMT=101 Verksamhetsgemensamt;K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR=110 Gudstjänster och kyrkliga handlingar;K140_UNDERVISNING=140 Undervisning;K210_DIAKONAL_VERKSAMHET=210 Diakonal verksamhet;K260_MISSION=260 Mission;K310_OVRIG_FORSAMLINGSVERKSAMHET=310 Övrig församlingsverksamhet;K360_SERVICEVERKSAMHET=360 Serviceverksamhet;K380_INOMKYRKLIGT_TILLHANDAHALLANDE=380 Inomkyrkligt tillhandahållande;K410_SKATTEPLIKTIG_RORELSE=410 Skattepliktig rörelse;K510_STRATEGISK_STYRNING=510 Strategisk styrning;K580_VERKSAMHETSLEDNING=580 Verksamhetsledning;K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD=610 Församlingsadministration och verksamhetsstöd;K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION=630 Gemensamma kostnader och administration;K650_FASTIGHETER_OCH_LOKALER=650 Fastigheter och lokaler;K690_FINANSIELLA_POSTER=690 Finansiella poster;K801_VERKSAMHETSGEMENSAMT=801 Verksamhetsgemensamt;K810_ADMINISTRATION_OCH_LEDNING=810 Administration och ledning;K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL=820 Gravsättning och kyrkogårdsskötsel;K840_KREMATORIUM=840 Krematorium;K860_FASTIGHETER_OCH_MARK=860 Fastigheter och mark;K890_INOMKYRKLIGT_TILLHANDAHALLANDE_INOM_BV=890 Inomkyrkligt tillhandahållande inom BV"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KPLANBYTE_RECEPT: {
          AttributeName: 'KPLANBYTE_RECEPT',
          DisplayLabel: 'Kontoplanbyte, recept',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp för stiftelse',
          Hint: 'Används för stiftelser',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        GASBAS_ID: {
          AttributeName: 'GASBAS_ID',
          DisplayLabel: 'GASBAS, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gas',
        },
        SPARR_ATTEST: {
          AttributeName: 'SPARR_ATTEST',
          DisplayLabel: 'Spärr för attest',
          Hint: 'Gäller enbart baskonto - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXP_TILL_LON: {
          AttributeName: 'EXP_TILL_LON',
          DisplayLabel: 'Exporterad till Lön',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        EXP_TILL_TID: {
          AttributeName: 'EXP_TILL_TID',
          DisplayLabel: 'Exporterad till HRM',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Ändrad, datum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        aktuelltFlexHRMid: {
          AttributeName: 'aktuelltFlexHRMid',
          DisplayLabel: 'aktuelltFlexHRMid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXPORTERA_TILL_FLEX: {
          AttributeName: 'EXPORTERA_TILL_FLEX',
          DisplayLabel: 'Exportera till Lön/Tid',
          Hint: 'Nej/Lön/Lön&Tid',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['LON', 'Lön'], ['LON_TID', 'Lön&Tid']]),
          EnumSortValues: new Map([['NEJ', '1'], ['LON', '2'], ['LON_TID', '4']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;LON=Lön;LON_TID=Lön&Tid"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        aktuellFlexLonStatus: {
          AttributeName: 'aktuellFlexLonStatus',
          DisplayLabel: 'Exporterad till Flex lön',
          Hint: 'Exporterad/Felaktig/Ej Exporterad',
          DataType: 'Enum',
          EnumValues: new Map([['EXPORTERAD', 'Exporterad'], ['FELAKTIG', 'Felaktig'], ['EJ_EXPORTERAD', 'Ej Exporterad']]),
          EnumSortValues: new Map([['EXPORTERAD', 'E'], ['FELAKTIG', 'F'], ['EJ_EXPORTERAD', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXPORTERAD=Exporterad;FELAKTIG=Felaktig;EJ_EXPORTERAD=Ej Exporterad"',
        },
        aktuellFlexHRMStatus: {
          AttributeName: 'aktuellFlexHRMStatus',
          DisplayLabel: 'Exporterad till Flex HRM',
          Hint: 'Exporterad/Felaktig/Ej Exporterad',
          DataType: 'Enum',
          EnumValues: new Map([['EXPORTERAD', 'Exporterad'], ['FELAKTIG', 'Felaktig'], ['EJ_EXPORTERAD', 'Ej Exporterad']]),
          EnumSortValues: new Map([['EXPORTERAD', 'E'], ['FELAKTIG', 'F'], ['EJ_EXPORTERAD', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXPORTERAD=Exporterad;FELAKTIG=Felaktig;EJ_EXPORTERAD=Ej Exporterad"',
        },
        VERKS_KAT: {
          AttributeName: 'VERKS_KAT',
          DisplayLabel: 'Verksamhetskategori',
          Hint: 'Obligatorisk grundnivå/Frivillig delverksamhet/Frivillig aktivitetstnivå/Ej definierad',
          DataType: 'Enum',
          EnumValues: new Map([['OBLIGATORISK_GRUNDNIVA', 'Obligatorisk grundnivå'], ['FRIVILLIG_DELVERKSAMHET', 'Frivillig delverksamhet'], ['FRIVILLIG_AKTIVITETSTNIVA', 'Frivillig aktivitetstnivå'], ['EJ_DEFINIERAD', 'Ej definierad']]),
          EnumSortValues: new Map([['OBLIGATORISK_GRUNDNIVA', 'G'], ['FRIVILLIG_DELVERKSAMHET', 'D'], ['FRIVILLIG_AKTIVITETSTNIVA', 'A'], ['EJ_DEFINIERAD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="OBLIGATORISK_GRUNDNIVA=Obligatorisk grundnivå;FRIVILLIG_DELVERKSAMHET=Frivillig delverksamhet;FRIVILLIG_AKTIVITETSTNIVA=Frivillig aktivitetstnivå;EJ_DEFINIERAD=Ej definierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gas',
        },
        AKTNIVA_INTERVALL: {
          AttributeName: 'AKTNIVA_INTERVALL',
          DisplayLabel: 'Giltiga aktivitetsnivåer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gas',
        },
        LokalaKoder: {
          AttributeName: 'LokalaKoder',
          DisplayLabel: 'Lokala koder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        FelaktigLokalKod: {
          AttributeName: 'FelaktigLokalKod',
          DisplayLabel: 'Felaktig lokal kod',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Gas',
        },
        ERSATT_MED_KONTODEL: {
          AttributeName: 'ERSATT_MED_KONTODEL',
          DisplayLabel: 'Ersätt med',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        ERSATT_DATUM: {
          AttributeName: 'ERSATT_DATUM',
          DisplayLabel: 'Ersätt, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        TILLAGGSINFO_KOD: {
          AttributeName: 'TILLAGGSINFO_KOD',
          DisplayLabel: 'Tilläggsinfo, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOBEGREPP_1_1_1: {
          AttributeName: 'KONTOBEGREPP_1_1_1',
          DisplayLabel: '@KONTOBEGREPP_1_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIKKONTO: {
          AttributeName: 'RUBRIKKONTO',
          DisplayLabel: 'Underkonto ska användas enligt Kyrk-Bas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOKAL_EXP_TILL_FLEX: {
          AttributeName: 'LOKAL_EXP_TILL_FLEX',
          DisplayLabel: 'Till lön/HRM får ändras lokalt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOKALT_ATGARD_INTERVALL: {
          AttributeName: 'LOKALT_ATGARD_INTERVALL',
          DisplayLabel: 'Lokalt åtgärdsintervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gas',
        },
        ATGARD_KAT: {
          AttributeName: 'ATGARD_KAT',
          DisplayLabel: 'Åtgärdsnivå',
          Hint: 'Standard åtgärdsnivå/Lokal åtgärdsnivå/Ej definierad',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARD_ATGARDSNIVA', 'Standard åtgärdsnivå'], ['LOKAL_ATGARDSNIVA', 'Lokal åtgärdsnivå'], ['EJ_DEFINIERAD', 'Ej definierad']]),
          EnumSortValues: new Map([['STANDARD_ATGARDSNIVA', 'G'], ['LOKAL_ATGARDSNIVA', 'L'], ['EJ_DEFINIERAD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARD_ATGARDSNIVA=Standard åtgärdsnivå;LOKAL_ATGARDSNIVA=Lokal åtgärdsnivå;EJ_DEFINIERAD=Ej definierad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FASTIGHETS_ID: {
          AttributeName: 'FASTIGHETS_ID',
          DisplayLabel: 'Fastighetsid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HUVUDPROJEKT_ID: {
          AttributeName: 'HUVUDPROJEKT_ID',
          DisplayLabel: 'Huvudprojekt, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Nuv_Momsplikt_Fran: {
          AttributeName: 'Nuv_Momsplikt_Fran',
          DisplayLabel: 'Momsplikt, fr o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Nuv_Momsplikt_Till: {
          AttributeName: 'Nuv_Momsplikt_Till',
          DisplayLabel: 'Momsplikt, t o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Nuv_Momsplikt_Procent: {
          AttributeName: 'Nuv_Momsplikt_Procent',
          DisplayLabel: 'Momsplikt, procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Momsplikt_Fran: {
          AttributeName: 'Foreg_Momsplikt_Fran',
          DisplayLabel: 'Föreg momsplikt, fr o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Momsplikt_Till: {
          AttributeName: 'Foreg_Momsplikt_Till',
          DisplayLabel: 'Föreg, momsplikt, t o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Momsplikt_Procent: {
          AttributeName: 'Foreg_Momsplikt_Procent',
          DisplayLabel: 'Föreg, momsplikt, procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Foreg_Momsplikt_Fran: {
          AttributeName: 'Foreg_Foreg_Momsplikt_Fran',
          DisplayLabel: 'Före föreg, momsplikt, fr o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Foreg_Momsplikt_Till: {
          AttributeName: 'Foreg_Foreg_Momsplikt_Till',
          DisplayLabel: 'Före föreg, momsplikt, t o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        Foreg_Foreg_Momsplikt_Procent: {
          AttributeName: 'Foreg_Foreg_Momsplikt_Procent',
          DisplayLabel: 'Före föreg, momsplikt, procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          AttributeGroup: 'Momsplikt',
        },
        MomspliktigIdagEllerFramat: {
          AttributeName: 'MomspliktigIdagEllerFramat',
          DisplayLabel: 'Momspliktig',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Momsplikt',
        },
        MomspliktigFran: {
          AttributeName: 'MomspliktigFran',
          DisplayLabel: 'Momspliktig från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        MomspliktigTill: {
          AttributeName: 'MomspliktigTill',
          DisplayLabel: 'Momspliktig till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Momsplikt',
        },
        MomspliktigProcent: {
          AttributeName: 'MomspliktigProcent',
          DisplayLabel: 'Momspliktig, procent',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          AttributeGroup: 'Momsplikt',
        },
        UNDANTAG_PERIODISERING: {
          AttributeName: 'UNDANTAG_PERIODISERING',
          DisplayLabel: 'Undantag för periodisering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Kontodelsdef: {
          AssociationName: 'Kontodelsdef',
          DisplayLabel: 'Koddelsdefinition',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodeldef',
          AssociatedComponentName: 'Kontodeldef',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Momskod: {
          AssociationName: 'Momskod',
          DisplayLabel: 'Momskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKMomskod',
          AssociatedComponentName: 'Momskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ProjDebKontodel: {
          AssociationName: 'ProjDebKontodel',
          DisplayLabel: 'Debetkonto vid projektavslut',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ProjDebProjekt: {
          AssociationName: 'ProjDebProjekt',
          DisplayLabel: 'ProjDebProjekt (om man vill styra konto per projekt)',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ProjKredKontodel: {
          AssociationName: 'ProjKredKontodel',
          DisplayLabel: 'Kreditkonto vid projektavslut',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ProjKredProjekt: {
          AssociationName: 'ProjKredProjekt',
          DisplayLabel: 'ProjKredProjekt (om man vill styra konto vid projektavslut per projekt, ej implementerat än)',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp för stiftelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillaggsinfo: {
          AssociationName: 'Tillaggsinfo',
          DisplayLabel: 'Tilläggsinfo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKTillaggsinfo',
          AssociatedComponentName: 'Tillaggsinfo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fastighet: {
          AssociationName: 'Fastighet',
          DisplayLabel: 'Fastighet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARPlats',
          AssociatedComponentName: 'Byggnad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Huvudprojekt: {
          AssociationName: 'Huvudprojekt',
          DisplayLabel: 'Huvudprojekt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKHuvudprojekt',
          AssociatedComponentName: 'Huvudprojekt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde1: {
          AssociationName: 'Konteringsvarde1',
          DisplayLabel: 'Konteringsvärde1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde2: {
          AssociationName: 'Konteringsvarde2',
          DisplayLabel: 'Konteringsvärde2',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde3: {
          AssociationName: 'Konteringsvarde3',
          DisplayLabel: 'Konteringsvärde3',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde4: {
          AssociationName: 'Konteringsvarde4',
          DisplayLabel: 'Konteringsvärde4',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde5: {
          AssociationName: 'Konteringsvarde5',
          DisplayLabel: 'Konteringsvärde5',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde6: {
          AssociationName: 'Konteringsvarde6',
          DisplayLabel: 'Konteringsvärde6',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde7: {
          AssociationName: 'Konteringsvarde7',
          DisplayLabel: 'Konteringsvärde7',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde8: {
          AssociationName: 'Konteringsvarde8',
          DisplayLabel: 'Konteringsvärde8',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde9: {
          AssociationName: 'Konteringsvarde9',
          DisplayLabel: 'Konteringsvärde9',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringsvarde10: {
          AssociationName: 'Konteringsvarde10',
          DisplayLabel: 'Konteringsvärde10',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontoanvandning: {
          AssociationName: 'Kontoanvandning',
          DisplayLabel: 'Användning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoanvandning',
          AssociatedComponentName: 'Kontoanvandning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontering1: {
          AssociationName: 'Kontering1',
          DisplayLabel: 'Kontering1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetkontering1: {
          AssociationName: 'Budgetkontering1',
          DisplayLabel: 'Budgetkontering1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBudgetkontering',
          AssociatedComponentName: 'Budgetkontering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ingbalans1: {
          AssociationName: 'Ingbalans1',
          DisplayLabel: 'Ingbalans1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKTEDEKIngBalans',
          AssociatedComponentName: 'IngBalans',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskoder: {
          AssociationName: 'Konteringskoder',
          DisplayLabel: 'Konteringskoder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKTEDEKKonteringskoder',
          AssociatedComponentName: 'Konteringskoder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kombinationer: {
          AssociationName: 'Kombinationer',
          DisplayLabel: 'Kombinationer',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodelkombination',
          AssociatedComponentName: 'Kontodelkombination',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kombinationsvillkor: {
          AssociationName: 'Kombinationsvillkor',
          DisplayLabel: 'Kombinationsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKTEDEKKombinationsvillkor',
          AssociatedComponentName: 'Kombinationsvillkor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Recept: {
          AssociationName: 'Recept',
          DisplayLabel: 'Beräkningsrecept',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodelRecept',
          AssociatedComponentName: 'KontodelRecept',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        LokalKontoanvandning: {
          AssociationName: 'LokalKontoanvandning',
          DisplayLabel: 'Lokal användning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKLokalKontoanvandning',
          AssociatedComponentName: 'LokalKontoanvandning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Avdragsratt: {
          AssociationName: 'Avdragsratt',
          DisplayLabel: 'Avdragsrätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAvdragsratt',
          AssociatedComponentName: 'Avdragsratt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontodelkombination: {
      CollectionName: 'EKKontodelkombination',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y'], ['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Kontodelkombination',
        Abstract: false,
        SOLabel: 'Koddelkombination',
        SOGLabel: 'Koddelkombination',
        SBLabel: 'Koddelkombinationen',
        SBGLabel: 'Koddelkombinationen',
        POLabel: 'Koddelkombinationer',
        POGLabel: 'Koddelkombinationer',
        PBLabel: 'Koddelkombinationerna',
        PBGLabel: 'Koddelkombinationerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Koddelkombinationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Koddelkombinationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Koddelkombinationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Koddelkombinationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMB_ORDNINGS_NR: {
          AttributeName: 'KOMB_ORDNINGS_NR',
          DisplayLabel: 'Kombination med kontodel nr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KOMBINATION: {
          AttributeName: 'KOMBINATION',
          DisplayLabel: 'Kombination',
          Hint: 'Får kombineras/Måste kombineras/Får ej kombineras',
          DataType: 'Enum',
          EnumValues: new Map([['FAR_KOMBINERAS', 'Får kombineras'], ['MASTE_KOMBINERAS', 'Måste kombineras'], ['FAR_EJ_KOMBINERAS', 'Får ej kombineras']]),
          EnumSortValues: new Map([['FAR_KOMBINERAS', '0'], ['MASTE_KOMBINERAS', '1'], ['FAR_EJ_KOMBINERAS', '2']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAR_KOMBINERAS=Får kombineras;MASTE_KOMBINERAS=Måste kombineras;FAR_EJ_KOMBINERAS=Får ej kombineras"',
        },
        LOKALT_KRAV: {
          AttributeName: 'LOKALT_KRAV',
          DisplayLabel: 'Lokalt krav',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Koddel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TillKontodelDef: {
          AssociationName: 'TillKontodelDef',
          DisplayLabel: 'Kombineras med',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodeldef',
          AssociatedComponentName: 'Kontodeldef',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontodeldef: {
      CollectionName: 'EKKontodeldef',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '17001']]),
      RootType: {
        TypeValue: 'Kontodeldef',
        Abstract: false,
        SOLabel: 'Koddelsdefinition',
        SOGLabel: 'Koddelsdefinition',
        SBLabel: 'Koddelsdefinitionen',
        SBGLabel: 'Koddelsdefinitionen',
        POLabel: 'Koddelsdefinitioner',
        POGLabel: 'Koddelsdefinitioner',
        PBLabel: 'Koddelsdefinitionerna',
        PBGLabel: 'Koddelsdefinitionerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Koddelsdefinitionen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Koddelsdefinitionen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Koddelsdefinitionen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Koddelsdefinitionen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Kontotyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ANTAL_POS: {
          AttributeName: 'ANTAL_POS',
          DisplayLabel: 'Antal positioner',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PROJEKT: {
          AttributeName: 'PROJEKT',
          DisplayLabel: 'Projekt',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        VERKSAMHET: {
          AttributeName: 'VERKSAMHET',
          DisplayLabel: 'Verksamhet',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KPLANBYTE_MOTSV_ORDNINGS_NR: {
          AttributeName: 'KPLANBYTE_MOTSV_ORDNINGS_NR',
          DisplayLabel: 'Kontoplanbyte, motsvarande ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLANBYTE_IMPORTSATT: {
          AttributeName: 'KPLANBYTE_IMPORTSATT',
          DisplayLabel: 'Kontoplanbyte, importsätt',
          Hint: 'Enligt kontodel/Enligt recept/Manuellt',
          DataType: 'Enum',
          EnumValues: new Map([['ENLIGT_KONTODEL', 'Enligt kontodel'], ['ENLIGT_RECEPT', 'Enligt recept'], ['MANUELLT', 'Manuellt']]),
          EnumSortValues: new Map([['ENLIGT_KONTODEL', 'K'], ['ENLIGT_RECEPT', 'R'], ['MANUELLT', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENLIGT_KONTODEL=Enligt kontodel;ENLIGT_RECEPT=Enligt recept;MANUELLT=Manuellt"',
        },
        STIFTELSE: {
          AttributeName: 'STIFTELSE',
          DisplayLabel: 'Stiftelse',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BERAKNAD: {
          AttributeName: 'BERAKNAD',
          DisplayLabel: 'Beräknad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BERAKNAS_FRAN_1: {
          AttributeName: 'BERAKNAS_FRAN_1',
          DisplayLabel: 'Beräknas från 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_2: {
          AttributeName: 'BERAKNAS_FRAN_2',
          DisplayLabel: 'Beräknas från 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_3: {
          AttributeName: 'BERAKNAS_FRAN_3',
          DisplayLabel: 'Beräknas från 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_4: {
          AttributeName: 'BERAKNAS_FRAN_4',
          DisplayLabel: 'Beräknas från 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_5: {
          AttributeName: 'BERAKNAS_FRAN_5',
          DisplayLabel: 'Beräknas från 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_6: {
          AttributeName: 'BERAKNAS_FRAN_6',
          DisplayLabel: 'Beräknas från 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BERAKNAS_FRAN_7: {
          AttributeName: 'BERAKNAS_FRAN_7',
          DisplayLabel: 'Beräknas från 7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_8: {
          AttributeName: 'BERAKNAS_FRAN_8',
          DisplayLabel: 'Beräknas från 8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_9: {
          AttributeName: 'BERAKNAS_FRAN_9',
          DisplayLabel: 'Beräknas från 9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BERAKNAS_FRAN_10: {
          AttributeName: 'BERAKNAS_FRAN_10',
          DisplayLabel: 'Beräknas från 10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDS_FOR: {
          AttributeName: 'ANVANDS_FOR',
          DisplayLabel: 'Används för',
          Hint: 'Ansvarsområde/Gåvor/Objekt/Åtgärd',
          DataType: 'Enum',
          EnumValues: new Map([['ANSVARSOMRADE', 'Ansvarsområde'], ['GAVOR', 'Gåvor'], ['OBJEKT', 'Objekt'], ['ATGARD', 'Åtgärd']]),
          EnumSortValues: new Map([['ANSVARSOMRADE', 'A'], ['GAVOR', 'G'], ['OBJEKT', 'O'], ['ATGARD', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANSVARSOMRADE=Ansvarsområde;GAVOR=Gåvor;OBJEKT=Objekt;ATGARD=Åtgärd"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISIBLEFROMDATE: {
          AttributeName: 'VISIBLEFROMDATE',
          DisplayLabel: 'Synlig from datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Övrigt',
        },
        VISIBLETODATE: {
          AttributeName: 'VISIBLETODATE',
          DisplayLabel: 'Synlig t o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Övrigt',
        },
        FASTIGHETSUPPFOLJNING: {
          AttributeName: 'FASTIGHETSUPPFOLJNING',
          DisplayLabel: 'Fastighetsuppföljning',
          Hint: 'Ska denna koddel användas fö fastighetsuppföljning? Normalt används Verksamhet - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDS_FOR_MOMS: {
          AttributeName: 'ANVANDS_FOR_MOMS',
          DisplayLabel: 'Används för moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        anvandForMoms: {
          AttributeName: 'anvandForMoms',
          DisplayLabel: 'Använd för moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
      },
      Associations: {
        Kontoplan: {
          AssociationName: 'Kontoplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Koddel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegreppdef: {
          AssociationName: 'Kontobegreppdef',
          DisplayLabel: 'Kodbegreppsdefinition',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontobegreppdef',
          AssociatedComponentName: 'Kontobegreppdef',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Huvudprojekt: {
          AssociationName: 'Huvudprojekt',
          DisplayLabel: 'Huvudprojekt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKHuvudprojekt',
          AssociatedComponentName: 'Huvudprojekt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontoplan: {
      CollectionName: 'EKKontoplan',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Kontoplan',
        Abstract: false,
        SOLabel: 'Kodplan',
        SOGLabel: 'Kodplans',
        SBLabel: 'Kodplanen',
        SBGLabel: 'Kodplanens',
        POLabel: 'Kodplaner',
        POGLabel: 'Kodplaners',
        PBLabel: 'Kodplanerna',
        PBGLabel: 'Kodplanernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kodplanens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kodplanens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kodplanens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kodplanens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Kontoplan',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        FRAN_BOKF_AR: {
          AttributeName: 'FRAN_BOKF_AR',
          DisplayLabel: 'Fr o m bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        TILL_BOKF_AR: {
          AttributeName: 'TILL_BOKF_AR',
          DisplayLabel: 'T o m bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        TI_PROJEKT: {
          AttributeName: 'TI_PROJEKT',
          DisplayLabel: 'TI_PROJEKT',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ av kontoplan',
          Hint: 'Kyrkbas/Stiftelse/EUBas/Stift',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKBAS', 'Kyrkbas'], ['STIFTELSE', 'Stiftelse'], ['EUBAS', 'EUBas'], ['STIFT', 'Stift']]),
          EnumSortValues: new Map([['KYRKBAS', 'K'], ['STIFTELSE', 'S'], ['EUBAS', 'E'], ['STIFT', 'T']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKBAS=Kyrkbas;STIFTELSE=Stiftelse;EUBAS=EUBas;STIFT=Stift"',
          GUIEditable: true,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVPAGINVIB: {
          AttributeName: 'ANVPAGINVIB',
          DisplayLabel: 'Ta med ing.balans i beräkning av pågående investeringar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Kontodelsdef: {
          AssociationName: 'Kontodelsdef',
          DisplayLabel: 'Koddelsdefinition',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodeldef',
          AssociatedComponentName: 'Kontodeldef',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKOBKollektFilRad: {
      CollectionName: 'EKKOBKollektFilRad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBKollektFilRad',
        Abstract: false,
        SOLabel: 'Kollektfilrad',
        SOGLabel: 'Kollektfilrad',
        SBLabel: 'Kollektfilraden',
        SBGLabel: 'Kollektfilradens',
        POLabel: 'Kollektfilrader',
        POGLabel: 'Kollektfilraders',
        PBLabel: 'Kollektfilraderna',
        PBGLabel: 'Kollektfilradernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kollektfilradens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kollektfilradens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kollektfilradens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FORSAMLING: {
          AttributeName: 'FORSAMLING',
          DisplayLabel: 'Församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOLLEKTSTALLE: {
          AttributeName: 'KOLLEKTSTALLE',
          DisplayLabel: 'Kollektställe',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOLLEKT_NR: {
          AttributeName: 'KOLLEKT_NR',
          DisplayLabel: 'Kollektnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INBETALNINGSSATT: {
          AttributeName: 'INBETALNINGSSATT',
          DisplayLabel: 'Inbetalningssätt',
          Hint: 'Kontant/Kort/Swish 1/Swish 2',
          DataType: 'Enum',
          EnumValues: new Map([['KONTANT', 'Kontant'], ['KORT', 'Kort'], ['SWISH_1', 'Swish 1'], ['SWISH_2', 'Swish 2']]),
          EnumSortValues: new Map([['KONTANT', 'K'], ['KORT', 'O'], ['SWISH_1', '1'], ['SWISH_2', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTANT=Kontant;KORT=Kort;SWISH_1=Swish 1;SWISH_2=Swish 2"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INBETALNING_KONTONUMMER: {
          AttributeName: 'INBETALNING_KONTONUMMER',
          DisplayLabel: 'Inbetalning, kontonnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GUID: {
          AttributeName: 'GUID',
          DisplayLabel: 'Guid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 38,
          InterfaceType: 'ifNone',
        },
        TRANSAKTIONS_TYP: {
          AttributeName: 'TRANSAKTIONS_TYP',
          DisplayLabel: 'Transaktionstyp',
          Hint: 'Normal/Makulering',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['MAKULERING', 'Makulering']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['MAKULERING', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;MAKULERING=Makulering"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillfalle: {
          AssociationName: 'Tillfalle',
          DisplayLabel: 'Tillfälle',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBKollektFilTillfalle',
          AssociatedComponentName: 'KOBKollektFilTillfalle',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKOBKollektFilTillfalle: {
      CollectionName: 'EKKOBKollektFilTillfalle',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBKollektFilTillfalle',
        Abstract: false,
        SOLabel: 'Kollektfilstillfälle',
        SOGLabel: 'Kollektfilstillfälle',
        SBLabel: 'Kollektfilstillfället',
        SBGLabel: 'Kollektfilstillfällets',
        POLabel: 'Kollektfilstillfällen',
        POGLabel: 'Kollektfilstillfällens',
        PBLabel: 'Kollektfilstillfällena',
        PBGLabel: 'Kollektfilstillfällenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kollektfilstillfällets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kollektfilstillfällets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kollektfilstillfällets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLFALLE_DATUM: {
          AttributeName: 'TILLFALLE_DATUM',
          DisplayLabel: 'Tillfälle, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_DATUM: {
          AttributeName: 'BOKF_DATUM',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TRANSAKTIONS_TYP: {
          AttributeName: 'TRANSAKTIONS_TYP',
          DisplayLabel: 'Transaktions typ',
          Hint: 'Normal/Makulering',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['MAKULERING', 'Makulering']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['MAKULERING', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;MAKULERING=Makulering"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        KOLLEKT_TYP: {
          AttributeName: 'KOLLEKT_TYP',
          DisplayLabel: 'Kollekt typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Kollekt',
        },
        KOLLEKT_TYP_KOD: {
          AttributeName: 'KOLLEKT_TYP_KOD',
          DisplayLabel: 'Kollekt typkod',
          Hint: 'Församlingskollekt (egna verksamheten)/Församlingskollekt (extern kontakt)/Förskollekt (nationell org)/Rikskollekt/Stiftskollekt',
          DataType: 'Enum',
          EnumValues: new Map([['FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_', 'Församlingskollekt (egna verksamheten)'], ['FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_', 'Församlingskollekt (extern kontakt)'], ['FORSKOLLEKT__NATIONELL_ORG_', 'Förskollekt (nationell org)'], ['RIKSKOLLEKT', 'Rikskollekt'], ['STIFTSKOLLEKT', 'Stiftskollekt']]),
          EnumSortValues: new Map([['FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_', '3'], ['FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_', '4'], ['FORSKOLLEKT__NATIONELL_ORG_', '8'], ['RIKSKOLLEKT', '1'], ['STIFTSKOLLEKT', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_=Församlingskollekt (egna verksamheten);FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_=Församlingskollekt (extern kontakt);FORSKOLLEKT__NATIONELL_ORG_=Förskollekt (nationell org);RIKSKOLLEKT=Rikskollekt;STIFTSKOLLEKT=Stiftskollekt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Kollekt',
        },
        KOLLEKT_ANDAMAL: {
          AttributeName: 'KOLLEKT_ANDAMAL',
          DisplayLabel: 'Kollekt ändamål',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Kollekt',
        },
        INSAMLING_TYP: {
          AttributeName: 'INSAMLING_TYP',
          DisplayLabel: 'Insamling, typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Insamling',
        },
        INSAMLING_TYP_KOD: {
          AttributeName: 'INSAMLING_TYP_KOD',
          DisplayLabel: 'Insamling, typkod',
          Hint: 'Anslag/Gåva/Insamlingsaktivitet',
          DataType: 'Enum',
          EnumValues: new Map([['ANSLAG', 'Anslag'], ['GAVA', 'Gåva'], ['INSAMLINGSAKTIVITET', 'Insamlingsaktivitet']]),
          EnumSortValues: new Map([['ANSLAG', '1'], ['GAVA', '5'], ['INSAMLINGSAKTIVITET', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANSLAG=Anslag;GAVA=Gåva;INSAMLINGSAKTIVITET=Insamlingsaktivitet"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        MOTTAGAR_TYP: {
          AttributeName: 'MOTTAGAR_TYP',
          DisplayLabel: 'Mottagartyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Insamling',
        },
        MOTTAGAR_TYP_KOD: {
          AttributeName: 'MOTTAGAR_TYP_KOD',
          DisplayLabel: 'Mottagare, typkod',
          Hint: 'Act Svenska kyrkan/Egna verksamheten/Extern kontakt/Svenska kyrkan i utlandet',
          DataType: 'Enum',
          EnumValues: new Map([['ACT_SVENSKA_KYRKAN', 'Act Svenska kyrkan'], ['EGNA_VERKSAMHETEN', 'Egna verksamheten'], ['EXTERN_KONTAKT', 'Extern kontakt'], ['SVENSKA_KYRKAN_I_UTLANDET', 'Svenska kyrkan i utlandet']]),
          EnumSortValues: new Map([['ACT_SVENSKA_KYRKAN', '2'], ['EGNA_VERKSAMHETEN', '4'], ['EXTERN_KONTAKT', '3'], ['SVENSKA_KYRKAN_I_UTLANDET', '1']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ACT_SVENSKA_KYRKAN=Act Svenska kyrkan;EGNA_VERKSAMHETEN=Egna verksamheten;EXTERN_KONTAKT=Extern kontakt;SVENSKA_KYRKAN_I_UTLANDET=Svenska kyrkan i utlandet"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        AKTIVITET_TYP: {
          AttributeName: 'AKTIVITET_TYP',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        GUID: {
          AttributeName: 'GUID',
          DisplayLabel: 'Guid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 38,
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        MOTTAGARE: {
          AttributeName: 'MOTTAGARE',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        AVSANDARE: {
          AttributeName: 'AVSANDARE',
          DisplayLabel: 'Avsändare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        INSAMLING_BELOPP: {
          AttributeName: 'INSAMLING_BELOPP',
          DisplayLabel: 'Insamlingsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Insamling',
        },
        INBETALNINGSSATT: {
          AttributeName: 'INBETALNINGSSATT',
          DisplayLabel: 'Inbetalningsmetod',
          Hint: 'Kontant/Kort/Swish 1/Swish 2',
          DataType: 'Enum',
          EnumValues: new Map([['KONTANT', 'Kontant'], ['KORT', 'Kort'], ['SWISH_1', 'Swish 1'], ['SWISH_2', 'Swish 2']]),
          EnumSortValues: new Map([['KONTANT', 'K'], ['KORT', 'O'], ['SWISH_1', '1'], ['SWISH_2', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTANT=Kontant;KORT=Kort;SWISH_1=Swish 1;SWISH_2=Swish 2"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        INBETALNING_KONTONUMMER: {
          AttributeName: 'INBETALNING_KONTONUMMER',
          DisplayLabel: 'Inbetalning, kontonnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        KOMMUNIKATIONSFIL_ID: {
          AttributeName: 'KOMMUNIKATIONSFIL_ID',
          DisplayLabel: 'Kommunikationsfil, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORGNR: {
          AttributeName: 'ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'Enhets-id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHETSNAMN: {
          AttributeName: 'ENHETSNAMN',
          DisplayLabel: 'Enhetsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INLAST_DATUM: {
          AttributeName: 'INLAST_DATUM',
          DisplayLabel: 'Inläst datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INLAST_SIGNATUR: {
          AttributeName: 'INLAST_SIGNATUR',
          DisplayLabel: 'Inläst sign',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Inläst/Hanterad/Komplettera transaktionstyper/Komplettera KOB-konto/Komplettera bokföringsgrupp/Felaktig/Backad/Bokföringsperiod låst/Bokföringsperiod saknas/Bokföringsår saknas/Journalnummerserie saknas/Verifikationsnummerserie saknas/Bokföringsordernummerserie saknas',
          DataType: 'Enum',
          EnumValues: new Map([['INLAST', 'Inläst'], ['HANTERAD', 'Hanterad'], ['KOMPLETTERA_TRANSAKTIONSTYPER', 'Komplettera transaktionstyper'], ['KOMPLETTERA_KOB_KONTO', 'Komplettera KOB-konto'], ['KOMPLETTERA_BOKFORINGSGRUPP', 'Komplettera bokföringsgrupp'], ['FELAKTIG', 'Felaktig'], ['BACKAD', 'Backad'], ['BOKFORINGSPERIOD_LAST', 'Bokföringsperiod låst'], ['BOKFORINGSPERIOD_SAKNAS', 'Bokföringsperiod saknas'], ['BOKFORINGSAR_SAKNAS', 'Bokföringsår saknas'], ['JOURNALNUMMERSERIE_SAKNAS', 'Journalnummerserie saknas'], ['VERIFIKATIONSNUMMERSERIE_SAKNAS', 'Verifikationsnummerserie saknas'], ['BOKFORINGSORDERNUMMERSERIE_SAKNAS', 'Bokföringsordernummerserie saknas']]),
          EnumSortValues: new Map([['INLAST', 'I'], ['HANTERAD', 'H'], ['KOMPLETTERA_TRANSAKTIONSTYPER', 'T'], ['KOMPLETTERA_KOB_KONTO', 'K'], ['KOMPLETTERA_BOKFORINGSGRUPP', 'G'], ['FELAKTIG', 'F'], ['BACKAD', 'B'], ['BOKFORINGSPERIOD_LAST', 'P'], ['BOKFORINGSPERIOD_SAKNAS', 'A'], ['BOKFORINGSAR_SAKNAS', 'C'], ['JOURNALNUMMERSERIE_SAKNAS', 'J'], ['VERIFIKATIONSNUMMERSERIE_SAKNAS', 'V'], ['BOKFORINGSORDERNUMMERSERIE_SAKNAS', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INLAST=Inläst;HANTERAD=Hanterad;KOMPLETTERA_TRANSAKTIONSTYPER=Komplettera transaktionstyper;KOMPLETTERA_KOB_KONTO=Komplettera KOB-konto;KOMPLETTERA_BOKFORINGSGRUPP=Komplettera bokföringsgrupp;FELAKTIG=Felaktig;BACKAD=Backad;BOKFORINGSPERIOD_LAST=Bokföringsperiod låst;BOKFORINGSPERIOD_SAKNAS=Bokföringsperiod saknas;BOKFORINGSAR_SAKNAS=Bokföringsår saknas;JOURNALNUMMERSERIE_SAKNAS=Journalnummerserie saknas;VERIFIKATIONSNUMMERSERIE_SAKNAS=Verifikationsnummerserie saknas;BOKFORINGSORDERNUMMERSERIE_SAKNAS=Bokföringsordernummerserie saknas"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Filens typ',
          Hint: 'Insamling/Kollekt',
          DataType: 'Enum',
          EnumValues: new Map([['INSAMLING', 'Insamling'], ['KOLLEKT', 'Kollekt']]),
          EnumSortValues: new Map([['INSAMLING', 'I'], ['KOLLEKT', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INSAMLING=Insamling;KOLLEKT=Kollekt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORONMARKNING: {
          AttributeName: 'ORONMARKNING',
          DisplayLabel: 'Öronmarkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Insamling',
        },
        SummaBelopp: {
          AttributeName: 'SummaBelopp',
          DisplayLabel: 'Totalt belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Belopprader: {
          AssociationName: 'Belopprader',
          DisplayLabel: 'Kollekt, beloppsrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBKollektFilRad',
          AssociatedComponentName: 'KOBKollektFilRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBKollektFilMottagare',
          AssociatedComponentName: 'KOBKollektFilMottagare',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKOBKollektstyrning: {
      CollectionName: 'EKKOBKollektstyrning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBKollektstyrning',
        Abstract: false,
        SOLabel: 'Kollektstyrning',
        SOGLabel: 'Kollektstyrning',
        SBLabel: 'Kollektstyrning',
        SBGLabel: 'Kollektstyrning',
        POLabel: 'Kollektstyrning',
        POGLabel: 'Kollektstyrning',
        PBLabel: 'Kollektstyrning',
        PBGLabel: 'Kollektstyrning',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kollektstyrning primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kollektstyrning versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kollektstyrning fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Tillfälletyp',
          Hint: 'Insamling/Kollekt',
          DataType: 'Enum',
          EnumValues: new Map([['INSAMLING', 'Insamling'], ['KOLLEKT', 'Kollekt']]),
          EnumSortValues: new Map([['INSAMLING', 'I'], ['KOLLEKT', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INSAMLING=Insamling;KOLLEKT=Kollekt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KBKonto: {
          AttributeName: 'KBKonto',
          DisplayLabel: 'Konto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Konto: {
          AttributeName: 'Konto',
          DisplayLabel: 'Konto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEB_KRED: {
          AttributeName: 'DEB_KRED',
          DisplayLabel: 'Styrning av kontering',
          Hint: 'Debetkontering/Kreditkontering',
          DataType: 'Enum',
          EnumValues: new Map([['DEBETKONTERING', 'Debetkontering'], ['KREDITKONTERING', 'Kreditkontering']]),
          EnumSortValues: new Map([['DEBETKONTERING', 'D'], ['KREDITKONTERING', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBETKONTERING=Debetkontering;KREDITKONTERING=Kreditkontering"',
          InterfaceType: 'ifChecklist',
        },
        KOLLEKT_TYP_KOD: {
          AttributeName: 'KOLLEKT_TYP_KOD',
          DisplayLabel: 'Kollekttyp',
          Hint: 'Församlingskollekt (egna verksamheten)/Församlingskollekt (extern kontakt)/Förskollekt (nationell org)/Rikskollekt/Stiftskollekt',
          DataType: 'Enum',
          EnumValues: new Map([['FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_', 'Församlingskollekt (egna verksamheten)'], ['FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_', 'Församlingskollekt (extern kontakt)'], ['FORSKOLLEKT__NATIONELL_ORG_', 'Förskollekt (nationell org)'], ['RIKSKOLLEKT', 'Rikskollekt'], ['STIFTSKOLLEKT', 'Stiftskollekt']]),
          EnumSortValues: new Map([['FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_', '3'], ['FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_', '4'], ['FORSKOLLEKT__NATIONELL_ORG_', '8'], ['RIKSKOLLEKT', '1'], ['STIFTSKOLLEKT', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORSAMLINGSKOLLEKT__EGNA_VERKSAMHETEN_=Församlingskollekt (egna verksamheten);FORSAMLINGSKOLLEKT__EXTERN_KONTAKT_=Församlingskollekt (extern kontakt);FORSKOLLEKT__NATIONELL_ORG_=Förskollekt (nationell org);RIKSKOLLEKT=Rikskollekt;STIFTSKOLLEKT=Stiftskollekt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INBETALNINGSSATT: {
          AttributeName: 'INBETALNINGSSATT',
          DisplayLabel: 'Inbetalningsmetod',
          Hint: 'Kontant/Kort/Swish 1/Swish 2',
          DataType: 'Enum',
          EnumValues: new Map([['KONTANT', 'Kontant'], ['KORT', 'Kort'], ['SWISH_1', 'Swish 1'], ['SWISH_2', 'Swish 2']]),
          EnumSortValues: new Map([['KONTANT', 'K'], ['KORT', 'O'], ['SWISH_1', '1'], ['SWISH_2', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTANT=Kontant;KORT=Kort;SWISH_1=Swish 1;SWISH_2=Swish 2"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MOTTAGAR_TYP_KOD: {
          AttributeName: 'MOTTAGAR_TYP_KOD',
          DisplayLabel: 'Mottagartyp',
          Hint: 'Act Svenska kyrkan/Egna verksamheten/Extern kontakt/Svenska kyrkan i utlandet',
          DataType: 'Enum',
          EnumValues: new Map([['ACT_SVENSKA_KYRKAN', 'Act Svenska kyrkan'], ['EGNA_VERKSAMHETEN', 'Egna verksamheten'], ['EXTERN_KONTAKT', 'Extern kontakt'], ['SVENSKA_KYRKAN_I_UTLANDET', 'Svenska kyrkan i utlandet']]),
          EnumSortValues: new Map([['ACT_SVENSKA_KYRKAN', '2'], ['EGNA_VERKSAMHETEN', '4'], ['EXTERN_KONTAKT', '3'], ['SVENSKA_KYRKAN_I_UTLANDET', '1']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ACT_SVENSKA_KYRKAN=Act Svenska kyrkan;EGNA_VERKSAMHETEN=Egna verksamheten;EXTERN_KONTAKT=Extern kontakt;SVENSKA_KYRKAN_I_UTLANDET=Svenska kyrkan i utlandet"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INSAMLING_TYP_KOD: {
          AttributeName: 'INSAMLING_TYP_KOD',
          DisplayLabel: 'Insamling, typ',
          Hint: 'Anslag/Gåva/Insamlingsaktivitet',
          DataType: 'Enum',
          EnumValues: new Map([['ANSLAG', 'Anslag'], ['GAVA', 'Gåva'], ['INSAMLINGSAKTIVITET', 'Insamlingsaktivitet']]),
          EnumSortValues: new Map([['ANSLAG', '1'], ['GAVA', '5'], ['INSAMLINGSAKTIVITET', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANSLAG=Anslag;GAVA=Gåva;INSAMLINGSAKTIVITET=Insamlingsaktivitet"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORSAMLING: {
          AttributeName: 'FORSAMLING',
          DisplayLabel: 'Församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOLLEKTSTALLE: {
          AttributeName: 'KOLLEKTSTALLE',
          DisplayLabel: 'Kollekställe',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVSANDARE: {
          AttributeName: 'AVSANDARE',
          DisplayLabel: 'Avsändare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Konto: {
          AssociationName: 'Konto',
          DisplayLabel: 'Konto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKOBKollektFilBankkontorad: {
      CollectionName: 'EKKOBKollektFilBankkontorad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBKollektFilBankkontorad',
        Abstract: false,
        SOLabel: 'Kollekttillfälle, bankkontorad',
        SOGLabel: 'Kollekttillfälle, bankkontorad',
        SBLabel: 'Kollekttillfälle, bankkontorad',
        SBGLabel: 'Kollekttillfälle, bankkontorad',
        POLabel: 'Kollekttillfälle, bankkontorad',
        POGLabel: 'Kollekttillfälle, bankkontorad',
        PBLabel: 'Kollekttillfälle, bankkontorad',
        PBGLabel: 'Kollekttillfälle, bankkontorad',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kollekttillfälle, bankkontorad primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kollekttillfälle, bankkontorad versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kollekttillfälle, bankkontorad fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GILTIGFRAN: {
          AttributeName: 'GILTIGFRAN',
          DisplayLabel: 'Giltig från',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CLEARINGNUMMER: {
          AttributeName: 'CLEARINGNUMMER',
          DisplayLabel: 'Clearingnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKNAMN: {
          AttributeName: 'BANKNAMN',
          DisplayLabel: 'Banknamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTONUMMER: {
          AttributeName: 'KONTONUMMER',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKOBKollektFilMottagare: {
      CollectionName: 'EKKOBKollektFilMottagare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBKollektFilMottagare',
        Abstract: false,
        SOLabel: 'Kollekttillfälle, mottagare',
        SOGLabel: 'Kollekttillfälle, mottagare',
        SBLabel: 'Kollekttillfälle, mottagare',
        SBGLabel: 'Kollekttillfälle, mottagare',
        POLabel: 'Kollekttillfälle, mottagare',
        POGLabel: 'Kollekttillfälle, mottagare',
        PBLabel: 'Kollekttillfälle, mottagare',
        PBGLabel: 'Kollekttillfälle, mottagare',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kollekttillfälle, mottagare primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kollekttillfälle, mottagare versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kollekttillfälle, mottagare fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORGNR: {
          AttributeName: 'ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKGIRO: {
          AttributeName: 'BANKGIRO',
          DisplayLabel: 'Bankgiro',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PLUSGIRO: {
          AttributeName: 'PLUSGIRO',
          DisplayLabel: 'Plusgiro',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTLANDSKONTAKT: {
          AttributeName: 'UTLANDSKONTAKT',
          DisplayLabel: 'Utlandskontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIC: {
          AttributeName: 'BIC',
          DisplayLabel: 'Bic',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 11,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IBAN: {
          AttributeName: 'IBAN',
          DisplayLabel: 'Iban',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 34,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKNAMN: {
          AttributeName: 'BANKNAMN',
          DisplayLabel: 'Banknamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKADRESS: {
          AttributeName: 'BANKADRESS',
          DisplayLabel: 'Bankadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PROCENTFORDELNING: {
          AttributeName: 'PROCENTFORDELNING',
          DisplayLabel: 'Procentuell fördelning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bankkonto: {
          AssociationName: 'Bankkonto',
          DisplayLabel: 'Bankkonto',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKOBKollektFilBankkontorad',
          AssociatedComponentName: 'KOBKollektFilBankkontorad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTEDEKKombinationsvillkor: {
      CollectionName: 'EKTEDEKKombinationsvillkor',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Kombinationsvillkor',
        Abstract: false,
        SOLabel: 'Kombinationsvillkor',
        SOGLabel: 'Kombinationsvillkor',
        SBLabel: 'Kombinationsvillkoret',
        SBGLabel: 'Kombinationsvillkoret',
        POLabel: 'Kombinationsvillkor',
        POGLabel: 'Kombinationsvillkor',
        PBLabel: 'Kombinationsvillkoren',
        PBGLabel: 'Kombinationsvillkoren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kombinationsvillkoret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kombinationsvillkoret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kombinationsvillkoret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kombinationsvillkoret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOMB_ORDNINGS_NR: {
          AttributeName: 'KOMB_ORDNINGS_NR',
          DisplayLabel: 'Kombination med koddel nr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FROM_KONTODEL: {
          AttributeName: 'FROM_KONTODEL',
          DisplayLabel: 'Fr o m kontodel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TOM_KONTODEL: {
          AttributeName: 'TOM_KONTODEL',
          DisplayLabel: 'T o m kontodel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillkontodel: {
          AssociationName: 'Tillkontodel',
          DisplayLabel: 'Komb med koddel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodeldef',
          AssociatedComponentName: 'Kontodeldef',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKKonteringsBegrepp: {
      CollectionName: 'EKKonteringsBegrepp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'KonteringsBegrepp',
        Abstract: false,
        SOLabel: 'Konteringsbegrepp',
        SOGLabel: 'Konteringsbegrepp',
        SBLabel: 'Konteringsbegreppet',
        SBGLabel: 'Konteringsbegreppet',
        POLabel: 'Konteringsbegrepp',
        POGLabel: 'Konteringsbegrepp',
        PBLabel: 'Konteringsbegreppen',
        PBGLabel: 'Konteringsbegreppen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringsbegreppet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringsbegreppet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringsbegreppet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringsbegreppet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_TYP: {
          AttributeName: 'MALL_TYP',
          DisplayLabel: 'Typ av konteringsmall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DELSYSTEM_1: {
          AttributeName: 'DELSYSTEM_1',
          DisplayLabel: 'Delsystem fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KLASS_NAMN_1: {
          AttributeName: 'KLASS_NAMN_1',
          DisplayLabel: 'Klassnamn fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_1_1: {
          AttributeName: 'ATTRIBUT_1_1',
          DisplayLabel: 'Fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_1_2: {
          AttributeName: 'ATTRIBUT_1_2',
          DisplayLabel: 'Fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_1_3: {
          AttributeName: 'ATTRIBUT_1_3',
          DisplayLabel: 'Fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_1_4: {
          AttributeName: 'ATTRIBUT_1_4',
          DisplayLabel: 'Fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_1_5: {
          AttributeName: 'ATTRIBUT_1_5',
          DisplayLabel: 'Fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID_ATTRIBUT_1: {
          AttributeName: 'ID_ATTRIBUT_1',
          DisplayLabel: 'Id attribut 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEL_AV_ATTRIBUT_1: {
          AttributeName: 'DEL_AV_ATTRIBUT_1',
          DisplayLabel: 'Del av fält 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTPOSITION_1: {
          AttributeName: 'STARTPOSITION_1',
          DisplayLabel: 'Start position 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTPOSITION_1: {
          AttributeName: 'SLUTPOSITION_1',
          DisplayLabel: 'Slut position 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSYSTEM_2: {
          AttributeName: 'DELSYSTEM_2',
          DisplayLabel: 'Delsystem fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KLASS_NAMN_2: {
          AttributeName: 'KLASS_NAMN_2',
          DisplayLabel: 'Klassnamn fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_2_1: {
          AttributeName: 'ATTRIBUT_2_1',
          DisplayLabel: 'Fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_2_2: {
          AttributeName: 'ATTRIBUT_2_2',
          DisplayLabel: 'Fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_2_3: {
          AttributeName: 'ATTRIBUT_2_3',
          DisplayLabel: 'Fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_2_4: {
          AttributeName: 'ATTRIBUT_2_4',
          DisplayLabel: 'Fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_2_5: {
          AttributeName: 'ATTRIBUT_2_5',
          DisplayLabel: 'Fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID_ATTRIBUT_2: {
          AttributeName: 'ID_ATTRIBUT_2',
          DisplayLabel: 'Id attribut 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEL_AV_ATTRIBUT_2: {
          AttributeName: 'DEL_AV_ATTRIBUT_2',
          DisplayLabel: 'Del av fält 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTPOSITION_2: {
          AttributeName: 'STARTPOSITION_2',
          DisplayLabel: 'Start position 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTPOSITION_2: {
          AttributeName: 'SLUTPOSITION_2',
          DisplayLabel: 'Slut position 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELSYSTEM_3: {
          AttributeName: 'DELSYSTEM_3',
          DisplayLabel: 'Delsystem fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KLASS_NAMN_3: {
          AttributeName: 'KLASS_NAMN_3',
          DisplayLabel: 'Klassnamn fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_3_1: {
          AttributeName: 'ATTRIBUT_3_1',
          DisplayLabel: 'Fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_3_2: {
          AttributeName: 'ATTRIBUT_3_2',
          DisplayLabel: 'Fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_3_3: {
          AttributeName: 'ATTRIBUT_3_3',
          DisplayLabel: 'Fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_3_4: {
          AttributeName: 'ATTRIBUT_3_4',
          DisplayLabel: 'Fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUT_3_5: {
          AttributeName: 'ATTRIBUT_3_5',
          DisplayLabel: 'Fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID_ATTRIBUT_3: {
          AttributeName: 'ID_ATTRIBUT_3',
          DisplayLabel: 'Id attribut 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEL_AV_ATTRIBUT_3: {
          AttributeName: 'DEL_AV_ATTRIBUT_3',
          DisplayLabel: 'Del av fält 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTPOSITION_3: {
          AttributeName: 'STARTPOSITION_3',
          DisplayLabel: 'Start position 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTPOSITION_3: {
          AttributeName: 'SLUTPOSITION_3',
          DisplayLabel: 'Slut position 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRIORITET: {
          AttributeName: 'PRIORITET',
          DisplayLabel: 'Prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDS: {
          AttributeName: 'ANVANDS',
          DisplayLabel: 'Används',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GILTIG_TOM: {
          AttributeName: 'GILTIG_TOM',
          DisplayLabel: 'Giltig t o m',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Konteringsvarde: {
          AssociationName: 'Konteringsvarde',
          DisplayLabel: 'Konteringsvärden',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTEDEKKonteringskoder: {
      CollectionName: 'EKTEDEKKonteringskoder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Konteringskoder',
        Abstract: false,
        SOLabel: 'Konteringskod',
        SOGLabel: 'Konteringskod',
        SBLabel: 'Konteringskoden',
        SBGLabel: 'Konteringskoden',
        POLabel: 'Konteringskoder',
        POGLabel: 'Konteringskoder',
        PBLabel: 'Konteringskoderna',
        PBGLabel: 'Konteringskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTERINGS_NR: {
          AttributeName: 'SORTERINGS_NR',
          DisplayLabel: 'Sorteringsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKKonteringsvarde: {
      CollectionName: 'EKKonteringsvarde',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Konteringsvarde',
        Abstract: false,
        SOLabel: 'Konteringsvärde',
        SOGLabel: 'Konteringsvärde',
        SBLabel: 'Konteringsvärdet',
        SBGLabel: 'Konteringsvärdet',
        POLabel: 'Konteringsvärden',
        POGLabel: 'Konteringsvärden',
        PBLabel: 'Konteringsvärdena',
        PBGLabel: 'Konteringsvärdena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringsvärdet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringsvärdet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringsvärdet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringsvärdet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1_1: {
          AttributeName: 'VARDE_1_1',
          DisplayLabel: 'Värde objekt 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1_2: {
          AttributeName: 'VARDE_1_2',
          DisplayLabel: 'Värde objekt 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1_3: {
          AttributeName: 'VARDE_1_3',
          DisplayLabel: 'Värde objekt 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1_4: {
          AttributeName: 'VARDE_1_4',
          DisplayLabel: 'Värde objekt 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1_5: {
          AttributeName: 'VARDE_1_5',
          DisplayLabel: 'Värde objekt 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_2_1: {
          AttributeName: 'VARDE_2_1',
          DisplayLabel: 'Värde objekt 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_2_2: {
          AttributeName: 'VARDE_2_2',
          DisplayLabel: 'Värde objekt 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_2_3: {
          AttributeName: 'VARDE_2_3',
          DisplayLabel: 'Värde objekt 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_2_4: {
          AttributeName: 'VARDE_2_4',
          DisplayLabel: 'Värde objekt 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_2_5: {
          AttributeName: 'VARDE_2_5',
          DisplayLabel: 'Värde objekt 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_3_1: {
          AttributeName: 'VARDE_3_1',
          DisplayLabel: 'Värde objekt 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_3_2: {
          AttributeName: 'VARDE_3_2',
          DisplayLabel: 'Värde objekt 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_3_3: {
          AttributeName: 'VARDE_3_3',
          DisplayLabel: 'Värde objekt 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_3_4: {
          AttributeName: 'VARDE_3_4',
          DisplayLabel: 'Värde objekt 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_3_5: {
          AttributeName: 'VARDE_3_5',
          DisplayLabel: 'Värde objekt 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROCENT: {
          AttributeName: 'PROCENT',
          DisplayLabel: 'Procentsats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ExtendedInfo: {
          AttributeName: 'ExtendedInfo',
          DisplayLabel: 'ExtendedInfo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Konteringsbegrepp: {
          AssociationName: 'Konteringsbegrepp',
          DisplayLabel: 'Konteringsbegrepp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsBegrepp',
          AssociatedComponentName: 'KonteringsBegrepp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        kodplan: {
          AssociationName: 'kodplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKAnalys: {
      CollectionName: 'EKAnalys',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Analys',
        Abstract: false,
        SOLabel: 'Kontoanalys',
        SOGLabel: 'Kontoanalys',
        SBLabel: 'Kontoanalysen',
        SBGLabel: 'Kontoanalysen',
        POLabel: 'Kontoanalyser',
        POGLabel: 'Kontoanalyser',
        PBLabel: 'Kontoanalyserna',
        PBGLabel: 'Kontoanalyserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontoanalysen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontoanalysen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontoanalysen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontoanalysen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANALYS: {
          AttributeName: 'ANALYS',
          DisplayLabel: 'Analys',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXCEL_MACRO_SOKVAG: {
          AttributeName: 'EXCEL_MACRO_SOKVAG',
          DisplayLabel: 'Sökväg för Excelmacro',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXCEL_MACRO_NAMN: {
          AttributeName: 'EXCEL_MACRO_NAMN',
          DisplayLabel: 'Namn för Excelmacro',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urvalsid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEBANALYS: {
          AttributeName: 'WEBANALYS',
          DisplayLabel: 'Webanalys',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKontoanvandning: {
      CollectionName: 'EKKontoanvandning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kontoanvandning',
        Abstract: false,
        SOLabel: 'Kontoanvändning',
        SOGLabel: 'Kontoanvändning',
        SBLabel: 'Kontoanvändningen',
        SBGLabel: 'Kontoanvändningen',
        POLabel: 'Kontoanvändningar',
        POGLabel: 'Kontoanvändningar',
        PBLabel: 'Kontoanvändningarna',
        PBGLabel: 'Kontoanvändningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontoanvändningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontoanvändningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontoanvändningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontoanvändningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontodel: {
          AttributeName: 'Kontodel',
          DisplayLabel: 'Kontodel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Koddel',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKStalleKontourval: {
      CollectionName: 'EKStalleKontourval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'StalleKontourval',
        Abstract: false,
        SOLabel: 'Kontobegr, arbetsställe',
        SOGLabel: 'Kontobegr, arbetsställe',
        SBLabel: 'Kontobegr, arbetsställe',
        SBGLabel: 'Kontobegr, arbetsställe',
        POLabel: 'Kontobegr, arbetsställe',
        POGLabel: 'Kontobegr, arbetsställe',
        PBLabel: 'Kontobegr, arbetsställe',
        PBGLabel: 'Kontobegr, arbetsställe',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontobegr, arbetsställe primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontobegr, arbetsställe versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontobegr, arbetsställe fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URVAL_ID: {
          AttributeName: 'URVAL_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontoplan: {
          AssociationName: 'Kontoplan',
          DisplayLabel: 'Kontoplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arbetsstalle: {
          AssociationName: 'Arbetsstalle',
          DisplayLabel: 'Arbetsställe',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSArbetsstalle',
          AssociatedComponentName: 'Arbetsstalle',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Kodbegränsning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    EKKontobegreppdef: {
      CollectionName: 'EKKontobegreppdef',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kontobegreppdef',
        Abstract: false,
        SOLabel: 'Kontobegreppsdefinition',
        SOGLabel: 'Kontobegreppsdefinition',
        SBLabel: 'Kontobegreppsdefinitionen',
        SBGLabel: 'Kontobegreppsdefinitionen',
        POLabel: 'Kontobegreppsdefinitioner',
        POGLabel: 'Kontobegreppsdefinitioner',
        PBLabel: 'Kontobegreppsdefinitionerna',
        PBGLabel: 'Kontobegreppsdefinitionerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontobegreppsdefinitionen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontobegreppsdefinitionen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontobegreppsdefinitionen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontobegreppsdefinitionen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILL_POSITION: {
          AttributeName: 'TILL_POSITION',
          DisplayLabel: 'Position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        FRAN_POSITION: {
          AttributeName: 'FRAN_POSITION',
          DisplayLabel: 'Fr o m position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodeldef: {
          AssociationName: 'Kontodeldef',
          DisplayLabel: 'Koddelsdefinition',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontodeldef',
          AssociatedComponentName: 'Kontodeldef',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontoplan: {
          AssociationName: 'Kontoplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegrepp: {
          AssociationName: 'Kontobegrepp',
          DisplayLabel: 'Kodbegrepp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKontobegrepp',
          AssociatedComponentName: 'Kontobegrepp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKKontodelRecept: {
      CollectionName: 'EKKontodelRecept',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KontodelRecept',
        Abstract: false,
        SOLabel: 'Kontodelrecept',
        SOGLabel: 'Kontodelrecepts',
        SBLabel: 'Kontodelreceptet',
        SBGLabel: 'Kontodelreceptets',
        POLabel: 'Kontodelrecept',
        POGLabel: 'Kontodelrecepts',
        PBLabel: 'Kontodelrecepten',
        PBGLabel: 'Kontodelreceptens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontodelreceptets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontodelreceptets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontodelreceptets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Kontodel, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Datum, fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'Datum, t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Receptvarde: {
          AssociationName: 'Receptvarde',
          DisplayLabel: 'Receptvärde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodelReceptvarde',
          AssociatedComponentName: 'KontodelReceptvarde',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKEDKontoExport: {
      CollectionName: 'EKEDKontoExport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KontoExport',
        Abstract: false,
        SOLabel: 'Kontoexport',
        SOGLabel: 'Kontoexport',
        SBLabel: 'Kontoexport',
        SBGLabel: 'Kontoexport',
        POLabel: 'Kontoexport',
        POGLabel: 'Kontoexport',
        PBLabel: 'Kontoexport',
        PBGLabel: 'Kontoexport',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontoexport primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontoexport versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontoexport id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontoexport fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'KPLAN_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'ORDNINGSNR',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'KONTO_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'TID',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REPLY: {
          AttributeName: 'REPLY',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKontoExport: {
      CollectionName: 'EKKontoExport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kontoexport',
        Abstract: false,
        SOLabel: 'Kontoexport',
        SOGLabel: 'Kontoexport',
        SBLabel: 'Kontoexport',
        SBGLabel: 'Kontoexport',
        POLabel: 'Kontoexport',
        POGLabel: 'Kontoexport',
        PBLabel: 'Kontoexport',
        PBGLabel: 'Kontoexport',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontoexport primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontoexport versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontoexport id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontoexport fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'KPLAN_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'KONTO_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'TID',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Exporterad/Felaktig',
          DataType: 'Enum',
          EnumValues: new Map([['EXPORTERAD', 'Exporterad'], ['FELAKTIG', 'Felaktig']]),
          EnumSortValues: new Map([['EXPORTERAD', 'E'], ['FELAKTIG', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXPORTERAD=Exporterad;FELAKTIG=Felaktig"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REPLY: {
          AttributeName: 'REPLY',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'ORDNINGS_NR',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOEXPORTVAG_ID: {
          AttributeName: 'KONTOEXPORTVAG_ID',
          DisplayLabel: 'KONTOEXPORTVAG_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AKTUELL_STATUS: {
          AttributeName: 'AKTUELL_STATUS',
          DisplayLabel: 'Aktuell status',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CREATED_ID: {
          AttributeName: 'CREATED_ID',
          DisplayLabel: 'Id för skapad post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Koddel: {
          AssociationName: 'Koddel',
          DisplayLabel: 'Koddel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKKontoExportVag: {
      CollectionName: 'EKKontoExportVag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KontoExportVag',
        Abstract: false,
        SOLabel: 'Kontoexportväg',
        SOGLabel: 'Kontoexportvägs',
        SBLabel: 'Kontoexportvägen',
        SBGLabel: 'Kontoexportvägens',
        POLabel: 'Kontoexportvägar',
        POGLabel: 'Kontoexportvägarnas',
        PBLabel: 'Kontoexportvägarna',
        PBGLabel: 'Kontoexportvägarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontoexportvägens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontoexportvägens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontoexportvägens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontoexportvägens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        URL: {
          AttributeName: 'URL',
          DisplayLabel: 'URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        USERNAME: {
          AttributeName: 'USERNAME',
          DisplayLabel: 'Användarnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PASSWORD: {
          AttributeName: 'PASSWORD',
          DisplayLabel: 'Lösenord',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        COMPANY_NO: {
          AttributeName: 'COMPANY_NO',
          DisplayLabel: 'CompanyNo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FelaktigaExporter: {
          AttributeName: 'FelaktigaExporter',
          DisplayLabel: 'Felaktiga exporter',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
        },
        KODDELSMAPPNING: {
          AttributeName: 'KODDELSMAPPNING',
          DisplayLabel: 'Koddelsmappning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Export från datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKonto: {
      CollectionName: 'EKKonto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Konto',
        Abstract: false,
        SOLabel: 'Konto i huvudbok',
        SOGLabel: 'Konto i huvudbok',
        SBLabel: 'Kontot i huvudboken',
        SBGLabel: 'Kontot i huvudboken',
        POLabel: 'Konton i huvudboken',
        POGLabel: 'Konton i huvudboken',
        PBLabel: 'Kontona i huvudboken',
        PBGLabel: 'Kontona i huvudboken',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontot i huvudboken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontot i huvudboken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontot i huvudboken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontot i huvudboken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTODEL_1: {
          AttributeName: 'KONTODEL_1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '1']]),
        },
        KONTODEL_2: {
          AttributeName: 'KONTODEL_2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '2']]),
        },
        KONTODEL_3: {
          AttributeName: 'KONTODEL_3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '3']]),
        },
        KONTODEL_4: {
          AttributeName: 'KONTODEL_4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '4']]),
        },
        KONTODEL_5: {
          AttributeName: 'KONTODEL_5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '5']]),
        },
        KONTODEL_6: {
          AttributeName: 'KONTODEL_6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '6']]),
        },
        KONTODEL_7: {
          AttributeName: 'KONTODEL_7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '7']]),
        },
        KONTODEL_8: {
          AttributeName: 'KONTODEL_8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '8']]),
        },
        KONTODEL_9: {
          AttributeName: 'KONTODEL_9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '9']]),
        },
        KONTODEL_10: {
          AttributeName: 'KONTODEL_10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '10']]),
        },
        REDOVISN_TYP: {
          AttributeName: 'REDOVISN_TYP',
          DisplayLabel: 'Redovisningsklass',
          Hint: 'Ställningskonto/Resultatkonto/Internkonto/Odefinierat',
          DataType: 'Enum',
          EnumValues: new Map([['STALLNINGSKONTO', 'Ställningskonto'], ['RESULTATKONTO', 'Resultatkonto'], ['INTERNKONTO', 'Internkonto'], ['ODEFINIERAT', 'Odefinierat']]),
          EnumSortValues: new Map([['STALLNINGSKONTO', 'S'], ['RESULTATKONTO', 'R'], ['INTERNKONTO', 'I'], ['ODEFINIERAT', 'O']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STALLNINGSKONTO=Ställningskonto;RESULTATKONTO=Resultatkonto;INTERNKONTO=Internkonto;ODEFINIERAT=Odefinierat"',
          InterfaceType: 'ifChecklist',
        },
        KI_TYP: {
          AttributeName: 'KI_TYP',
          DisplayLabel: 'Redovisningsgrupp',
          Hint: 'Intäkter/Kostnader/Personalkostnader/Avskrivningar/Odefinierad/Tillgångar/Skulder/Interna Intäkter/Interna Kostnader/Interna Tillgångar/Interna Skulder',
          DataType: 'Enum',
          EnumValues: new Map([['INTAKTER', 'Intäkter'], ['KOSTNADER', 'Kostnader'], ['PERSONALKOSTNADER', 'Personalkostnader'], ['AVSKRIVNINGAR', 'Avskrivningar'], ['ODEFINIERAD', 'Odefinierad'], ['TILLGANGAR', 'Tillgångar'], ['SKULDER', 'Skulder'], ['INTERNA_INTAKTER', 'Interna Intäkter'], ['INTERNA_KOSTNADER', 'Interna Kostnader'], ['INTERNA_TILLGANGAR', 'Interna Tillgångar'], ['INTERNA_SKULDER', 'Interna Skulder']]),
          EnumSortValues: new Map([['INTAKTER', 'I'], ['KOSTNADER', 'K'], ['PERSONALKOSTNADER', 'P'], ['AVSKRIVNINGAR', 'R'], ['ODEFINIERAD', 'O'], ['TILLGANGAR', 'T'], ['SKULDER', 'U'], ['INTERNA_INTAKTER', 'V'], ['INTERNA_KOSTNADER', 'X'], ['INTERNA_TILLGANGAR', 'Y'], ['INTERNA_SKULDER', 'Z']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTAKTER=Intäkter;KOSTNADER=Kostnader;PERSONALKOSTNADER=Personalkostnader;AVSKRIVNINGAR=Avskrivningar;ODEFINIERAD=Odefinierad;TILLGANGAR=Tillgångar;SKULDER=Skulder;INTERNA_INTAKTER=Interna Intäkter;INTERNA_KOSTNADER=Interna Kostnader;INTERNA_TILLGANGAR=Interna Tillgångar;INTERNA_SKULDER=Interna Skulder"',
          InterfaceType: 'ifChecklist',
        },
        INTERN_KONTO: {
          AttributeName: 'INTERN_KONTO',
          DisplayLabel: 'Internkonto',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_KOD: {
          AttributeName: 'MOMS_KOD',
          DisplayLabel: 'Momskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        AVSLUTAT_MOT_PROJEKT: {
          AttributeName: 'AVSLUTAT_MOT_PROJEKT',
          DisplayLabel: 'Avslutat mot projekt',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
          Required: true,
        },
        Konteringskod: {
          AttributeName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.interval,
        },
        KB_VERKSOMR: {
          AttributeName: 'KB_VERKSOMR',
          DisplayLabel: 'Verksamhetsområde',
          Hint: '1 Grundläggande uppgift/3 Övrig kyrklig verksamhet/5 Styrning och ledning/6 Stödjande verksamhet/8 Begravningsverksamhet/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['K1_GRUNDLAGGANDE_UPPGIFT', '1 Grundläggande uppgift'], ['K3_OVRIG_KYRKLIG_VERKSAMHET', '3 Övrig kyrklig verksamhet'], ['K5_STYRNING_OCH_LEDNING', '5 Styrning och ledning'], ['K6_STODJANDE_VERKSAMHET', '6 Stödjande verksamhet'], ['K8_BEGRAVNINGSVERKSAMHET', '8 Begravningsverksamhet'], ['KODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['K1_GRUNDLAGGANDE_UPPGIFT', '1'], ['K3_OVRIG_KYRKLIG_VERKSAMHET', '3'], ['K5_STYRNING_OCH_LEDNING', '5'], ['K6_STODJANDE_VERKSAMHET', '6'], ['K8_BEGRAVNINGSVERKSAMHET', '8'], ['KODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K1_GRUNDLAGGANDE_UPPGIFT=1 Grundläggande uppgift;K3_OVRIG_KYRKLIG_VERKSAMHET=3 Övrig kyrklig verksamhet;K5_STYRNING_OCH_LEDNING=5 Styrning och ledning;K6_STODJANDE_VERKSAMHET=6 Stödjande verksamhet;K8_BEGRAVNINGSVERKSAMHET=8 Begravningsverksamhet;KODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KB_VERKSAMHET: {
          AttributeName: 'KB_VERKSAMHET',
          DisplayLabel: 'Verksamhetsnivå',
          Hint: '101 Verksamhetsgemensamt/110 Gudstjänster och kyrkliga handlingar/140 Undervisning/210 Diakonal verksamhet/260 Mission/310 Övrig församlingsverksamhet/360 Serviceverksamhet/380 Inomkyrklig försäljning/410 Skattepliktig rörelse/510 Strategisk styrning/580 Verksamhetsledning/610 Församlingsadministration och verksamhetsstöd/630 Gemensamma kostnader och administration/650 Fastigheter och lokaler/690 Finansiella poster/801 Verksamhetsgemensamt/810 Administration och ledning/820 Gravsättning och kyrkogårdsskötsel/840 Krematorium/860 Fastigheter och mark/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['K101_VERKSAMHETSGEMENSAMT', '101 Verksamhetsgemensamt'], ['K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR', '110 Gudstjänster och kyrkliga handlingar'], ['K140_UNDERVISNING', '140 Undervisning'], ['K210_DIAKONAL_VERKSAMHET', '210 Diakonal verksamhet'], ['K260_MISSION', '260 Mission'], ['K310_OVRIG_FORSAMLINGSVERKSAMHET', '310 Övrig församlingsverksamhet'], ['K360_SERVICEVERKSAMHET', '360 Serviceverksamhet'], ['K380_INOMKYRKLIG_FORSALJNING', '380 Inomkyrklig försäljning'], ['K410_SKATTEPLIKTIG_RORELSE', '410 Skattepliktig rörelse'], ['K510_STRATEGISK_STYRNING', '510 Strategisk styrning'], ['K580_VERKSAMHETSLEDNING', '580 Verksamhetsledning'], ['K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD', '610 Församlingsadministration och verksamhetsstöd'], ['K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION', '630 Gemensamma kostnader och administration'], ['K650_FASTIGHETER_OCH_LOKALER', '650 Fastigheter och lokaler'], ['K690_FINANSIELLA_POSTER', '690 Finansiella poster'], ['K801_VERKSAMHETSGEMENSAMT', '801 Verksamhetsgemensamt'], ['K810_ADMINISTRATION_OCH_LEDNING', '810 Administration och ledning'], ['K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL', '820 Gravsättning och kyrkogårdsskötsel'], ['K840_KREMATORIUM', '840 Krematorium'], ['K860_FASTIGHETER_OCH_MARK', '860 Fastigheter och mark'], ['KODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['K101_VERKSAMHETSGEMENSAMT', '101'], ['K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR', '110'], ['K140_UNDERVISNING', '140'], ['K210_DIAKONAL_VERKSAMHET', '210'], ['K260_MISSION', '260'], ['K310_OVRIG_FORSAMLINGSVERKSAMHET', '310'], ['K360_SERVICEVERKSAMHET', '360'], ['K380_INOMKYRKLIG_FORSALJNING', '380'], ['K410_SKATTEPLIKTIG_RORELSE', '410'], ['K510_STRATEGISK_STYRNING', '510'], ['K580_VERKSAMHETSLEDNING', '580'], ['K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD', '610'], ['K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION', '630'], ['K650_FASTIGHETER_OCH_LOKALER', '650'], ['K690_FINANSIELLA_POSTER', '690'], ['K801_VERKSAMHETSGEMENSAMT', '801'], ['K810_ADMINISTRATION_OCH_LEDNING', '810'], ['K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL', '820'], ['K840_KREMATORIUM', '840'], ['K860_FASTIGHETER_OCH_MARK', '860'], ['KODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K101_VERKSAMHETSGEMENSAMT=101 Verksamhetsgemensamt;K110_GUDSTJANSTER_OCH_KYRKLIGA_HANDLINGAR=110 Gudstjänster och kyrkliga handlingar;K140_UNDERVISNING=140 Undervisning;K210_DIAKONAL_VERKSAMHET=210 Diakonal verksamhet;K260_MISSION=260 Mission;K310_OVRIG_FORSAMLINGSVERKSAMHET=310 Övrig församlingsverksamhet;K360_SERVICEVERKSAMHET=360 Serviceverksamhet;K380_INOMKYRKLIG_FORSALJNING=380 Inomkyrklig försäljning;K410_SKATTEPLIKTIG_RORELSE=410 Skattepliktig rörelse;K510_STRATEGISK_STYRNING=510 Strategisk styrning;K580_VERKSAMHETSLEDNING=580 Verksamhetsledning;K610_FORSAMLINGSADMINISTRATION_OCH_VERKSAMHETSSTOD=610 Församlingsadministration och verksamhetsstöd;K630_GEMENSAMMA_KOSTNADER_OCH_ADMINISTRATION=630 Gemensamma kostnader och administration;K650_FASTIGHETER_OCH_LOKALER=650 Fastigheter och lokaler;K690_FINANSIELLA_POSTER=690 Finansiella poster;K801_VERKSAMHETSGEMENSAMT=801 Verksamhetsgemensamt;K810_ADMINISTRATION_OCH_LEDNING=810 Administration och ledning;K820_GRAVSATTNING_OCH_KYRKOGARDSSKOTSEL=820 Gravsättning och kyrkogårdsskötsel;K840_KREMATORIUM=840 Krematorium;K860_FASTIGHETER_OCH_MARK=860 Fastigheter och mark;KODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Anställningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LONEART: {
          AttributeName: 'LONEART',
          DisplayLabel: 'Löneart',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEFATTNINGSKOD: {
          AttributeName: 'BEFATTNINGSKOD',
          DisplayLabel: 'Befattning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOBEGREPP_1_1_1: {
          AttributeName: 'KONTOBEGREPP_1_1_1',
          DisplayLabel: '@KONTOBEGREPP_1_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_1_1_2: {
          AttributeName: 'KONTOBEGREPP_1_1_2',
          DisplayLabel: '@KONTOBEGREPP_1_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_2_1_1: {
          AttributeName: 'KONTOBEGREPP_2_1_1',
          DisplayLabel: '@KONTOBEGREPP_2_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_2_1_2: {
          AttributeName: 'KONTOBEGREPP_2_1_2',
          DisplayLabel: '@KONTOBEGREPP_2_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_3_1_1: {
          AttributeName: 'KONTOBEGREPP_3_1_1',
          DisplayLabel: '@KONTOBEGREPP_3_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_3_1_2: {
          AttributeName: 'KONTOBEGREPP_3_1_2',
          DisplayLabel: '@KONTOBEGREPP_3_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_4_1_1: {
          AttributeName: 'KONTOBEGREPP_4_1_1',
          DisplayLabel: '@KONTOBEGREPP_4_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_4_1_2: {
          AttributeName: 'KONTOBEGREPP_4_1_2',
          DisplayLabel: '@KONTOBEGREPP_4_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_5_1_1: {
          AttributeName: 'KONTOBEGREPP_5_1_1',
          DisplayLabel: '@KONTOBEGREPP_5_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_5_1_2: {
          AttributeName: 'KONTOBEGREPP_5_1_2',
          DisplayLabel: '@KONTOBEGREPP_5_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_6_1_1: {
          AttributeName: 'KONTOBEGREPP_6_1_1',
          DisplayLabel: '@KONTOBEGREPP_6_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_6_1_2: {
          AttributeName: 'KONTOBEGREPP_6_1_2',
          DisplayLabel: '@KONTOBEGREPP_6_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_7_1_1: {
          AttributeName: 'KONTOBEGREPP_7_1_1',
          DisplayLabel: '@KONTOBEGREPP_7_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_7_1_2: {
          AttributeName: 'KONTOBEGREPP_7_1_2',
          DisplayLabel: '@KONTOBEGREPP_7_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_8_1_1: {
          AttributeName: 'KONTOBEGREPP_8_1_1',
          DisplayLabel: '@KONTOBEGREPP_8_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_8_1_2: {
          AttributeName: 'KONTOBEGREPP_8_1_2',
          DisplayLabel: '@KONTOBEGREPP_8_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_9_1_1: {
          AttributeName: 'KONTOBEGREPP_9_1_1',
          DisplayLabel: '@KONTOBEGREPP_9_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_9_1_2: {
          AttributeName: 'KONTOBEGREPP_9_1_2',
          DisplayLabel: '@KONTOBEGREPP_9_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_10_1_1: {
          AttributeName: 'KONTOBEGREPP_10_1_1',
          DisplayLabel: '@KONTOBEGREPP_10_1_1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        KONTOBEGREPP_10_1_2: {
          AttributeName: 'KONTOBEGREPP_10_1_2',
          DisplayLabel: '@KONTOBEGREPP_10_1_2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval],
          DefaultCondOperator: T.interval,
          Properties: new Map([['KONTOBEGREPP', 'Y']]),
        },
        Loneartsgrupp: {
          AttributeName: 'Loneartsgrupp',
          DisplayLabel: 'Löneartsgrupp',
          Hint: 'Årslön/Semesterersättningar/Särskilda ersättningar/Arb.avg o avtalsenl soc avgifter/Lönebidrag',
          DataType: 'Enum',
          EnumValues: new Map([['ARSLON', 'Årslön'], ['SEMESTERERSATTNINGAR', 'Semesterersättningar'], ['SARSKILDA_ERSATTNINGAR', 'Särskilda ersättningar'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'Arb.avg o avtalsenl soc avgifter'], ['LONEBIDRAG', 'Lönebidrag']]),
          EnumSortValues: new Map([['ARSLON', 'ÅRSLÖN'], ['SEMESTERERSATTNINGAR', 'SEMERS'], ['SARSKILDA_ERSATTNINGAR', 'SÄRSKERS'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'SOCAVG'], ['LONEBIDRAG', 'LÖNEBIDRAG']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSLON=Årslön;SEMESTERERSATTNINGAR=Semesterersättningar;SARSKILDA_ERSATTNINGAR=Särskilda ersättningar;ARB_AVG_O_AVTALSENL_SOC_AVGIFTER=Arb.avg o avtalsenl soc avgifter;LONEBIDRAG=Lönebidrag"',
          InterfaceType: 'ifChecklist',
        },
        PersonalkostnaderExkluderade: {
          AttributeName: 'PersonalkostnaderExkluderade',
          DisplayLabel: 'Personalkostnader exkluderade',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        LONEARTKOD: {
          AttributeName: 'LONEARTKOD',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Fastighetsnummer: {
          AttributeName: 'Fastighetsnummer',
          DisplayLabel: 'Fastighetsnr',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Fastighetsuppföljning',
        },
        Fastighetstyp: {
          AttributeName: 'Fastighetstyp',
          DisplayLabel: 'Fastighetstyp',
          Hint: 'Administration/förvaltningsområde/Administrationsbyggnad/Andaktsrum/Begravningsområde/Begravningsplats/Bisättningsrum/Bostadshus/Bostadsområde/Bygdegård/Bystuga/Bårhus/Ceremonirum/ceremonihall/Cykelparkering/Flerbostadshus/Friggebod/Förrådsbyggnad/Församlingshem/Förskolebyggnad/Förskoleområde/Garage/Gravkor/Mausoleum/Hotell/Jordbruksmark/Jordkällare/Klockstapel/Kolumbarium/Krematorium/Kursgård/Kyrka/kapell/Kyrkogårdsförvaltningsområde/Kyrkogårdsmur/Kyrkoområde/Kyrkorum/kyrksal/kapellrum/Kyrkstuga/Kyrktomt/Källsorteringshus/Lekplats/Lekstuga/Lägergård/Museum/Omkopplingsstation/Ordenslokal/Parkeringsplats/Parkmark/Personalbyggnad/Prästgård/Radiomast/Restaurang/Samlingslokal/Skogs- och jordbruksområde/Skogsmark/Skolbyggnad/Skolgård/Skorstensanläggning/Skyddsbyggnad/Skärmtak/Stiftsgård/Studentbostadsområde/Teknikbod/Toalett/Trädgård/Vaktmästeri/Vandrarhem/Vatten/Verkstad/Växthus/Äldreboende/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['ADMINISTRATION_FORVALTNINGSOMRADE', 'Administration/förvaltningsområde'], ['ADMINISTRATIONSBYGGNAD', 'Administrationsbyggnad'], ['ANDAKTSRUM', 'Andaktsrum'], ['BEGRAVNINGSOMRADE', 'Begravningsområde'], ['BEGRAVNINGSPLATS', 'Begravningsplats'], ['BISATTNINGSRUM', 'Bisättningsrum'], ['BOSTADSHUS', 'Bostadshus'], ['BOSTADSOMRADE', 'Bostadsområde'], ['BYGDEGARD_BYSTUGA', 'Bygdegård/Bystuga'], ['BARHUS', 'Bårhus'], ['CEREMONIRUM_CEREMONIHALL', 'Ceremonirum/ceremonihall'], ['CYKELPARKERING', 'Cykelparkering'], ['FLERBOSTADSHUS', 'Flerbostadshus'], ['FRIGGEBOD', 'Friggebod'], ['FORRADSBYGGNAD', 'Förrådsbyggnad'], ['FORSAMLINGSHEM', 'Församlingshem'], ['FORSKOLEBYGGNAD', 'Förskolebyggnad'], ['FORSKOLEOMRADE', 'Förskoleområde'], ['GARAGE', 'Garage'], ['GRAVKOR_MAUSOLEUM', 'Gravkor/Mausoleum'], ['HOTELL', 'Hotell'], ['JORDBRUKSMARK', 'Jordbruksmark'], ['JORDKALLARE', 'Jordkällare'], ['KLOCKSTAPEL', 'Klockstapel'], ['KOLUMBARIUM', 'Kolumbarium'], ['KREMATORIUM', 'Krematorium'], ['KURSGARD', 'Kursgård'], ['KYRKA_KAPELL', 'Kyrka/kapell'], ['KYRKOGARDSFORVALTNINGSOMRADE', 'Kyrkogårdsförvaltningsområde'], ['KYRKOGARDSMUR', 'Kyrkogårdsmur'], ['KYRKOOMRADE', 'Kyrkoområde'], ['KYRKORUM_KYRKSAL_KAPELLRUM', 'Kyrkorum/kyrksal/kapellrum'], ['KYRKSTUGA', 'Kyrkstuga'], ['KYRKTOMT', 'Kyrktomt'], ['KALLSORTERINGSHUS', 'Källsorteringshus'], ['LEKPLATS', 'Lekplats'], ['LEKSTUGA', 'Lekstuga'], ['LAGERGARD', 'Lägergård'], ['MUSEUM', 'Museum'], ['OMKOPPLINGSSTATION', 'Omkopplingsstation'], ['ORDENSLOKAL', 'Ordenslokal'], ['PARKERINGSPLATS', 'Parkeringsplats'], ['PARKMARK', 'Parkmark'], ['PERSONALBYGGNAD', 'Personalbyggnad'], ['PRASTGARD', 'Prästgård'], ['RADIOMAST', 'Radiomast'], ['RESTAURANG', 'Restaurang'], ['SAMLINGSLOKAL', 'Samlingslokal'], ['SKOGS__OCH_JORDBRUKSOMRADE', 'Skogs- och jordbruksområde'], ['SKOGSMARK', 'Skogsmark'], ['SKOLBYGGNAD', 'Skolbyggnad'], ['SKOLGARD', 'Skolgård'], ['SKORSTENSANLAGGNING', 'Skorstensanläggning'], ['SKYDDSBYGGNAD', 'Skyddsbyggnad'], ['SKARMTAK', 'Skärmtak'], ['STIFTSGARD', 'Stiftsgård'], ['STUDENTBOSTADSOMRADE', 'Studentbostadsområde'], ['TEKNIKBOD', 'Teknikbod'], ['TOALETT', 'Toalett'], ['TRADGARD', 'Trädgård'], ['VAKTMASTERI', 'Vaktmästeri'], ['VANDRARHEM', 'Vandrarhem'], ['VATTEN', 'Vatten'], ['VERKSTAD', 'Verkstad'], ['VAXTHUS', 'Växthus'], ['ALDREBOENDE', 'Äldreboende'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['ADMINISTRATION_FORVALTNINGSOMRADE', 'BCA'], ['ADMINISTRATIONSBYGGNAD', 'AEA'], ['ANDAKTSRUM', 'BED01'], ['BEGRAVNINGSOMRADE', 'BJB'], ['BEGRAVNINGSPLATS', 'DCE'], ['BISATTNINGSRUM', 'BED04'], ['BOSTADSHUS', 'AAA02'], ['BOSTADSOMRADE', 'AA_'], ['BYGDEGARD_BYSTUGA', 'ANB03'], ['BARHUS', 'APE01'], ['CEREMONIRUM_CEREMONIHALL', 'BED03'], ['CYKELPARKERING', 'CCA'], ['FLERBOSTADSHUS', 'AAB'], ['FRIGGEBOD', 'AKA'], ['FORRADSBYGGNAD', 'APA'], ['FORSAMLINGSHEM', 'ANB01'], ['FORSKOLEBYGGNAD', 'AHA'], ['FORSKOLEOMRADE', 'BFA'], ['GARAGE', 'APB02'], ['GRAVKOR_MAUSOLEUM', 'APF02'], ['HOTELL', 'ABA'], ['JORDBRUKSMARK', 'DDE'], ['JORDKALLARE', 'APA02'], ['KLOCKSTAPEL', 'BBJ'], ['KOLUMBARIUM', 'APF03'], ['KREMATORIUM', 'BFD'], ['KURSGARD', 'AHD'], ['KYRKA_KAPELL', 'AND01'], ['KYRKOGARDSFORVALTNINGSOMRADE', 'BCD'], ['KYRKOGARDSMUR', 'RUA'], ['KYRKOOMRADE', 'BJA'], ['KYRKORUM_KYRKSAL_KAPELLRUM', 'BED02'], ['KYRKSTUGA', 'AAA03'], ['KYRKTOMT', 'BEE'], ['KALLSORTERINGSHUS', 'APC'], ['LEKPLATS', 'DEF'], ['LEKSTUGA', 'AKG'], ['LAGERGARD', 'ABB'], ['MUSEUM', 'AMC'], ['OMKOPPLINGSSTATION', 'BBE'], ['ORDENSLOKAL', 'AND04'], ['PARKERINGSPLATS', 'CCB'], ['PARKMARK', 'DBB'], ['PERSONALBYGGNAD', 'ANF'], ['PRASTGARD', 'AAA01'], ['RADIOMAST', 'BBA'], ['RESTAURANG', 'ABC'], ['SAMLINGSLOKAL', 'ANB02'], ['SKOGS__OCH_JORDBRUKSOMRADE', 'BDH'], ['SKOGSMARK', 'DDD'], ['SKOLBYGGNAD', 'AHB'], ['SKOLGARD', 'DCD'], ['SKORSTENSANLAGGNING', 'BCA'], ['SKYDDSBYGGNAD', 'ADA'], ['SKARMTAK', 'AKF'], ['STIFTSGARD', 'BFF'], ['STUDENTBOSTADSOMRADE', 'AAB'], ['TEKNIKBOD', 'BBF'], ['TOALETT', 'ACA'], ['TRADGARD', 'DBA'], ['VAKTMASTERI', 'AFB01'], ['VANDRARHEM', 'ABB'], ['VATTEN', 'GCD'], ['VERKSTAD', 'AFB02'], ['VAXTHUS', 'AKE'], ['ALDREBOENDE', 'AAC'], ['OVRIGT', 'ZZZ']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ADMINISTRATION_FORVALTNINGSOMRADE=Administration/förvaltningsområde;ADMINISTRATIONSBYGGNAD=Administrationsbyggnad;ANDAKTSRUM=Andaktsrum;BEGRAVNINGSOMRADE=Begravningsområde;BEGRAVNINGSPLATS=Begravningsplats;BISATTNINGSRUM=Bisättningsrum;BOSTADSHUS=Bostadshus;BOSTADSOMRADE=Bostadsområde;BYGDEGARD_BYSTUGA=Bygdegård/Bystuga;BARHUS=Bårhus;CEREMONIRUM_CEREMONIHALL=Ceremonirum/ceremonihall;CYKELPARKERING=Cykelparkering;FLERBOSTADSHUS=Flerbostadshus;FRIGGEBOD=Friggebod;FORRADSBYGGNAD=Förrådsbyggnad;FORSAMLINGSHEM=Församlingshem;FORSKOLEBYGGNAD=Förskolebyggnad;FORSKOLEOMRADE=Förskoleområde;GARAGE=Garage;GRAVKOR_MAUSOLEUM=Gravkor/Mausoleum;HOTELL=Hotell;JORDBRUKSMARK=Jordbruksmark;JORDKALLARE=Jordkällare;KLOCKSTAPEL=Klockstapel;KOLUMBARIUM=Kolumbarium;KREMATORIUM=Krematorium;KURSGARD=Kursgård;KYRKA_KAPELL=Kyrka/kapell;KYRKOGARDSFORVALTNINGSOMRADE=Kyrkogårdsförvaltningsområde;KYRKOGARDSMUR=Kyrkogårdsmur;KYRKOOMRADE=Kyrkoområde;KYRKORUM_KYRKSAL_KAPELLRUM=Kyrkorum/kyrksal/kapellrum;KYRKSTUGA=Kyrkstuga;KYRKTOMT=Kyrktomt;KALLSORTERINGSHUS=Källsorteringshus;LEKPLATS=Lekplats;LEKSTUGA=Lekstuga;LAGERGARD=Lägergård;MUSEUM=Museum;OMKOPPLINGSSTATION=Omkopplingsstation;ORDENSLOKAL=Ordenslokal;PARKERINGSPLATS=Parkeringsplats;PARKMARK=Parkmark;PERSONALBYGGNAD=Personalbyggnad;PRASTGARD=Prästgård;RADIOMAST=Radiomast;RESTAURANG=Restaurang;SAMLINGSLOKAL=Samlingslokal;SKOGS__OCH_JORDBRUKSOMRADE=Skogs- och jordbruksområde;SKOGSMARK=Skogsmark;SKOLBYGGNAD=Skolbyggnad;SKOLGARD=Skolgård;SKORSTENSANLAGGNING=Skorstensanläggning;SKYDDSBYGGNAD=Skyddsbyggnad;SKARMTAK=Skärmtak;STIFTSGARD=Stiftsgård;STUDENTBOSTADSOMRADE=Studentbostadsområde;TEKNIKBOD=Teknikbod;TOALETT=Toalett;TRADGARD=Trädgård;VAKTMASTERI=Vaktmästeri;VANDRARHEM=Vandrarhem;VATTEN=Vatten;VERKSTAD=Verkstad;VAXTHUS=Växthus;ALDREBOENDE=Äldreboende;OVRIGT=Övrigt"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Fastighetsuppföljning',
        },
        Huvudprojekt: {
          AttributeName: 'Huvudprojekt',
          DisplayLabel: 'Huvudprojekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Leverantorsnr: {
          AttributeName: 'Leverantorsnr',
          DisplayLabel: 'Leverantörsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        Leverantorsnamn: {
          AttributeName: 'Leverantorsnamn',
          DisplayLabel: 'Leverantörsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Loneart: {
          AssociationName: 'Loneart',
          DisplayLabel: 'Löneart',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKLoneart',
          AssociatedComponentName: 'Loneart',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKLagradRapport: {
      CollectionName: 'EKLagradRapport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LagradRapport',
        Abstract: false,
        SOLabel: 'Lagrad rapport',
        SOGLabel: 'Lagrad rapport',
        SBLabel: 'Lagrade rapporten',
        SBGLabel: 'Lagrade rapporten',
        POLabel: 'Lagrade rapporter',
        POGLabel: 'Lagrade rapporter',
        PBLabel: 'Lagrade rapporterna',
        PBGLabel: 'Lagrade rapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lagrade rapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lagrade rapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lagrade rapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORTPAKET_ID: {
          AttributeName: 'RAPPORTPAKET_ID',
          DisplayLabel: 'Rapportpaket, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RAPPORT_NAMN: {
          AttributeName: 'RAPPORT_NAMN',
          DisplayLabel: 'Rapportnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Bokföringsperiod',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKFDATUM_FROM: {
          AttributeName: 'BOKFDATUM_FROM',
          DisplayLabel: 'Bokföringsdatum, from',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKFDATUM_TOM: {
          AttributeName: 'BOKFDATUM_TOM',
          DisplayLabel: 'Bokföringsdatum, tom',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKLagradRapportBlob',
          AssociatedComponentName: 'LagradRapportBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Behorighet: {
          AssociationName: 'Behorighet',
          DisplayLabel: 'Behöriga användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKTEDEKLagradRapportAnv',
          AssociatedComponentName: 'LagradRapportAnv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKLagradRapportBlob: {
      CollectionName: 'EKLagradRapportBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LagradRapportBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKLagradRapportBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKLagradRapportBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKLagradRapportBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORT: {
          AttributeName: 'RAPPORT',
          DisplayLabel: 'Rapport i pdf-format',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAPPORTSIZE: {
          AttributeName: 'RAPPORTSIZE',
          DisplayLabel: 'Rapport, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKTEDEKRapportpaketLogg: {
      CollectionName: 'EKTEDEKRapportpaketLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportpaketLogg',
        Abstract: false,
        SOLabel: 'Logg för rapportpaket',
        SOGLabel: 'Logg för rapportpaket',
        SBLabel: 'Logg för rapportpaketet',
        SBGLabel: 'Logg för rapportpaketet',
        POLabel: 'Logg för rapportpaket',
        POGLabel: 'Logg för rapportpaket',
        PBLabel: 'Logg för rapportpaken',
        PBGLabel: 'Logg för rapportpaken',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Logg för rapportpaketet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Logg för rapportpaketet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Logg för rapportpaketet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Bokföringsperiod',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BOKFDATUM_FROM: {
          AttributeName: 'BOKFDATUM_FROM',
          DisplayLabel: 'Bokföringsdatum, from',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BOKFDATUM_TOM: {
          AttributeName: 'BOKFDATUM_TOM',
          DisplayLabel: 'Bokföringsdatum, tom',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Anvandare: {
          AttributeName: 'Anvandare',
          DisplayLabel: 'Distribuerad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Distribuerad av',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Rapportpaket: {
          AssociationName: 'Rapportpaket',
          DisplayLabel: 'Rapportpaket',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportpaket',
          AssociatedComponentName: 'Rapportpaket',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKLokalKontoanvandning: {
      CollectionName: 'EKLokalKontoanvandning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LokalKontoanvandning',
        Abstract: false,
        SOLabel: 'Lokal kontoanvändning',
        SOGLabel: 'Lokal kontoanvändnings',
        SBLabel: 'Lokala kontoanvändningen',
        SBGLabel: 'Lokala kontoanvändningens',
        POLabel: 'Lokala kontoanvändningar',
        POGLabel: 'Lokala kontoanvändningars',
        PBLabel: 'Lokala kontoanvändningarna',
        PBGLabel: 'Lokala kontoanvändningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lokala kontoanvändningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lokala kontoanvändningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lokala kontoanvändningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_TYP: {
          AttributeName: 'MALL_TYP',
          DisplayLabel: 'Lokal användning',
          Hint: 'Kassa kontant/Bank kontant/Skåp kontant/Kort/Swish/KOB-konto',
          DataType: 'Enum',
          EnumValues: new Map([['KASSA_KONTANT', 'Kassa kontant'], ['BANK_KONTANT', 'Bank kontant'], ['SKAP_KONTANT', 'Skåp kontant'], ['KORT', 'Kort'], ['SWISH', 'Swish'], ['KOB_KONTO', 'KOB-konto']]),
          EnumSortValues: new Map([['KASSA_KONTANT', 'K_KONT'], ['BANK_KONTANT', 'K_BANK'], ['SKAP_KONTANT', 'K_SKAP'], ['KORT', 'K_KORT'], ['SWISH', 'K_SWISH'], ['KOB_KONTO', 'K_KOB']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KASSA_KONTANT=Kassa kontant;BANK_KONTANT=Bank kontant;SKAP_KONTANT=Skåp kontant;KORT=Kort;SWISH=Swish;KOB_KONTO=KOB-konto"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Kontodel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKLoneart: {
      CollectionName: 'EKLoneart',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Loneart',
        Abstract: false,
        SOLabel: 'Löneart',
        SOGLabel: 'Lönearts',
        SBLabel: 'Lönearten',
        SBGLabel: 'Löneartens',
        POLabel: 'Lönearter',
        POGLabel: 'Lönearters',
        PBLabel: 'Lönearterna',
        PBGLabel: 'Lönearternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Löneartens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Löneartens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Löneartens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Löneartens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Numerisk löneart',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        LONEARTSGRUPP: {
          AttributeName: 'LONEARTSGRUPP',
          DisplayLabel: 'Löneartsgrupp',
          Hint: 'Årslön/Semesterersättningar/Särskilda ersättningar/Arb.avg o avtalsenl soc avgifter/Lönebidrag',
          DataType: 'Enum',
          EnumValues: new Map([['ARSLON', 'Årslön'], ['SEMESTERERSATTNINGAR', 'Semesterersättningar'], ['SARSKILDA_ERSATTNINGAR', 'Särskilda ersättningar'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'Arb.avg o avtalsenl soc avgifter'], ['LONEBIDRAG', 'Lönebidrag']]),
          EnumSortValues: new Map([['ARSLON', 'ÅRSLÖN'], ['SEMESTERERSATTNINGAR', 'SEMERS'], ['SARSKILDA_ERSATTNINGAR', 'SÄRSKERS'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'SOCAVG'], ['LONEBIDRAG', 'LÖNEBIDRAG']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSLON=Årslön;SEMESTERERSATTNINGAR=Semesterersättningar;SARSKILDA_ERSATTNINGAR=Särskilda ersättningar;ARB_AVG_O_AVTALSENL_SOC_AVGIFTER=Arb.avg o avtalsenl soc avgifter;LONEBIDRAG=Lönebidrag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INTEGRATIONSTYP: {
          AttributeName: 'INTEGRATIONSTYP',
          DisplayLabel: 'Integrationstyp',
          Hint: 'Flex/Hogia/HRM Systems/Visma HR Plus',
          DataType: 'Enum',
          EnumValues: new Map([['FLEX', 'Flex'], ['HOGIA', 'Hogia'], ['HRM_SYSTEMS', 'HRM Systems'], ['VISMA_HR_PLUS', 'Visma HR Plus']]),
          EnumSortValues: new Map([['FLEX', 'F'], ['HOGIA', 'O'], ['HRM_SYSTEMS', 'R'], ['VISMA_HR_PLUS', 'V']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FLEX=Flex;HOGIA=Hogia;HRM_SYSTEMS=HRM Systems;VISMA_HR_PLUS=Visma HR Plus"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        KOD_ALFA: {
          AttributeName: 'KOD_ALFA',
          DisplayLabel: 'Alfanumerisk löneart',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Loneartskod: {
          AttributeName: 'Loneartskod',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKLonetillaggLonekonto: {
      CollectionName: 'EKLonetillaggLonekonto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LonetillaggLonekonto',
        Abstract: false,
        SOLabel: 'Lönekonto för särsk ersättningar',
        SOGLabel: 'Lönekonto för särsk ersättningar',
        SBLabel: 'Lönekonto för särsk ersättningar',
        SBGLabel: 'Lönekonto för särsk ersättningar',
        POLabel: 'Lönekonto för särsk ersättningar',
        POGLabel: 'Lönekonto för särsk ersättningar',
        PBLabel: 'Lönekonto för särsk ersättningar',
        PBGLabel: 'Lönekonto för särsk ersättningar',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lönekonto för särsk ersättningar primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lönekonto för särsk ersättningar versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lönekonto för särsk ersättningar fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Konto, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Koddel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKRapportRapportmall: {
      CollectionName: 'EKRapportRapportmall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportRapportmall',
        Abstract: false,
        SOLabel: 'Mallar för en rapport',
        SOGLabel: 'Mallar för en rapport',
        SBLabel: 'Mallarna för en rapport',
        SBGLabel: 'Mallarna för en rapport',
        POLabel: 'Mallar för en rapport',
        POGLabel: 'Mallar för en rapport',
        PBLabel: 'Mallar för en rapport',
        PBGLabel: 'Mallar för en rapport',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mallarna för en rapport primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mallarna för en rapport versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mallarna för en rapport fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'Mall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKMappaAnstnr: {
      CollectionName: 'EKMappaAnstnr',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'MappaAnstnr',
        Abstract: false,
        SOLabel: 'Mappa anstnr',
        SOGLabel: 'Mappa anstnr',
        SBLabel: 'Mappa anstnr',
        SBGLabel: 'Mappa anstnr',
        POLabel: 'Mappa anstnr',
        POGLabel: 'Mappa anstnr',
        PBLabel: 'Mappa anstnr',
        PBGLabel: 'Mappa anstnr',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mappa anstnr primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mappa anstnr versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mappa anstnr fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN_ANSTNR: {
          AttributeName: 'FRAN_ANSTNR',
          DisplayLabel: 'Från anställningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILL_ANSTNR: {
          AttributeName: 'TILL_ANSTNR',
          DisplayLabel: 'Till anställningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKMomskod: {
      CollectionName: 'EKMomskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2016']]),
      RootType: {
        TypeValue: 'Momskod',
        Abstract: false,
        SOLabel: 'Momskod',
        SOGLabel: 'Momskod',
        SBLabel: 'Momskoden',
        SBGLabel: 'Momskoden',
        POLabel: 'Momskoder',
        POGLabel: 'Momskoder',
        PBLabel: 'Momskoderna',
        PBGLabel: 'Momskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Momskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Momskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Momskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Momskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_KOD: {
          AttributeName: 'MOMS_KOD',
          DisplayLabel: 'Momskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'KodBenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UNDERLAG_BETALNING_SKV: {
          AttributeName: 'UNDERLAG_BETALNING_SKV',
          DisplayLabel: 'Underlag för beräkning till momskod 49',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKMomsunderlag: {
      CollectionName: 'EKMomsunderlag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Momsunderlag',
        Abstract: false,
        SOLabel: 'Momsunderlag',
        SOGLabel: 'Momsunderlags',
        SBLabel: 'Momsunderlaget',
        SBGLabel: 'Momsunderlagets',
        POLabel: 'Momsunderlag',
        POGLabel: 'Momsunderlags',
        PBLabel: 'Momsunderlagen',
        PBGLabel: 'Momsunderlagens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Momsunderlagets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Momsunderlagets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Momsunderlagets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERIOD_START: {
          AttributeName: 'PERIOD_START',
          DisplayLabel: 'Period, start',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIOD_SLUT: {
          AttributeName: 'PERIOD_SLUT',
          DisplayLabel: 'Period, slut',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad/Kvitterad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad'], ['KVITTERAD', 'Kvitterad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B'], ['KVITTERAD', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad;KVITTERAD=Kvitterad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        FIL_ID: {
          AttributeName: 'FIL_ID',
          DisplayLabel: 'Skapad fil id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Period: {
          AttributeName: 'Period',
          DisplayLabel: 'Period',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TEXTUPPLYSNING: {
          AttributeName: 'TEXTUPPLYSNING',
          DisplayLabel: 'Textupplysning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rader: {
          AssociationName: 'Rader',
          DisplayLabel: 'Rader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKMomsunderlagrad',
          AssociatedComponentName: 'Momsunderlagrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKMomsunderlagDokument',
          AssociatedComponentName: 'MomsunderlagDokument',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKMomsunderlagrad: {
      CollectionName: 'EKMomsunderlagrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Momsunderlagrad',
        Abstract: false,
        SOLabel: 'Momsunderlagrad',
        SOGLabel: 'Momsunderlagrads',
        SBLabel: 'Momsunderlagraden',
        SBGLabel: 'Momsunderlagradens',
        POLabel: 'Momsunderlagrader',
        POGLabel: 'Momsunderlagraders',
        PBLabel: 'Momsunderlagraderna',
        PBGLabel: 'Momsunderlagradernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Momsunderlagradens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Momsunderlagradens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Momsunderlagradens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMSUNDERLAG_ID: {
          AttributeName: 'MOMSUNDERLAG_ID',
          DisplayLabel: 'Id, momsunderlag',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MOMSKOD: {
          AttributeName: 'MOMSKOD',
          DisplayLabel: 'Momskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 150,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INGAR_I_MOMSRAD: {
          AttributeName: 'INGAR_I_MOMSRAD',
          DisplayLabel: 'Ingår i',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TillSKV: {
          AttributeName: 'TillSKV',
          DisplayLabel: 'Till Skatteverket',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        Nollrad: {
          AttributeName: 'Nollrad',
          DisplayLabel: 'Nollrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Momsunderlag: {
          AssociationName: 'Momsunderlag',
          DisplayLabel: 'Momsunderlag',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKMomsunderlag',
          AssociatedComponentName: 'Momsunderlag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKOmfordelningLogg: {
      CollectionName: 'EKOmfordelningLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OmfordelningLogg',
        Abstract: false,
        SOLabel: 'Omfördelning, logg',
        SOGLabel: 'Omfördelning, logg',
        SBLabel: 'Omfördelning, loggen',
        SBGLabel: 'Omfördelning, loggen',
        POLabel: 'Omfördelning, loggar',
        POGLabel: 'Omfördelning, loggar',
        PBLabel: 'Omfördelning, loggarna',
        PBGLabel: 'Omfördelning, loggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Omfördelning, loggen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Omfördelning, loggen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Omfördelning, loggen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UNDERLAG_BOKF_AR: {
          AttributeName: 'UNDERLAG_BOKF_AR',
          DisplayLabel: 'Underlag, bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
        },
        UNDERLAG_BOKF_PER: {
          AttributeName: 'UNDERLAG_BOKF_PER',
          DisplayLabel: 'Underlag, period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
        RAPP_BOKF_AR: {
          AttributeName: 'RAPP_BOKF_AR',
          DisplayLabel: 'Rapport, bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
        },
        RAPP_BOKF_PER: {
          AttributeName: 'RAPP_BOKF_PER',
          DisplayLabel: 'Rapport, period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        Omfattning: {
          AttributeName: 'Omfattning',
          DisplayLabel: 'Omfattning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokford: {
          AttributeName: 'Bokford',
          DisplayLabel: 'Bokförd',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
      },
      Associations: {
        Bokfver: {
          AssociationName: 'Bokfver',
          DisplayLabel: 'Bokföringsverifikation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'Bokfver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPeriodUtskickLoggAnv: {
      CollectionName: 'EKPeriodUtskickLoggAnv',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PeriodUtskickLoggAnv',
        Abstract: false,
        SOLabel: 'Period utskick användare',
        SOGLabel: 'Period utskick användare',
        SBLabel: 'Period utskick användare',
        SBGLabel: 'Period utskick användare',
        POLabel: 'Period utskick användare',
        POGLabel: 'Period utskick användare',
        PBLabel: 'Period utskick användare',
        PBGLabel: 'Period utskick användare',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Period utskick användare primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Period utskick användare versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Period utskick användare fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKPeriodUtskickLogg: {
      CollectionName: 'EKPeriodUtskickLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PeriodUtskickLogg',
        Abstract: false,
        SOLabel: 'Periodutskick logg',
        SOGLabel: 'Periodutskick logg',
        SBLabel: 'Periodutskick logg',
        SBGLabel: 'Periodutskick logg',
        POLabel: 'Periodutskick logg',
        POGLabel: 'Periodutskick logg',
        PBLabel: 'Periodutskick logg',
        PBGLabel: 'Periodutskick logg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Periodutskick logg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Periodutskick logg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Periodutskick logg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokf. år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERIOD: {
          AttributeName: 'PERIOD',
          DisplayLabel: 'Period',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKICKAD_AV_ID: {
          AttributeName: 'SKICKAD_AV_ID',
          DisplayLabel: 'Skickad av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MottagarLista: {
          AttributeName: 'MottagarLista',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Period/År',
          DataType: 'Enum',
          EnumValues: new Map([['PERIOD', 'Period'], ['AR', 'År']]),
          EnumSortValues: new Map([['PERIOD', 'P'], ['AR', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PERIOD=Period;AR=År"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        SkickadAv: {
          AssociationName: 'SkickadAv',
          DisplayLabel: 'Skickad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        SkickadTill: {
          AssociationName: 'SkickadTill',
          DisplayLabel: 'Skickad till',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPeriodUtskickLoggAnv',
          AssociatedComponentName: 'PeriodUtskickLoggAnv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPersonalBudggrupp: {
      CollectionName: 'EKPersonalBudggrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalBudggrupp',
        Abstract: false,
        SOLabel: 'Personal, budgetgrupper',
        SOGLabel: 'Personal, budgetgrupper',
        SBLabel: 'Personal, budgetgrupper',
        SBGLabel: 'Personal, budgetgrupper',
        POLabel: 'Personal, budgetgrupper',
        POGLabel: 'Personal, budgetgrupper',
        PBLabel: 'Personal, budgetgrupper',
        PBGLabel: 'Personal, budgetgrupper',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personal, budgetgrupper primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personal, budgetgrupper versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personal, budgetgrupper fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUDG_GRUPP_ID: {
          AttributeName: 'BUDG_GRUPP_ID',
          DisplayLabel: 'Id, budgetgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        PERS_ID: {
          AttributeName: 'PERS_ID',
          DisplayLabel: 'Id, personal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKPersonalFordelnBokfar: {
      CollectionName: 'EKPersonalFordelnBokfar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalFordelnBokfar',
        Abstract: false,
        SOLabel: 'Personal, fördelning bokföringsår',
        SOGLabel: 'Personal, fördelning bokföringsår',
        SBLabel: 'Personal, fördelning bokföringsår',
        SBGLabel: 'Personal, fördelning bokföringsår',
        POLabel: 'Personal, fördelning bokföringsår',
        POGLabel: 'Personal, fördelning bokföringsår',
        PBLabel: 'Personal, fördelning bokföringsår',
        PBGLabel: 'Personal, fördelning bokföringsår',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personal, fördelning bokföringsår primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personal, fördelning bokföringsår versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personal, fördelning bokföringsår fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KALLA: {
          AttributeName: 'KALLA',
          DisplayLabel: 'Källa',
          Hint: 'Arbetsbudget/Flex/Manuellt registrerad/Kopierad från föregående år',
          DataType: 'Enum',
          EnumValues: new Map([['ARBETSBUDGET', 'Arbetsbudget'], ['FLEX', 'Flex'], ['MANUELLT_REGISTRERAD', 'Manuellt registrerad'], ['KOPIERAD_FRAN_FOREGAENDE_AR', 'Kopierad från föregående år']]),
          EnumSortValues: new Map([['ARBETSBUDGET', 'A'], ['FLEX', 'L'], ['MANUELLT_REGISTRERAD', 'R'], ['KOPIERAD_FRAN_FOREGAENDE_AR', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARBETSBUDGET=Arbetsbudget;FLEX=Flex;MANUELLT_REGISTRERAD=Manuellt registrerad;KOPIERAD_FRAN_FOREGAENDE_AR=Kopierad från föregående år"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Exporterad till fil/Justerad, ej exporterad/Arbetsbudget bokförd, ej exporterad/Exporterad för manuell justering/Importerad från lönesystem',
          DataType: 'Enum',
          EnumValues: new Map([['EXPORTERAD_TILL_FIL', 'Exporterad till fil'], ['JUSTERAD__EJ_EXPORTERAD', 'Justerad, ej exporterad'], ['ARBETSBUDGET_BOKFORD__EJ_EXPORTERAD', 'Arbetsbudget bokförd, ej exporterad'], ['EXPORTERAD_FOR_MANUELL_JUSTERING', 'Exporterad för manuell justering'], ['IMPORTERAD_FRAN_LONESYSTEM', 'Importerad från lönesystem']]),
          EnumSortValues: new Map([['EXPORTERAD_TILL_FIL', 'E'], ['JUSTERAD__EJ_EXPORTERAD', 'J'], ['ARBETSBUDGET_BOKFORD__EJ_EXPORTERAD', 'A'], ['EXPORTERAD_FOR_MANUELL_JUSTERING', 'M'], ['IMPORTERAD_FRAN_LONESYSTEM', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXPORTERAD_TILL_FIL=Exporterad till fil;JUSTERAD__EJ_EXPORTERAD=Justerad, ej exporterad;ARBETSBUDGET_BOKFORD__EJ_EXPORTERAD=Arbetsbudget bokförd, ej exporterad;EXPORTERAD_FOR_MANUELL_JUSTERING=Exporterad för manuell justering;IMPORTERAD_FRAN_LONESYSTEM=Importerad från lönesystem"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_SIGNATUR: {
          AttributeName: 'STATUS_SIGNATUR',
          DisplayLabel: 'Status, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKPersonalFordelnPeriod: {
      CollectionName: 'EKPersonalFordelnPeriod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalFordelnPeriod',
        Abstract: false,
        SOLabel: 'Personal, fördelning period',
        SOGLabel: 'Personal, fördelning period',
        SBLabel: 'Personal, fördelning period',
        SBGLabel: 'Personal, fördelning period',
        POLabel: 'Personal, fördelning period',
        POGLabel: 'Personal, fördelning period',
        PBLabel: 'Personal, fördelning period',
        PBGLabel: 'Personal, fördelning period',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personal, fördelning period primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personal, fördelning period versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personal, fördelning period fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_PERIOD: {
          AttributeName: 'FROM_PERIOD',
          DisplayLabel: 'Fr.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_PERIOD: {
          AttributeName: 'TOM_PERIOD',
          DisplayLabel: 'T.o.m',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TotalProcent: {
          AttributeName: 'TotalProcent',
          DisplayLabel: 'Totalt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        PeriodIntervall: {
          AttributeName: 'PeriodIntervall',
          DisplayLabel: 'Periodintervall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Personal: {
          AssociationName: 'Personal',
          DisplayLabel: 'Personal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonal',
          AssociatedComponentName: 'Personal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        FordelningBokfar: {
          AssociationName: 'FordelningBokfar',
          DisplayLabel: 'Exportstatus',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalFordelnBokfar',
          AssociatedComponentName: 'PersonalFordelnBokfar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Procent: {
          AssociationName: 'Procent',
          DisplayLabel: 'Procent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalFordelnProcent',
          AssociatedComponentName: 'PersonalFordelnProcent',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPersonalFordelnProcent: {
      CollectionName: 'EKPersonalFordelnProcent',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalFordelnProcent',
        Abstract: false,
        SOLabel: 'Personal, fördelning procent',
        SOGLabel: 'Personal, fördelning procent',
        SBLabel: 'Personal, fördelning procent',
        SBGLabel: 'Personal, fördelning procent',
        POLabel: 'Personal, fördelning procent',
        POGLabel: 'Personal, fördelning procent',
        PBLabel: 'Personal, fördelning procent',
        PBGLabel: 'Personal, fördelning procent',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personal, fördelning procent primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personal, fördelning procent versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personal, fördelning procent fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Id, kontoplan',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnummer 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Id, konto_1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnummer 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Id, konto_2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnummer 3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Id, konto_3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnummer 4',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Id, konto_4',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnummer 5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Id, konto_5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnummer 6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Id, konto_6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnummer 7',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Id, konto_7',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnummer 8',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Id, konto_8',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnummer 9',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Id, konto_9',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnummer 10',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Id, konto_10',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PROCENTSATS: {
          AttributeName: 'PROCENTSATS',
          DisplayLabel: 'Procentsats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y']]),
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontodel1: {
          AttributeName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel2: {
          AttributeName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel3: {
          AttributeName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel4: {
          AttributeName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel5: {
          AttributeName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel6: {
          AttributeName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel7: {
          AttributeName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel8: {
          AttributeName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel9: {
          AttributeName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Kontodel10: {
          AttributeName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Period: {
          AssociationName: 'Period',
          DisplayLabel: 'Period',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalFordelnPeriod',
          AssociatedComponentName: 'PersonalFordelnPeriod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKPersonalLonkonto: {
      CollectionName: 'EKPersonalLonkonto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalLonkonto',
        Abstract: false,
        SOLabel: 'Personal, lönekonto',
        SOGLabel: 'Personal, lönekonto',
        SBLabel: 'Personal, lönekonto',
        SBGLabel: 'Personal, lönekonto',
        POLabel: 'Personal, lönekonto',
        POGLabel: 'Personal, lönekonto',
        PBLabel: 'Personal, lönekonto',
        PBGLabel: 'Personal, lönekonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personal, lönekonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personal, lönekonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personal, lönekonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Id, konto',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Koddel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPersonalgruppAnstalld: {
      CollectionName: 'EKPersonalgruppAnstalld',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PersonalgruppAnstalld',
        Abstract: false,
        SOLabel: 'Personalgrupp, anställda',
        SOGLabel: 'Personalgrupp, anställda',
        SBLabel: 'Personalgrupp, anställda',
        SBGLabel: 'Personalgrupp, anställda',
        POLabel: 'Personalgrupp, anställda',
        POGLabel: 'Personalgrupp, anställda',
        PBLabel: 'Personalgrupp, anställda',
        PBGLabel: 'Personalgrupp, anställda',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personalgrupp, anställda primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personalgrupp, anställda versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personalgrupp, anställda fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FROM_AR: {
          AttributeName: 'FROM_AR',
          DisplayLabel: 'År, from',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOM_AR: {
          AttributeName: 'TOM_AR',
          DisplayLabel: 'Till, år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ArsIntervall: {
          AttributeName: 'ArsIntervall',
          DisplayLabel: 'Årsintervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Nummer, externt anställd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_LONESYSTEM: {
          AttributeName: 'FRAN_LONESYSTEM',
          DisplayLabel: 'Från lönesystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Personalgrupp: {
          AssociationName: 'Personalgrupp',
          DisplayLabel: 'Personalgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonal',
          AssociatedComponentName: 'PersonalPersgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPersonal: {
      CollectionName: 'EKPersonal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2043']]),
      RootType: {
        TypeValue: 'Personal',
        Abstract: true,
        SOLabel: 'Personalpost',
        SOGLabel: 'Personalpost',
        SBLabel: 'Personalposten',
        SBGLabel: 'Personalpostens',
        POLabel: 'Personalposter',
        POGLabel: 'Personalposters',
        PBLabel: 'Personalposterna',
        PBGLabel: 'Personalposternas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'PersonalAnstalld',
            Abstract: false,
            SOLabel: 'Anställd',
            SOGLabel: 'Anställd',
            SBLabel: 'Anställd',
            SBGLabel: 'Anställd',
            POLabel: 'Anställd',
            POGLabel: 'Anställd',
            PBLabel: 'Anställd',
            PBGLabel: 'Anställd',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'PersonalPersgrupp',
            Abstract: false,
            SOLabel: 'Personalgrupp',
            SOGLabel: 'Personalgrupp',
            SBLabel: 'Personalgrupp',
            SBGLabel: 'Personalgrupp',
            POLabel: 'Personalgrupp',
            POGLabel: 'Personalgrupp',
            PBLabel: 'Personalgrupp',
            PBGLabel: 'Personalgrupp',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personalpostens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personalpostens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['PERSONALANSTALLD', 'Anställd'], ['PERSONALPERSGRUPP', 'Personalgrupp']]),
          EnumSortValues: new Map([['PERSONALANSTALLD', 'A'], ['PERSONALPERSGRUPP', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PERSONALANSTALLD=Anställd;PERSONALPERSGRUPP=Personalgrupp"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Personalpostens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personalpostens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Externt Anställningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANSTALLD_ID: {
          AttributeName: 'ANSTALLD_ID',
          DisplayLabel: 'Id, Anställd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FODELSE_AR: {
          AttributeName: 'FODELSE_AR',
          DisplayLabel: 'Födelseår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANST_MANAD: {
          AttributeName: 'ANST_MANAD',
          DisplayLabel: 'Anställningsmånad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SLUT_MANAD: {
          AttributeName: 'SLUT_MANAD',
          DisplayLabel: 'Slutmånad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SEM_DGR: {
          AttributeName: 'SEM_DGR',
          DisplayLabel: 'Semesterdagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVTALS_OMR_ID: {
          AttributeName: 'AVTALS_OMR_ID',
          DisplayLabel: 'Id, avtalsområde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LON_TYP: {
          AttributeName: 'LON_TYP',
          DisplayLabel: 'Lönetyp',
          Hint: 'Månadslön/Timlön/Tillfälligt anställda',
          DataType: 'Enum',
          EnumValues: new Map([['MANADSLON', 'Månadslön'], ['TIMLON', 'Timlön'], ['TILLFALLIGT_ANSTALLDA', 'Tillfälligt anställda']]),
          EnumSortValues: new Map([['MANADSLON', 'M'], ['TIMLON', 'T'], ['TILLFALLIGT_ANSTALLDA', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANADSLON=Månadslön;TIMLON=Timlön;TILLFALLIGT_ANSTALLDA=Tillfälligt anställda"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Manadslon: {
          AttributeName: 'Manadslon',
          DisplayLabel: 'Månadslön',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAN_LONESYSTEM: {
          AttributeName: 'FRAN_LONESYSTEM',
          DisplayLabel: 'Från lönesystem',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HELTIDSLON: {
          AttributeName: 'HELTIDSLON',
          DisplayLabel: 'Heltidslön',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SYSSELSATTNINGSGRAD: {
          AttributeName: 'SYSSELSATTNINGSGRAD',
          DisplayLabel: 'Sysselsättningsgrad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="3"',
          FormatterDisplayParams: 'Decimals="3";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UPPEHALL_FAKTOR: {
          AttributeName: 'UPPEHALL_FAKTOR',
          DisplayLabel: 'Uppehållsfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="2"',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BefKodBen: {
          AttributeName: 'BefKodBen',
          DisplayLabel: 'BefKodBen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEFATTNINGSKOD: {
          AttributeName: 'BEFATTNINGSKOD',
          DisplayLabel: 'Befattningskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LON_AVSER_AR: {
          AttributeName: 'LON_AVSER_AR',
          DisplayLabel: 'Lön avser år',
          Hint: 'Ska tas bort',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        BUDGETGRUPP_ID: {
          AttributeName: 'BUDGETGRUPP_ID',
          DisplayLabel: 'Budgetgrupp, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Lonekonto: {
          AttributeName: 'Lonekonto',
          DisplayLabel: 'Lönekonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ErsatterAnstalld: {
          AttributeName: 'ErsatterAnstalld',
          DisplayLabel: 'Ersätter personalpost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ErsattsAvAnstalld: {
          AttributeName: 'ErsattsAvAnstalld',
          DisplayLabel: 'Ersätts av personalpost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ErsatterExterntAnstnr: {
          AttributeName: 'ErsatterExterntAnstnr',
          DisplayLabel: 'Ersätter anställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ErsattsAvExterntAnstnr: {
          AttributeName: 'ErsattsAvExterntAnstnr',
          DisplayLabel: 'Ersatts av anställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avtalsomrade: {
          AssociationName: 'Avtalsomrade',
          DisplayLabel: 'Avtalsområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAvtalsOmrade',
          AssociatedComponentName: 'Avtalsomrade',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Budgetgrupp: {
          AssociationName: 'Budgetgrupp',
          DisplayLabel: 'Budgetgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBudgetgrupp',
          AssociatedComponentName: 'Budgetgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Befattningskod: {
          AssociationName: 'Befattningskod',
          DisplayLabel: 'Befattningskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBefattningskod',
          AssociatedComponentName: 'Befattningskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Lonkonto: {
          AssociationName: 'Lonkonto',
          DisplayLabel: 'Lönekonto',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalLonkonto',
          AssociatedComponentName: 'PersonalLonkonto',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FordelnPeriod: {
          AssociationName: 'FordelnPeriod',
          DisplayLabel: 'Fördelningsperioder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalFordelnPeriod',
          AssociatedComponentName: 'PersonalFordelnPeriod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anstallda: {
          AssociationName: 'Anstallda',
          DisplayLabel: 'Anställda',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalgruppAnstalld',
          AssociatedComponentName: 'PersonalgruppAnstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        FordelnBokfar: {
          AssociationName: 'FordelnBokfar',
          DisplayLabel: 'Fördelning, bokföringsår',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKPersonalFordelnBokfar',
          AssociatedComponentName: 'PersonalFordelnBokfar',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKPlaneradBetalning: {
      CollectionName: 'EKPlaneradBetalning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PlaneradBetalning',
        Abstract: false,
        SOLabel: 'Planerad betalning',
        SOGLabel: 'Planerad betalning',
        SBLabel: 'Planerade betanlingen',
        SBGLabel: 'Planerade betanlingen',
        POLabel: 'Planerade betalningar',
        POGLabel: 'Planerade betalningar',
        PBLabel: 'Planerade betalningarna',
        PBGLabel: 'Planerade betalningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Planerade betanlingen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Planerade betanlingen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Planerade betanlingen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Planerade betanlingen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'ORDNINGS_NR_1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'KONTOID_1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'KPLAN_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKUtdeladRapportPren: {
      CollectionName: 'EKUtdeladRapportPren',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'UtdeladRapportPren',
        Abstract: false,
        SOLabel: 'Prenumerant',
        SOGLabel: 'Prenumerant',
        SBLabel: 'Prenumeranten',
        SBGLabel: 'Prenumeranten',
        POLabel: 'Prenumeranter',
        POGLabel: 'Prenumeranter',
        PBLabel: 'Prenumeranterna',
        PBGLabel: 'Prenumeranterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prenumeranten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prenumeranten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prenumeranten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Användare/E-postadress',
          DataType: 'Enum',
          EnumValues: new Map([['ANVANDARE', 'Användare'], ['E_POSTADRESS', 'E-postadress']]),
          EnumSortValues: new Map([['ANVANDARE', 'A'], ['E_POSTADRESS', 'E']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVANDARE=Användare;E_POSTADRESS=E-postadress"',
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTERNANV_ID: {
          AttributeName: 'EXTERNANV_ID',
          DisplayLabel: 'Extern användare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prenumerant: {
          AttributeName: 'Prenumerant',
          DisplayLabel: 'Prenumerant',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTEDEKUtdeladRapportAnv: {
      CollectionName: 'EKTEDEKUtdeladRapportAnv',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'UtdeladRapportAnv',
        Abstract: false,
        SOLabel: 'Rapportbehörighet',
        SOGLabel: 'Rapportbehörighet',
        SBLabel: 'Rapportbehörigheten',
        SBGLabel: 'Rapportbehörigheten',
        POLabel: 'Rapportbehörigheter',
        POGLabel: 'Rapportbehörigheter',
        PBLabel: 'Rapportbehörigheterna',
        PBGLabel: 'Rapportbehörigheterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportbehörigheten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportbehörigheten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportbehörigheten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Anvandare: {
          AttributeName: 'Anvandare',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rapport: {
          AssociationName: 'Rapport',
          DisplayLabel: 'Rapport',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKEkonomirapport',
          AssociatedComponentName: 'Ekonomirapport',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    EKTEDEKLagradRapportAnv: {
      CollectionName: 'EKTEDEKLagradRapportAnv',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'LagradRapportAnv',
        Abstract: false,
        SOLabel: 'Rapport lagrad för användare',
        SOGLabel: 'Rapport lagrad för användare',
        SBLabel: 'Rapporten lagrad för användare',
        SBGLabel: 'Rapporten lagrad för användare',
        POLabel: 'Rapporter lagrad för användare',
        POGLabel: 'Rapporter lagrad för användare',
        PBLabel: 'Rapporterna lagrad för användare',
        PBGLabel: 'Rapporterna lagrad för användare',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporten lagrad för användare primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporten lagrad för användare versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporten lagrad för användare fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGEN: {
          AttributeName: 'MOTTAGEN',
          DisplayLabel: 'Mottagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportkategori: {
      CollectionName: 'EKRapportkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapportkategori',
        Abstract: false,
        SOLabel: 'Rapportkategori',
        SOGLabel: 'Rapportkategori',
        SBLabel: 'Rapportkategorin',
        SBGLabel: 'Rapportkategorin',
        POLabel: 'Rapportkategorier',
        POGLabel: 'Rapportkategorier',
        PBLabel: 'Rapportkategorierna',
        PBGLabel: 'Rapportkategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportkategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportkategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportkategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportkategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportMallNiva: {
      CollectionName: 'EKRapportMallNiva',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportMallNiva',
        Abstract: false,
        SOLabel: 'Rapportmall - nivå',
        SOGLabel: 'Rapportmall - nivå',
        SBLabel: 'Rapportmall - nivån',
        SBGLabel: 'Rapportmall - nivån',
        POLabel: 'Rapportmall - nivåer',
        POGLabel: 'Rapportmall - nivåer',
        PBLabel: 'Rapportmall - nivåerna',
        PBGLabel: 'Rapportmall - nivåerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportmall - nivån primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportmall - nivån versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportmall - nivån fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FONT_NAMN: {
          AttributeName: 'FONT_NAMN',
          DisplayLabel: 'Font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOLD: {
          AttributeName: 'BOLD',
          DisplayLabel: 'Fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        ITALIC: {
          AttributeName: 'ITALIC',
          DisplayLabel: 'Kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UNDERLINE: {
          AttributeName: 'UNDERLINE',
          DisplayLabel: 'Understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STRIKE_OUT: {
          AttributeName: 'STRIKE_OUT',
          DisplayLabel: 'STRIKE_OUT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIVERSE: {
          AttributeName: 'DIVERSE',
          DisplayLabel: 'Diverse inställningar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportMall: {
      CollectionName: 'EKRapportMall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapportMall',
        Abstract: false,
        SOLabel: 'Rapportmall',
        SOGLabel: 'Rapportmall',
        SBLabel: 'Rapportmallen',
        SBGLabel: 'Rapportmallen',
        POLabel: 'Rapportmallar',
        POGLabel: 'Rapportmallar',
        PBLabel: 'Rapportmallarna',
        PBGLabel: 'Rapportmallarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportmallen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportmallen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportmallen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportmallen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LAYOUT: {
          AttributeName: 'LAYOUT',
          DisplayLabel: 'Layout',
          Hint: 'Standardlayout',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARDLAYOUT', 'Standardlayout']]),
          EnumSortValues: new Map([['STANDARDLAYOUT', 'STANDARD']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARDLAYOUT=Standardlayout"',
        },
        ANVAND_FARG: {
          AttributeName: 'ANVAND_FARG',
          DisplayLabel: 'Färga nivåer',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        INDENTERA: {
          AttributeName: 'INDENTERA',
          DisplayLabel: 'Indentera nivåer',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Stående/Liggande',
          Hint: 'Liggande A4/Stående A4',
          DataType: 'Enum',
          EnumValues: new Map([['LIGGANDE_A4', 'Liggande A4'], ['STAENDE_A4', 'Stående A4']]),
          EnumSortValues: new Map([['LIGGANDE_A4', 'L'], ['STAENDE_A4', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LIGGANDE_A4=Liggande A4;STAENDE_A4=Stående A4"',
          InterfaceType: 'ifChecklist',
        },
        RUB_FONT_NAMN: {
          AttributeName: 'RUB_FONT_NAMN',
          DisplayLabel: 'Rubrik - Font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_STORLEK: {
          AttributeName: 'RUB_STORLEK',
          DisplayLabel: 'Rubrik - storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUB_BOLD: {
          AttributeName: 'RUB_BOLD',
          DisplayLabel: 'Rubrik - Fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RUB_ITALIC: {
          AttributeName: 'RUB_ITALIC',
          DisplayLabel: 'Rubrik - Kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RUB_UNDERLINE: {
          AttributeName: 'RUB_UNDERLINE',
          DisplayLabel: 'Rubrik - Understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RUB_STRIKE_OUT: {
          AttributeName: 'RUB_STRIKE_OUT',
          DisplayLabel: 'Rubrik - Överstruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_FONT_NAMN: {
          AttributeName: 'SUMMA_FONT_NAMN',
          DisplayLabel: 'Summa - Font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMA_STORLEK: {
          AttributeName: 'SUMMA_STORLEK',
          DisplayLabel: 'Summa - Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMA_BOLD: {
          AttributeName: 'SUMMA_BOLD',
          DisplayLabel: 'Summa - Fetstil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_ITALIC: {
          AttributeName: 'SUMMA_ITALIC',
          DisplayLabel: 'Summa - Kursiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_UNDERLINE: {
          AttributeName: 'SUMMA_UNDERLINE',
          DisplayLabel: 'Summa - Understruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SUMMA_STRIKE_OUT: {
          AttributeName: 'SUMMA_STRIKE_OUT',
          DisplayLabel: 'Summa - Överstruken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Niva: {
          AssociationName: 'Niva',
          DisplayLabel: 'Nivåer',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportMallNiva',
          AssociatedComponentName: 'RapportMallNiva',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKRapportpaket: {
      CollectionName: 'EKRapportpaket',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapportpaket',
        Abstract: false,
        SOLabel: 'Rapportpaket',
        SOGLabel: 'Rapportpaket',
        SBLabel: 'Rapportpaketet',
        SBGLabel: 'Rapportpaketet',
        POLabel: 'Rapportpaket',
        POGLabel: 'Rapportpaket',
        PBLabel: 'Rapportpaketen',
        PBGLabel: 'Rapportpaketen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportpaketet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportpaketet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportpaketet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportpaketet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        MED_SORTERING: {
          AttributeName: 'MED_SORTERING',
          DisplayLabel: 'Sortering',
          Hint: 'Ett mail per användare/Ett mail per rapport/Ett mail per rapport/användare',
          DataType: 'Enum',
          EnumValues: new Map([['ETT_MAIL_PER_ANVANDARE', 'Ett mail per användare'], ['ETT_MAIL_PER_RAPPORT', 'Ett mail per rapport'], ['ETT_MAIL_PER_RAPPORT_ANVANDARE', 'Ett mail per rapport/användare']]),
          EnumSortValues: new Map([['ETT_MAIL_PER_ANVANDARE', '0'], ['ETT_MAIL_PER_RAPPORT', '1'], ['ETT_MAIL_PER_RAPPORT_ANVANDARE', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ETT_MAIL_PER_ANVANDARE=Ett mail per användare;ETT_MAIL_PER_RAPPORT=Ett mail per rapport;ETT_MAIL_PER_RAPPORT_ANVANDARE=Ett mail per rapport/användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        MED_AMNE: {
          AttributeName: 'MED_AMNE',
          DisplayLabel: 'Ämne',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MED_MEDDELANDE: {
          AttributeName: 'MED_MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MED_AVS_EMAIL: {
          AttributeName: 'MED_AVS_EMAIL',
          DisplayLabel: 'Avsändare, e-postadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MED_AVS_NAMN: {
          AttributeName: 'MED_AVS_NAMN',
          DisplayLabel: 'Avsändare, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DISTR_SATT: {
          AttributeName: 'DISTR_SATT',
          DisplayLabel: 'Distribueringssätt',
          Hint: 'E-post/Utskrift/WebAveny Ekonomi',
          DataType: 'Enum',
          EnumValues: new Map([['E_POST', 'E-post'], ['UTSKRIFT', 'Utskrift'], ['WEBAVENY_EKONOMI', 'WebAveny Ekonomi']]),
          EnumSortValues: new Map([['E_POST', 'E'], ['UTSKRIFT', 'U'], ['WEBAVENY_EKONOMI', 'W']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="E_POST=E-post;UTSKRIFT=Utskrift;WEBAVENY_EKONOMI=WebAveny Ekonomi"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          AttributeGroup: 'GAS',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKTEDEKRapportpaketLogg',
          AssociatedComponentName: 'Rapportpaketlogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKRapportUrval: {
      CollectionName: 'EKRapportUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapportUrval',
        Abstract: false,
        SOLabel: 'Rapporturval',
        SOGLabel: 'Rapporturval',
        SBLabel: 'Rapporturvalet',
        SBGLabel: 'Rapporturvalet',
        POLabel: 'Rapporturval',
        POGLabel: 'Rapporturval',
        PBLabel: 'Rapporturvalen',
        PBGLabel: 'Rapporturvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporturvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporturvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporturvalet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporturvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANV_ID: {
          AttributeName: 'ANV_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKontodelReceptvarde: {
      CollectionName: 'EKKontodelReceptvarde',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KontodelReceptvarde',
        Abstract: false,
        SOLabel: 'Receptvärde',
        SOGLabel: 'Receptvärdes',
        SBLabel: 'Receptvärdet',
        SBGLabel: 'Receptvärdets',
        POLabel: 'Receptvärde',
        POGLabel: 'Receptvärdes',
        PBLabel: 'Receptvärden',
        PBGLabel: 'Receptvärdens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Receptvärdets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Receptvärdets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Receptvärdets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Kontodel, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RECEPT_ID: {
          AttributeName: 'RECEPT_ID',
          DisplayLabel: 'Recept, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_ORDNINGS_NR: {
          AttributeName: 'VARDE_ORDNINGS_NR',
          DisplayLabel: 'Värde, ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VARDE_FROM: {
          AttributeName: 'VARDE_FROM',
          DisplayLabel: 'Fr o m',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VARDE_TOM: {
          AttributeName: 'VARDE_TOM',
          DisplayLabel: 'T o m',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Intervall: {
          AttributeName: 'Intervall',
          DisplayLabel: 'Intervall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRapportHuvudFalt: {
      CollectionName: 'EKRapportHuvudFalt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'RapporthuvudFalt',
        Abstract: true,
        SOLabel: 'Sidhuvud, fält',
        SOGLabel: 'Sidhuvud, fält',
        SBLabel: 'Sidhuvud, fältet',
        SBGLabel: 'Sidhuvud, fältet',
        POLabel: 'Sidhuvud, fält',
        POGLabel: 'Sidhuvud, fält',
        PBLabel: 'Sidhuvud, fälten',
        PBGLabel: 'Sidhuvud, fälten',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'RapporthuvudFormfalt',
            Abstract: false,
            SOLabel: 'Rapporthuvud, formfält',
            SOGLabel: 'Rapporthuvud, formfält',
            SBLabel: 'Rapporthuvud, formfältet',
            SBGLabel: 'Rapporthuvud, formfältet',
            POLabel: 'Rapporthuvud, formfält',
            POGLabel: 'Rapporthuvud, formfält',
            PBLabel: 'Rapporthuvud, formfälten',
            PBGLabel: 'Rapporthuvud, formfälten',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapporthuvudTextfalt',
            Abstract: false,
            SOLabel: 'Rapporthuvud, textfält',
            SOGLabel: 'Rapporthuvud, textfält',
            SBLabel: 'Rapporthuvud, textfältet',
            SBGLabel: 'Rapporthuvud, textfältet',
            POLabel: 'Rapporthuvud, textfält',
            POGLabel: 'Rapporthuvud, textfält',
            PBLabel: 'Rapporthuvud, textfälten',
            PBGLabel: 'Rapporthuvud, textfälten',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RapporthuvudBildfalt',
            Abstract: false,
            SOLabel: 'Rapporthuvud, bild',
            SOGLabel: 'Rapporthuvud, bild',
            SBLabel: 'Rapporthuvud, bilden',
            SBGLabel: 'Rapporthuvud, bilden',
            POLabel: 'Rapporthuvud, bilder',
            POGLabel: 'Rapporthuvud, bilder',
            PBLabel: 'Rapporthuvud, bilderna',
            PBGLabel: 'Rapporthuvud, bilderna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Sidhuvud, fältet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Sidhuvud, fältet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['RAPPORTHUVUDFORMFALT', 'Rapporthuvud, formfält'], ['RAPPORTHUVUDTEXTFALT', 'Rapporthuvud, textfält'], ['RAPPORTHUVUDBILDFALT', 'Rapporthuvud, bild']]),
          EnumSortValues: new Map([['RAPPORTHUVUDFORMFALT', 'F'], ['RAPPORTHUVUDTEXTFALT', 'T'], ['RAPPORTHUVUDBILDFALT', 'B']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Sidhuvud, fältet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIZE_LEFT: {
          AttributeName: 'SIZE_LEFT',
          DisplayLabel: 'Startpos, sidled (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        SIZE_TOP: {
          AttributeName: 'SIZE_TOP',
          DisplayLabel: 'Startpos, höjdled (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        SIZE_WIDTH: {
          AttributeName: 'SIZE_WIDTH',
          DisplayLabel: 'Bredd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        SIZE_HEIGHT: {
          AttributeName: 'SIZE_HEIGHT',
          DisplayLabel: 'Höjd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
        },
        TEXT_COLOR: {
          AttributeName: 'TEXT_COLOR',
          DisplayLabel: 'Teckenfärg',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BACKGROUND_COLOR: {
          AttributeName: 'BACKGROUND_COLOR',
          DisplayLabel: 'Bakgrundsfärg',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SHAPE: {
          AttributeName: 'SHAPE',
          DisplayLabel: 'Typ av form',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudFormfalt'],
        },
        FONT_NAMN: {
          AttributeName: 'FONT_NAMN',
          DisplayLabel: 'Font',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        BOLD: {
          AttributeName: 'BOLD',
          DisplayLabel: 'Fetstil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        ITALIC: {
          AttributeName: 'ITALIC',
          DisplayLabel: 'Kursiv',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        UNDERLINE: {
          AttributeName: 'UNDERLINE',
          DisplayLabel: 'Understruken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        STRIKE_OUT: {
          AttributeName: 'STRIKE_OUT',
          DisplayLabel: 'STRIKE_OUT',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        AUTOSIZE: {
          AttributeName: 'AUTOSIZE',
          DisplayLabel: 'Anpassa bredd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        AUTOSTRETCH: {
          AttributeName: 'AUTOSTRETCH',
          DisplayLabel: 'Anpassa höjd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        FALTTEXT: {
          AttributeName: 'FALTTEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudTextfalt'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportHuvudFaltBlob',
          AssociatedComponentName: 'RapporthuvudBildfaltBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    EKRapportHuvudFaltBlob: {
      CollectionName: 'EKRapportHuvudFaltBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RapporthuvudBildfaltBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKRapportHuvudFaltBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKRapportHuvudFaltBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKRapportHuvudFaltBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudBildfalt'],
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RapporthuvudBildfalt'],
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Bild',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['RapporthuvudBildfalt'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKRegEjStdKto: {
      CollectionName: 'EKRegEjStdKto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RegEjStdKto',
        Abstract: false,
        SOLabel: 'Standardkonto som ej registreras',
        SOGLabel: 'Standardkonto som ej registreras',
        SBLabel: 'Standardkontot som ej registreras',
        SBGLabel: 'Standardkontot som ej registreras',
        POLabel: 'Standardkonton som ej registreras',
        POGLabel: 'Standardkonton som ej registreras',
        PBLabel: 'Standardkontona som ej registreras',
        PBGLabel: 'Standardkontona som ej registreras',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Standardkontot som ej registreras primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Standardkontot som ej registreras versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Standardkontot som ej registreras id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Standardkontot som ej registreras fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KONTODEL: {
          AttributeName: 'KONTODEL',
          DisplayLabel: 'Kontodel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKDetaljeringsniva: {
      CollectionName: 'EKDetaljeringsniva',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Detaljeringsniva',
        Abstract: false,
        SOLabel: 'Summeringsrecept',
        SOGLabel: 'Summeringsrecept',
        SBLabel: 'Summeringsreceptet',
        SBGLabel: 'Summeringsreceptet',
        POLabel: 'Summeringsrecept',
        POGLabel: 'Summeringsrecept',
        PBLabel: 'Summeringsreceptena',
        PBGLabel: 'Summeringsreceptena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Summeringsreceptet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Summeringsreceptet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Summeringsreceptet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Summeringsreceptet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gas',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokfgrupper: {
          AssociationName: 'Bokfgrupper',
          DisplayLabel: 'Bokföringsgrupper',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKDetaljeringsnivaGrupp',
          AssociatedComponentName: 'DetaljeringsnivaGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKSarskLoneskattLonekonto: {
      CollectionName: 'EKSarskLoneskattLonekonto',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SarskLoneskattLonekonto',
        Abstract: false,
        SOLabel: 'Särskild löneskatt lönekonto',
        SOGLabel: 'Särskild löneskatt lönekonto',
        SBLabel: 'Särskild löneskatt lönekonto',
        SBGLabel: 'Särskild löneskatt lönekonto',
        POLabel: 'Särskild löneskatt lonekonton',
        POGLabel: 'Särskild löneskatt lönekonto',
        PBLabel: 'Särskild löneskatt lönekonto',
        PBGLabel: 'Särskild löneskatt lönekonto',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Särskild löneskatt lönekonto primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Särskild löneskatt lönekonto versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Särskild löneskatt lönekonto fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PALAGG_ID: {
          AttributeName: 'PALAGG_ID',
          DisplayLabel: 'Pålägg, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTO_ID: {
          AttributeName: 'KONTO_ID',
          DisplayLabel: 'Konto id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Kontodel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKLonetillagg: {
      CollectionName: 'EKLonetillagg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Lonetillagg',
        Abstract: false,
        SOLabel: 'Lönetillägg',
        SOGLabel: 'Lönetillägg',
        SBLabel: 'Lönetillägg',
        SBGLabel: 'Lönetillägg',
        POLabel: 'Lönetillägg',
        POGLabel: 'Lönetillägg',
        PBLabel: 'Lönetillägg',
        PBGLabel: 'Lönetillägg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lönetillägg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lönetillägg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Lönetillägg id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lönetillägg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        AVTALSENL_SOC_AVG: {
          AttributeName: 'AVTALSENL_SOC_AVG',
          DisplayLabel: 'Avtalsenliga sociala avgifter',
          Hint: 'Nej/Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'NullText="Nej"',
          FormatterDisplayParams: 'NullText="Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARBETSGIVARAVGIFT: {
          AttributeName: 'ARBETSGIVARAVGIFT',
          DisplayLabel: 'Arbetsgivaravgift',
          Hint: 'Nej/Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'NullText="Nej"',
          FormatterDisplayParams: 'NullText="Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEARTER: {
          AttributeName: 'LONEARTER',
          DisplayLabel: 'Lönearter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEKONTO_ENL_PERSONAL: {
          AttributeName: 'LONEKONTO_ENL_PERSONAL',
          DisplayLabel: 'Lönekonto enligt månadslön/timlön',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEARTER_ENIAC_SPECIAL: {
          AttributeName: 'LONEARTER_ENIAC_SPECIAL',
          DisplayLabel: 'Sparade lönearter för Hogia - special BasDemo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INGAR_I_FAP: {
          AttributeName: 'INGAR_I_FAP',
          DisplayLabel: 'Ingår i beräkning av FÅP',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LONEARTER_ALFA: {
          AttributeName: 'LONEARTER_ALFA',
          DisplayLabel: 'Lönearter, Visma HR Plus',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lonkonto: {
          AssociationName: 'Lonkonto',
          DisplayLabel: 'Lönekonto',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKLonetillaggLonekonto',
          AssociatedComponentName: 'LonetillaggLonekonto',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTillaggsinfo: {
      CollectionName: 'EKTillaggsinfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Tillaggsinfo',
        Abstract: false,
        SOLabel: 'Tilläggsinfo',
        SOGLabel: 'Tilläggsinfos',
        SBLabel: 'Tilläggsinfon',
        SBGLabel: 'Tilläggsinfons',
        POLabel: 'Tilläggsinfo',
        POGLabel: 'Tilläggsinfos',
        PBLabel: 'Tilläggsinfon',
        PBGLabel: 'Tilläggsinfons',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tilläggsinfons primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tilläggsinfons versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tilläggsinfons id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Falt: {
          AssociationName: 'Falt',
          DisplayLabel: 'Fält',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKTillaggsinfoFalt',
          AssociatedComponentName: 'TillaggsinfoFalt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel: {
          AssociationName: 'Kontodel',
          DisplayLabel: 'Kontodel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKTillaggsinfoFalt: {
      CollectionName: 'EKTillaggsinfoFalt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TillaggsinfoFalt',
        Abstract: false,
        SOLabel: 'Tilläggsinfo, fält',
        SOGLabel: 'Tilläggsinfo, fält',
        SBLabel: 'Tilläggsinfo, fält',
        SBGLabel: 'Tilläggsinfo, fält',
        POLabel: 'Tilläggsinfo, fält',
        POGLabel: 'Tilläggsinfo, fält',
        PBLabel: 'Tilläggsinfo, fält',
        PBGLabel: 'Tilläggsinfo, fält',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tilläggsinfo, fält primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tilläggsinfo, fält versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tilläggsinfo, fält fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTORDER: {
          AttributeName: 'SORTORDER',
          DisplayLabel: 'Sortering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIELD_NAME: {
          AttributeName: 'FIELD_NAME',
          DisplayLabel: 'Fältnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Använd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OBLIGATORISK: {
          AttributeName: 'OBLIGATORISK',
          DisplayLabel: 'Obligatoriskt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Hjälptext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV_ENABLED: {
          AttributeName: 'AKTIV_ENABLED',
          DisplayLabel: 'Kan aktiveras/avaktiveras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKKOBTransTyp: {
      CollectionName: 'EKKOBTransTyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBTransTyp',
        Abstract: false,
        SOLabel: 'Transaktionstyp',
        SOGLabel: 'Transaktionstyp',
        SBLabel: 'Transaktionstypen',
        SBGLabel: 'Transaktionstypens',
        POLabel: 'Transaktionstyper',
        POGLabel: 'Transaktionstypers',
        PBLabel: 'Transaktionstyperna',
        PBGLabel: 'Transaktionstypernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Transaktionstypens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Transaktionstypens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Transaktionstypens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Transaktionstypens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYPKOD: {
          AttributeName: 'TYPKOD',
          DisplayLabel: 'Typkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          MaxInputLength: 10,
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod, id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KBMotkonto: {
          AttributeName: 'KBMotkonto',
          DisplayLabel: 'Motkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Motkonto: {
          AttributeName: 'Motkonto',
          DisplayLabel: 'Motkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Motkonto: {
          AssociationName: 'Motkonto',
          DisplayLabel: 'Motkonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKGavogruppUrval: {
      CollectionName: 'EKGavogruppUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GavogruppUrval',
        Abstract: false,
        SOLabel: 'Urval gåvorader',
        SOGLabel: 'Urval gåvorader',
        SBLabel: 'Urvalet av gåvorader',
        SBGLabel: 'Urvalet av gåvorader',
        POLabel: 'Urval gåvorader',
        POGLabel: 'Urval gåvorader',
        PBLabel: 'Urval gåvorader',
        PBGLabel: 'Urval gåvorader',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Urvalet av gåvorader primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Urvalet av gåvorader versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Urvalet av gåvorader fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBokfver: {
      CollectionName: 'EKBokfver',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Bokfgrupp'], ['USER_DEF_REPORT_ROUTINE', '2004'], ['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'BokfVer',
        Abstract: false,
        SOLabel: 'Verifikation',
        SOGLabel: 'Verifikation',
        SBLabel: 'Verifikationen',
        SBGLabel: 'Verifikationen',
        POLabel: 'Verifikationer',
        POGLabel: 'Verifikationer',
        PBLabel: 'Verifikationerna',
        PBGLabel: 'Verifikationerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verifikationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verifikationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verifikationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verifikationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_PER: {
          AttributeName: 'BOKF_PER',
          DisplayLabel: 'Bokföringsperiod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        I_HUVUDBOK: {
          AttributeName: 'I_HUVUDBOK',
          DisplayLabel: 'Definitivbokförd',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        JOURNAL_ID: {
          AttributeName: 'JOURNAL_ID',
          DisplayLabel: 'JournalID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registrerad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PERIODISERINGS_NR: {
          AttributeName: 'PERIODISERINGS_NR',
          DisplayLabel: 'Periodiseringsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BUNT_ID: {
          AttributeName: 'BUNT_ID',
          DisplayLabel: 'BuntId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANVISNINGS_NR: {
          AttributeName: 'HANVISNINGS_NR',
          DisplayLabel: 'Hänvisningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'Valuta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VERKAT_KOD: {
          AttributeName: 'VERKAT_KOD',
          DisplayLabel: 'Verifikationskategori',
          Hint: 'EK|Verifikationsregistrering/EK|Periodisera verifikationer/EK|Import enligt SIE/EK|Inläsning av löneverifikationer/EK|Internfördelning från Lön/EK|Bokför om lön/EK|Avsluta projekt/EK|Bokför omfördelning/EK|Bokför om ändamålsbestämda medel/EK|Bokföringsfil från KOB/EK|Kollektfil från KOB/EK|Bokför om momsskuld/LR|Ankomstregistrering/LR|Definitivbokning/LR|Bokför utbetalningsuppdrag/LR|Återredovisning av utbetalningar/LR|Fakturabunt/LR|Justera belopp för leverantörsfakturor/LR|Makulera fakturahändelse/KR|Manuell inbetalning/KR|Inbetalningar KOB och Autogiro/KR|Inbetalningar Bg/Pg/KR|Återredovisning från orderintegration/KR|Betalning av bankkontofakturor/KR|Betalning av internfakturor/KR|Insättning på avtal/KR|Kreditering/KR|Bokför kundförlust/KR|Utbetalning av tillgodohavande/KR|Beräkna tillgodoränta/KR|Kravutskrift/KR|Makulering/justering av fakturahändelser/KR|Makulering/justering av kontohändelser/OF|Order/OF|Kreditorder/OF|Importera orderunderlag/OF|Fakturering/OF|Dröjsmålsräntefakturering/OF|Kundfakturabunt/GA|Fakturera gravskötslar/GA|Kreditera gravskötslar/GA|Avräkna avräkningsavtal/GA|Fakturera gravskötselavtal/GA|Avräkna fasttidsavtal/GA|Uppräkna fasttidsavtal/GA|Skapa beställningsorder/GA|Justera saldo på avtal/BO|Fakturera aktiviteter/AR|Bokför avskrivningar/AR|Bokför internränta/AR|Nedskrivning/AR|Avyttring/utrangering/omklassificering/AR|Aktivera pågående investeringar/AR|Ombokför påg. investeringar/investeringsrader/AR|Makulera aktivering av påg. investeringar/AR|Makulera ombokföring av påg. investeringar/investeringsrader/AR|Makulera senaste bokförda händelsen/AR|Omklassificering/AR|Byt investeringskonto/KJ|Fakturera kremationer/TI|Bokför tidrapporteringar/BJ|Fakturera bisättningar/WEK|Bokföringsorder/WOF|WebOrder',
          DataType: 'Enum',
          EnumValues: new Map([['EK_VERIFIKATIONSREGISTRERING', 'EK|Verifikationsregistrering'], ['EK_PERIODISERA_VERIFIKATIONER', 'EK|Periodisera verifikationer'], ['EK_IMPORT_ENLIGT_SIE', 'EK|Import enligt SIE'], ['EK_INLASNING_AV_LONEVERIFIKATIONER', 'EK|Inläsning av löneverifikationer'], ['EK_INTERNFORDELNING_FRAN_LON', 'EK|Internfördelning från Lön'], ['EK_BOKFOR_OM_LON', 'EK|Bokför om lön'], ['EK_AVSLUTA_PROJEKT', 'EK|Avsluta projekt'], ['EK_BOKFOR_OMFORDELNING', 'EK|Bokför omfördelning'], ['EK_BOKFOR_OM_ANDAMALSBESTAMDA_MEDEL', 'EK|Bokför om ändamålsbestämda medel'], ['EK_BOKFORINGSFIL_FRAN_KOB', 'EK|Bokföringsfil från KOB'], ['EK_KOLLEKTFIL_FRAN_KOB', 'EK|Kollektfil från KOB'], ['EK_BOKFOR_OM_MOMSSKULD', 'EK|Bokför om momsskuld'], ['LR_ANKOMSTREGISTRERING', 'LR|Ankomstregistrering'], ['LR_DEFINITIVBOKNING', 'LR|Definitivbokning'], ['LR_BOKFOR_UTBETALNINGSUPPDRAG', 'LR|Bokför utbetalningsuppdrag'], ['LR_ATERREDOVISNING_AV_UTBETALNINGAR', 'LR|Återredovisning av utbetalningar'], ['LR_FAKTURABUNT', 'LR|Fakturabunt'], ['LR_JUSTERA_BELOPP_FOR_LEVERANTORSFAKTUROR', 'LR|Justera belopp för leverantörsfakturor'], ['LR_MAKULERA_FAKTURAHANDELSE', 'LR|Makulera fakturahändelse'], ['KR_MANUELL_INBETALNING', 'KR|Manuell inbetalning'], ['KR_INBETALNINGAR_KOB_OCH_AUTOGIRO', 'KR|Inbetalningar KOB och Autogiro'], ['KR_INBETALNINGAR_BG_PG', 'KR|Inbetalningar Bg/Pg'], ['KR_ATERREDOVISNING_FRAN_ORDERINTEGRATION', 'KR|Återredovisning från orderintegration'], ['KR_BETALNING_AV_BANKKONTOFAKTUROR', 'KR|Betalning av bankkontofakturor'], ['KR_BETALNING_AV_INTERNFAKTUROR', 'KR|Betalning av internfakturor'], ['KR_INSATTNING_PA_AVTAL', 'KR|Insättning på avtal'], ['KR_KREDITERING', 'KR|Kreditering'], ['KR_BOKFOR_KUNDFORLUST', 'KR|Bokför kundförlust'], ['KR_UTBETALNING_AV_TILLGODOHAVANDE', 'KR|Utbetalning av tillgodohavande'], ['KR_BERAKNA_TILLGODORANTA', 'KR|Beräkna tillgodoränta'], ['KR_KRAVUTSKRIFT', 'KR|Kravutskrift'], ['KR_MAKULERING_JUSTERING_AV_FAKTURAHANDELSER', 'KR|Makulering/justering av fakturahändelser'], ['KR_MAKULERING_JUSTERING_AV_KONTOHANDELSER', 'KR|Makulering/justering av kontohändelser'], ['OF_ORDER', 'OF|Order'], ['OF_KREDITORDER', 'OF|Kreditorder'], ['OF_IMPORTERA_ORDERUNDERLAG', 'OF|Importera orderunderlag'], ['OF_FAKTURERING', 'OF|Fakturering'], ['OF_DROJSMALSRANTEFAKTURERING', 'OF|Dröjsmålsräntefakturering'], ['GA_FAKTURERA_GRAVSKOTSLAR', 'GA|Fakturera gravskötslar'], ['GA_KREDITERA_GRAVSKOTSLAR', 'GA|Kreditera gravskötslar'], ['GA_AVRAKNA_AVRAKNINGSAVTAL', 'GA|Avräkna avräkningsavtal'], ['GA_FAKTURERA_GRAVSKOTSELAVTAL', 'GA|Fakturera gravskötselavtal'], ['GA_AVRAKNA_FASTTIDSAVTAL', 'GA|Avräkna fasttidsavtal'], ['GA_UPPRAKNA_FASTTIDSAVTAL', 'GA|Uppräkna fasttidsavtal'], ['GA_SKAPA_BESTALLNINGSORDER', 'GA|Skapa beställningsorder'], ['GA_JUSTERA_SALDO_PA_AVTAL', 'GA|Justera saldo på avtal'], ['BO_FAKTURERA_AKTIVITETER', 'BO|Fakturera aktiviteter'], ['AR_BOKFOR_AVSKRIVNINGAR', 'AR|Bokför avskrivningar'], ['AR_BOKFOR_INTERNRANTA', 'AR|Bokför internränta'], ['AR_NEDSKRIVNING', 'AR|Nedskrivning'], ['AR_AVYTTRING_UTRANGERING_OMKLASSIFICERING', 'AR|Avyttring/utrangering/omklassificering'], ['AR_AKTIVERA_PAGAENDE_INVESTERINGAR', 'AR|Aktivera pågående investeringar'], ['AR_OMBOKFOR_PAG__INVESTERINGAR_INVESTERINGSRADER', 'AR|Ombokför påg. investeringar/investeringsrader'], ['AR_MAKULERA_AKTIVERING_AV_PAG__INVESTERINGAR', 'AR|Makulera aktivering av påg. investeringar'], ['AR_MAKULERA_OMBOKFORING_AV_PAG__INVESTERINGAR_INVESTERINGSRADER', 'AR|Makulera ombokföring av påg. investeringar/investeringsrader'], ['AR_MAKULERA_SENASTE_BOKFORDA_HANDELSEN', 'AR|Makulera senaste bokförda händelsen'], ['AR_OMKLASSIFICERING', 'AR|Omklassificering'], ['AR_BYT_INVESTERINGSKONTO', 'AR|Byt investeringskonto'], ['KJ_FAKTURERA_KREMATIONER', 'KJ|Fakturera kremationer'], ['TI_BOKFOR_TIDRAPPORTERINGAR', 'TI|Bokför tidrapporteringar'], ['BJ_FAKTURERA_BISATTNINGAR', 'BJ|Fakturera bisättningar'], ['WEK_BOKFORINGSORDER', 'WEK|Bokföringsorder'], ['WOF_WEBORDER', 'WOF|WebOrder']]),
          EnumSortValues: new Map([['EK_VERIFIKATIONSREGISTRERING', 'BVR'], ['EK_PERIODISERA_VERIFIKATIONER', 'BPV'], ['EK_IMPORT_ENLIGT_SIE', 'BIS'], ['EK_INLASNING_AV_LONEVERIFIKATIONER', 'BIL'], ['EK_INTERNFORDELNING_FRAN_LON', 'BII'], ['EK_BOKFOR_OM_LON', 'BOL'], ['EK_AVSLUTA_PROJEKT', 'BPA'], ['EK_BOKFOR_OMFORDELNING', 'BBO'], ['EK_BOKFOR_OM_ANDAMALSBESTAMDA_MEDEL', 'BÄM'], ['EK_BOKFORINGSFIL_FRAN_KOB', 'BAK'], ['EK_KOLLEKTFIL_FRAN_KOB', 'BFK'], ['EK_BOKFOR_OM_MOMSSKULD', 'BOM'], ['LR_ANKOMSTREGISTRERING', 'BAR'], ['LR_DEFINITIVBOKNING', 'BDB'], ['LR_BOKFOR_UTBETALNINGSUPPDRAG', 'BBU'], ['LR_ATERREDOVISNING_AV_UTBETALNINGAR', 'BBR'], ['LR_FAKTURABUNT', 'BFB'], ['LR_JUSTERA_BELOPP_FOR_LEVERANTORSFAKTUROR', 'BJB'], ['LR_MAKULERA_FAKTURAHANDELSE', 'BJL'], ['KR_MANUELL_INBETALNING', 'BMI'], ['KR_INBETALNINGAR_KOB_OCH_AUTOGIRO', 'BAI'], ['KR_INBETALNINGAR_BG_PG', 'BIF'], ['KR_ATERREDOVISNING_FRAN_ORDERINTEGRATION', 'BAA'], ['KR_BETALNING_AV_BANKKONTOFAKTUROR', 'BBB'], ['KR_BETALNING_AV_INTERNFAKTUROR', 'BRI'], ['KR_INSATTNING_PA_AVTAL', 'BIA'], ['KR_KREDITERING', 'BKK'], ['KR_BOKFOR_KUNDFORLUST', 'BKF'], ['KR_UTBETALNING_AV_TILLGODOHAVANDE', 'BUT'], ['KR_BERAKNA_TILLGODORANTA', 'BBT'], ['KR_KRAVUTSKRIFT', 'FKU'], ['KR_MAKULERING_JUSTERING_AV_FAKTURAHANDELSER', 'BJK'], ['KR_MAKULERING_JUSTERING_AV_KONTOHANDELSER', 'BMK'], ['OF_ORDER', 'FOR'], ['OF_KREDITORDER', 'FKO'], ['OF_IMPORTERA_ORDERUNDERLAG', 'FIO'], ['OF_FAKTURERING', 'FFA'], ['OF_DROJSMALSRANTEFAKTURERING', 'FDR'], ['GA_FAKTURERA_GRAVSKOTSLAR', 'FGA'], ['GA_KREDITERA_GRAVSKOTSLAR', 'BKG'], ['GA_AVRAKNA_AVRAKNINGSAVTAL', 'FAV'], ['GA_FAKTURERA_GRAVSKOTSELAVTAL', 'FSA'], ['GA_AVRAKNA_FASTTIDSAVTAL', 'FAK'], ['GA_UPPRAKNA_FASTTIDSAVTAL', 'FUF'], ['GA_SKAPA_BESTALLNINGSORDER', 'FBE'], ['GA_JUSTERA_SALDO_PA_AVTAL', 'BJA'], ['BO_FAKTURERA_AKTIVITETER', 'FBO'], ['AR_BOKFOR_AVSKRIVNINGAR', 'BAV'], ['AR_BOKFOR_INTERNRANTA', 'BIN'], ['AR_NEDSKRIVNING', 'BNS'], ['AR_AVYTTRING_UTRANGERING_OMKLASSIFICERING', 'BAU'], ['AR_AKTIVERA_PAGAENDE_INVESTERINGAR', 'BAP'], ['AR_OMBOKFOR_PAG__INVESTERINGAR_INVESTERINGSRADER', 'BKI'], ['AR_MAKULERA_AKTIVERING_AV_PAG__INVESTERINGAR', 'BMA'], ['AR_MAKULERA_OMBOKFORING_AV_PAG__INVESTERINGAR_INVESTERINGSRADER', 'BMO'], ['AR_MAKULERA_SENASTE_BOKFORDA_HANDELSEN', 'BMV'], ['AR_OMKLASSIFICERING', 'BAO'], ['AR_BYT_INVESTERINGSKONTO', 'BAB'], ['KJ_FAKTURERA_KREMATIONER', 'FKJ'], ['TI_BOKFOR_TIDRAPPORTERINGAR', 'BTI'], ['BJ_FAKTURERA_BISATTNINGAR', 'FBJ'], ['WEK_BOKFORINGSORDER', 'BWB'], ['WOF_WEBORDER', 'FWO']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EK_VERIFIKATIONSREGISTRERING=EK|Verifikationsregistrering;EK_PERIODISERA_VERIFIKATIONER=EK|Periodisera verifikationer;EK_IMPORT_ENLIGT_SIE=EK|Import enligt SIE;EK_INLASNING_AV_LONEVERIFIKATIONER=EK|Inläsning av löneverifikationer;EK_INTERNFORDELNING_FRAN_LON=EK|Internfördelning från Lön;EK_BOKFOR_OM_LON=EK|Bokför om lön;EK_AVSLUTA_PROJEKT=EK|Avsluta projekt;EK_BOKFOR_OMFORDELNING=EK|Bokför omfördelning;EK_BOKFOR_OM_ANDAMALSBESTAMDA_MEDEL=EK|Bokför om ändamålsbestämda medel;EK_BOKFORINGSFIL_FRAN_KOB=EK|Bokföringsfil från KOB;EK_KOLLEKTFIL_FRAN_KOB=EK|Kollektfil från KOB;EK_BOKFOR_OM_MOMSSKULD=EK|Bokför om momsskuld;LR_ANKOMSTREGISTRERING=LR|Ankomstregistrering;LR_DEFINITIVBOKNING=LR|Definitivbokning;LR_BOKFOR_UTBETALNINGSUPPDRAG=LR|Bokför utbetalningsuppdrag;LR_ATERREDOVISNING_AV_UTBETALNINGAR=LR|Återredovisning av utbetalningar;LR_FAKTURABUNT=LR|Fakturabunt;LR_JUSTERA_BELOPP_FOR_LEVERANTORSFAKTUROR=LR|Justera belopp för leverantörsfakturor;LR_MAKULERA_FAKTURAHANDELSE=LR|Makulera fakturahändelse;KR_MANUELL_INBETALNING=KR|Manuell inbetalning;KR_INBETALNINGAR_KOB_OCH_AUTOGIRO=KR|Inbetalningar KOB och Autogiro;KR_INBETALNINGAR_BG_PG=KR|Inbetalningar Bg/Pg;KR_ATERREDOVISNING_FRAN_ORDERINTEGRATION=KR|Återredovisning från orderintegration;KR_BETALNING_AV_BANKKONTOFAKTUROR=KR|Betalning av bankkontofakturor;KR_BETALNING_AV_INTERNFAKTUROR=KR|Betalning av internfakturor;KR_INSATTNING_PA_AVTAL=KR|Insättning på avtal;KR_KREDITERING=KR|Kreditering;KR_BOKFOR_KUNDFORLUST=KR|Bokför kundförlust;KR_UTBETALNING_AV_TILLGODOHAVANDE=KR|Utbetalning av tillgodohavande;KR_BERAKNA_TILLGODORANTA=KR|Beräkna tillgodoränta;KR_KRAVUTSKRIFT=KR|Kravutskrift;KR_MAKULERING_JUSTERING_AV_FAKTURAHANDELSER=KR|Makulering/justering av fakturahändelser;KR_MAKULERING_JUSTERING_AV_KONTOHANDELSER=KR|Makulering/justering av kontohändelser;OF_ORDER=OF|Order;OF_KREDITORDER=OF|Kreditorder;OF_IMPORTERA_ORDERUNDERLAG=OF|Importera orderunderlag;OF_FAKTURERING=OF|Fakturering;OF_DROJSMALSRANTEFAKTURERING=OF|Dröjsmålsräntefakturering;GA_FAKTURERA_GRAVSKOTSLAR=GA|Fakturera gravskötslar;GA_KREDITERA_GRAVSKOTSLAR=GA|Kreditera gravskötslar;GA_AVRAKNA_AVRAKNINGSAVTAL=GA|Avräkna avräkningsavtal;GA_FAKTURERA_GRAVSKOTSELAVTAL=GA|Fakturera gravskötselavtal;GA_AVRAKNA_FASTTIDSAVTAL=GA|Avräkna fasttidsavtal;GA_UPPRAKNA_FASTTIDSAVTAL=GA|Uppräkna fasttidsavtal;GA_SKAPA_BESTALLNINGSORDER=GA|Skapa beställningsorder;GA_JUSTERA_SALDO_PA_AVTAL=GA|Justera saldo på avtal;BO_FAKTURERA_AKTIVITETER=BO|Fakturera aktiviteter;AR_BOKFOR_AVSKRIVNINGAR=AR|Bokför avskrivningar;AR_BOKFOR_INTERNRANTA=AR|Bokför internränta;AR_NEDSKRIVNING=AR|Nedskrivning;AR_AVYTTRING_UTRANGERING_OMKLASSIFICERING=AR|Avyttring/utrangering/omklassificering;AR_AKTIVERA_PAGAENDE_INVESTERINGAR=AR|Aktivera pågående investeringar;AR_OMBOKFOR_PAG__INVESTERINGAR_INVESTERINGSRADER=AR|Ombokför påg. investeringar/investeringsrader;AR_MAKULERA_AKTIVERING_AV_PAG__INVESTERINGAR=AR|Makulera aktivering av påg. investeringar;AR_MAKULERA_OMBOKFORING_AV_PAG__INVESTERINGAR_INVESTERINGSRADER=AR|Makulera ombokföring av påg. investeringar/investeringsrader;AR_MAKULERA_SENASTE_BOKFORDA_HANDELSEN=AR|Makulera senaste bokförda händelsen;AR_OMKLASSIFICERING=AR|Omklassificering;AR_BYT_INVESTERINGSKONTO=AR|Byt investeringskonto;KJ_FAKTURERA_KREMATIONER=KJ|Fakturera kremationer;TI_BOKFOR_TIDRAPPORTERINGAR=TI|Bokför tidrapporteringar;BJ_FAKTURERA_BISATTNINGAR=BJ|Fakturera bisättningar;WEK_BOKFORINGSORDER=WEK|Bokföringsorder;WOF_WEBORDER=WOF|WebOrder"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BACKAD: {
          AttributeName: 'BACKAD',
          DisplayLabel: 'Backad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        URSPR_BOKF_AR: {
          AttributeName: 'URSPR_BOKF_AR',
          DisplayLabel: 'Ursprungsverifikation, bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Ursprungsverifikation',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        URSPR_VER_NR: {
          AttributeName: 'URSPR_VER_NR',
          DisplayLabel: 'Ursprungsverifikation, verifikationsnr',
          Hint: 'Periodiserad från vernr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Ursprungsverifikation',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        INTERN_VER: {
          AttributeName: 'INTERN_VER',
          DisplayLabel: 'Internverifikation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Summa_Debet: {
          AttributeName: 'Summa_Debet',
          DisplayLabel: 'Summa debet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        Summa_Kredit: {
          AttributeName: 'Summa_Kredit',
          DisplayLabel: 'Summa kredit',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        Saldo: {
          AttributeName: 'Saldo',
          DisplayLabel: 'Saldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Belopp',
        },
        Period: {
          AttributeName: 'Period',
          DisplayLabel: 'Bokföringsperiod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodKort: {
          AttributeName: 'PeriodKort',
          DisplayLabel: 'Period (förkortning)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Ursprung: {
          AttributeName: 'Ursprung',
          DisplayLabel: 'Ursprungsverifikation',
          Hint: 'Ex 2010 - 20899',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Ursprungsverifikation',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Journalnr: {
          AttributeName: 'Journalnr',
          DisplayLabel: 'Journalnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        KundFakturanr: {
          AttributeName: 'KundFakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kundreskontra',
        },
        Kundnr: {
          AttributeName: 'Kundnr',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kundreskontra',
        },
        Kundnamn: {
          AttributeName: 'Kundnamn',
          DisplayLabel: 'Kundnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Kundreskontra',
        },
        sqlCalcVernr: {
          AttributeName: 'sqlCalcVernr',
          DisplayLabel: 'sqlCalcVernr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Ursprungsdatum: {
          AttributeName: 'Ursprungsdatum',
          DisplayLabel: 'Ursprungsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Ankregnr: {
          AttributeName: 'Ankregnr',
          DisplayLabel: 'Ankregnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Signatur: {
          AttributeName: 'Signatur',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundForfallodatum: {
          AttributeName: 'KundForfallodatum',
          DisplayLabel: 'Förfallodatum, kundfaktura',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Verifikationsreferenser: {
          AttributeName: 'Verifikationsreferenser',
          DisplayLabel: 'Verifikationsreferenser',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StandardVernr: {
          AttributeName: 'StandardVernr',
          DisplayLabel: 'StandardVernr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevFakturanr: {
          AttributeName: 'LevFakturanr',
          DisplayLabel: 'Leverantörsfakturanummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Levnr: {
          AttributeName: 'Levnr',
          DisplayLabel: 'Leverantörsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HarAndringsVerifikation: {
          AttributeName: 'HarAndringsVerifikation',
          DisplayLabel: 'Har ändringsverifikation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StringVernr: {
          AttributeName: 'StringVernr',
          DisplayLabel: 'Sträng Verifikationsnummer',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        MOMSOMFORING_FIL_ID: {
          AttributeName: 'MOMSOMFORING_FIL_ID',
          DisplayLabel: 'Omförd på fil, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLAT_SPARRADE_KONTON: {
          AttributeName: 'TILLAT_SPARRADE_KONTON',
          DisplayLabel: 'Tillåt manuell bokföring på spärrade konton',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarFelaktigPeriodisering: {
          AttributeName: 'HarFelaktigPeriodisering',
          DisplayLabel: 'Innehåller felaktig periodisering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarIntaktsmomsrader: {
          AttributeName: 'HarIntaktsmomsrader',
          DisplayLabel: 'Har intäksmomsrader',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        EjHanteradForskottsverifikation: {
          AttributeName: 'EjHanteradForskottsverifikation',
          DisplayLabel: 'Ej hanterade förskottsverifikation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfverBlob',
          AssociatedComponentName: 'BokfVerBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Bokforingsjournal: {
          AssociationName: 'Bokforingsjournal',
          DisplayLabel: 'Bokföringsjournal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfjournal',
          AssociatedComponentName: 'Journal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Period: {
          AssociationName: 'Period',
          DisplayLabel: 'Bokföringsperiod',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfPeriod',
          AssociatedComponentName: 'BokfPeriod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ursprungsverifikation: {
          AssociationName: 'Ursprungsverifikation',
          DisplayLabel: 'Periodiserad i verifikation',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'Bokfver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Registrerad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokforingsorder: {
          AssociationName: 'Bokforingsorder',
          DisplayLabel: 'Bokföringsorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokforder',
          AssociatedComponentName: 'Bokforder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kodplan: {
          AssociationName: 'Kodplan',
          DisplayLabel: 'Kodplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontoplan',
          AssociatedComponentName: 'Kontoplan',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Konteringar: {
          AssociationName: 'Konteringar',
          DisplayLabel: 'Verifikationsrader',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelser: {
          AssociationName: 'Handelser',
          DisplayLabel: 'Bokföringshändelser',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'BokfHandelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfVerDok',
          AssociatedComponentName: 'BokfVerDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        RemovedDokument: {
          AssociationName: 'RemovedDokument',
          DisplayLabel: 'Borttagna dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKBokfVerRemovedDok',
          AssociatedComponentName: 'BokfVerRemovedDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokfverBlob: {
      CollectionName: 'EKBokfverBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfVerBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'EKBokfverBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'EKBokfverBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'EKBokfverBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'EKBokfverBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    EKBokfkontering: {
      CollectionName: 'EKBokfkontering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '2026'], ['AllowSelection', '2026']]),
      RootType: {
        TypeValue: 'BokfKontering',
        Abstract: false,
        SOLabel: 'Verifikationsrad',
        SOGLabel: 'Verifikationsrad',
        SBLabel: 'Verifikationsraden',
        SBGLabel: 'Verifikationsradens',
        POLabel: 'Verifikationsrader',
        POGLabel: 'Verifikationsraders',
        PBLabel: 'Verifikationsraderna',
        PBGLabel: 'Verifikationsradernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verifikationsradens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verifikationsradens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verifikationsradens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verifikationsradens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          Hint: 'Bokföringsår på formen ÅÅÅÅ',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Verifikationsnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET: {
          AttributeName: 'DEBET',
          DisplayLabel: 'Debetbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        KREDIT: {
          AttributeName: 'KREDIT',
          DisplayLabel: 'Kreditbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        DEB_KRED: {
          AttributeName: 'DEB_KRED',
          DisplayLabel: 'Debet/Kredit',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AUTOMAT_ID: {
          AttributeName: 'AUTOMAT_ID',
          DisplayLabel: 'Automatkontering id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOMAT_LOPNR: {
          AttributeName: 'AUTOMAT_LOPNR',
          DisplayLabel: 'Automatiseringslöpnt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEBET_VALUTA: {
          AttributeName: 'DEBET_VALUTA',
          DisplayLabel: 'Debet valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREDIT_VALUTA: {
          AttributeName: 'KREDIT_VALUTA',
          DisplayLabel: 'Kredit valuta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_BOKF_GRUPP_ID: {
          AttributeName: 'HANDELSE_BOKF_GRUPP_ID',
          DisplayLabel: 'Händelsens bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Händelseid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTKONTO_KOD: {
          AttributeName: 'MOTKONTO_KOD',
          DisplayLabel: 'Motkontokod',
          Hint: 'Motkonto till intäktskonto/Leverantörsskulder/Ingående momskonto/Preliminärkonto vid ankomstregistrering/Debetkonto vid avskrivning/Kreditkonto vid avskrivning/Investeringskonto som ombokförs/Återföring av investeringar/Återföring av avskrivningar/Återföring av nedskrivningar/Intäkt från försäljning/Realisationsvinst/förlust',
          DataType: 'Enum',
          EnumValues: new Map([['MOTKONTO_TILL_INTAKTSKONTO', 'Motkonto till intäktskonto'], ['LEVERANTORSSKULDER', 'Leverantörsskulder'], ['INGAENDE_MOMSKONTO', 'Ingående momskonto'], ['PRELIMINARKONTO_VID_ANKOMSTREGISTRERING', 'Preliminärkonto vid ankomstregistrering'], ['DEBETKONTO_VID_AVSKRIVNING', 'Debetkonto vid avskrivning'], ['KREDITKONTO_VID_AVSKRIVNING', 'Kreditkonto vid avskrivning'], ['INVESTERINGSKONTO_SOM_OMBOKFORS', 'Investeringskonto som ombokförs'], ['ATERFORING_AV_INVESTERINGAR', 'Återföring av investeringar'], ['ATERFORING_AV_AVSKRIVNINGAR', 'Återföring av avskrivningar'], ['ATERFORING_AV_NEDSKRIVNINGAR', 'Återföring av nedskrivningar'], ['INTAKT_FRAN_FORSALJNING', 'Intäkt från försäljning'], ['REALISATIONSVINST_FORLUST', 'Realisationsvinst/förlust']]),
          EnumSortValues: new Map([['MOTKONTO_TILL_INTAKTSKONTO', 'M'], ['LEVERANTORSSKULDER', 'L'], ['INGAENDE_MOMSKONTO', 'I'], ['PRELIMINARKONTO_VID_ANKOMSTREGISTRERING', 'P'], ['DEBETKONTO_VID_AVSKRIVNING', 'D'], ['KREDITKONTO_VID_AVSKRIVNING', 'K'], ['INVESTERINGSKONTO_SOM_OMBOKFORS', 'O'], ['ATERFORING_AV_INVESTERINGAR', 'V'], ['ATERFORING_AV_AVSKRIVNINGAR', 'A'], ['ATERFORING_AV_NEDSKRIVNINGAR', 'N'], ['INTAKT_FRAN_FORSALJNING', 'F'], ['REALISATIONSVINST_FORLUST', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MOTKONTO_TILL_INTAKTSKONTO=Motkonto till intäktskonto;LEVERANTORSSKULDER=Leverantörsskulder;INGAENDE_MOMSKONTO=Ingående momskonto;PRELIMINARKONTO_VID_ANKOMSTREGISTRERING=Preliminärkonto vid ankomstregistrering;DEBETKONTO_VID_AVSKRIVNING=Debetkonto vid avskrivning;KREDITKONTO_VID_AVSKRIVNING=Kreditkonto vid avskrivning;INVESTERINGSKONTO_SOM_OMBOKFORS=Investeringskonto som ombokförs;ATERFORING_AV_INVESTERINGAR=Återföring av investeringar;ATERFORING_AV_AVSKRIVNINGAR=Återföring av avskrivningar;ATERFORING_AV_NEDSKRIVNINGAR=Återföring av nedskrivningar;INTAKT_FRAN_FORSALJNING=Intäkt från försäljning;REALISATIONSVINST_FORLUST=Realisationsvinst/förlust"',
        },
        URSPR_BOKF_AR: {
          AttributeName: 'URSPR_BOKF_AR',
          DisplayLabel: 'Ursprungskontering, bokföringsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        URSPR_VER_NR: {
          AttributeName: 'URSPR_VER_NR',
          DisplayLabel: 'Ursprungkontering, verifikationsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URSPR_LOPNR: {
          AttributeName: 'URSPR_LOPNR',
          DisplayLabel: 'Ursprungkontering, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOKONT_NIVA: {
          AttributeName: 'AUTOKONT_NIVA',
          DisplayLabel: 'Automatkonteringsnivå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AUTOKONT_LOPNR: {
          AttributeName: 'AUTOKONT_LOPNR',
          DisplayLabel: 'Löpnr för ursprungskontering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOMAT_DEBET: {
          AttributeName: 'AUTOMAT_DEBET',
          DisplayLabel: 'Fördelat belopp, debet',
          Hint: 'Angivet debetbelopp före automatkontering',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Automatkontering, belopp',
        },
        AUTOMAT_KREDIT: {
          AttributeName: 'AUTOMAT_KREDIT',
          DisplayLabel: 'Fördelat belopp, kredit',
          Hint: 'Angivet kreditbelopp före',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Automatkontering, belopp',
        },
        KONTERINGSKOD_ID: {
          AttributeName: 'KONTERINGSKOD_ID',
          DisplayLabel: 'Konteringskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatKonteringskod',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        PERIODISERAD: {
          AttributeName: 'PERIODISERAD',
          DisplayLabel: 'Periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Kontoben: {
          AttributeName: 'Kontoben',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontostrang: {
          AttributeName: 'Kontostrang',
          DisplayLabel: 'Kodsträng',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kontoben1: {
          AttributeName: 'Kontoben1',
          DisplayLabel: 'Benämning 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben2: {
          AttributeName: 'Kontoben2',
          DisplayLabel: 'Benämning 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben3: {
          AttributeName: 'Kontoben3',
          DisplayLabel: 'Benämning3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben4: {
          AttributeName: 'Kontoben4',
          DisplayLabel: 'Benämning 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben5: {
          AttributeName: 'Kontoben5',
          DisplayLabel: 'Benämning 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben6: {
          AttributeName: 'Kontoben6',
          DisplayLabel: 'Benämning 6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben7: {
          AttributeName: 'Kontoben7',
          DisplayLabel: 'Benämning 7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben8: {
          AttributeName: 'Kontoben8',
          DisplayLabel: 'Benämning 8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben9: {
          AttributeName: 'Kontoben9',
          DisplayLabel: 'Benämning 9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontoben10: {
          AttributeName: 'Kontoben10',
          DisplayLabel: 'Benämning 10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL1: {
          AttributeName: 'KDEL1',
          DisplayLabel: 'Kontodel1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL2: {
          AttributeName: 'KDEL2',
          DisplayLabel: 'Kontodel2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL3: {
          AttributeName: 'KDEL3',
          DisplayLabel: 'Kontodel3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL4: {
          AttributeName: 'KDEL4',
          DisplayLabel: 'Kontodel4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL5: {
          AttributeName: 'KDEL5',
          DisplayLabel: 'Kontodel5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL6: {
          AttributeName: 'KDEL6',
          DisplayLabel: 'Kontodel6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL7: {
          AttributeName: 'KDEL7',
          DisplayLabel: 'Kontodel7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL8: {
          AttributeName: 'KDEL8',
          DisplayLabel: 'Kontodel8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL9: {
          AttributeName: 'KDEL9',
          DisplayLabel: 'Kontodel9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KDEL10: {
          AttributeName: 'KDEL10',
          DisplayLabel: 'Kontodel10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KBEN1: {
          AttributeName: 'KBEN1',
          DisplayLabel: 'Kontobenämning1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN2: {
          AttributeName: 'KBEN2',
          DisplayLabel: 'Kontobenämning2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN3: {
          AttributeName: 'KBEN3',
          DisplayLabel: 'Kontobenämning3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN4: {
          AttributeName: 'KBEN4',
          DisplayLabel: 'Kontobenämning4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN5: {
          AttributeName: 'KBEN5',
          DisplayLabel: 'Kontobenämning5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN6: {
          AttributeName: 'KBEN6',
          DisplayLabel: 'Kontobenämning6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN7: {
          AttributeName: 'KBEN7',
          DisplayLabel: 'Kontobenämning7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN8: {
          AttributeName: 'KBEN8',
          DisplayLabel: 'Kontobenämning8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN9: {
          AttributeName: 'KBEN9',
          DisplayLabel: 'Kontobenämning9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBEN10: {
          AttributeName: 'KBEN10',
          DisplayLabel: 'Kontobenämning10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROJEKT_AVSLUTAT_2: {
          AttributeName: 'PROJEKT_AVSLUTAT_2',
          DisplayLabel: '@KONTO2@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_3: {
          AttributeName: 'PROJEKT_AVSLUTAT_3',
          DisplayLabel: '@KONTO3@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_4: {
          AttributeName: 'PROJEKT_AVSLUTAT_4',
          DisplayLabel: '@KONTO4@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_5: {
          AttributeName: 'PROJEKT_AVSLUTAT_5',
          DisplayLabel: '@KONTO5@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_6: {
          AttributeName: 'PROJEKT_AVSLUTAT_6',
          DisplayLabel: '@KONTO6@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_7: {
          AttributeName: 'PROJEKT_AVSLUTAT_7',
          DisplayLabel: '@KONTO7@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_8: {
          AttributeName: 'PROJEKT_AVSLUTAT_8',
          DisplayLabel: '@KONTO8@',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_9: {
          AttributeName: 'PROJEKT_AVSLUTAT_9',
          DisplayLabel: '@KONTO9@ avslutat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROJEKT_AVSLUTAT_10: {
          AttributeName: 'PROJEKT_AVSLUTAT_10',
          DisplayLabel: '@KONTO10@',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        EKOSTYR_DATUM: {
          AttributeName: 'EKOSTYR_DATUM',
          DisplayLabel: 'Överförd till Ekostyr, datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLNINGS_NR: {
          AttributeName: 'BESTALLNINGS_NR',
          DisplayLabel: 'Ekostyr, beställningsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANG_ID: {
          AttributeName: 'TILLGANG_ID',
          DisplayLabel: 'Tillgång, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANG_UPPR_LOPNR: {
          AttributeName: 'TILLGANG_UPPR_LOPNR',
          DisplayLabel: 'Tillgång, uppr löpn',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLGANG_LOPNR: {
          AttributeName: 'TILLGANG_LOPNR',
          DisplayLabel: 'Tillgång, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROJEKT_BOKF_AR: {
          AttributeName: 'PROJEKT_BOKF_AR',
          DisplayLabel: 'Projektavslut, bokf.år',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PROJEKT_VER_NR: {
          AttributeName: 'PROJEKT_VER_NR',
          DisplayLabel: 'Projektavslut, vernr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        INTRANTA_TILLGANG_ID: {
          AttributeName: 'INTRANTA_TILLGANG_ID',
          DisplayLabel: 'Internränta, tillgång id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTRANTA_UPPR_LOPNR: {
          AttributeName: 'INTRANTA_UPPR_LOPNR',
          DisplayLabel: 'Internränta, uppr löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSLUTAT_MOT_PROJEKT: {
          AttributeName: 'AVSLUTAT_MOT_PROJEKT',
          DisplayLabel: 'Avslutat mot projekt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Bokfdatum: {
          AttributeName: 'Bokfdatum',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Vertext: {
          AttributeName: 'Vertext',
          DisplayLabel: 'Verifikationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Saldo: {
          AttributeName: 'Saldo',
          DisplayLabel: 'Saldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        calcVertext: {
          AttributeName: 'calcVertext',
          DisplayLabel: 'calcVertext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvslutadMotProjekt: {
          AttributeName: 'AvslutadMotProjekt',
          DisplayLabel: 'Avslutad mot projekt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        journalNr: {
          AttributeName: 'journalNr',
          DisplayLabel: 'Journal Nr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        i_huvudbok: {
          AttributeName: 'i_huvudbok',
          DisplayLabel: 'Införd i huvudbok',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        PROJEKT_LOPNR: {
          AttributeName: 'PROJEKT_LOPNR',
          DisplayLabel: 'Projekt, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevNr: {
          AttributeName: 'LevNr',
          DisplayLabel: 'LevNr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevNamn: {
          AttributeName: 'LevNamn',
          DisplayLabel: 'LevNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LevFaktnr: {
          AttributeName: 'LevFaktnr',
          DisplayLabel: 'LevFaktnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Registrerat antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Enhet: {
          AttributeName: 'Enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvslutatProjektVernr: {
          AttributeName: 'AvslutatProjektVernr',
          DisplayLabel: 'Avslutat mot vernr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Ankregnr: {
          AttributeName: 'Ankregnr',
          DisplayLabel: 'Ankregnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AutomatSaldo: {
          AttributeName: 'AutomatSaldo',
          DisplayLabel: 'Saldo, innan automatkontering',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Automatkontering, belopp',
        },
        SortLopnr: {
          AttributeName: 'SortLopnr',
          DisplayLabel: 'Sorteringsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        Konto_del1: {
          AttributeName: 'Konto_del1',
          DisplayLabel: '@KONTO1@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '1']]),
        },
        Konto_del2: {
          AttributeName: 'Konto_del2',
          DisplayLabel: '@KONTO2@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '2']]),
        },
        Konto_del3: {
          AttributeName: 'Konto_del3',
          DisplayLabel: '@KONTO3@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '3']]),
        },
        Konto_del4: {
          AttributeName: 'Konto_del4',
          DisplayLabel: '@KONTO4@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '4']]),
        },
        Konto_del5: {
          AttributeName: 'Konto_del5',
          DisplayLabel: '@KONTO5@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '5']]),
        },
        Konto_del6: {
          AttributeName: 'Konto_del6',
          DisplayLabel: '@KONTO6@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '6']]),
        },
        Konto_del7: {
          AttributeName: 'Konto_del7',
          DisplayLabel: '@KONTO7@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '7']]),
        },
        Konto_del8: {
          AttributeName: 'Konto_del8',
          DisplayLabel: '@KONTO8@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '8']]),
        },
        Konto_del9: {
          AttributeName: 'Konto_del9',
          DisplayLabel: '@KONTO9@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '9']]),
        },
        Konto_del10: {
          AttributeName: 'Konto_del10',
          DisplayLabel: '@KONTO10@',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['Kontodel', '10']]),
        },
        EXTERNT_ANSTNR: {
          AttributeName: 'EXTERNT_ANSTNR',
          DisplayLabel: 'Anställningsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVSER_PERIOD: {
          AttributeName: 'AVSER_PERIOD',
          DisplayLabel: 'Avser löneperiod',
          Hint: 'Om denna är blank så är löneperioden den som står på verifikationen. Detta fält används vid korrigering av lönefördelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodiseradTillKontostrang: {
          AttributeName: 'PeriodiseradTillKontostrang',
          DisplayLabel: 'Periodiserad till konto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodiseradTillKontoben: {
          AttributeName: 'PeriodiseradTillKontoben',
          DisplayLabel: 'Periodiserad till konto benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodiseradTillDatum: {
          AttributeName: 'PeriodiseradTillDatum',
          DisplayLabel: 'Periodiserad, till datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        PeriodiseradFranDatum: {
          AttributeName: 'PeriodiseradFranDatum',
          DisplayLabel: 'Periodiserad, från datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        PeriodiseradIntervall: {
          AttributeName: 'PeriodiseradIntervall',
          DisplayLabel: 'Periodisera, intervall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AvserLoneperiod: {
          AttributeName: 'AvserLoneperiod',
          DisplayLabel: 'Avser löneperiod',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        LONEART: {
          AttributeName: 'LONEART',
          DisplayLabel: 'Löneart',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodiseradTillBaskonto: {
          AttributeName: 'PeriodiseradTillBaskonto',
          DisplayLabel: 'PeriodiseradTillBaskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PeriodiseradTillBaskontoben: {
          AttributeName: 'PeriodiseradTillBaskontoben',
          DisplayLabel: 'PeriodiseradTillBaskontoben',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEFATTNINGSKOD: {
          AttributeName: 'BEFATTNINGSKOD',
          DisplayLabel: 'Befattningskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BokfortAntal: {
          AttributeName: 'BokfortAntal',
          DisplayLabel: 'Bokfört antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Loneartsgrupp: {
          AttributeName: 'Loneartsgrupp',
          DisplayLabel: 'Löneartsgrupp',
          Hint: 'Årslön/Semesterersättningar/Särskilda ersättningar/Arb.avg o avtalsenl soc avgifter/Lönebidrag',
          DataType: 'Enum',
          EnumValues: new Map([['ARSLON', 'Årslön'], ['SEMESTERERSATTNINGAR', 'Semesterersättningar'], ['SARSKILDA_ERSATTNINGAR', 'Särskilda ersättningar'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'Arb.avg o avtalsenl soc avgifter'], ['LONEBIDRAG', 'Lönebidrag']]),
          EnumSortValues: new Map([['ARSLON', 'ÅRSLÖN'], ['SEMESTERERSATTNINGAR', 'SEMERS'], ['SARSKILDA_ERSATTNINGAR', 'SÄRSKERS'], ['ARB_AVG_O_AVTALSENL_SOC_AVGIFTER', 'SOCAVG'], ['LONEBIDRAG', 'LÖNEBIDRAG']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSLON=Årslön;SEMESTERERSATTNINGAR=Semesterersättningar;SARSKILDA_ERSATTNINGAR=Särskilda ersättningar;ARB_AVG_O_AVTALSENL_SOC_AVGIFTER=Arb.avg o avtalsenl soc avgifter;LONEBIDRAG=Lönebidrag"',
          InterfaceType: 'ifChecklist',
        },
        ArVernrRadnr: {
          AttributeName: 'ArVernrRadnr',
          DisplayLabel: 'Verifikationsrad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LONEARTKOD: {
          AttributeName: 'LONEARTKOD',
          DisplayLabel: 'Löneart',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Fastighetsnr: {
          AttributeName: 'Fastighetsnr',
          DisplayLabel: 'Fastighetsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Fastighetsuppföljning',
        },
        Fastighetstyp: {
          AttributeName: 'Fastighetstyp',
          DisplayLabel: 'Fastighetstyp',
          Hint: 'Församlingshem/Kyrka',
          DataType: 'Enum',
          EnumValues: new Map([['FORSAMLINGSHEM', 'Församlingshem'], ['KYRKA', 'Kyrka']]),
          EnumSortValues: new Map([['FORSAMLINGSHEM', 'F'], ['KYRKA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORSAMLINGSHEM=Församlingshem;KYRKA=Kyrka"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Fastighetsuppföljning',
        },
        ProjektOrdningsnr: {
          AttributeName: 'ProjektOrdningsnr',
          DisplayLabel: 'ProjektOrdningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ProjektKontoid: {
          AttributeName: 'ProjektKontoid',
          DisplayLabel: 'ProjektKontoid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HuvudprojektId: {
          AttributeName: 'HuvudprojektId',
          DisplayLabel: 'HuvudprojektId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKICKAD_MOMSFILRAD_ID: {
          AttributeName: 'SKICKAD_MOMSFILRAD_ID',
          DisplayLabel: 'Skickad med momsfil, rad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS_BOKF_AR: {
          AttributeName: 'MOMS_BOKF_AR',
          DisplayLabel: 'Avvikande momsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        MOMS_BOKF_PER: {
          AttributeName: 'MOMS_BOKF_PER',
          DisplayLabel: 'Avvikande momsperiod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Momsperiod: {
          AttributeName: 'Momsperiod',
          DisplayLabel: 'Momsperiod',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AvvikandeMomsperiod: {
          AttributeName: 'AvvikandeMomsperiod',
          DisplayLabel: 'Avvikande momsperiod',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FelaktigtPeriodiserad: {
          AttributeName: 'FelaktigtPeriodiserad',
          DisplayLabel: 'Felaktigt periodiserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        FiltreraEnligtMinKodbehorighetDatum: {
          AttributeName: 'FiltreraEnligtMinKodbehorighetDatum',
          DisplayLabel: 'Filtrera enligt kodbehörighet',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokfver: {
          AssociationName: 'Bokfver',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel1: {
          AssociationName: 'Kontodel1',
          DisplayLabel: '@KONTO1@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel2: {
          AssociationName: 'Kontodel2',
          DisplayLabel: '@KONTO2@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel3: {
          AssociationName: 'Kontodel3',
          DisplayLabel: '@KONTO3@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel4: {
          AssociationName: 'Kontodel4',
          DisplayLabel: '@KONTO4@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel5: {
          AssociationName: 'Kontodel5',
          DisplayLabel: '@KONTO5@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel6: {
          AssociationName: 'Kontodel6',
          DisplayLabel: '@KONTO6@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel7: {
          AssociationName: 'Kontodel7',
          DisplayLabel: '@KONTO7@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel8: {
          AssociationName: 'Kontodel8',
          DisplayLabel: '@KONTO8@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel9: {
          AssociationName: 'Kontodel9',
          DisplayLabel: '@KONTO9@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontodel10: {
          AssociationName: 'Kontodel10',
          DisplayLabel: '@KONTO10@',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKontodel',
          AssociatedComponentName: 'Kontodel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Konteringskod: {
          AssociationName: 'Konteringskod',
          DisplayLabel: 'Konteringskod',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonteringskod',
          AssociatedComponentName: 'Konteringskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'Fakturahandelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Automatkontering: {
          AssociationName: 'Automatkontering',
          DisplayLabel: 'Automatkontering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAutomatkonteringar',
          AssociatedComponentName: 'Automatkontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ursprungskontering: {
          AssociationName: 'Ursprungskontering',
          DisplayLabel: 'Ursprungskontering',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfkontering',
          AssociatedComponentName: 'BokfKontering',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfar: {
          AssociationName: 'Bokfar',
          DisplayLabel: 'Bokföringsår',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfar',
          AssociatedComponentName: 'Bokfar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Loneart: {
          AssociationName: 'Loneart',
          DisplayLabel: 'Löneart',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKLoneart',
          AssociatedComponentName: 'Loneart',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Huvudprojekt: {
          AssociationName: 'Huvudprojekt',
          DisplayLabel: 'Huvudprojekt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKHuvudprojekt',
          AssociatedComponentName: 'Huvudprojekt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Investeringsrad: {
          AssociationName: 'Investeringsrad',
          DisplayLabel: 'Investeringsrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvesteringsrad',
          AssociatedComponentName: 'BokfInvrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    EKBokfverref: {
      CollectionName: 'EKBokfverref',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bokfverref',
        Abstract: false,
        SOLabel: 'Verifikationsreferens',
        SOGLabel: 'Verifikationsreferens',
        SBLabel: 'Verifikationsreferensen',
        SBGLabel: 'Verifikationsreferensen',
        POLabel: 'Verifikationsreferenser',
        POGLabel: 'Verifikationsreferenser',
        PBLabel: 'Verifikationsreferenserna',
        PBGLabel: 'Verifikationsreferenserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verifikationsreferensen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verifikationsreferensen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verifikationsreferensen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR_1: {
          AttributeName: 'BOKF_AR_1',
          DisplayLabel: 'Bokföringsår, verifikation 1',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
        },
        VER_NR_1: {
          AttributeName: 'VER_NR_1',
          DisplayLabel: 'Verifikationsnr, verifikation 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BOKF_AR_2: {
          AttributeName: 'BOKF_AR_2',
          DisplayLabel: 'Bokföringsår, verifikation 2',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
        },
        VER_NR_2: {
          AttributeName: 'VER_NR_2',
          DisplayLabel: 'Verifikationsnr, verifikation 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        REF_TYP: {
          AttributeName: 'REF_TYP',
          DisplayLabel: 'Referenstyp',
          Hint: 'Automatisk/Registrerad',
          DataType: 'Enum',
          EnumValues: new Map([['AUTOMATISK', 'Automatisk'], ['REGISTRERAD', 'Registrerad']]),
          EnumSortValues: new Map([['AUTOMATISK', 'A'], ['REGISTRERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AUTOMATISK=Automatisk;REGISTRERAD=Registrerad"',
          GUIEditable: true,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Verifikation2: {
          AssociationName: 'Verifikation2',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'BokfVer',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
  },
};

export default EK;
